// ADL
import $ from 'jquery';
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import frm from '../formAux.js'
import tabler from './tabler_adl.js';
const { Liquid } = require('liquidjs');

var descriptor = [];
var txtObj = null;
var txtObjAdj = null;
var gPDF = null;
var txtTags = null;
var tListAdj = null;
var pageNum = null;
var mode = 'adl';

var closeIcon = '';
var searchIcon = '';
var mainLeftOffset = 70;

var adjKey = new RegExp('^#adj#');
var consensusKey = new RegExp('^#con#');
var labelKey = new RegExp('^#...#');

var colorAdj = '#ffff00';
var colorConsensus = '#44ff44';
var colorGroundtruth = '#00ffff';
var adjMode = false;


setTimeout( function(){window.checkInNLP()}, 1000 );

// ADLEND

// EXPORTSTART
var closeIcon = '<i class="fa fa-close"></i>';
var searchIcon = '<i class="fa fa-search"></i>';
var gPDF = null;
var origPlumber = null;
var plumberData = null;
var comprehendPlumbData = null;

function px(v) { return v+'px'; }
function pc(v) { if( v < 0 ) v = 0; if( v > 100 ) v = 100; return Math.round(v)+'%'; }
function val(v) { v = parseFloat(v); if( isNaN(v) ) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isarray( o ){ return o instanceof Array;}
function isobj( o ){ return o instanceof Object;}
function isnumber( o ){ return typeof(o) == 'number' && !isNaN(o);}
function defined( o ){ return typeof(o) != 'undefined';}
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec(){	return new Date().getTime(); }
function getsec(){ return Math.round(getmsec()/1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig,'').toLowerCase() }
function aLast( a ) { return a.length ? a[a.length-1] : null }

function aUnique( a ) {
    var h = {};
    function has( v ) { 
        var r = !(v in h);
        h[v] = 1;
        return r;
    }
    return a.filter( i => has(i) )
}

function iarray( v, n )
{
	var ret = [];
	for( var i = 0 ; i < n ; i++ )
	ret.push( v instanceof Object ? clone(v) : v );
	return ret;
}

function jsonParse( data ) {
	if( typeof(data) == 'string' ) {
		try {
			data = JSON.parse(data);
		} catch(e) { data = {} }
	}
	return data;
}

function bool( s )
{
	if( typeof(s) == 'boolean' ) return s;
	if( !defined(s) || s === null ) return false;
	if( typeof(s) == 'number' ) return s > 0;
	if( s.match(/^y/i) ) return true;
	return false;
}

function sbool( v )
{
	return ['No','Yes'][v];
}

function paletteWheel( div, brightness )
{
	if( !brightness ) brightness = 1;
  	var steps = [[255,0,0],[0,255,0],[0,0,255],[255,0,0]];
    var colors = [];
    function interpolate(v)
    {
        v *= steps.length-1;
        var i = Math.floor(v);
        var r = v-i;
        var ir = 1-r;
        // console.log( 'v', v, 'i', i, 'r', r );
        return [steps[i][0]*ir+steps[i+1][0]*r,steps[i][1]*ir+steps[i+1][1]*r,steps[i][2]*ir+steps[i+1][2]*r];
    }
    for( var d = 0 ; d < div ; d++ )
    {
        var c = interpolate( d/div);
        var hc = '#' + c.map( v => Math.min(Math.floor(v*brightness),255).toString(16).padStart(2,'0')).join('');
        colors.push( hc );
    }
    return colors;
}

var CLOSESPAN = 1.2;
var g_tagId = 1;
var tList = null;
var currentPage = 1;
var totalPages = 1;
var dataLoaded = false;
var rangeList = [];
var linkList = [];
var questionList = [];
var pageList = {};
var classifications = {};
var linksDrawn = [];
var linkHeight = 0;
var fontSize = 20;
var lineHeightMin = fontSize*2;
var lineHeight = lineHeightMin;
var tagHeight = 35;
var tagMargin = 4;

var pageDone = true;
var showTexts = false;
var showAdjudication = false;
var showTags = false;
var showLinks = false;
var showTables = false;
var showBoxes = false;
var globalZoom = 1;
var ocrMode = false;
var oocrMode = false;
var tableMode = false;

var over = null;
var overTidLabel = null;
var selected = null;
var selectedLink = null;


var regTags = /(<[a-z][^>]*>|\&[a-z]*;|<\/[a-z][^>]*>)/i;
var regOTag = /^<([a-z]+)[^>]*>$/i;
var regCTag = /^<\/([a-z]+)[^>]*>$/i;
var regEChar = /^&[a-z]*;$/i;
var regId = /id="([^"]*)"/i;
var regSingleTag = /(br|hr)/i;

var htmlTextMode = false;
var imageMode = false;
var videoMode = false;

var hotKeysVals = {};
var hotKeysChars = {};
var hKeyId = 0;

function setColors( list )
{
	// console.log( 'SETCOLORS' )
	var count = 0;
	function walk( list, func )
	{
		for( var k in list )
		{
			var l = list[k]
			if( func ) func(l)
			if( isobj(l) && l.sublabels ) walk( l.sublabels, func );
		}
	}
	walk( list, function(){ count++ })
	var cnum = 0;
	var wheel = paletteWheel(count, 0.7);
	walk( list, function(o){
		// console.log( 'walk', o )
		if( !o.color ) o.color = wheel[cnum];
		cnum++;
	})
	// console.log( 'setColors', count, paletteWheel(count) )
}

function resetHotKeys() {
	hotKeysVals = {};
	hKeyId = 0;
}

function setHotKeys( list, type, func, ext )
{
	var keys = "1234567890";
	if( ext ) var keys = "1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZ"; 
	// console.log( 'setHotKeys', list, type, func )
	if( isarray( list ) ) {
		for( var k of list )
		{
			if( hKeyId >= keys.length ) continue;
			var o = {char:keys[hKeyId],str:k,type:type,callback:func};
			hotKeysVals[k] = hotKeysChars[keys[hKeyId]] = o;
			hKeyId++;
		}
	} else {
		for( var k in list )
		{
			if( hKeyId >= keys.length ) continue;
			var o = {char:keys[hKeyId],str:k,type:type,callback:func};
			hotKeysVals[k] = hotKeysChars[keys[hKeyId]] = o;
			hKeyId++;
			if( isobj(list[k]) && list[k].sublabels ) setHotKeys( list[k].sublabels, type, func );
		}
	}
}

var hKeyPressed = null;
function hotKeyPress( c, s )
{
	if( c in hotKeysChars )
	{
		if( s )
		{
			// console.log( 'HOTKEY', c );
			hKeyPressed = hotKeysChars[c];
			hKeyPressed.callback( 'set', hKeyPressed.str );
			drawTags();
			$('.hotkey').removeClass('hotkey-pressed');
			$('.hotkey_'+c).addClass('hotkey-pressed');
		}
		else {
			if( hKeyPressed )
			{
				// console.log( 'HOTKEY off', c );
				hKeyPressed = null;
				$('.hotkey').removeClass('hotkey-pressed');
			}
		}
	}
}

var logTimeStart;
function logTime( s, start ) {
	var now = new Date().getTime()
	if( !logTimeStart || start ) logTimeStart = now;

	// console.log( s, now-logTimeStart)
}

function findAgain()
{
	// console.log( 'findAgain', findNext )
	if( !findNext || !findPrev ) return;
	if( skeys.shiftOn ) findPrev();
	else findNext();
}

var skeys = {
	shiftOn: false,
	ctrlOn: false,
	altOn: false,
	metaOn: false,
	rOn: false,
	cOn: false,
}


function showSummary() {
	var summary = [];
	// labels
	if( descriptor.labels ) {
		// console.log( 'RANGES', rangeList )
		for( var l in descriptor.labels ) {
			var ct = 0;
			for( var r of rangeList ) {
				if( r.properties.indexOf(l) >= 0 ) ct++;
			}
			summary.push( {label:l, type:'label', count:ct})
		}
	}
	if( descriptor.relationships ) {
		// console.log( 'relationships', linkList )
		for( var r in descriptor.relationships ) {
			var ct = 0;
			for( var l of linkList ) {
				if( l.relationship == r ) ct++;
			}
			summary.push( {label:r, type:'relationship', count:ct})
		}
	}
	if( descriptor.boxes ) {
		// console.log( 'boxes', boxes )
		for( var b in descriptor.boxes ) {
			var ct = 0;
			for( var bb of boxes ) {
				if( bb.label == b ) ct++;
			}
			summary.push( {label:b, type:'box', count:ct})
		}
	}
	if( descriptor.attributes ) {
		for( var a of descriptor.attributes ) {
			var ct = 0;
			if( descriptor.text_attributes.attributes && descriptor.text_attributes.attributes[a.label] ) ct++;
			summary.push( {label:a.label, type:'doc. attribute', count: ct} )
		}
	}
	if( descriptor.pageAttributes ) {
		for( var a of descriptor.pageAttributes ) {
			var ct = 0;
			if( descriptor.text_attributes.pageAttributes ) {
				for( var pa of descriptor.text_attributes.pageAttributes ) {
					if( pa && pa[a.label] ) ct++;
				}
			}
			// && descriptor.text_attributes.pageAttributes[a.label] ) ct++;
			summary.push( {label:a.label, type:'page attribute', count: ct} )
		}
	}
	// console.log( 'SUMMARY', summary )
	frm.myAlert('Annotation Summary', '<div style="min-height: 400px"><table id="summarytable" class="table-grid"></table></div>', 'Ok')

	var desc = {
		title: 'Summary',
		columns: {
			label: 'Name',
			type: 'Type',
			count: 'Count',
		},
		hideSinglePageTotal: true,
		filter: true,
		search: true,
		sort: true,
		initialSort: 'Type',
		initialSortDir: -1,
		pageSize: 1000,
		noFilter: {
			count: 1,
		},
		noSearch: { thumb: 1 },
		noSort: null,
		centerCol: ['count'],
		format: tabler.formatString,
		forceType: { count: 1 },
		// formatCol: {
		// 	thumb: frm.formatThumb,
		// 	touched: tabler.formatTimeAgoSec,
		// 	state: tabler.formatState,
		// 	preview: frm.formatPreview,
		// 	annotations: frm.smallerText,
		// }
		// clickCol: ['stateLabel','source'],
	}
	var tab = tabler.table($('#summarytable'), desc, 'annotationsummary');
	$('.modal-header').hide();
	for( var s of summary ) {
		tab.addRow(s, function (col, row) {
			// console.log('tabler click', a.fileId, row[col])
			// fileClickTabler(col, row)
		})
	}
	tab.draw();

}

function setKey( k, v ) {
	// return
	var old = skeys[k];
	skeys[k] = v;
	if( v != old ) {

		if( oocrMode && k == 'shiftOn') {
			if( v ) {
				tagUnselect();
				popupOut();
				selectRange = [];
				paintSelectBoundingBox();
				$('.c_tag').addClass('mouse-invisible')
				$('.nlpbbox').addClass('mouse-invisible')
				$('.table-ocr').addClass('mouse-invisible')
			}
			else {
				$('.mouse-invisible').removeClass('mouse-invisible')
				if( selected ) {
					var s = selected;
					tagUnselect();
					tagSelect(s);
				}
			}
			return;
		}
		if( k == 'shiftOn' || (k == 'ctrlOn' && descriptor.selectBoundingBox) ) {
			if( !v ) {
				if( selected )
				{
					popupClear = true;
					setTimeout( function(){tagSelect( selected )}, 1 );
				}
			}
			else {
				popupOut();
			}
		}
		if( k == 'altOn' ) {
			if( v ) {
				if( htmlTextMode ) $('.c_tag').css({borderColor:'transparent'});
				else $('.c_tag').hide();
				$('.link').hide();
				$('.tag_label').addClass('ultraLeft')
				$('.popup-list').addClass('ultraLeft')
			}
			else {
				if( htmlTextMode ) $('.c_tag').css({borderColor:''});
				else $('.c_tag').show();
				if( showLinks ) $('.link').show();
				$('.tag_label').removeClass('ultraLeft')
				$('.popup-list').removeClass('ultraLeft')
				if( showPopupAlt ) {
					showPopupAlt();
					showPopupAlt = null;
				}
			}
		}
		if( descriptor.selectBoundingBox ) {
			// console.log( 'setKey', selected, k.match(/(shiftOn|ctrlOn)/))
			if( selected && k.match(/(shiftOn|ctrlOn)/) )
				setTimeout( paintSelectRange, 1 );
		}
	}
}

function isEdit( ev ) {
	return (ev.target.tagName == 'INPUT' || ev.target.tagName == 'TEXTAREA' || ev.target.contentEditable == 'true') && ev.target.type != 'checkbox' && $(ev.target).prop('id') != 'keysearch';
}

function keyDown(ev) {
	// console.log( 'keydown', ev.keyCode, ev.key, ev );
	var ocOn = skeys.ctrlOn;
	var osOn = skeys.shiftOn;

	if (!skeys.ctrlOn && ev.ctrlKey) {
		if( !isEdit(ev) ) setKey( 'ctrlOn', true );
		// console.log('skeys.ctrlOn', skeys.ctrlOn)
	}
	if (!skeys.altOn && ev.altKey) {
		if( !isEdit(ev) || ocrMode ) setKey( 'altOn', true );
		// console.log('skeys.altOn', skeys.altOn)
		ev.preventDefault();
		ev.stopPropagation();
	}
	if (!skeys.metaOn && ev.metaKey) {
		if( !isEdit(ev) ) setKey( 'metaOn', true );
		// console.log('skeys.metaOn', skeys.metaOn)
	}
	if (!skeys.rOn && ev.keyCode == 82) {
		if( !isEdit(ev) ) setKey( 'rOn', true );
		// console.log('skeys.rOn', skeys.rOn)
	}
	if (!skeys.cOn && ev.keyCode == 67) {
		if( !isEdit(ev) ) setKey( 'cOn', true );
		// console.log('skeys.cOn', skeys.cOn)
	}
	if( !skeys.tabOn && ev.keyCode == 9 ) {
		// console.log( 'TAB' )
		// if( !isEdit(ev) ) 
		setKey( 'tabOn', true );
		ev.preventDefault();
		ev.stopPropagation();
		return false;
	}
	if (ev.keyCode == 114) {
		ev.preventDefault();
		return findAgain();
	}
	if (skeys.ctrlOn || skeys.metaOn) {
		// console.log('CTRL +', ev.keyCode, ev.key);
		if (ev.key == 'k' || ev.key == 'K') {
			saveClipboard(gPDF.plainText[currentPage - 1]);
			return ev.preventDefault();
		}
		if (ev.key == 'c' || ev.key == 'C') {
			if (selected) {
				// console.log('selected', selected)
				saveClipboard(tagFind(selected).text);
				return ev.preventDefault();
			}
		}
		if (ev.key == 'g' || ev.key == 'G') {
			ev.preventDefault();
			return findAgain();
		}

		if (ev.key == '=' || ev.key == '+') {
			zoomIn();
			return ev.preventDefault();
		}
		if (ev.key == 'f' || ev.key == 'F') {
			if (selected) $('#pdfsearch').val(tagFind(selected).text);
			$('#pdfsearch').focus();
			$('#sbtnsearch').click();
			if (!selected) {
				setTimeout(function () { $('#pdfsearch').focus(); }, 100)
			}
			return ev.preventDefault();
		}
		if (ev.key == '-' || ev.key == '_') {
			zoomOut();
			return ev.preventDefault();
		}
		if (ev.key == '0' || ev.key == ')') {
			setTimeout(zoomReset, 100);
			return;
			// return ev.preventDefault();
		}
		if (ev.key == 'ArrowRight') // arrow right
		{
			arrowPage(1);
			ev.preventDefault();
		}
		else if (ev.key == 'ArrowLeft') // arrow left
		{
			arrowPage(-1);
			ev.preventDefault();
		}
		else if (ev.key == ']') // move to the next tag
		{
			arrowTag(1);
			ev.preventDefault();
		}
		else if (ev.key == '[') // move to the prev tag
		{
			arrowTag(-1);
			ev.preventDefault();
		}
		else if (ev.key == '}') // move to the next with same type
		{
			arrowTag(1, 1);
			ev.preventDefault();
		}
		else if (ev.key == '{') // move to the prev with same type
		{
			arrowTag(-1, 1);
			ev.preventDefault();
		}
	}
	// if( skeys.altOn )
	// {
	// 	if( ev.keyCode == 39 ) // arrow right
	// 	{
	// 		arrowTag(1);
	// 		ev.preventDefault();
	// 	}
	// 	else if( ev.keyCode == 37 ) // arrow left
	// 	{
	// 		arrowTag(-1);
	// 		ev.preventDefault();
	// 	}
	// }
	// console.log( 'keyCode', ev.keyCode );
	if (!skeys.shiftOn && ev.shiftKey) {
		if ( isEdit(ev) ) return;
		setKey( 'shiftOn', true );
		// console.log('skeys.shiftOn', skeys.shiftOn)
	}
	if (hKeyPressed) return ev.preventDefault();

	if( !isEdit(ev) ) hotKeyPress(String.fromCharCode(ev.keyCode), 1);
}

function arrowPage(off)
{
	// console.log( 'arrowPage', off );
	function scrollBottom(){$('#maincolumn').scrollTop(10000000000000);}
	function scrollTop(){$('#maincolumn').scrollTop(0);}
	if( off > 0 )
	{
		if( currentPage < gPDF.numPages )
			drawPDF( gPDF, currentPage+1, globalZoom, scrollTop );

	}
	else if( off < 0 )
	{
		if( currentPage > 1 )
			drawPDF( gPDF, currentPage-1, globalZoom, scrollTop );
	}
}

function isAdj(o)
{
	if( showAdjudication && o.adj_forward ) return false;
	return (o && o.adj) || false;
}

var lastArrowSelect = null;
function arrowTag(off,same)
{
	// console.log( 'arrowTag', off, selected );
	var jumped = false;
	if( !selected ) selected = lastArrowSelect;



	if( !selected )
	{
		var r = null;
		for( var i = 0 ; i < rangeList.length ; i++ )
		{
			if( isAdj(rangeList[i]) ) continue;
			r = rangeList[i].id;
			if( rangeList[i].page >= currentPage ) break;
		}
		jumped = true;
		selected = r;
	}
	lastArrowSelect = selected;
	if( !selected ) return;
	var forceType = null;
	if( same )forceType = tagFind(selected).type;
	function show()
	{
		// console.log( 'currentTag', currentTag, idx );
		var id = rangeList[idx].id;
		var span = $('.cid_'+id);
		// console.log( 'span', span);
		// tagOut();
		selected = null;
		tagOut.apply(span[0]);
		tagOver.apply(span[0]);
		tagSelect(id);
		selectedPos();
	}
	var idx = -1;
	for( var i = 0 ; i < rangeList.length ; i++ )
		if( rangeList[i].id == selected )
		{
			idx = i;
			break;
		}
	if( off > 0 && !jumped )
	{
		idx++;
		while(
			idx < rangeList.length &&
			(
				isAdj(rangeList[i]) ||
				(forceType && forceType != rangeList[idx].type )
			)
		) idx++;
	}
	else if( off < 0 && idx > 0 )
	{
		idx--
		while(
			idx > 0 &&
			(
				isAdj(rangeList[i]) ||
				(forceType && forceType != rangeList[idx].type )
			)
		) idx--;
	}
	if( idx < 0 || idx >= rangeList.length || (forceType && forceType != rangeList[idx].type ) ) return;
	var currentTag = rangeList[idx].id;
	var tag = tagFind(currentTag);
	if( tag.page != currentPage )
	{
		drawPDF( gPDF, tag.page, globalZoom, show );
	}
	else show();
}


function keyup( ev )
{
    // console.log( 'keyup', ev.keyCode, ev.target.tagName, ev.target.contentEditable == 'true' )
	if( skeys.ctrlOn && !ev.ctrlKey )
	{
		setKey( 'ctrlOn', false );
		// console.log( 'skeys.ctrlOn', skeys.ctrlOn )
	}
	if( skeys.altOn && !ev.altKey )
	{
		setKey( 'altOn', false );
		// console.log( 'skeys.altOn', skeys.altOn )
		ev.preventDefault();
		ev.stopPropagation();

	}
	if( skeys.metaOn && !ev.metaKey )
	{
		setKey( 'metaOn', false );
		// console.log( 'skeys.metaOn', skeys.metaOn )
	}
	if (skeys.rOn && ev.keyCode == 82) {
		setKey( 'rOn', false );
		// console.log('skeys.rOn', skeys.rOn)
	}
	if (skeys.cOn && ev.keyCode == 67) {
		setKey( 'cOn', false );
		// console.log('skeys.cOn', skeys.cOn)
	}
	// if( ev.target.tagName == 'INPUT' || ev.target.tagName == 'TEXTAREA' ) return;

	if( skeys.shiftOn && !ev.shiftKey )
	{
		// console.log( 'shiftOff')
		setKey( 'shiftOn', false );
		// console.log( 'skeys.shiftOn', skeys.shiftOn )
	}


    if( ev.keyCode == 46 && !isEdit(ev) )
    {
		// if(over || selected) delRange( over || selected);
		if( selected ) {
			delRange( selected);
			boxUnselect();
			drawBoxes();
		}
		else if( selectedLink )
		{
			var tmp = selectedLink.split('-');
			// console.log( 'delLink', tmp )
			delLink(tmp[0],tmp[1],true);
		}
		else if( selectedBox !== null && !$('#myModal').is(':visible') ) delBox(selectedBox,7);
		drawText();
		drawBoxes();
    }
	if( !isEdit(ev) ) hotKeyPress(String.fromCharCode(ev.keyCode), 0);
}

function alfaColor( c )
{
	if( c.charAt(0) == '#' ) c = c.substr(1);
	c = c.substr(0,6);
	var a = showAdjudication ? 'ff' : '66';
	c = '#' + c + a;
	return c;
}

$(document.body).off('mousedown').on('mousedown',boxDn);
$(document.body).off('mouseup').on('mouseup',boxUp);
$(document.body).off('mousemove').on('mousemove',boxMv);


var adlPageYOffset = 0;

function rotateXY( x, y, cx, cy, an ) {
	x -= cx;
	y -= cy;
	let nx = x*Math.cos(an)-y*Math.sin(an)+cx;
	let ny = y*Math.cos(an)+x*Math.sin(an)+cy;
	x = nx;
	y = ny;
	return [x,y];
}

function page2Pdf(pageCoord, rbox, p1 )
{
	var boxLoc = canvasBox;
	var w = boxLoc.width*zoomValue;
	var h = boxLoc.height*zoomValue;
	var x = pageCoord.left-boxLoc.left;
	var y = pageCoord.top-boxLoc.top-adlPageYOffset;
	// console.log( 'pageCoord', pageCoord, boxLoc.top )
	x /= w;
	y /= h;
	if( rbox && rbox.rotate ) {
		// console.log( 'ROTATE', rbox, p1 )
		var an = -toRad(rbox.rotate);
		var cx = (p1.left+x)/2;
		var cy = (p1.top+y)/2;
		// [x,y] = rotateXY( x, y, )
		x -= cx;
		y -= cy;
		let nx = x*Math.cos(an)-y*Math.sin(an)+cx;
		let ny = y*Math.cos(an)+x*Math.sin(an)+cy;
		x = nx;
		y = ny;
	}
	x = Math.floor(x*boxLoc.width)/boxLoc.width;
	y = Math.floor(y*boxLoc.height)/boxLoc.height;
	var ret = {top:y,left:x};
	// console.log( ret );
	return ret;
}

function pdf2Page(pdfCoord)
{
	// var blayer = $('#box-layer');
	var boxLoc = canvasBox;
	var w = boxLoc.width/zoomValue;
	var h = boxLoc.height/zoomValue;
	var x = pdfCoord.left*w+boxLoc.left;
	var y = pdfCoord.top*h+boxLoc.top+adlPageYOffset;
	return {top:y,left:x};
}

function pdf2Box(pdfCoord)
{
	var boxLoc = drawPos;
	var w = boxLoc.width/zoomValue;
	var h = boxLoc.height/zoomValue;
	var x = pdfCoord.left*w;
	// var y = pdfCoord.top*h+120;
	var y = pdfCoord.top*h;
	return {top:y,left:x};
}



function page2Box(pageCoord)
{
	return pdf2Box(page2Pdf(pageCoord));
}

function evCoord(ev)
{
	// var ret = {top:(ev.pageY-drawPos.y)/zoomValue,left:(ev.pageX-drawPos.x)/zoomValue};
	var ret = {top:ev.pageY+$('#maincolumn').scrollTop(),left:ev.pageX+$('#maincolumn').scrollLeft()};
	// console.log( 'evCoord', ret );
	return ret;
}


var boxes = [];
var selectedBox = null;
var boxP1 = null;
var boxP2 = null;
var boxMode = 0;

function usingBoxes()
{
	return showBoxes || ocrMode;
}
window.usingBoxes = usingBoxes;

function boxTarget( el ) {
	// console.log( 'boxTarget', el )
	return $(el).hasClass('nlpbbox') || $(el).hasClass('nlpbbox-hook') || $(el).closest('.tool-button').length; 
	// return $(el).hasClass('nlpbbox') || $(el).hasClass('nlpbbox-hook'); 
}

function ocrTarget( el ) {
	return $(el).hasClass('c_ocr')
}




function popupTarget( el )
{
	return $(el).closest('.popup-list').length > 0;
}


var boxAdj = null;
var boxRotate = null;
var inputEdit = null;

function boxDn(ev)
{
	// console.log( 'boxDn')
	if( inputEdit ) {
		// console.log( 'INPUTEDIT', inputEdit );
		// alert(1)
		inputEdit.blur();

	}
	if( !hasBoxes || !usingBoxes() ) return;
	if( ev.button == 2 ) {
		boxUnselect();
		drawBoxes();
		return;
	}
	$(document.body).off('mousemove').on('mousemove',boxMv);

	// if( ocrMode && skeys.shiftOn ) return;
	if( $(ev.target).closest('.tool-button').length ) return;
	var isBox = boxTarget(ev.target);
	// console.log( 'ev.target', ev.target, isBox )
	// if( !isBox ) return;
	// console.log( 'isBox', isBox, showBoxes )
	if( !isBox && !showBoxes ) return;
	// console.log( 'AAAAAAAAAAAAA', ev.target )
	// if( ocrTarget( ev.target ) ) return;
	// console.log( 'BBBBBBBBBBBBB')
	// console.log( 'boxDn', ev, ev.target, $(ev.target).prop('id') );
	// if( $(ev.target).prop('id') == 'text-layer' || $(ev.target).hasClass('nlpbbox') || $(ev.target).hasClass('nlpbbox-hook'))
	if( $(ev.target).closest('#text-layer').length || isBox )
	{
		// console.log( 'xxxx')
		ev.preventDefault();
		boxP1 = boxP2 = page2Pdf(evCoord(ev));
		var s = inBox(boxP1);
		var dombox = $(ev.target).closest('.nlpbbox');
		if( $(ev.target).hasClass('nlpbbox-hook') ) {
			var bid = dombox.prop('bid');
			var corner = $(ev.target).prop('corner');
			// console.log( 'BID ev.target', ev.target, bid, 'corner', corner );
			s = {bid:bid,corner:corner}

			// s = boxes.find( b => b.bid == bid )
		}
		if( $(ev.target).hasClass('nlpbbox')  ) {
			var bid = dombox.prop('bid');
			s = {bid:bid,corner:-1}
		}
		if( $(ev.target).hasClass('pp') && showBoxes ) {
			var tid = $(ev.target).attr('tid')
			if( tid )
			return setTimeout( function(){
				tagSelect(tid);
			}, 200 );
		}
		// console.log( 'inBox1', s, ev.target );
		// s = boxex.find( b => b.bid == bid )
		if( !ocrMode ) tagUnselect();
		tableUnselect();
		linkUnselect();
		if( s === null )
		{
			boxesClearUnlabeled();
			var b = addBox( g_boxId++, currentPage, boxCoords(boxP1,boxP2), '' );
			selectedBox = b.idx;
			boxMode = 1;
			// console.log( 'addBox', boxP1, b.idx );
		}
		else
		{
			setTimeout( function(){
				// console.log( 'ssssssssssss', s )
				selectedBox = s.bid;
				// console.log( 'INBOX2', s )
				boxMode = 0;
				if( s.corner >= 0 )
				{
					// console.log( 's.corner', s.corner)
					popupOut();
					var b = boxFind(selectedBox);
					if( s.corner < 4 ) {
						boxMode = 1;
						boxP1.left = s.corner & 1 ? b.box[0] : b.box[2];
						boxP1.top = s.corner & 2 ? b.box[1] : b.box[3];
					}
					else if( s.corner > 3 ) {
						boxMode = 3;
						if( s.corner == 5 ) {
							boxAdj = {
								idx: 3,
								dim: 'top',
								box: clone(b.box),
							}
						}
						else if( s.corner == 6 ) {
							boxAdj = {
								idx: 0,
								dim: 'left',
								box: clone(b.box),
							}
						}
						else if( s.corner == 7 ) {
							boxAdj = {
								idx: 2,
								dim: 'left',
								box: clone(b.box),
							}
						}
						else if( s.corner == 4 ) {
							boxAdj = {
								idx: 1,
								dim: 'top',
								box: clone(b.box),
							}
						}						
					}
					if( s.corner == 8 ) {
						boxMode = 2;
						boxRotate = {
							rotate: b.rotate || 0,
							cx: (b.box[0]+b.box[2])/2,
							cy: (b.box[1]+b.box[3])/2,
						}
					} 
					// console.log( 'boxMode', boxMode )
				}
				else {
					if( s.overClose ) return delBox( selectedBox,8 );
					else if( s.overLabel ) setBoxLabel();
					var sbox = boxFind(selectedBox);
					if( sbox.tagId )
					{
						selected = sbox.tagId;
						// delBox( sbox.idx );
						adjustOCR( sbox.tagId, sbox.box );
						showPopup('labels',$('.cid_'+sbox.tagId), tagFind(sbox.tagId) );
					}
					else
						showPopup('boxes',$('#box_'+selectedBox), sbox );
				}
				drawBox( selectedBox );
			}, 100 );
		}
		// console.log( 'boxDn', ev, ev.target );
	}
	// ev.preventDefault();
	// ev.stopPropagation();
}

function toDeg( a ) { return a*180/Math.PI }
function toRad( a ) { return a*Math.PI/180 }

function boxAdjust(ev)
{
	if( selectedBox === null ) return;
	var box = boxFind( selectedBox );
	if( boxMode == 2 ) {
		var p = page2Pdf(evCoord(ev));
		var cx = (box.box[0]+box.box[2])/2;
		var cy = (box.box[1]+box.box[3])/2;
		var ang = Math.round(toDeg(-Math.atan2( cx-p.left, cy-p.top )))
		// console.log( 'rotate', p, cx, cy, toDeg(ang) )
		box.rotate = ang;
	} else if(boxMode == 1) {
		boxP2 = page2Pdf(evCoord(ev), box, boxP1);
		if( !box ) return;
		box.box = boxCoords( boxP1, boxP2);
		// console.log( 'boxAdjust', selectedBox )
		var sbox = boxFind(selectedBox);
		if( ocrMode && !showBoxes && !sbox.rawBox && !skeys.shiftOn ) {
			// console.log( 'boxAdjust', box.box, sbox.tagId, selectedBox, sbox.rawBox )
			selectRange = boundingBoxColideFindText(box.box)
			paintSelectBoundingBox();
		}
	}
	else if(boxMode == 3) {
		var p = page2Pdf(evCoord(ev), box, boxP1);
		if( !box ) return;
		var tmpBox = clone(boxAdj.box);
		tmpBox[boxAdj.idx] = p[boxAdj.dim];
		boxP1 = {left:tmpBox[0], top:tmpBox[1]}
		boxP2 = {left:tmpBox[2], top:tmpBox[3]}
		box.box = boxCoords( boxP1, boxP2);
		// console.log( 'boxAdjust', selectedBox )
		var sbox = boxFind(selectedBox);
		if( ocrMode && !showBoxes && !sbox.rawBox && !skeys.shiftOn ) {
			// console.log( 'boxAdjust', box.box, sbox.tagId, selectedBox, sbox.rawBox )
			selectRange = boundingBoxColideFindText(box.box)
			paintSelectBoundingBox();
		}
	}
	// console.log( boxes[selectedBox].box )
	return drawBox( selectedBox );
}

function boxUp(ev)
{
	// console.log( 'boxMode', boxMode, selectedBox, clone(boxes) )
	if( boxMode )
	{
		if( !boxAdjust(ev) && selectedBox !== null ) return delBox( selectedBox, 1 );
		boxMode = 0;
		if( blockEdit ) {
			blockEdit = false;
			delBox( selectedBox, 2 );
			boxUnselect();
			blockEdit = true;
			return locked();
		}
		ev.preventDefault();
		checkBoxLabel();
		setTimeout( function(){
			var sbox = boxFind(selectedBox);
			// console.log( 'SBOX', sbox.tagId, ocrMode )
			if( sbox && sbox.tagId && ocrMode )
			{
				selectRange = [];
				selected = sbox.tagId;
				// alert( 'box selected ' +selected)
				var tag = tagFind( sbox.tagId )
				// console.log( 'tag', tag )
				// adjustOCR( sbox.tagId, sbox.box );
				// showPopup('labels',$('.cid_'+sbox.tagId), tagFind(sbox.tagId) );
				tag.box = clone(sbox.box);
				if( sbox.rotate ) tag.rotate = sbox.rotate;
				else delete tag.rotate;
				adjustOCR( sbox.tagId, sbox.box, tag.rotate || 0)
				$('.tag_'+sbox.tagId).remove();
				drawTag(sbox.tagId)
				// console.log( 'linkcheck linkList', linkList )
				for( var l of linkList ) {
					// console.log( 'linkcheck aaaa')
					// console.log( 'linkcheck', l, l.id1, l.id2, sbox.tagId )
					if( l.i1.split('_')[0] == sbox.tagId || l.i2.split('_')[0] == sbox.tagId ) {
						// console.log( 'redraw link', l )
						$('.link_'+l.lid).remove();
						linkTag( l.i1, l.i2, l.relationship, l );
					}
				}
				selected = null;
				tagSelect(sbox.tagId)
				setTimeout( function(){
				}, 200 )
			}
			else {
				if( ocrMode ) {
					selectRange = [];

					// return;
				// }
				// else if( false && descriptor.comprehendMode ) {
				// 	alert(1)
					inputEdit = null;
					var newId = g_tagId++;
					var bb = sbox.box;
					if( bb[0] > 1 ) return;
					var tag = addOCR( [], newId, '', false, currentPage, null, bb, true );
					sortRange();
					sbox.rawBox = true;
					tag.rawBox = true;
					tag.text = '';
					if (tag.text || tag.textAdjust) tagSelect(newId);
					else {
						var message = $('<input>').prop('type', 'text').addClass('label-input').val(sbox.label);
						message.off('keyup').on('keyup', function (ev) {
							if (ev.keyCode == 13) $("#modal-close").click();
						})
						// console.log('tag', tag, 'boxes', clone(boxes))
						// myAlert( 'Box Text', message, "Set text", function(){
						// 	tag.textAdjust = $('.label-input').val().trim();
						// 	if( tag.textAdjust ) tagSelect( newId );
						// 	return true;
						// });
						// setKey('altOn',0)
						tagSelect(newId);
						// console.log('tag2', tag, 'boxes', clone(boxes))
						setTimeout(function () {
							try {
								$('.tag-text-area')[0].focus();
							} catch (e) { }
						}, 600)
					}
					return;
				}
				showPopup('boxes',$('#box_'+selectedBox), sbox );
			}
		}, 100 );
		// rightFocus('boxeskeys');
		changed();

	}
	// console.log( 'boxUp', ev, page2Pdf(evCoord(ev)) );
}

function boxMv(ev)
{
	// console.log( 'move', boxOver, boxMode );
	if( boxOver ) return;
	if( boxMode )
	{
		boxAdjust(ev);
		ev.preventDefault();
	}
	if( !usingBoxes() || showAdjudication )
	{
		// $('.nlpbbox').hide();
		// if( selectedBox !== null ) $('#box_'+selectedBox).show();
		// var s = inBox(page2Pdf(evCoord(ev)));
		// if( s && !$('.popup-list').length )
		// {
		// 	$('#box_'+s.bid).show();
		// }
	}
}

function boxFind( id ) {
	return boxes.find(b => b.idx == id );
}

function setBoxLabel()
{
	if( selectedBox === null ) return;
	var sbox = boxFind( selectedBox );
	if( boxesLabels ) return;
	if( oocrMode ) {
		return;
	} 
	var message = $('<input>').prop('type','text').addClass('label-input').val(sbox.label);
	message.off('keyup').on('keyup', function(ev){
		if( ev.keyCode == 13 ) $("#modal-close").click();
	})
	frm.myAlert( 'Box Label', message, "Set Label", function(){
		sbox.label = $('.label-input').val();
		drawBox(selectedBox);
		if( selectedBox !== null && sbox.label == '' || sbox.label == 'tmp' ) return false;
		return true;
	});
	setTimeout( function(){ $('.label-input').select(); }, 500 );
}

function checkBoxLabel()
{
	if( descriptor.comprehendMode ) return;
	if( selectedBox === null ) return;
	var obox = boxFind( selectedBox );
	if( obox.label == '' || obox.label == 'tmp' )
			setBoxLabel();
}

function inBox(pdfCoord)
{
	if( skeys.shiftOn ) return null;
	var area = 0;
	var ret = null;
	// console.log( 'inBox', boxes )
	for( var i = 0 ; i < boxes.length ; i++ )
	{
		var b = boxes[i];
		// b.idx = i;
		if( b.page == currentPage &&
			pdfCoord.left >= b.box[0] &&
			pdfCoord.left <= b.box[2] &&
			pdfCoord.top >= b.box[1] &&
			pdfCoord.top <= b.box[3] )
		{
			var pb = pdf2Box(pdfCoord);
			var b1 = pdf2Box({left:b.box[0],top:b.box[1]});
			var b2 = pdf2Box({left:b.box[2],top:b.box[3]});
			var ct = 0;
			var pos = 0;
			var dist = 15;
			if( pb.left-b1.left < dist ){ ct++ };
			if( b2.left-pb.left < dist ){ ct++; pos |= 1 };
			if( pb.top-b1.top < dist ){ ct++ };
			if( b2.top-pb.top < dist ){ ct++; pos |= 2 };
			if( ct < 2 ) pos = -1;
			// console.log( 'overlabel', pb, b.labelRect );

			var labelRect = getRect(b.labelObj);
			var overLabel = labelRect &&
							pb.top >= labelRect.top &&
							pb.left >= labelRect.left &&
							pb.top <= labelRect.top+labelRect.height &&
							pb.left <= labelRect.left+labelRect.width;
			var overClose = null;
			if( overLabel )
			{
				var closeRect = getRect(b.closeObj);
				var overClose = closeRect &&
								pb.top >= closeRect.top &&
								pb.left >= closeRect.left &&
								pb.top <= closeRect.top+closeRect.height &&
								pb.left <= closeRect.left+closeRect.width;
			}
			var a = (b.box[2]-b.box[0])*(b.box[3]-b.box[1]);
			if( !area || a < area )
			{
				area = a;
				ret = {bid:b.idx,corner:pos,overLabel:overLabel,overClose: overClose};
			}
		}
	}
	return ret;
}

function boxCoords( p1, p2 )
{
	if( p1.left < p2.left )
	{
		var x1 = p1.left;
		var x2 = p2.left;
	}
	else {
		var x1 = p2.left;
		var x2 = p1.left;
	}
	if( p1.top < p2.top )
	{
		var y1 = p1.top;
		var y2 = p2.top;
	}
	else {
		var y1 = p2.top;
		var y2 = p1.top;
	}
	return [x1,y1,x2,y2];
}

function drawBoxes()
{
	boxes.forEach( (b,idx) => {
		if( !b.idx ) b.idx = idx+1;
		if( g_boxId <= b.idx ) g_boxId = b.idx+1;
	})
	// console.log( 'drawBoxes')
	clearUsed($('#boxeskeys'));
	$('.nlpbbox').remove();
	for( var i = 0 ; i < boxes.length ; i++ )
	{
		if( !('idx' in boxes[i]) ) boxes[i].idx = i;
		drawBox( boxes[i].idx );
	}
	drawUsed($('#boxeskeys'));
}

function getRect( o )
{
	if( !$(o).length ) return null;
	var l = $(o)[0].getBoundingClientRect();
	var rect = page2Box( l );
	rect.width = l.width;
	rect.height = l.height;
	if( !rect.width && !rect.height ) return null;
	return rect;
}

function drawBox( id )
{
	// console.log( 'drawBox', id, zoomValue )
	var invZoom = 1/zoomValue;
	var bid = 'box_' + id;
	$('#'+bid).remove();
	$('.nlpbbox-selected').removeClass('nlpbbox-selected');
	var obox =  boxFind( id );
	var box = obox.box;
	var label = obox.label;
	var page = obox.page;
	if( page != currentPage ) return;
	var p1 = pdf2Box({left:box[0],top:box[1]});
	var p2 = pdf2Box({left:box[2],top:box[3]});
	// [p1,p2] = fromZoom( p1, p2 )
	var left = p1.left;
	var top = p1.top;
	var width = p2.left-p1.left;
	var height = p2.top-p1.top;
	var cx = ((p1.left+p2.left)/2);
	var cy = ((p1.top+p2.top)/2);
	var ow = width;
	var oh = height;
	width *= zoomValue;
	height *= zoomValue;
	left += (ow-width)/2;
	top += (oh-height)/2;

	if( width < 5 && height < 5 ) return null;
	// console.log( 'drawBox', id, label )
	var color = boxesLabels ? findColor(label) : 'red';
	if( color == tagDefaultColor ) color = 'red';
	if( obox.color ) color = obox.color;
	// console.log( 'color', label, color, tagDefaultColor)
	var css = {left:px(left*zoomValue),top:px(top*zoomValue),width:px(width*zoomValue),height:px(height*zoomValue),borderColor: color};
	// console.log( 'CSS', css );


	

	var hookColor = color;
	var hookBgColor = 'transparent';
	var hookBgColor = color;
	
	if( descriptor.comprehendMode && !ocrMode ) hookColor = 'rgba( 255, 0, 0, 0.01 )';


	setUsed($('#boxeskeys'), label );
	var slabel = simplify(label);

	var rot = obox.rotate || 0;
	css.transform = 'scale('+invZoom+') rotate('+rot+'deg)'
	var b = $('<DIV>').prop('id',bid).prop('bid',id).addClass('nlpbbox').addClass('nlpbbox_'+slabel);
	b.css(css);
	var hookWidth = 8;
	var rotateHeight = 30;
	var hookW2 = hookWidth/(2);
	var wh = height;
	b.append($('<DIV>').addClass('nlpbbox-hook nlpbbox-hook-tl').prop('corner',0).css({top:px(-hookW2),left:px(-hookW2),borderColor: hookColor, backgroundColor: hookBgColor}));
	b.append($('<DIV>').addClass('nlpbbox-hook nlpbbox-hook-tr').prop('corner',1).css({top:px(-hookW2),right:px(-hookW2),borderColor: hookColor, backgroundColor: hookBgColor}));
	b.append($('<DIV>').addClass('nlpbbox-hook nlpbbox-hook-bl').prop('corner',2).css({bottom:px(-hookW2),left:px(-hookW2),borderColor: hookColor, backgroundColor: hookBgColor}));
	b.append($('<DIV>').addClass('nlpbbox-hook nlpbbox-hook-br').prop('corner',3).css({bottom:px(-hookW2),right:px(-hookW2),borderColor: hookColor, backgroundColor: hookBgColor}));

	if( descriptor.allowBoxRotation ) {
		b.append($('<DIV>').addClass('nlpbbox-line-rot').css({top:px(-rotateHeight),left:px(width*zoomValue/2-1),height:px(rotateHeight), borderColor: hookColor}));
		// b.append($('<DIV>').addClass('nlpbbox-hook nlpbbox-hook-rot').prop('corner',4).css({top:px(-hookW2-rotateHeight),left:px(-hookW2+width*zoomValue/2),color: hookColor,borderColor: hookColor, backgroundColor: hookBgColor}).html('<i class="fa fa-rotate-right no-click"></i>'));
		b.append($('<DIV>').addClass('nlpbbox-hook nlpbbox-hook-rot').prop('corner',8).css({top:px(-hookW2-rotateHeight),left:px(-hookW2+width*zoomValue/2),color: hookColor,borderColor: hookColor, backgroundColor: hookBgColor}));
	}

	b.append($('<DIV>').addClass('nlpbbox-hook nlpbbox-hook-updn').prop('corner',4).css({top:px(-hookW2),left:px(-hookW2+width*zoomValue/2),color: hookColor,borderColor: hookColor, backgroundColor: hookBgColor}));
	b.append($('<DIV>').addClass('nlpbbox-hook nlpbbox-hook-updn').prop('corner',5).css({bottom:px(-hookW2),left:px(-hookW2+width*zoomValue/2),color: hookColor,borderColor: hookColor, backgroundColor: hookBgColor}));

	b.append($('<DIV>').addClass('nlpbbox-hook nlpbbox-hook-side').prop('corner',6).css({top:px(-hookW2+wh*zoomValue/2),left:px(-hookW2),color: hookColor,borderColor: hookColor, backgroundColor: hookBgColor}));

	b.append($('<DIV>').addClass('nlpbbox-hook nlpbbox-hook-side').prop('corner',7).css({top:px(-hookW2+wh*zoomValue/2),right:px(-hookW2),color: hookColor,borderColor: hookColor, backgroundColor: hookBgColor}));


	var olabel = $('<DIV>').addClass('nlpbbox-label')
	.css({bottom:px(0),left:px(10),backgroundColor: color})
	.html(label);
	olabel.hide(); /// hide label
	b.append(olabel);
	if( label == '' ) olabel.hide();
	var xis = $('<div>').addClass('tag_box_close').html(closeIcon);
	olabel.append(xis);
	
	b.on('contextmenu', ignoreRightClick );

	if( obox.idx == selectedBox ) b.addClass('nlpbbox-selected');
	else if( !usingBoxes() ) b.hide();
	$('#box-layer').append(b);
	// calculate label rect based on box coordinates
	obox.labelObj = olabel;
	obox.closeObj = xis;


	// $('.nlpbbox').css({borderWidth:0.1})
	return true;
}

function delBox( id, num )
{
	if( !defined(id) || id === null ) return;
	// console.log( 'delBoxx ', id, num )
	if( blockEdit ) return locked();

	// if( ocrMode ) {
	// 	console.trace( 'delboxxxxxxxx', rangeList.find( r => r.id == id ) )
	// 	if( !rangeList.find( r => r.id == id ) )
	// 	$('[tid='+id+']').remove();
	// }

	changed();
	popupOut();

	var bid = 'box_' + id;
	$('#'+bid).remove();

	var idx = boxes.findIndex( b => b.idx == id );
	if( idx < 0 ) return;
	boxes.splice(idx,1);
	if( id === selectedBox ) selectedBox = null;
	drawBoxes();
	return true;
}

function boxesClearUnlabeled()
{
	// console.trace( 'CLEAR' );
	for( var i = boxes.length-1 ; i >= 0 ; i-- ) if( boxes[i].label == '' ) {
		delBox(boxes[i].idx, 4);
	}
}

function boxUnselect()
{
	boxesClearUnlabeled();
	tagDownOff();
	if( selectedBox === null ) return;
	$('.nlpbbox-selected').removeClass('nlpbbox-selected');
	selectedBox = null;
	selectScroll();
}

var selectScrollTid = null;
function selectScroll()
{
	clearTimeout( selectScrollTid );
	selectScrollTid = setTimeout( function(){
		if( !selected && !selectedBox && !selectedLink )
		{
			// rightFocus('submit');
		}
	},500 );
}

var g_boxId = 1;
function addBox( id, page, box, label )
{
	var b = {page:page,idx:id,box:box,label:label};
	boxes.push( b );
	return b;
}

var alignError = 0;
var alignErrCt = 0;
var alignCt = 0;
var alignTexts = [];

function alignCheckTag( tag, retry )
{
	if( descriptor.noRealign || descriptor.selectBoundingBox ) return;
	// if( !engine2() ) return;
	// var comp = gPDF.plainText[tag.page-1];
	var ptext = gPDF.plainText[tag.page-1];
	var tobj = gPDF.textContent[tag.page-1];
	var comp = alignTexts[tag.page-1].txt;
	var pos = alignTexts[tag.page-1].offsets;
	var offset = 0;
	var found = [];
	if( comp )
	{
		var atxt = ptext.substring(tag.range[0],tag.range[1]);
		if( atxt == tag.text ) return;
		// console.log( 'disaligned tag', tag.text, 'page', tag.page, '->', atxt );
		// find all matches and get offsets
		var text = tag.text.replace(/ /g,'');
		var i = 0;
		var offset = 0;
		while( i++ < 500 )
		{
			var m = comp.indexOf(text);
			if( m == -1 ) break;
			// console.log( 'match', comp.length, m );
			found.push({text:text,offset:offset+m, o1: pos[offset+m], o2: pos[offset+m+text.length-1]+1});
			offset += m + text.length;
			comp = comp.substr(m + text.length);
		}
	}
	// console.log( 'TEXT', text, found, tag.range, alignError, tag.box )
	if( !found.length )
	{
		var recover = [
			['...','…'],
		]
		if( !retry ) retry = 0;
		if( retry < recover.length )
		{
			var rvr = recover[retry];
			if( !tag.otext ) tag.otext = tag.text;
			while( 1 )
			{
				if( tag.text.indexOf(rvr[0]) == -1 ) break;
				tag.text = tag.text.replace(rvr[0],rvr[1]);
			}
			// console.log( 'RECOVER', rvr, retry, tag.text );
			return alignCheckTag( tag, retry+1 );
		}
		alignErrCt++;
		tag.ignore = true;
		return console.error( 'Irrecoverable alignment on tag', tag.id, 'page', tag.page, JSON.stringify(tag.otext) );
	}
	// find the closest match
	var best = null;
	var min = 10000000;
	for( var i = 0 ; i < found.length ; i++ )
	{
		if( tag.box && engine2() )
		{
			var fo = tobj[found[i].o1];
			var dx = fo[1]-tag.box[0];
			var dy = fo[2]-tag.box[1];
			var diff = Math.sqrt(dx*dx+dy*dy);
			// console.log( 'diffbox', text, i, 'off', found[i].o1, diff, min );
		}
		else
			var diff = Math.abs((tag.range[0]+alignError)-found[i].o1);
		if( diff < min )
		{
			min = diff;
			best = found[i];
			// console.log( '----------------- best', clone(best));
		}
	}
	alignError = tag.range[0]-best.offset;
	// tag.text = best.text;
	tag.text = ptext.substr(best.o1,best.o2-best.o1);
	tag.range = [best.o1,best.o2];
	// console.log( 'Input tag realigned', tag.id, 'page', tag.page, JSON.stringify(tag.text), 'offset adjust', alignError );
	alignCt++;
}


function alignCheck( pdf )
{
	try {
		alignTexts = [];
		pdf.plainText.forEach( p => alignTexts.push( noSpaceText(p)));
		var tags = descriptor.text_attributes.tags;
		var links = descriptor.text_attributes.links;
		if( !tags ) tags = [];
		if( !links ) links = [];
		links.forEach( l => { l.id1 = l.id1.toString(); l.id2 = l.id2.toString()});
		var lastPage = -1;
		tags.forEach( t => {
			if( t.page != lastPage ) { lastPage = t.page; alignError = 0; }
			t.id = t.id.toString();
			alignCheckTag(t)
		});
		if( !descriptor.adjudication_attributes ) return;
		var tags = descriptor.adjudication_attributes.tags;
		var links = descriptor.adjudication_attributes.links;
		if( !tags ) tags = [];
		if( !links ) links = [];
		links.forEach( l => { l.id1 = l.id1.toString(); l.id2 = l.id2.toString()});
		var lastPage = -1;
		tags.forEach( t => {
			if( t.page != lastPage ) { lastPage = t.page; alignError = 0; }
			t.id = t.id.toString();
			alignCheckTag(t)
		});
	} catch(e) { console.error('alignCheck',e)}
}

function noSpaceText( t )
{
	var tmp = t.split('');
	var txt = [];
	var off = [];
	tmp.forEach( (t,i) => {
		if( t == ' ' ) return;
		txt.push(t);
		off.push(i);
	});
	return {txt:txt.join(''),offsets:off};
}


// function alignCheckTag( tag )
// {
// 	if( descriptor.noRealign ) return;
// 	var comp = gPDF.plainText[tag.page-1];
// 	var offset = 0;
// 	var found = [];
// 	if( comp )
// 	{
// 		var atxt = comp.substring(tag.range[0],tag.range[1]);
// 		if( atxt == tag.text ) return;
// 		// console.log( 'disaligned tag', tag.text, 'page', tag.page, '->', atxt );
// 		// find all matches and get offsets
// 		var reg = decodeEntities(tag.text)
// 		var m = null;
// 		var clist = reg.match(/[^a-z0-9 \\]/gi);
// 		if( clist )
// 		{
// 			var cl = {};
// 			clist.forEach( c => cl[c] = 1 );
// 			clist = Object.keys(cl);
// 			reg = reg.split('\\').join('\\\\');
// 			clist.forEach( c => {
// 				reg = reg.split(c).join('\\'+c);
// 			})
// 			// console.log( 'clist', clist, reg );
// 		}
// 		reg = reg.replace(/ /g, " *");
// 		reg = new RegExp(reg);
// 		var i = 0;
// 		while( i++ < 10 )
// 		{
// 			var m = comp.match(reg);
// 			if( !m ) break;
// 			// console.log( 'match', comp.length, m );
// 			found.push({text:m[0],offset:offset+m.index});
// 			offset += m.index + m[0].length;
// 			comp = comp.substr(m.index + m[0].length);
// 		}
// 	}
// 	if( !found.length )
// 	{
// 		alignErrCt++;
// 		return console.error( 'Irrecoverable alignment on tag', tag.id, 'page', tag.page, JSON.stringify(tag.text) );
// 	}
// 	// find the closest match
// 	var best = null;
// 	var min = 10000000;
// 	for( var i = 0 ; i < found.length ; i++ )
// 	{
// 		var diff = Math.abs((tag.range[0]+alignError)-found[i].offset);
// 		if( diff < min )
// 		{
// 			min = diff;
// 			best = found[i];
// 		}
// 	}
// 	alignError = tag.range[0]-best.offset;
// 	tag.text = best.text;
// 	tag.range = [best.offset,best.offset+best.text.length];
// 	console.log( 'Input tag realigned', tag.id, 'page', tag.page, JSON.stringify(tag.text), 'offset adjust', alignError );
// 	alignCt++;
// }
//
//
// function alignCheck()
// {
// 	var tags = descriptor.text_attributes.tags;
// 	var links = descriptor.text_attributes.links;
// 	if( !tags ) tags = [];
// 	if( !links ) links = [];
// 	links.forEach( l => { l.id1 = l.id1.toString(); l.id2 = l.id2.toString()});
// 	tags.forEach( t => {
// 		t.id = t.id.toString();
// 		alignCheckTag(t)
// 	});
// 	if( !descriptor.adjudication_attributes ) return;
// 	var tags = descriptor.adjudication_attributes.tags;
// 	var links = descriptor.adjudication_attributes.links;
// 	if( !tags ) tags = [];
// 	if( !links ) links = [];
// 	links.forEach( l => { l.id1 = l.id1.toString(); l.id2 = l.id2.toString()});
// 	tags.forEach( t => { t.id = t.id.toString(); alignCheckTag(t) });
// }



var optim = 1;

var layerW, layerH;
function layersOut()
{
	if( !optim ) return;
	layerW = txtObjWidth();
	layerH = txtObjHeight();
	txtObjAdj.remove();
	txtObj.remove();
	if( htmlTextMode )
	{
		txtObj.css({width:layerW,height:layerH});
		txtObjAdj.css({width:layerW,height:layerH});
	}
}

function layersIn()
{
	if( !optim ) return;
	$('#maincolumn').append(txtObjAdj);
	$('#maincolumn').append(txtObj);
	txtObjAdj.addClass('out-layer');
	txtObj.addClass('out-layer');
	txtObj.css({width:layerW,height:layerH});
	txtObjAdj.css({width:layerW,height:layerH});
}

function layersBack()
{
	txtObjAdj.removeClass('out-layer');
	txtObj.removeClass('out-layer');
	txtObj.css({width:layerW,height:layerH});
	txtObjAdj.css({width:layerW,height:layerH});
}

function disableLayer()
{
	try {
		$('#maincolumn')[0].removeChild(txtObj[0]);
	}
	catch(e){}
}

function enableLayer()
{
	$('#maincolumn')[0].appendChild(txtObj[0])
}

function listRanges() {
	return rangeList;
}

function listLinks() {
	return linkList;
}

function listBoxes() {
	return boxes;
}

function listQuestions() {
	return questionList;
}


function clearAnnotations() {
	rangeList.splice(0,1000)
	linkList.splice(0,1000)
	tableList.splice(0,1000)
	boxes.splice(0,1000);
	changed();
}

window.listRanges = listRanges;
window.listLinks = listLinks;
window.listBoxes = listBoxes;
window.listQuestions = listQuestions;

window.exportData = exportData;
window.clearAnnotations = clearAnnotations;

var txtObjMarginTop = 0;
var boxLayerMaringTop = 0;

function setTxt( tags, links )
{
	// console.log( 'SETTXT ---------------------------------------------------', tcount(1) )
    if( !tags ) tags = [];

	rangeChanged = true;
	rangeList = tags;
	tableList = tableList || descriptor.text_attributes.tables || [];
	if( descriptor.ocrTableMode ) {
		addDescriptorLabel( 'TABLEHEADER', false, {type:'table',attribute:true});
		addDescriptorLabel( 'TABLECELL', false, {type:'table',placeholder:true});
	}


	mergeRange(tags,links);

	// console.log( 'RANGES1', clone(rangeList))


	if( engine2() || htmlTextMode )
	{
		$('#text-layer').addClass('unselectable');
		$('#text-layer-adj').addClass('unselectable');
	}
	if( !$('#text-layer').length ) return;
	txtObj = $('#text-layer');
	// console.log( 'rrrrrrrrrrrrrrrrrrrrrrrrrrrrr', $('#text-layer')[0] )
	drawPos = $('#text-layer')[0].getBoundingClientRect()
	txtObjMarginTop = parseInt(txtObj.css('margin-top')) || 0;
	boxLayerMaringTop = parseInt($('#box-layer').css('margin-top')) || 0;


	// console.log( 'txtObj', txtObjWidth(), txtObjHeight())
	if( showAdjudication )
	{
		txtObjAdj.remove();
		txtObjAdj = txtObj.clone();
		var spans = txtObjAdj.find('span');
		if( engine2() || htmlTextMode )
		{
			for( var i = 0 ; i < spans.length ; i++ )
			{
				$(spans[i]).attr('o1', i );
				$(spans[i]).attr('o2', i+1 );
			}
		}
		else {
			for( var i = 0 ; i < spans.length ; i++ )
			{
				var item = gPDF.textContent[currentPage-1].items[i];
				$(spans[i]).attr('o1', item.textOffset );
				$(spans[i]).attr('o2', item.textOffset+item.str.length );
			}
		}
		txtObjAdj.prop('id','text-layer-adj').insertBefore(txtObj);
		// txtObjAdj.find('.pdf_text').addClass('adj_text');
	}
	else {
		txtObjAdj.remove();
		txtObjAdj = $('<DIV>').prop('id','text-layer-adj').insertBefore(txtObj);
	}
	// txtObjAdj.addClass('.text-layer-adj');
	// txtObj.addClass('.text-layer');
    txtTags = tags;
    initColors();
	

	layersOut();
    tList = getText( txtObj );
	tListAdj = getText( txtObjAdj );
	fixComprehend( origPlumber, comprehendPlumbData, rangeList );



	if (oocrMode) {
		disableSort = true;
		var rlist = clone(rangeList);
		rangeList.splice(0, 100000000000000);
		rlist.forEach(function (t, idx) {
			if ((t.adj && !showAdjudication) || (t.page != currentPage)) {
				rangeList[idx] = t;
				return;
			}
			if (t.ignore) return;
			if (!('id' in t) || t.id === null || !defined(t.id)) {
				console.error('tag without id', t.range, t.text, ' the initial value must have a unique id');
				return;
			}
			var text = t.textAdjust || t.text;
			var nt = addOCR(t.range, t.id, t.type, t.adj, t.page, t.properties, t.box, t.rawBox || null);
			nt.text = text;
			nt.table = t.table;
			rangeList[idx] = nt;
			// t.box = tagBox(t.id)
		});
		for (var i = rangeList.length - 1; i >= 0; i--) if (!rangeList[i]) rangeList.splice(i, 1);
		boxes = [];
		drawBoxes();
		disableSort = false;
	}
    else if (ocrMode) {
		disableSort = true;
		var rlist = clone(rangeList);
		rangeList.splice(0, 100000000000000);
		rlist.forEach(function (t, idx) {
			if( t.rawBox ) t.range = [];
			else {
				if( (!t.range || t.range[0] === null) && t.blocks ) {
					// recover the missing range based on the blocks field
					t.range = [];
					let tcont = gPDF.textContent[t.page-1]
					for( let i = 0 ; i < tcont.length ; i++ ) {
						if( tcont[i][8] >= 0 && t.blocks.indexOf( tcont[i][8] ) >= 0 )
							t.range.push( i );
					}
				}

			}
			if ((t.adj && !showAdjudication) || (t.page != currentPage)) {
				rangeList[idx] = t;
				return;
			}
			if (t.adj && !showAdjudication) return;
			if (t.page != currentPage) return;
			if (t.ignore) return;
			if (!('id' in t) || t.id === null || !defined(t.id)) {
				console.error('tag without id', t.range, t.text, ' the initial value must have a unique id');
				return;
			}
			// console.log( 'SPLITDEB TID', t.id, t.range, t )
			if (t.id >= g_tagId) g_tagId = t.id + 1;
			if( t.range.length ) {
				// console.log( 'add splitRange', t.range, t.id, t.type, t.adj, t.page);
				rangeList[idx] = splitRange(t.range, t.id, t.type, t.adj, t.page);
			}
			else {
				var text = t.textAdjust || t.text;
				// console.log( 'addOCR', t.range, t.id, t.type, t.adj, t.page, t.properties, t.box, true );
				var nt = addOCR(t.range, t.id, t.type, t.adj, t.page, t.properties, t.box, true );
				nt.text = text;
				nt.table = t.table;
				rangeList[idx] = nt;
			}
			setBox( rangeList[idx] )
			if( t.rotate ) adjustOCR( t.id, t.box, t.rotate )
			for( var v in t ) {
				if( v != 'id' ) rangeList[idx][v] = t[v];
			}
			// if (t.table) rangeList[idx].table = t.table;
			// rangeList[idx].properties = t.properties;
			// t.box = tagBox(t.id)
		});
		for (var i = rangeList.length - 1; i >= 0; i--) if (!rangeList[i]) rangeList.splice(i, 1);
		boxes = [];
		drawBoxes();
		disableSort = false;
	}
	else {
		var rlist = clone(rangeList);
		rangeList.splice(0, 100000000000000);
		rlist.forEach(function (t, idx) {
			if ((t.adj && !showAdjudication) || (t.page != currentPage)) {
				rangeList[idx] = t;
				return;
			}
			if (t.adj && !showAdjudication) return;
			if (t.page != currentPage) return;
			if (t.ignore) return;
			if (!('id' in t) || t.id === null || !defined(t.id)) {
				console.error('tag without id', t.range, t.text, ' the initial value must have a unique id');
				return;
			}
			// console.log( 'TID', t.id )
			if (t.id >= g_tagId) g_tagId = t.id + 1;
			if( t.range.length ) {
				rangeList[idx] = splitRange(t.range, t.id, t.type, t.adj, t.page);
			}
			for( var v in t ) {
				if( v != 'id' ) rangeList[idx][v] = t[v];
			}
			// if (t.table) rangeList[idx].table = t.table;
			// rangeList[idx].properties = t.properties;
			// t.box = tagBox(t.id)
		});
	}
	for( var i = rangeList.length ; i >= 0 ; i-- ) {
		if( !rangeList[i] ) rangeList.splice(i,1);
	}
	// console.log( 'RANGES', clone(rangeList))
	layersIn();
	// console.log( 'txtObj', txtObjWidth(), txtObjHeight())
	rangeList.forEach( function(t){
		t.box = tagBox(t.id)
	});
	layersOut();

	if( rangeList.length )
	{
		linkList = [];
		links.forEach( function(l){
			addLink( l.page, l.id1, l.id2, l.relationship, l.adj, l );
		});
	}

	// return;
	// if( rangeList[0] ) console.log( 'AAAAAAAAAAAAAAAAAAAAAAAAa', rangeList[0].blocks )

	fixRanges();
	cleanDuplicateAdjudication();
	//

    // // console.log( tList );
    sortRange();
	// return;
    drawText();
	// console.log( 'SETTXT END -----------------------------------------------', tcount() )
	layersIn();
	setMouse();
	tagOut(1);
	layersBack();
	$('.c_tag').off('mouseover').on('mouseover', tagOver );
	$('.c_tag').off('mouseout').on('mouseout', tagOut );
	$('.link_close').off('click').on('click', linkDel );
	$('.link_label').off('mouseover').on('mouseover', linkOver );
	$('.link_label').off('mouseout').on('mouseout', linkOut );
	$('.link_label').off('mouseup').on('mouseup', linkClick );
	if( usingBoxes() ) drawBoxes();
	if( gPDF && tableList && tableList.length ) {
		for( var tab of tableList ) {
			// console.log( 'TABLE', tab.page, currentPage )
			if( tab.id >= tabId ) tabId = tab.id+1;
			if( tab.page == currentPage ) {
				// console.log( 'TABLEDRAW', tab )
				drawTable( tab )
			} 
		}
	}
	ocrLinks()
}

function calcLineTop( line )
{
    return line*lineHeight + lineHeight/2 - fontSize - 20;
}


var ocrLinkTid = null;
function ocrLinks() {
	if( !ocrMode ) return;
	// return; 
	if( descriptor.disableAutoKeyPairLinking ) return;

	clearTimeout( ocrLinkTid );
	ocrLinkTid = setTimeout( function(){
		var keys = {};
		var values = {};
		var single = {};
	
		function push( o, k, v )
		{
			if( !o[k] ) o[k] = [v];
			else o[k].push(v);
		}
		function canLink( a, b ) {
			if( linked[a] || linked[b] ) return false;
			// console.log( 'canLink', a+'_'+b, userDelLink[a+'-'+b], userDelLink[a+'-'+b] != 1, 'linked', linked[a], linked[b], clone(linked) )
			return userDelLink[a+'-'+b] != 1;
		}
		function dist( a, b ) {
			var ta = tagFind(a);
			var tb = tagFind(b);
			var dx = Math.abs(((ta.box[0]+ta.box[2])/2)-((tb.box[0]+tb.box[2])/2))
			var dy = Math.abs(((ta.box[1]+ta.box[3])/2)-((tb.box[1]+tb.box[3])/2))
			var dist = Math.sqrt(dx*dx+dy*dy);
			var a45 = Math.PI/4;
			var da = 1-Math.abs(Math.atan2( dx, dy) - a45)/a45;
			dist *= da;
			// console.log('DIST', a, b, dist, da )
			return dist;
		}
		
		for( var r of rangeList ) {
			if( !r.properties ) continue;
			r.kstype = {};
			for( var p of r.properties ) {
	
				var [lab,type] = keysetType(p);
				r.kstype = type;
				if( type == 'KEY' ) push(keys, lab, r.id)
				else if( type == 'VAL' ) push(values, lab, r.id)
				else push(single, lab, r.id)
			}
		}
		function linkParam( i ) {
			var nl = [null,null,null,null];
			var [i1, k1] = i.split('_');
			var r = rangeList.find( r => r.id == i1 );
			if( !r ) return nl;
			var p = r.properties.find( p => simplify(p) == k1 );
			if( !p ) return nl;
			var [kl,kt] = keysetType(p);
			return [i1,kl,kt]
		}
		function setLinked( i ) {
			// console.log( 'setLinked', i )
			if( !linked[i] ) linked[i] = 1;
			else linked[i]++;
		}
		function unsetLinked( i ) {
			// console.log( 'unsetLinked', i )
			if( linked[i] ) linked[i]--;
		}
		function checkLinked( i ) {
			// console.log( 'checkLinked', i, linked[i] > 0 )
			return linked[i] > 0;
		}
		var dlink = [];
		var ilink = [];
		var linked = {};
		// clean invalid links
		for( var l of linkList ) {
			var [i1,label1,type1] = linkParam(l.i1);
			var [i2,label2,type2] = linkParam(l.i2);
			setLinked(l.i1);
			setLinked(l.i2);
			if( label1 != label2 ) dlink.push( l );
			if( type1 == type2 ) dlink.push( l )
			if( type1 == 'VAL' && type2 == 'KEY') ilink.push( l )
			// console.log('link', i1,label1,type1, i2,label2,type2)
		}
		var redo = false;
		// clean inv links
		while( dlink.length ) {
			redo = true;
			var d = dlink.shift();
			unsetLinked( d.i1 );
			unsetLinked( d.i2 );
			delLink( d.i1, d.i2 );
			changed();
		}
		if( redo ) {
			drawLinks();
		}
		// invert inverted links
		while( ilink.length ) {
			redo = true;
			d = ilink.shift();
			delLink( d.i1, d.i2 );
			addLink( d.page, d.i2, d.i1, d.relationship, null )
			changed();
		}
		// if there where changes stop here
		if( redo ) {
			drawLinks();
			return;
		}
		var added = false;
		// check for new automatic links to be created
		for( var l in keys ) {
			if( l == 'GENERIC' ) continue;
 			var kl = simplify(l+'KEY');
			var vl = simplify(l+'VAL');
			var candidates = []
			for( var id of keys[l] ) {
				var i1 = id + '_' + kl;
				if( checkLinked(i1) ) {
					// console.log( i1, 'ja tem' );
					continue;
				}
				// find link candidates
				if( values[l] ) {
					for( var id2 of values[l] ) {
						var i2 = id2 + '_' + vl;
						if( !checkLinked(i2) && canLink( i1, i2 )) {
							// console.log( 'link', i1, i2 );
							added = true;
							candidates.push( [i1,i2,id, id2,dist(id,id2)] );
						}
					}
				}
			}
			candidates.sort( (a,b) => {
				return a[4] < b[4] ? -1 : 1
			});
			// console.log( 'candidates', clone(candidates) )
			while( candidates.length ) {
				var c = candidates.shift();
				// console.log( 'CHECKING', c )
				if( canLink( c[0], c[1] ) ) {
					setLinked(c[0]); setLinked(c[1]); addLink( 0, c[0], c[1], 'key-pair')
				}
			}
	}
		if( added ) {
			rangeChanged = true;
			tagPanelUpdate();
			drawLinks()
		} 
		// console.log( 'ocrLinks', keys, values, single, 'dlink', dlink, 'ilink', ilink, 'linked', linked )
	}, 500 );
}


var userDelLink = {};
function delLink( source, target, mark )
{
	// console.log( 'delLink', source, target, mark )
	if( blockEdit ) return locked();
	linkChanged = true;
	if( htmlTextMode ) setTimeout(drawHtmlAdjust, 100);

	if( mark ) userDelLink[source+'-'+target] = 1;
	changed();
	// popupOut();
	var [id1,lab1] = source.toString().split('_');
	var [id2,lab2] = target ? target.toString().split('_') : [null,null];

	// console.log( 'DELLINK', source, target );
    if( !id2 )
    {
		var reg = new RegExp('^'+id1+'_.*');
		if( !lab1 )
		{
			for( var i = linkList.length-1 ; i >= 0 ; i-- )
			{
				var l = linkList[i];
				var match = l.i1.match(reg) || l.i2.match(reg);
				if( match )
				{
					// console.log( 'delmatch', match[0] )
					$('.link_'+linkList[i].lid).remove();
					linkList.splice(i,1);
				}
			}
		}
		if( lab1 == '*' )
		{
			var t = tagFind(id1);
			if( !t ) return;
			var labs = {}; if( t.properties ) t.properties.forEach( p => labs[id1+'_'+simplify(p)] = 1 );
			// console.log( 'labs', labs )
			for( var i = linkList.length-1 ; i >= 0 ; i-- )
			{
				var l = linkList[i];
				var match = l.i1.match(reg) || l.i2.match(reg);
				if( match && !labs[match[0]])
				{
					// console.log( 'delmatch2', match[0] )
					$('.link_'+linkList[i].lid).remove();
					linkList.splice(i,1);
				}
			}
		}
    }
    else {
        for( var i = linkList.length-1 ; i >= 0 ; i-- )
        {
            var l = linkList[i];
            if( l.i1 == source && l.i2 == target )
			{
				// console.log( 'DELLINK FOUND', linkList[i] );
				$('.link_'+linkList[i].lid).remove();
				linkList.splice(i,1);
			}
        }
    }
	linkPanelUpdate();
}

function tagBox2(id)
{
	var t = tagFind(id);
	if( ocrMode ) return t.box;
	var box = [null, null, null, null];
	var tc = gPDF.textContent[t.page-1];
	if( descriptor.selectBoundingBox ) {
		var i = t.range[0];
		box = clone( gPDF.textContent[t.page-1][i] );
		box.shift();
		box.splice(4);
	}
	else {
		for( var i = t.range[0] ; i < t.range[1] ; i++ )
		{
			for( var j = 0 ; j < 2 ; j++ )
				if( box[j] === null || box[j] > tc[i][j+1] ) box[j] = tc[i][j+1];
			for( var j = 2 ; j < 4 ; j++ )
				if( box[j] === null || box[j] < tc[i][j+1] ) box[j] = tc[i][j+1];
		}
	}
	return box;
}

function tagBox3(id)
{
	var tags = $('.cid_'+id);
	var x1 = null;
	var x2 = null;
	var y1 = null;
	var y2 = null;
	var line = -1;
	function probe(p)
	{
		p = $(p);
		// var pos = p.position()
		// console.log( p[0] )
		// var pos = p.prop('pos')
		var _x1 = p.attr('left')*1;
		var _x2 = _x1+p.width();
		var _y1 = p.attr('top')*1;
		var _y2 = _x1+p.height();
		if( line < 0 ) line = p.attr('line')*1;
		if( x1 === null || x1 > _x1 ) x1 = _x1;
		if( x2 === null || x2 < _x2 ) x2 = _x2;
		if( y1 === null || y1 > _y1 ) y1 = _y1;
		if( y2 === null || y2 < _y2 ) y2 = _y2;
		// console.log( 'probe', x1, y1, x2, y2, p.left, p.top )
	}
	for( var p of tags ) probe(p);
	x1 /= txtObjWidth();
	x2 /= txtObjWidth();
	y1 /= txtObjHeight();
	y2 /= txtObjHeight();
	return [x1,y1,x2,y2, line];
}


function tagBox(id)
{
	if( htmlTextMode ) return tagBox3(id);
	if( engine2() ) return tagBox2(id);
	var tags = $('.cid_'+id);
	// console.log( 'tagBox', id )
	var x1 = null;
	var x2 = null;
	var y1 = null;
	var y2 = null;
	function probe(p)
	{
		if( x1 === null || x1 > p.left ) x1 = p.left;
		if( x2 === null || x2 < p.left ) x2 = p.left;
		if( y1 === null || y1 > p.top ) y1 = p.top;
		if( y2 === null || y2 < p.top ) y2 = p.top;
		// console.log( 'probe', x1, y1, x2, y2, p.left, p.top )
	}
	for( var i = 0 ; i < tags.length ; i++ )
	{
		var r = tags[i].getBoundingClientRect();
		var p = {left:r.left,top:r.top};
		probe(p);
		p.left += r.width;
		p.top += r.height;
		probe(p);
	}
	// console.log( tags.length, x1, y1, x2, y2 );
	var p1 = page2Pdf({left:x1,top:y1});
	var p2 = page2Pdf({left:x2,top:y2});
	// console.log( 'box', [p1.left,p1.top,p2.left,p2.top] );
	return [p1.left,p1.top,p2.left,p2.top];
}

var extraInit = function(){}

var claimTask = function() {
	descriptor.blockEdit = blockEdit = false;
	fixButtons(descriptor);
	// alert( 'claim')
}

var releaseTask = function() {
	descriptor.blockEdit = blockEdit = true;
	fixButtons(descriptor);
}


var submitAnnotations = function()
{
	console.log('nlp_pdf_adl.js - 2375')
	var annotations = exportData();
	if( annotations )
	{
		// console.log( '\n\n\n'+JSON.stringify(annotations,null,'\t'))
		$('crowd-form').show();
		document.getElementById('annotations').value = JSON.stringify(annotations);
	}
	else
		return false;
};

var changed = function()
{
	ocrLinks();
	// console.log( 'changed' )
}

var declineReason = '';

// Function to generate unique HTML for a grading form for each question
function gradingFormHTML(questionKey) {
    return `
        <div class="grading-container" id="grading-container-${questionKey}" data-key="${questionKey}">
            <h2>Grading Scale</h2>
            <form id="grading-form-${questionKey}">
                <div class="grading-body">
                    <!-- Left Column -->
                    <div class="grading-column">
                        <!-- Relevance -->
                        <div class="criterion">
                            <span class="criterion-label">Relevance</span>
                            <div class="radio-group-container">
                                <div class="radio-option"><label for="relevance1-${questionKey}">1</label><input type="radio" id="relevance1-${questionKey}" name="relevance-${questionKey}" value="1 - Poor"></div>
                                <div class="radio-option"><label for="relevance2-${questionKey}">2 </label><input type="radio" id="relevance2-${questionKey}" name="relevance-${questionKey}" value="2 - Fair"></div>
                                <div class="radio-option"><label for="relevance3-${questionKey}">3</label><input type="radio" id="relevance3-${questionKey}" name="relevance-${questionKey}" value="3 - Good"></div>
                                <div class="radio-option"><label for="relevance4-${questionKey}">4</label><input type="radio" id="relevance4-${questionKey}" name="relevance-${questionKey}" value="4 - Very Good"></div>
                                <div class="radio-option"><label for="relevance5-${questionKey}">5 </label><input type="radio" id="relevance5-${questionKey}" name="relevance-${questionKey}" value="5 - Excellent"></div>
                            </div>
                        </div>
                        <!-- Variation -->
                        <div class="criterion">
                            <span class="criterion-label">Variation</span>
                            <div class="radio-group-container">
                                <div class="radio-option"><label for="variation1-${questionKey}">1</label><input type="radio" id="variation1-${questionKey}" name="variation-${questionKey}" value="1 - Poor"></div>
                                <div class="radio-option"><label for="variation2-${questionKey}">2</label><input type="radio" id="variation2-${questionKey}" name="variation-${questionKey}" value="2 - Fair"></div>
                                <div class="radio-option"><label for="variation3-${questionKey}">3</label><input type="radio" id="variation3-${questionKey}" name="variation-${questionKey}" value="3 - Good"></div>
								<div class="radio-option"><label for="variation4-${questionKey}">4</label><input type="radio" id="variation4-${questionKey}" name="variation-${questionKey}" value="4 - Very Good"></div>
                                <div class="radio-option"><label for="variation5-${questionKey}">5</label><input type="radio" id="variation5-${questionKey}" name="variation-${questionKey}" value="5 - Excellent"></div>
                            </div>
                        </div>
                        <!-- Grammar/Spelling -->
                        <div class="criterion">
                            <span class="criterion-label">Grammar/Spelling</span>
                            <div class="radio-group-container">
                                <div class="radio-option"><label for="grammar1-${questionKey}">1</label><input type="radio" id="grammar1-${questionKey}" name="grammar-${questionKey}" value="1 - Poor"></div>
                                <div class="radio-option"><label for="grammar2-${questionKey}">2</label><input type="radio" id="grammar2-${questionKey}" name="grammar-${questionKey}" value="2 - Fair"></div>
                                <div class="radio-option"><label for="grammar3-${questionKey}">3</label><input type="radio" id="grammar3-${questionKey}" name="grammar-${questionKey}" value="3 - Good"></div>
								<div class="radio-option"><label for="grammar4-${questionKey}">4</label><input type="radio" id="grammar4-${questionKey}" name="grammar-${questionKey}" value="4 - Very Good"></div>
								<div class="radio-option"><label for="grammar5-${questionKey}">5</label><input type="radio" id="grammar5-${questionKey}" name="grammar-${questionKey}" value="5 - Excellent"></div>
                            </div>
                        </div>
                    </div>

                    <!-- Right Column -->
                    <div class="grading-column">
                        <!-- Verbosity -->
                        <div class="criterion">
                            <span class="criterion-label">Verbosity</span>
                            <div class="radio-group-container">
                                <div class="radio-option"><label for="verbosity1-${questionKey}">1</label><input type="radio" id="verbosity1-${questionKey}" name="verbosity-${questionKey}" value="1 - Poor"></div>
                                <div class="radio-option"><label for="verbosity2-${questionKey}">2</label><input type="radio" id="verbosity2-${questionKey}" name="verbosity-${questionKey}" value="2 - Fair"></div>
                                <div class="radio-option"><label for="verbosity3-${questionKey}">3</label><input type="radio" id="verbosity3-${questionKey}" name="verbosity-${questionKey}" value="3 - Good"></div>
								<div class="radio-option"><label for="verbosity4-${questionKey}">4</label><input type="radio" id="verbosity4-${questionKey}" name="verbosity-${questionKey}" value="4 - Very Good"></div>
								<div class="radio-option"><label for="verbosity5-${questionKey}">5</label><input type="radio" id="verbosity5-${questionKey}" name="verbosity-${questionKey}" value="5 - Excellent"></div>
                            </div>
                        </div>
                        <!-- Domain Alignment -->
                        <div class="criterion">
                            <span class="criterion-label">Domain Alignment</span>
                            <div class="radio-group-container">
                                <div class="radio-option"><label for="domain1-${questionKey}">1</label><input type="radio" id="domain1-${questionKey}" name="domain-${questionKey}" value="1 - Poor"></div>
                                <div class="radio-option"><label for="domain2-${questionKey}">2</label><input type="radio" id="domain2-${questionKey}" name="domain-${questionKey}" value="2 - Fair"></div>
                                <div class="radio-option"><label for="domain3-${questionKey}">3</label><input type="radio" id="domain3-${questionKey}" name="domain-${questionKey}" value="3 - Good"></div>
								<div class="radio-option"><label for="domain4-${questionKey}">4</label><input type="radio" id="domain4-${questionKey}" name="domain-${questionKey}" value="4 - Very Good"></div>
								<div class="radio-option"><label for="domain5-${questionKey}">5</label><input type="radio" id="domain5-${questionKey}" name="domain-${questionKey}" value="5 - Excellent"></div>
                            </div>
                        </div>
                        <!-- Text Length -->
                        <div class="criterion">
                            <span class="criterion-label">Text Length</span>
                            <div class="radio-group-container">
                                <div class="radio-option"><label for="length1-${questionKey}">1</label><input type="radio" id="length1-${questionKey}" name="length-${questionKey}" value="1 - Poor"></div>
                                <div class="radio-option"><label for="length2-${questionKey}">2</label><input type="radio" id="length2-${questionKey}" name="length-${questionKey}" value="2 - Fair"></div>
                                <div class="radio-option"><label for="length3-${questionKey}">3</label><input type="radio" id="length3-${questionKey}" name="length-${questionKey}" value="3 - Good"></div>
								<div class="radio-option"><label for="length4-${questionKey}">4</label><input type="radio" id="length4-${questionKey}" name="length-${questionKey}" value="4 - Very Good"></div>
								<div class="radio-option"><label for="length5-${questionKey}">5</label><input type="radio" id="length5-${questionKey}" name="length-${questionKey}" value="5 - Excellent"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div class="score-display">
                <div class="scale-reference">1 - Poor | 2 - Fair | 3 - Good | 4 - Very Good | 5 - Excellent</div>
                Score <span id="score-value-${questionKey}">0</span>%
            </div>
        </div>
    `;
}

// Function to inject CSS for grading forms, ensures it's only added once.
function injectGradingCSS() {
    if ($('#grading-styles').length === 0) {
        const gradingCSS = `
            <style id="grading-styles">
            .grading-container {
                background-color: #f8f9fa;
                padding: 20px;
                border-radius: 8px;
                margin-top: 20px;
                border: 1px solid #dee2e6;
            }
            .grading-container h2 {
                font-size: 18px;
                font-weight: 600;
                margin-top: 0;
                margin-bottom: 20px;
                color: #343a40;
            }
            .grading-body {
                display: flex;
                flex-wrap: wrap;
                gap: 20px 40px;
            }
            .grading-column {
                flex: 1;
                min-width: 220px;
                display: flex;
                flex-direction: column;
                gap: 15px;
            }
	.scale-reference {
    font-size: 0.9em;
    color: #666;
    margin-bottom: 5px;
    text-align: left;
}
            .criterion {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            .criterion-label {
                font-size: 15px;
                font-weight: 500;
            }
            .radio-group-container {
                display: flex;
                align-items: center;
                gap: 14px;
            }
            .radio-option {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 4px;
            }
            .radio-option label {
                font-size: 13px;
                font-weight: 500;
                color: #495057;
            }
            .grading-container input[type="radio"] {
                -webkit-appearance: none;
                appearance: none;
                background-color: #fff;
                margin: 0;
                font: inherit;
                color: currentColor;
                width: 18px;
                height: 18px;
                border: 2px solid #0d2c4e;
                border-radius: 50%;
                cursor: pointer;
                display: grid;
                place-content: center;
            }
            .grading-container input[type="radio"]::before {
                content: "";
                width: 8px;
                height: 8px;
                border-radius: 50%;
                transform: scale(0);
                transition: 120ms transform ease-in-out;
                box-shadow: inset 1em 1em #0d2c4e;
            }
            .grading-container input[type="radio"]:checked::before {
                transform: scale(1);
            }
            .score-display {
                margin-top: 20px;
                text-align: right;
                font-size: 16px;
                font-weight: 500;
                color: #343a40;
            }
				.overall-score-container {
    margin-top: 30px;
    padding-top: 20px;
    border-top: 2px solid #e9ecef;
    text-align: right;
    font-size: 22px;
    font-weight: 600;
    color: #0d2c4e;
}
            </style>
        `;
        $('head').append(gradingCSS);
    }
}

// Function to initialize a specific grading form's functionality
function initializeGradingForm(questionKey) {
    const maxScore = 30;
    const formSelector = `#grading-form-${questionKey}`;
    const scoreSelector = `#score-value-${questionKey}`;

    function calculateAndUpdateScore() {
        let currentScore = 0;
        
        $(`${formSelector} input[type="radio"]:checked`).each(function() {
            currentScore += parseInt($(this).val(), 10);
        });
        
        const percentage = (maxScore > 0) ? (currentScore / maxScore) * 100 : 0;
        $(scoreSelector).text(Math.round(percentage));
    }
    
    // Initial calculation
    calculateAndUpdateScore();
    
    // Add event listener for changes
    $(`${formSelector} input[type="radio"]`).on('change', calculateAndUpdateScore);
}

// Function to generate the HTML for the overall score display
function overallScoreHTML() {
    return `
        <div class="overall-score-container">
            Overall Score <span id="overall-score-value">0</span>%
        </div>
    `;
}

// Function to calculate and update the overall average score
function updateOverallScore() {
    const maxScorePerForm = 30;
    let totalScore = 0;
    let formCount = 0;

    // Iterate over each grading form to sum up the scores
    $('.grading-container').each(function() {
        formCount++;
        let currentFormScore = 0;
        $(this).find('input[type="radio"]:checked').each(function() {
            currentFormScore += parseInt($(this).val(), 10);
        });
        totalScore += currentFormScore;
    });

    // Calculate the average percentage
    const totalMaxScore = formCount * maxScorePerForm;
    const percentage = (totalMaxScore > 0) ? (totalScore / totalMaxScore) * 100 : 0;

    // Update the UI
    $('#overall-score-value').text(Math.round(percentage));
}
function exportData(noCheck, subset) {
    try {
        function serror(txt, el) {
            frm.myAlert('Submit Error', txt, 'Ok', async function() {
                await frm.myAlertClose();
                let o = $(el)[0];
                if (o) o.focus();
            });
            return null;
        }

        var check = !noCheck;
        var ret = {};

        const sourceMeta = descriptor.htmlText?.metadata ||
                           descriptor.pdf?.metadata ||
                           descriptor.image?.metadata ||
                           descriptor.video?.metadata;

        if (sourceMeta) {
            if (sourceMeta.Title !== undefined) {
                ret.Title = sourceMeta.Title;
            }
            if (sourceMeta.Theme !== undefined) {
                ret.Theme = sourceMeta.Theme;
            }

            const nestedMetadata = clone(sourceMeta);

            if (Object.keys(nestedMetadata).length > 0) {
                ret.metadata = nestedMetadata;
            } else {
                if (sourceMeta) ret.metadata = {};
            }
        }

        if (!imageMode && !videoMode && !htmlTextMode) {
            ret.pdf_fingerprint = gPDF._pdfInfo.fingerprint;
        }
        ret.dimensions = gPDF.dimensions;
        ret.version = descriptor.version;

        if (declined) {
            if (1 && check && declineReason == '') {
                frm.myAlert('Decline Task', 'Please provide a reason for declining the task.<br><textarea id="decline_reason" placeholder="Enter reason" class="export-reason form-control mb-2"></textarea>', 'Ok', function() {
                    submitAnnotations();
                }, 'Cancel');
                $('#modal-close').attr('disabled', true);

                function declineCk() {
                    declineReason = $('#decline_reason').val().trim();
                    $('#modal-close').attr('disabled', declineReason.length < 5);
                }
                $('#decline_reason').on('change', declineCk).on('keyup', declineCk);
                return null;
            }
            ret.taskDeclined = true;
            ret.declineReason = declineReason;
            check = false;
        }

        if (hasAttributes) {
            for (var i = 0; i < descriptor.attributes.length; i++) {
                var a = descriptor.attributes[i];
                if (!descriptor.text_attributes.attributes) descriptor.text_attributes.attributes = {};
                if (!bool(a.optional) && (
                        !descriptor.text_attributes.attributes[a.label] ||
                        descriptor.text_attributes.attributes[a.label] == '_new'
                    ) && check) {
                    frm.myAlert('Submit Error', 'Document attribute "' + a.label + '" not set. Choose one.');
                    $('#right').scrollTop(100000);
                    return null;
                }
            }
            ret.attributes = descriptor.text_attributes.attributes;
        }


        if (hasPageAttributes) {
            for (var p = 0; p < gPDF.numPages; p++) {
                for (var i = 0; i < descriptor.pageAttributes.length; i++) {
                    var a = descriptor.pageAttributes[i];
                    if (!bool(a.optional) && (
                            !descriptor.text_attributes.pageAttributes[p] ||
                            !descriptor.text_attributes.pageAttributes[p][a.label] ||
                            descriptor.text_attributes.pageAttributes[p][a.label] == '_new'
                        ) && check) {
                        frm.myAlert('Submit Error', 'Page attribute "' + a.label + '" not set on page <b>' + (p + 1) + '</b>. Choose one.');
                        drawPDF(gPDF, (p + 1), globalZoom, function() {
                            $('#right').scrollTop(0);
                        });
                        return null;
                    }
                }
            }
            ret.pageAttributes = descriptor.text_attributes.pageAttributes;
        }

        if ($('#annotator_notes').val().trim() > '') {
            if (!ret.attributes) ret.attributes = {};
            ret.attributes["Aditional Notes"] = $('#annotator_notes').val().trim();
        }

        var validIds = {};
        var newId = 1;
        var translate = {};
        if (hasLabels) {
            if (descriptor.exportFormat == 1 && !descriptor.comprehendMode) ret.absoluteOffsets = true;
            if (htmlTextMode) ret.absoluteOffsets = true;
            ret.tags = [];
            rangeList.forEach(function(r) {
                if (r.adj || r.type == 'tmp' || r.ignore) return;
                validIds[r.id] = 1;
                for (var p of r.properties) {
                    var type = p;
                    var k = r.id + '_' + simplify(type);
                    var id = newId++;
                    translate[k] = id;
                    var tobj = {
                        page: r.page,
                        range: clone(r.range),
                        text: r.text,
                        id: id,
                        type: type
                    };
                    if (r.table) tobj.table = clone(r.table);
                    if (r.blocks) tobj.blocks = clone(r.blocks);
                    if (r.textAdjust) {
                        if (r.rawBox) {
                            tobj.text = r.textAdjust;
                        } else {
                            tobj.textAdjust = r.textAdjust;
                        }
                    }
                    if (r.comment > '') tobj.comment = r.comment;
                    tobj.box = r.box ? r.box : tagBox(r.id);
                    if (r.rotate) tobj.rotate = r.rotate;
                    if (r.rawBox) {
                        tobj.rawBox = r.rawBox;
                        tobj.range = [];
                    }
                    if (!tobj.box || htmlTextMode) delete tobj.box;
                    ret.tags.push(tobj)
                }
            });
            if (ret.absoluteOffsets) {
                for (var r of ret.tags) {
                    if (isarray(r.range) && r.range.length > 0) {
                        for (var i = 0; i < r.range.length; i++)
                            r.range[i] += descriptor.exportOffsets[r.page - 1];
                    }
                    if (htmlTextMode) r.page = 1;
                }
            }
            ret.pageOffsets = descriptor.exportOffsets;
        }

        if (hasLinks) {
            ret.links = [];
            linkList.forEach(function(l) {
                if (l.relationship == 'tmp') return;
                if (!l.i1 || !l.i2 || !validIds[l.i1.split('_')[0]] || !validIds[l.i2.split('_')[0]]) return;

                var i1 = translate[l.i1];
                var i2 = translate[l.i2];
                var page = l.page;
                if (htmlTextMode) page = 1;
                if (!defined(i1) || !defined(i2)) return;
                ret.links.push({
                    page: page,
                    id1: i1,
                    id2: i2,
                    relationship: l.relationship
                })
                if (htmlTextMode) l.page = 1;
            });
        }

        if (hasBoxes) {
            ret.boxes = [];
            if (boxes) boxes.forEach(b => {
                if (b.label == '') return;
                let bobj = {
                    page: b.page,
                    box: b.box,
                    label: b.label
                };
                if (b.rotate) bobj.rotate = b.rotate;
                ret.boxes.push(bobj)
            });
        }

        if (tableList.length) {
            ret.tables = clone(tableList);
            ret.tables.forEach(t => delete t.ignore);
        }


        if (descriptor.qaMode) {
            if (check) {
                let i = 1;
                let totalScores = [];
                for (let q of Object.values(descriptor.questions)) {
                    let ql = findQuestion(q.name);
                    if (ql.questionNotApplicable) continue;
                    let elid = (q.summary ? 'summary' : 'question') + '_' + i;
                    if (!ql.name || (!ql.question && !ql.summary)) return serror('The instrunction "<b>' + q.instruction1 + '</b>" was not answered.', $('#' + elid))

                    if (!q.summary && !ql.answerNotApplicable) {
                        let elid = 'answer_' + i;
                        if (window.GlobalVars.PDFProjectType == 'Content Generation') {

                        } else {
                            if (!ql.answer) return serror('The instrunction "<b>' + q.instruction1 + '</b>" was not answered.', $('#' + elid))
                        }

                        function convertGradingToText(numericValue) {
                            const gradingMap = {
                                1: "Poor",
                                2: "Fair",
                                3: "Good",
                                4: "Very Good",
                                5: "Excellent"
                            };
                            return gradingMap[numericValue] || numericValue;
                        }

                        if (window.GlobalVars.PDFProjectType == 'Content Generation' && reviewMode) {
                            let formSelector = `#grading-form-${q.name}`;
                            if ($(formSelector).length > 0) {
                                let gradingCriteria = ['relevance', 'variation', 'grammar', 'verbosity', 'domain', 'length'];
                                let hasUnselectedCriteria = false;
                                let gradingData = {};

                                for (let criterion of gradingCriteria) {
                                    let selectedValue = $(`input[name="${criterion}-${q.name}"]:checked`).val();
                                    if (!selectedValue) {
                                        hasUnselectedCriteria = true;
                                        break;
                                    }
                                    gradingData[criterion] = convertGradingToText(parseInt(selectedValue, 10));
                                }

                                if (hasUnselectedCriteria) {
                                    return serror(`Please complete all grading criteria for question "${q.instruction1}" before submitting.`);
                                }

                                let numericTotal = 0;
                                for (let criterion of gradingCriteria) {
                                    let selectedValue = $(`input[name="${criterion}-${q.name}"]:checked`).val();
                                    numericTotal += parseInt(selectedValue, 10);
                                }

                                const maxScore = 30;
                                const percentage = (maxScore > 0) ? (numericTotal / maxScore) * 100 : 0;

                                ql.grading = gradingData;
                                ql.grading.scorePercentage = Math.round(percentage);
                                totalScores.push(ql.grading.scorePercentage);
                            } else {
                                return serror('Grading scale form is missing for a Content Generation question.');
                            }
                        }
                    }
                    i++;
                }

                let averageScore = 0;
                if (totalScores.length > 0) {
                    averageScore = totalScores.reduce((sum, score) => sum + score, 0) / totalScores.length;
                }

                for (let q of Object.values(descriptor.questions)) {
                    let ql = findQuestion(q.name);
                    if (ql.questionNotApplicable) continue;
                    if (window.GlobalVars.PDFProjectType == 'Content Generation' && reviewMode && ql.grading) {
                        ql.grading.overallScore = Math.round(averageScore);
                    }
                }

                if (descriptor.requestTextHighlightQ || descriptor.requestTextHighlightA) {
                    let highlights = {};
                    for (let r of rangeList) {
                        for (let t of r.properties) {
                            t = t.replace(/^[QS]:/, 'i1_').replace(/^[A]:/, 'i2_')
                            highlights[t] = 1
                        }
                    }
                    for (let q of Object.values(descriptor.questions)) {
                        if (q.summary) continue
                        let ql = findQuestion(q.name);
                        if (descriptor.requestTextHighlightQ && !highlights['i1_' + q.name] && !ql.questionSkipHighlight) return serror('You need to hightlight the text corresponding to the instruction "<b>' + q.instruction1 + '</b>"')
                        if (!q.summary) {
                            if (descriptor.requestTextHighlightA && !highlights['i2_' + q.name] && !ql.answerSkipHighlight) return serror('You need to hightlight the text corresponding to the instruction "<b>' + q.instruction2 + '</b>"')
                        }
                        i++;
                    }
                }
                if (descriptor.requestTextHighlightS) {
                    let highlights = {};
                    for (let r of rangeList) {
                        for (let t of r.properties) {
                            t = t.replace(/^[QS]:/, 'i1_').replace(/^[A]:/, 'i2_')
                            highlights[t] = 1
                        }
                    }
                    for (let q of Object.values(descriptor.questions)) {
                        if (!q.summary) continue
                        let ql = findQuestion(q.name);
                        if (!highlights['i1_' + q.name] && !ql.answerSkipHighlight) return serror('You need to hightlight the text corresponding to the instruction "<b>' + q.instruction1 + '</b>"')
                        i++;
                    }
                }
            }
            ret.questions = questionList;
        }


        if (hasClassification) {
            ret.classificationTypes = {};
            for (var j = 0; j < descriptor.classification.length; j++) {
                var c = descriptor.classification[j];
                if (!c.name) continue;
                ret.classificationTypes[c.name] = c.type;
                if (c.optional) continue;
                if (check && Object.keys(classifications[c.name]).length == 0) {
                    frm.myAlert('Submit Error', 'Classification "<b>' + c.name + '</b>" needs an answer.');
                    var ctarget = $('#classification_' + j);
                    $('#right').scrollTop(ctarget.position().top - ctarget.outerHeight());
                    return null;
                }
            }
            ret.classifications = {};
            for (var k in classifications)
                ret.classifications[k] = Object.keys(classifications[k])
        }


        ret.plainText = {};
        if (htmlTextMode) {
            ret.plainText = {
                1: gPDF.plainText.join('')
            };
        } else if (descriptor.exportAllPlainTextPages) {
            gPDF.plainText.forEach((p, idx) => {
                ret.plainText[idx + 1] = clone(p)
            });
        } else {
            const pagesWithAnnotations = Object.keys(ret.tags || {}).reduce((acc, key) => {
                acc[ret.tags[key].page] = true;
                return acc;
            }, {});
            Object.keys(pagesWithAnnotations).forEach(p => {
                if (gPDF.plainText[p - 1] !== undefined) {
                    ret.plainText[p] = gPDF.plainText[p - 1];
                }
            });
        }

        if (descriptor.disableExportPlainText) delete ret.plainText;
        if (hasClassification) {
            delete ret.plainText;
        }

        if (reviewMode) {
            if (!$('#reviewer_rate').val() && check) {
                frm.myAlert('Submit Error', 'Please assign the quality of the annotations');
                return null;
            }
            if ($('#reviewer_rate').val() == 'Adjust' && !$('#reviewer_notes').val().trim() && check) {
                frm.myAlert('Submit Error', 'Please add a note to the annotator with your requests', 'Ok', function() {
                    frm.myAlertClose(chatPopup)
                });
                return null;
            }
            ret.review = {
                rate: $('#reviewer_rate').val(),
                note: $('#reviewer_notes').val()
            }
        }


        ret.jobStart = descriptor.text_attributes.jobStart;
        ret.sessionTime = (getsec() - descriptor.text_attributes.sessionStart);
        ret.elapsedTime = descriptor.text_attributes.elapsedTime + ret.sessionTime;
        ret.updateTime = getsec();

        if (ocrMode) delete ret.boxes;
        if (descriptor.selectBoundingBox) ret.selectBoundingBox = true;


        if (descriptor.comprehendMode && descriptor.comprehendExport) {
            const finalRet = comprehendAnnotationExport(comprehendBlocksAux, ret);

            if (ret.Title !== undefined) finalRet.Title = ret.Title;
            if (ret.Theme !== undefined) finalRet.Theme = ret.Theme;
            if (ret.pdf_fingerprint !== undefined) finalRet.pdf_fingerprint = ret.pdf_fingerprint;
            if (ret.dimensions !== undefined) finalRet.dimensions = ret.dimensions;
            if (ret.version !== undefined) finalRet.version = ret.version;

            ret = finalRet;
        }


        var out = ret;

        frm.undotKeys(out);
        return out;

    } catch (e) {
        console.error('exportData error', e);
        return null;
    }
}


function saveClipboard( txt )
{
	var input = $('<textarea>').val(txt).css({position:'absolute',top:px(-10000),left:px(-100000)});
	$(document.body).append(input);
	input.select();
	// input.setSelectionRange(0, 99999999);
	document.execCommand("copy");
	setTimeout( function(){
		input.remove();
	}, 100 );
}

function delTmpLinks(force)
{
    for( var i = linkList.length-1 ; i >= 0 ; i-- )
    {
        var l = linkList[i];
        // if( l.relationship == 'tmp' && l.lid != selectedLink )
        if( l.relationship == 'tmp' && (!force || l.lid != selectedLink))
		{
			$('.link_'+l.lid).remove();
			linkList.splice(i,1);
		}
    }
}

function visibleLinks()
{
	if( skeys.altOn ) return;
	if( showLinks && !showAdjudication ) return $('.link').show();
	// if( showLinks ) return $('.link').show();
	$('.link').hide();
	$('.l_tmp').show();
	if( overTidLabel ) $('.link_lb_'+overTidLabel).show();
	else if( over ) $('.link_item_'+over).show();
	else if( selected ) $('.link_item_'+selected).show();
	else if( selectedLink )
	{
		$('.link_arrow_'+selectedLink).show();
		$('.link_label_'+selectedLink).show();
		$('.link_'+selectedLink).show();
	}
}

function drawLinks()
{
    // $('.link').remove();
    linkList.sort( function(a,b){
        return a.didx < b.didx ? -1 : 1;
    });
    var mh = 0;
    linksDrawn = [];
    linkList.forEach( function(l)
    {
		if( l.page != currentPage && l.page2 != currentPage ) return;
		// console.log( 'aaaaaaaaaaaaaaaaa', l.page, currentPage, l.i1, l.i2, l.relationship )
        var h = linkTag( l.i1, l.i2, l.relationship, l );
        if( h > mh ) mh = h;
    });
    linkOut();
	$('.link').hide();
	visibleLinks();
    return mh;
}

var lastLnkTid = null;
var lastLnkTime = 0;

function setLinkTmp()
{
	clearTimeout( linkDirTid );
	$(document.body).off('mousemove').on('mousemove', linkTmp );
	$(document.body).off('mouseout').on('mouseout', linkTmp );
}

function unsetLinkTmp()
{
	linkDir = '';
	linkDirLast = -1;
	clearTimeout( linkDirTid );
	$(document.body).off('mousemove', linkTmp );
	$(document.body).off('mouseout', linkTmp );
}

function locked() {
	// console.log( 'locked', initComplete )
	if( !initComplete ) return;
	if( descriptor.task_can_claim ) {
		var lockTxt = "You don't own this task on it's current state. Therefore annotations can't be created or modifyed.<br><br>You may <b>claim</b> the task and become the task owner as <b>"+descriptor.task_role+"</b>";
	}
	else {
		// var lockTxt = "You don't own this task on it's current state. Therefore annotations can't be created or modifyed.";
		return false;
	}
	// lockTxt = '<table class="alert-table"><tr><td><i class="fa fa-lock alert-icon"></i></td><td>'+lockTxt+'</td></tr></table>';
	frm.myAlert( '<i class="fa fa-lock alert-icon"></i> Task Locked', lockTxt )
	// console.trace('locked');
	return false;
}

function loading(str)
{
	if( !str ) str = '';
	$('.lds-hourglass').remove();

	var ld = $('<div class="lds-hourglass loading"><div class="lds-text">'+str+'</div></div>').css({
		position: 'fixed',
		// top:$('#maincolumn').outerHeight()/2-40,
		// top:$(window).height()/2-40,
		top: $(document.body).outerHeight()/2-40,
		left:$('#maincolumn').width()/2-40+mainLeftOffset,
	})
	$('#maincolumn').append(ld);

}

window._loading = loading;

function loadingOut()
{
	$('.loading').remove();
}

window._loadingOut = loadingOut;

function linkDirSet()
{
	// $('#annotator_notes').val( linkDir );
	var scrollInc = 120;
	var delay = 5000;
	if( linkDir == 'TOP' )
	{
		$('#maincolumn').scrollTop($('#maincolumn').scrollTop()-scrollInc)
		delay = 200;
	}
	else if( linkDir == 'BOTTOM' )
	{
		$('#maincolumn').scrollTop($('#maincolumn').scrollTop()+scrollInc)
		delay = 200;
	}
	else if( linkDir == 'RIGHT' )
	{
		arrowPage(1);
	}
	else if( linkDir == 'LEFT' )
	{
		arrowPage(-1);
	}
	else return;
	clearTimeout( linkDirTid );
	linkDirTid = setTimeout( linkDirSet, delay );
}

var linkDir = 0;
var linkDirLast = -1;
var linkDirTid = null;
function linkTmp(ev)
{
	// console.log( 'linkTmp', ev.pageX, ev.pageY )
	function mouseOutCheck(ev){
		var x = ev.pageX;
		var y = ev.pageY;
		// console.log( ev.pageY, ev.screenY )
		var mainBox = $('#maincolumn')[0].getBoundingClientRect();
		var x1 = mainBox.x+15;
		var x2 = mainBox.x+mainBox.width-15;
		var y1 = mainBox.y+15;
		var y2 = mainBox.y+mainBox.height-50;
		// clearTimeout( linkDirTid );
		if( x < x1 && y > y1 && y < y2 )
		{
			linkDir = 'LEFT';
		}
		else if( x > x2 && y > y1 && y < y2 )
		{
			linkDir = 'RIGHT';
		}
		else if( y < y1 && x > x1 && x < x2 )
		{
			linkDir = 'TOP';
		}
		else if( y > y2 && x > x1 && x < x2 )
		{
			linkDir = 'BOTTOM';
		}
		else {
			linkDir = '';
			linkDirLast = -1;
			clearTimeout( linkDirTid );
			// console.log( 'not')
		}
		// console.log( linkDir, linkDirLast )
		if( linkDir != linkDirLast )
		{
			linkDirTid = setTimeout( linkDirSet, 1000 );
			linkDirLast = linkDir;
		}

		// if( ev.target != txtObj[0] ) return;
		// console.log( 'outttt', ev.pageX, ev.pageY, mainBox )
	}
	mouseOutCheck(ev);
	clearTimeout( lastLnkTid );
	lastLnkTid = setTimeout( function(){ linkTmp2(ev)}, 100 );
	var now = Date.now();
	if( now-lastLnkTime < 50 ) return;
	linkTmp2(ev);
	lastLnkTime = now;
}

function linkTmp2(ev)
{
	// console.log( Date.now())
	if( !txtObj[0] ) return;
	var main = $('#maincolumn');
	var st = main.scrollTop();
	var sl = main.scrollLeft();
	var toff = $('#text-layer').offset()
	// var x = (ev.pageX-drawPos.x+sl)/zoomValue;
	// var y = (ev.pageY-drawPos.y+st)/zoomValue;
	var x = (ev.pageX-toff.left)/zoomValue;
	var y = (ev.pageY-toff.top)/zoomValue;
	// console.log( 'linktmp', ev.pageY, drawPos )

	// console.log( 'X', x, 'y', y, drawPos, $('#text-layer').scrollTop() )

	var p1 = clone(tagDownPos);
    var p2 = {x1:x-20,y1:y};
	if( p1.page < currentPage ) p1.x1 = -50;
	if( p1.page > currentPage ) p1.x1 = $('#maincolumn').width()+50;
	// console.log( 'linktmp POSITIONS', p1, p2, p1.page, 'tagDownPos', tagDownPos );

	// return;
	var lid = 'TMPLID';
    if( p1.x1 > p2.x1 )
    {
        var tmp = p1;
		p1 = p2;
		p2 = tmp;
		var direction = 1;
    }
	else {
		var direction = 0;
	}
	var idx = 0;
    var c1 = 0;
    var c2 = 0;
    var inter = 0;
	// txtObj.find('.link_'+lid).remove();
	var minTop = Math.min(p1.y1, p2.y1);
	var minLeft = Math.min(p1.x1,p2.x1);
	var maxTop = Math.max(p1.y1, p2.y1);
	var maxLeft = Math.max(p1.x1,p2.x1);
	// var lid = id1 < id2 ? id1+'_'+id2 : id2+'_'+id1;
	// console.log( 'color', sv, defineColor(sv), minTop, minLeft, maxTop, maxLeft )

	var topVal = direction ? 10 : 30;
	var leftval = direction ? 2 : 12;
	var top = minTop-15-topVal;
	p1.x1 += 0;
	p2.x1 -= 10;
	var h = p1.y1-top-5;
	var h2 = p2.y1-top-5;
	var w = p2.x1-p1.x1+10;
	var w2 = 20;
	var l = p1.x1;
	var l2 = p2.x1-w2;
	// top -= 25;
	top += 7;
	l += 20;
	l2 += 20;
	if( direction ) l -= 10;
	else l2 += 10;

	var twidth = $('#maincolumn').width()
	var lnk1 = $('#l1'+lid);
	if( !lnk1.length )
	{
		var lnk1 = $('<DIV>').addClass('link_top_left')
		.addClass('link_'+lid)
		.addClass('link_tmp')
		.addClass('no-click')
		.prop('id', 'l1'+lid)
		txtObj.append(lnk1);
	}
	if( w+l > twidth )	w = twidth-l;
	lnk1.css({top:px(top),left:px(l),width:px(w), height:px(h),zIndex:3000-idx});

	var lnk2 = $('#l2'+lid);
	if( !lnk2.length )
	{
		var lnk2 = $('<DIV>').addClass('link_right')
		.addClass('link_'+lid)
		.addClass('link_tmp')
		.addClass('no-click')
		.prop('id', 'l2'+lid)
		txtObj.append(lnk2);
	}
	lnk2.css({top:px(top),left:px(l2),width:px(w2), height:px(h2),zIndex:3000-idx});
	if( (l2+w2) > twidth ) lnk2.remove(); /// OTHER PAGE


	var aleft = direction?l-4:l2+14;
	var ah = direction?h:h2;
	var arrow = $('#arr'+lid);
	if( !arrow.length )
	{
		var arrow = $('<DIV>').addClass('link_arrow')
		.addClass('link_tmp')
		.addClass('no-click')
		.addClass('link_'+lid)
		.addClass('link_arrow_'+lid)
		.prop('id', 'arr'+lid)
		txtObj.append(arrow);
	}
	arrow.css({top:px(top+ah-10),left:px(aleft),zIndex:3000-idx})
	if( aleft > twidth ) arrow.remove();
}

function linkTag( source, target, relationship, linkObj )
{
	var [id1,lab1] = source.split('_');
	var [id2,lab2] = target.split('_');

	// console.log( 'LINKTAG', id1, id2, relationship );
	if( blockEdit && relationship == 'tmp' ) return locked();

	let linkColor = tagColors[simplify(relationship)];

    setUsed($('#relationships'), relationship );
    var t1 = tagFind(id1);
    var t2 = tagFind(id2);
	var tdest = t2;
	if( !t1 || !t2 ) return;
	// console.log( 'linkTag', t1.adj, t2.adj );

	// check if link is cross adjudication
	if( !t1.adj ) t1.adj = false;
	if( !t2.adj ) t2.adj = false;
	if( t1.adj != t2.adj ) return;
	if( t1.adj && !showAdjudication ) return;
	// console.log( 'linkTag', id1, id2, 'idx', t1.idx, t2.idx );
    // var p1 = tagPos( id1 );
    // var p2 = tagPos( id2 );
	var p1 = labelPos( source );
    var p2 = labelPos( target );

	if( htmlTextMode ) linkObj.topLine = Math.min(t1.line,t2.line);
	// console.log( 'POSITIONS', p1, p2 );
	var extraLab = '';
	if( p1 === null )
	{
		p1 = clone(p2);
		if( !p1 ) return;
		p1.x1 = t1.page < currentPage ? -250 : txtObjWidth()+250;
		p1.id = id1;
		extraLab = ' <span class="link-cross-page" id="linkpage'+t1.id+'">(page '+t1.page+')</span>';
	}
	if( p2 === null )
	{
		p2 = clone(p1);
		if( !p2 ) return;
		p2.x1 = t2.page < currentPage ? -250 : txtObjWidth()+250;
		p2.id = id1;
		extraLab = ' <span class="link-cross-page" id="linkpage'+t2.id+'">(page '+t2.page+')</span>';
	}
	if( !p1 || !p2 )
	{
		console.error( 'invalid links', id1, p1, id2, p2 );
		return;
	}
	var lid = source+'-'+target;
    if( p1.x1 > p2.x1 )
    {
        var tmp = [id1,t1,p1,lab1];
		id1 = id2;
		t1 = t2;
		p1 = p2;
		lab1 = lab2;
		id2 = tmp[0];
		t2 = tmp[1];
		p2 = tmp[2];
		lab2 = tmp[3];
		var direction = 1;
    }
	else {
		var direction = 0;
	}
	var lidx1 = t1.properties.map( v => simplify(v) ).indexOf(lab1);
	var lidx2 = t2.properties.map( v => simplify(v) ).indexOf(lab2);

	p1.x1 += lidx1*4;
	p2.x1 += lidx2*4;
	var idx = t1.idx;
	var idx = 0;
	// console.log( 'linkTag direction', id1, id2, direction );
	// console.log( 'linkTag', id1, id2, 'idx', t1.idx, t2.idx, p1, p2 );
    var c1 = 0;
    var c2 = 0;
    var inter = 0;
    var sv = simplify(relationship);
	var sig = lid+'-'+sv;
	// console.log( 'lid', lid, 'sig', sig, txtObj.find('.link_'+lid).length )
	if( txtObj.find('.link_'+lid).length )
	{
		if( txtObj.find('.link_'+lid).prop('sig') == sig )
		{
			// console.log( 'already linked');
			return;
		}
		txtObj.find('.link_'+lid).remove();
 	}
    defineColor(sv);
	var minTop = Math.min(p1.y1, p2.y1);
	var minLeft = Math.min(p1.x1,p2.x1);
	var maxTop = Math.max(p1.y1, p2.y1);
	var maxLeft = Math.max(p1.x1,p2.x1);
	// var lid = id1 < id2 ? id1+'_'+id2 : id2+'_'+id1;
	// console.log( 'color', sv, defineColor(sv), minTop, minLeft, maxTop, maxLeft )

	var topVal = direction ? 10 : 30;
	var leftval = direction ? 2 : 12;
	var top = minTop-15-topVal;
	p1.x1 += 0;
	p2.x1 -= 10;

	var h = p1.y1-top-5;
	var h2 = p2.y1-top-5;
	var w = p2.x1-p1.x1+10;
	var w2 = 20;
	var l = p1.x1;
	var l2 = p2.x1-w2;
	var line = '';
	var topOffset = 0;
	if( htmlTextMode )
	{
		line = Math.min( t1.line, t2.line );
		topOffset = lineOffset[line] || 0;
	}

	// top -= 25;
	top += 7;
	l += 20;
	l2 += 20;
	if( t1.adj )
	{
		top -= 25;
		h -= 10;
		h2 -= 10;
	}
	if( direction ) l -= 10;
	else l2 += 10;

	var hoff = 0;
	var hsel = 0;
	if( htmlTextMode )
	{
		if( t1.line != t2.line )
		{
			if( t1.line > t2.line )
			{
				var line1 = t1.line;
				var line2 = t2.line;
				var baseh = h;
				var hsel = 1;
				var hoff = lineOffset[line1]-lineOffset[line2];
			}
			else
			{
				var line1 = t2.line;
				var line2 = t1.line;
				var baseh = h2;
				var hsel = 2;
				var hoff = lineOffset[line1]-lineOffset[line2];
			}
		}
		// h += lineOffset[t1.line];
		// h2 += lineOffset[t2.line];
	}
	// hoff = 0;
	// console.log( 'LID', lid, id1, id2 );

	var twidth = $('#maincolumn').width();
	if( w+l > twidth )	w = twidth-l;
	var lnk = $('<DIV>').addClass('link_top_left')
						.addClass('link_'+lid)
						.addClass('link_item_'+id1)
						.addClass('link_item_'+id2)
						.addClass('link_lb_'+id1+'_'+lab1)
						.addClass('link_lb_'+id2+'_'+lab2)
						.addClass('link')
						.addClass('no-click')
						.addClass('l_'+sv)
						.prop('lid', lid)
						.addClass('adjusttop')
						.attr('top', top)
						.attr('line', line)
						.css({top:px(top+topOffset),left:px(l),width:px(w), height:px(h),zIndex:3000-idx});
	if( hsel == 1 ) lnk.addClass('adjustheight').attr('height',baseh).attr('line1',line1).attr('line2',line2).css({height:baseh+hoff})
	txtObj.append(lnk);
	var lnk = $('<DIV>').addClass('link_right')
						.addClass('link_'+lid)
						.addClass('link_item_'+id1)
						.addClass('link_item_'+id2)
						.addClass('link_lb_'+id1+'_'+lab1)
						.addClass('link_lb_'+id2+'_'+lab2)
						.addClass('link')
						.addClass('no-click')
						.addClass('l_'+sv)
						.prop('lid', lid)
						.addClass('adjusttop')
						.attr('top', top)
						.attr('line', line)
						.css({top:px(top+topOffset),left:px(l2),width:px(w2), height:px(h2),zIndex:3000-idx});
	if( hsel == 2 ) lnk.addClass('adjustheight').attr('height',baseh).attr('line1',line1).attr('line2',line2).css({height:baseh+hoff})
	txtObj.append(lnk);
	if( (l2+w2) > twidth ) lnk.remove(); /// OTHER PAGE

	var aleft = direction?l-4:l2+14;
	var ah = direction?h:h2;
	var ahoff = 0;
	if( htmlTextMode ) ahoff += lineOffset[tdest.line];
	var arrow = $('<DIV>').addClass('link_arrow')
						  .addClass('link')
						  .addClass('no-click')
						  .addClass('link_'+lid)
						  .addClass('link_arrow_'+lid)
						  .addClass('link_item_'+id1)
						  .addClass('link_item_'+id2)
						  .addClass('link_lb_'+id1+'_'+lab1)
  						  .addClass('link_lb_'+id2+'_'+lab2)
						  .addClass('adjusttop')
						  .attr('top', top+ah-10)
						  .attr('line', tdest.line )
						  .css({top:px(top+ah-10+ahoff),left:px(aleft),zIndex:3000-idx, borderTopColor: linkColor })
	txtObj.append(arrow);
	if( aleft > twidth ) arrow.remove();
	var lName = relationship;
	// if( lName == 'tmp' ) lName = '(select)';
	if( lName == 'tmp' ) lName = '(select)';
    var lab = $('<div>').addClass('link_label')
                        .addClass('link_label_'+lid)
						.addClass('link_item_'+id1)
						.addClass('link_item_'+id2)
						.addClass('link_lb_'+id1+'_'+lab1)
						.addClass('link_lb_'+id2+'_'+lab2)
						.addClass('link_'+lid)
                        .addClass('link')
                        .addClass('l_'+sv)
                        .prop('lid', lid)
                        .html(lName+extraLab)
						.addClass('adjusttop')
						.attr('top', top-10)
						.attr('line', line)
                        .css({top:px(top-10+topOffset),left:px(l+15),zIndex:4000-idx});


    var xis = $('<div>').addClass('tag_close link_close').prop('lid',lid).html(closeIcon);
    lab.append(xis);
    xis.click(linkDel)
	txtObj.append(lab);

	if( parseInt(lab.css('left')) < 10 ) lab.css({left:px(10)});
	$('.link_label_'+lid).off('mouseover').on('mouseover', linkOver );
	$('.link_label_'+lid).off('mouseout').on('mouseout', linkOut );
	$('.link_label_'+lid).off('click').on('click', linkClick );
	txtObj.find('.link_'+lid).prop('sig',sig);
	// console.log( "txtObj.find('.link_"+lid+"').prop('sig')" );
}

window.addLink = addLink;
function addLink( page, source, target, relationship, adj, origObj )
{
	if( !hasLinks ) return;
	if( !defined(source) || !defined(target) ) return;
	// console.log( 'ADDLINK-----', page, source, target, relationship, adj, origObj)
	linkChanged = true;
	linkPanelUpdate();
	// console.log( 'addLink', page, source, target, relationship, adj, origObj )
	var [id1,l1] = source.split('_');
	var [id2,l2] = target.split('_');
	for( var i = 0 ; i < linkList.length ; i++ )
    {
        var l = linkList[i];
        if( l.i1 == id1 && l.i2 == id2 )
        {
            return;
        }
    }
	var didx = 1;
    var lid = source + '-' + target;
	if( linkList.find( l => l.lid == lid ) ) return;
	if( ocrMode && linkList.find( l => l.i1 == source || l.i2 == target) ) return;
	var t1 = tagFind(id1);
    var t2 = tagFind(id2);
	if( !t1 || !t2 )
	{
		if( origObj )
		{
			var i1 = origObj.origId1 || id1;
			var i2 = origObj.origId2 || id2;
			console.error( 'invalid'+(origObj.adj ? ' adjudication ':' ')+'link', 'please check the ids:', 'id1', i1, t1?'found':'not found', 'id2', i2, t2?'found':'not found' );
		}
		return;
	}
	var page = t1.page;
	var page2 = t2.page;

	// linkList.push( {page: page, page2: page2, i1: id1, i2: id2, lid: lid, relationship: relationship, didx: didx, adj: adj == true } );
	linkList.push( {page: page, page2: page2, i1: source, i2: target, lid: lid, relationship: relationship, didx: didx, adj: adj == true } );
	if( page != currentPage && page2 != currentPage ) return;
	return lid;
}




function linkDel(ev)
{
	var lid = $(this).prop('lid');
	tmp = lid.split('-');
	delLink(tmp[0],tmp[1],true);
	drawText();
	eventOutsideEnd();
	ev.preventDefault();
}

function linkFind( lid )
{
    for( var i = 0 ; i < linkList.length ; i++ )
        if( linkList[i].lid == lid ) return linkList[i];
    return null;
}

var boxOver = null;
function boxSet( com, v )
{
	// console.log( 'boxSet', com, v );
	if( selectedBox !== null && com == 'set' )
	{
		if( blockEdit ) return locked();
		changed();
		var b = boxFind(selectedBox);
		b.label = v;
		drawBox( selectedBox );
		// setTimeout( function(){
			// listReset( $('#boxeskeys') );
		// },10 );
		popupOut();

	}
	else if( com == 'over' )
	{
		if( v > '' )
		{
			var sv = simplify(v);
			$('.nlpbbox').hide();
			$('.nlpbbox_').show();
			$('.nlpbbox-selected').show();
			$('.nlpbbox_'+sv).show();
			boxOver = v;
		}
	}
	else if( com == 'out' )
	{
		boxOver = null;
		drawBoxes();
	}
	return false;
}

function detectOS()
{
	var ua = navigator.userAgent;
	var patts = [ "ipad", "iphone", "ipod", "android", "linux", "windows", "mac" ];
	var os = [ "ios", "ios", "ios", "android", "linux", "windows", "mac" ];
	// var myLang = navigator['userLanguage'] || navigator['language'];
	// myLang = myLang.toLowerCase();
	// myLang = myLang.split('-')[0];
	for( var i = 0 ; i < patts.length ; i++ )
	{
		var r = RegExp( patts[i], "i" );
		if( ua.match(r) )
		{
			// var myOS = os[i];
			// var myPlatform = myOS == 'android' || myOS == 'ios' ? "mobile" : "desktop";
			return os[i];
		}
	}
}


function showHelp()
{
	var hotKeys = [
		// {key:'Ctrl </span> + <span><b>F</b></span> or <span>F3', command: 'Find text'},  mani
		// {key:'Ctrl + <b>G</b>', command: 'Find next'},
		// {key:'Ctrl + <b>]</b>', command: 'Move to next entity'},
		// {key:'Ctrl + <b>[</b>', command: 'Move to previous entity'},
		// {key:'Ctrl + <b>}</b>', command: 'Move to next entity of same type'},
		// {key:'Ctrl + <>{</b>', command: 'Move to previous entity of same type'},
		// {key:'Ctrl + <b>Arrow Right</b>', command: 'Move to next page'},
		// {key:'Ctrl + <b>Arrow Left</b>', command: 'Move to previous page'},
		// {key:'Ctrl + <i class="fa fa-plus"></i>', command: 'Zoom In'},
		// {key:'Ctrl + <i class="fa fa-minus"></i>', command: 'Zoom Out'},
		// {key:'Ctrl + <b>0</b>', command: 'Zoom Reset'},
		// {key:'Ctrl + <b>Text select</b>', command: 'Select exact text (don\'t expand)'},
		// {key:'Alt', command: 'Hide Annotations, Label popup '} //mani
		{key:'Ctrl </span> + <span>F</span> or <span>F3', command: 'Find text'},
		{key:'Ctrl </span> + <span> G', command: 'Find next'},
		{key:'Ctrl </span> + <span> ]', command: 'Move to next entity'},
		{key:'Ctrl </span> + <span> [', command: 'Move to previous entity'},
		{key:'Ctrl </span> + <span> }', command: 'Move to next entity of same type'},
		{key:'Ctrl </span> + <span> {', command: 'Move to previous entity of same type'},
		{key:'Ctrl </span> + <span> Arrow Right', command: 'Move to next page'},
		{key:'Ctrl </span> + <span> Arrow Left', command: 'Move to previous page'},
		{key:'Ctrl </span> + <span> <i class="fa fa-plus"></i>', command: 'Zoom In'},
		{key:'Ctrl </span> + <span> <i class="fa fa-minus"></i>', command: 'Zoom Out'},
		{key:'Ctrl </span> + <span> 0', command: 'Zoom Reset'},
		{key:'Alt', command: 'Hide Annotations, Label popup, Relationship '}
	];

	if( ocrMode || window.GlobalVars.PDFProjectType == 'Comprehend NER' ) {
		hotKeys.push( {key:'Shift </span> + <span> Text select', command: 'Add words to selected text'} )//mani removed <b></b>
		hotKeys.push( {key:'Ctrl </span> + <span> Text select', command: 'Unselect words from current annotation'} )
	} else {
		hotKeys.push({key:'Shift </span> + <span> Text select', command: 'Hide previous annotations for inner seletions'})
		hotKeys.push({key:'Ctrl </span> + <span> Text select', command: 'Select exact text (don’t expand)'})
	}

	hotKeys = hotKeys.concat( [
		{key:'Alt </span> + <span> Entity select', command: 'Enable entity comment'},
		{key:'Delete', command: 'Delete selected entity/relationship/box'},
	] );
	var os = detectOS()
	if( os == 'ios' || os == 'mac')
	{
		for( var h of hotKeys )
		{
			h.key = h.key.replace(/Ctrl/g, 'Command' );
			h.key = h.key.replace(/Alt/g, 'Option' );
		}
	}
	var helps = [];
	for( var h of hotKeys )
	{
		helps.push('<tr><td class="help-key"><span>'+h.key+'</span></td><td class="help-command">'+h.command+'</td></tr>')
	}
	frm.myAlert( 'Command Help', '<table class="help-table">'+helps.join('')+'</table>', 'Ok' );

}

function linkSet( com, v )
{
    // console.log( 'linkSet', com, v, 'selectedLink', selectedLink );
    if( com == 'set' && selectedLink )
    {
		if( blockEdit ) return locked();
		changed();
		linkChanged = true;
		linkPanelUpdate();
		// var sl = selecteLink;
        var l = linkFind( selectedLink );
        // console.log( 'linkFind', l );
        // linkUnselect();
        if( !l ) return;
        l.relationship = v;
        var sv = simplify(v);
        defineColor(sv);

        // listReset( $('#relationships') );
        drawText();
		linkSelect(selectedLink);
		popupOut();

		// console.log( JSON.stringify(rangeList).toString())
    }
    else if( com == 'over' && v )
    {
        v = simplify(v);
        $('.link_label').hide();
        $('.link').hide();
        $('.link_over').show();;
		$('.link_label_over').show();
		$('.link_arrow_over').show();
        $('.l_'+v).show();
		drawTags(1);
    }
    else if( com == 'out' )
    {
        // $('.link_label').hide();
        // $('.link').hide();
		// visibleLinks();
		drawTags();
    }
	return false;
}

function linkSelect( lid )
{
	// console.log( 'linkSelect', lid );
    tagUnselect();
	boxUnselect();
	$('.link').removeClass('link_arrow_over');
    $('.link').removeClass('link_label_over');
    $('.link').removeClass('link_over');
    selectedLink = lid;
	$('.link_label_'+selectedLink).addClass('link_label_over');
	$('.link_arrow_'+selectedLink).addClass('link_arrow_over');
    $('.link_'+selectedLink).addClass('link_over');
    if( hasLinks ) $('#relationships').show();
	var [source,target] = lid.split('-');
	var poss = possibleLink( source, target );

	if( !poss.length )
	{
		poss = possibleLink(target, source)
		console.log( 'possible result2', poss )
		// if( !poss.length ) return;]
	}
	// tagDownId = null;
	setTimeout( function(){
		$('.link_label_'+selectedLink).show();
	}, 500 );
	// check if hotkey is pressed


	var lnk = linkFind( lid );
	lnk.possible = poss;
	// if( lnk.relationship == 'tmp')
	// {
	// 	setTimeout( function(){
	// 		showPopup('relationships',$('.link_label_'+lid), lnk);
	// 	}, 100 );
	// }
	if( poss.length > 1 || descriptor.allowLabelInput )
	{
		setTimeout( function(){
			// console.log( 'showPopup', '.link_label_'+lid, $('.link_label_'+lid).length, lnk);
			showPopup('relationships',$('.link_label_'+lid), lnk);
		}, 100 );
		selectScroll();
	}
	else {

		eventOutside( $('.link_label_'+lid), 'mousedown', function(){
			linkUnselect();
			eventOutsideEnd();
		});
	}
	// else linkUnselect();
	// rightFocus('relationships');
}

function linkUnselect()
{
    selectedLink = null;
    linkOut();
	tagDownOff();
	selectScroll();
	// $('#relationships').hide();
}

function linkCrossPage(o)
{
	return $(o).hasClass('link-cross-page')
}
function linkClick(ev)
{
    clearTimeout(linkOutTid);
	if( ev.target.tagName == 'I' ) return ev.preventDefault();
    var id = $(this).prop('lid');
	// console.log( 'linkClick', ev.target, id );
	if( linkCrossPage(ev.target))
	{
		var tmp = id.split('-');
		var t1 = tagFind(tmp[0].split('_')[0]);
		var t2 = tagFind(tmp[1].split('_')[0]);
		var goPage = t1.page != currentPage ? t1.page : t2.page;
		var goTag = t1.page != currentPage ? t1.id : t2.id;
		drawPDF( gPDF, goPage, globalZoom, function(){
			setTimeout( function(){
				// console.log( 'tagSelect', goTag );
				tagSelect(goTag);
				selectedPos();
			}, 300)
		} );
		return ev.preventDefault();
	}
    linkSelect( id );
    // console.log( 'selectedLink', selectedLink );
    return false;
}


function linkOver(ev)
{
	if( ev && linkCrossPage(ev.target) )
	{
		$(ev.target).addClass('link-cross-page-over');
		return ev.preventDefault();
	}
	if( boxMode ) return;
    clearTimeout(linkOutTid);
	$('.link').removeClass('link_arrow_over');
	$('.link').removeClass('link_label_over');
    $('.link').removeClass('link_over');

    var id = $(this).prop('lid');
    // console.log( 'overlink', id, '.link_label'+id );
	$('.link_arrow_'+id).addClass('link_arrow_over');
	$('.link_label_'+id).addClass('link_label_over');
    $('.link_'+id).addClass('link_over');
    // console.log( 'OVER', id );
    if( selectedLink )
    {
		$('.link_label_'+selectedLink).addClass('link_label_over');
		$('.link_arrow_'+selectedLink).addClass('link_arrow_over');
        $('.link_'+selectedLink).addClass('link_over');
    }
    return false;
}

var linkOutTid = null;
function linkOut(ev)
{
	if( ev && linkCrossPage(ev.target) )
	{
		$(ev.target).removeClass('link-cross-page-over');
		return ev.preventDefault();
	}
    clearTimeout(linkOutTid);
    linkOutTid = setTimeout( function(){
        $('.link').removeClass('link_label_over');
        $('.link').removeClass('link_over');
        if( selectedLink )
        {
			$('.link_label_'+selectedLink).addClass('link_label_over');
			$('.link_arrow_'+selectedLink).addClass('link_arrow_over');
            $('.link_'+selectedLink).addClass('link_over');
        }
    }, 100 );
}

function setUsed( div, v )
{
    var used = div.prop('used');
    if( !used ) used = {};
    used[v] = 1;
    div.prop('used',used);
}

var docUsed = {};
function setDocUsed( label, v )
{
	// console.log( 'setDocUsed', label, v )
	label = label.toLowerCase();
	if( !docUsed[label] ) docUsed[label] = {};
    docUsed[label][v] = 1;
}

function getDocUsed( label, v )
{
	// console.log( 'getDocUsed', label, v )
	label = label.toLowerCase();
	try {
		return docUsed[label][v] || 0;
	} catch(e){ return 0 };
}

function clearUsed( div, v )
{
    div.prop('used',{});
}

function drawUsed( div, v )
{
	if( !div || !div.length ) return;
	var docLabel = div.prop('id');
	// console.log( 'DOCLABEL', docLabel, div, div.prop('docLabel') )
	delete docUsed[docLabel];
	var docObj = rangeList;
	if( docLabel == 'relationships' ) docObj = linkList;
	else if( docLabel == 'boxes' ) docObj = boxes;
	docObj.forEach( d => {
		// console.log( 'docObj', d )
		if( d.type ) setDocUsed(docLabel,d.type);
		if( d.label ) setDocUsed(docLabel,d.label);
		if( d.properties ) d.properties.forEach( p => setDocUsed(docLabel,p) )
		if( d.relationship ) setDocUsed(docLabel,d.relationship);
	})
	// console.log( 'drawUsed', div, docLabel, docObj );
    var redraw = div[0].redraw;
    if( redraw ) redraw();
}

var possibleHash = {};
var possibleStartHash = {};
function makePossibleHash()
{
	possibleHash = {};
	possibleStartHash = {};
	function findLabels( v )
	{
		var out = [];
		for( var l in descriptor.labels )
		{
			var labelOk = false
			for( var f in descriptor.labels[l] )
			if( v == '' || simplify(l) == v ) labelOk = true;
			else {
				{
					if( simplify(descriptor.labels[l][f].toString()) == v )
					{
						labelOk = true;
						break;
					}
				}
			}
			if( labelOk ) out.push(simplify(l));
		}
		return out;
	}
	function add( source, target, rel )
	{
		var slist = findLabels(simplify(source));
		var tlist = findLabels(simplify(target));
		// console.log( 'add', source, target, slist, tlist )
		for( var s of slist )
		{
			for( var t of tlist )
			{
				var k = s + '_' + t;
				if( !possibleHash[k] ) possibleHash[k] = {};
				possibleHash[k][rel] = 1;
			}
		}
	}
	function addSingle( source, target )
	{
		var slist = findLabels(simplify(source));
		var tlist = findLabels(simplify(target));
		// console.log( 'addSingle', source, target, slist, tlist )
		for( var s of slist )
		{
			for( var t of tlist )
			{
				if( !possibleStartHash[s] ) possibleStartHash[s] = {};
				possibleStartHash[s][t] = 1;
			}
		}
		//
		//
		// source = simplify( source )
		// target = simplify( target )
		// if( !possibleStartHash[source] ) possibleStartHash[source] = {};
		// possibleStartHash[source][target] = 1;
	}
	for( var rel in descriptor.relationships )
	{
		var allowed = descriptor.relationships[rel].allowedRelationships;
		if( !allowed )
		{
			add( '*', '*', rel );
			addSingle( '*', '*', rel );
		}
		else for( var a of allowed )
		{
			for( var source of a.sourceEntityLabelCategories )
				for( var target of a.targetEntityLabelCategories )
				{
					add( source, target, rel )
					addSingle( source, target )
				}
		}
	}
	for( var p in possibleHash ) possibleHash[p] = Object.keys(possibleHash[p]);
	for( var p in possibleStartHash ) possibleStartHash[p] = Object.keys(possibleStartHash[p]);
	// console.log( 'possibleHash', clone(possibleHash) );
}

function possibleLink( a, b )
{
	var ret = [];
	var [tag1,lab1] = a.split('_');
	var [tag2,lab2] = b.split('_');
	
	if( ocrMode ) {
		// console.log( 'POSSIBLE', tag1, lab1, tag2, lab2 )
		if( !lab1.match(/.(key|val)$/) || !lab2.match(/.(key|val)$/)  ) return [];
		if( lab1.match(/.key$/) && !lab2.match(/.val$/) ) return [];
		if( lab1.match(/.val$/) && !lab2.match(/.key$/) ) return [];
		if( lab1.replace(/(key|val)$/) != lab2.replace(/(key|val)$/) ) return [];
		// console.log( 'POSSIBLEOK', tag1, lab1, tag2, lab2 )
	}
	if( tag1 == tag2 ) return ret;
	var k = simplify(lab1) + '_' + simplify(lab2);
	if( possibleHash[k] ) ret = ret.concat(possibleHash[k])
	if( possibleHash['_'] ) ret = ret.concat(possibleHash['_'])
	return ret;
}

function noTargetLink()
{
	$('.tag_label_target').removeClass('tag_label_target');
	$('.tag_label_impossible').removeClass('tag_label_impossible');
}

function checkLinks(id)
{
	delLink(id+'_*');
	$('.link_item_'+id).remove();
	drawLinks();
}

function drawTag( id, force )
{
    var r = tagFind(id);
	if( !r ) return;

	// check if it needs drawing
	if( !r.properties ) r.properties = [];
	var allLabels = r.properties.join('|');
	var otag = $('.tag_'+id);
	if( r.force ) { force = 1; delete r.force }
	if( otag.length )
	{
		if( otag.prop('allLabels') == allLabels && !force ) return;
		otag.remove();
	}

    var pos = tagPos(id);
	if( pos.position ) pos.x1 = pos.position.left;
	if( r.rawBox ) {
		pos.y1 -= 15;
		pos.y2 -= 15;
	}
	if( r.rotate ) {
		var cx = (pos.x2+pos.x1)/2;
		var cy = (pos.y2+pos.y1)/2;
		var an = toRad( r.rotate );
		[pos.x1,pos.y1] = rotateXY( pos.x1, pos.y1, cx, cy, an )
	}
	var topOffset = 0;
	console.log( 'drawTag', id, force, r.force, pos )
	if( htmlTextMode )
	{
		r.line = pos.line;
		topOffset = lineOffset[r.line] || 0;
	}
	else r.line = '';
	var topDec = 16;
	var tagH = topDec+2;
	// console.log( 'drawtag', id, pos )
	if( !pos )
	{
		// console.error( 'invalid tag element', id );
		return;
	}
	if( r.page != currentPage ) return;

	var pbottom = 0;
    var top = pos.y1-3;
	var stackSize = 0;

	{
		// find tag index for start char
		var c = txtObj.find('.pp'+r.range[0]);
		var ctags = getList( c, 'ids' );
		ctags.sort( function(a,b) { return rangeHash[a.toString()].idx < rangeHash[b.toString()].idx ? -1 : 1 })
		var cidx = ctags.indexOf(id.toString());
		// console.log('pp'+r.range[0], getList( c, 'ids' ), cidx );
		top -= topDec*cidx;
		tagH += topDec*cidx;
		stackSize+=cidx;
	}
	if( r.adj ) top -= 20;
	if( oocrMode ) top -= 10;

    var left = pos.x1;


	for( var label of r.properties )
	{
		// console.log( 'LABEL', label, label == 'TABLECELL' )
		if( label.match(/TABLECELL/) ) continue;
		stackSize++;
		var labelText = aliases[label] || label;
		// if( labelText == 'tmp' ) labelText = '(select)';
		if( labelText == 'tmp' ) labelText = '';
		let adjTag = false;
		let conTag = false;
		if( labelText.match( adjKey ) ) {
			adjTag = true;
			labelText = labelText.replace( adjKey, '');
		}
		if( labelText.match( consensusKey ) ) {
			conTag = true;
			labelText = labelText.replace( consensusKey, '');
		}
		labelText = '<span>' + labelText + '</span>';
		if( r.comment > '' ) labelText = '<sub>* </sub>'+labelText;


		var color = getFontColor(label);
		if( !color )
		{
			console.error( 'invalid color', label )
			color = '#000000';
		}
		color = color.substr(0,7);
		var txt = $('<div>').addClass('tag_label_text').html(labelText);
		if( adjMode ) {
			txt.css( { background: adjTag ? colorAdj : (conTag ? colorConsensus : colorGroundtruth)})
		}
		var slabel = simplify(label);
		var tidLabel = id+'_'+slabel;
		var ptop = top-18;
		var pos = {top:ptop,left:left};
		// console.log( 'drawTag', r.properties, label, pos )
		var tag = $('<div>').addClass('tag_label').addClass('adjusttop').addClass('tag_'+id).addClass('tag_visible_'+slabel).addClass('tag_'+tidLabel)
		.attr('top',ptop).attr('line',r.line).prop('tagid',id).prop('islabel',true).prop('labelText',labelText).prop('label',label).prop('allLabels',allLabels).prop('tidLabel', tidLabel ).prop('pos', pos).prop('tidLabel',tidLabel)
		.css({
			top:top-18+topOffset,
			left:left,
			height:tagH,
			paddingBottom: pbottom,
			color: color,
			// zIndex: r.range[0],
			zIndex: 20000,
		}).append(txt);
		// if( r.subCount > 0 ) tag.addClass('tag_parent')
		var xis = $('<div>').addClass('tag_close').html(closeIcon);
		if( r.adj ) tag.addClass('tag_adj');
		// tag.append(xis);
		txt.append(xis);
		setUsed($('#labels'), label );
		xis.on('mousedown',function(ev){
			if( blockEdit ) return locked();
			var label = $(this).closest('.tag_label').prop('label')
			delRangeLabel( id, label );
			tagPanelUpdate();
			// var idx = r.properties.indexOf(label);
			// if( idx >= 0 ) r.properties.splice(idx,1);
			// if( r.rawBox ) {
			// 	delBox( r.id )
			// 	selected = null;
			// }
			// //AQUI
			// drawTag( id )
			// delTmp();
			// checkLinks(id);
			// if( htmlTextMode ) setTimeout(drawHtmlAdjust, 100);
			ev.preventDefault();
			return false;
		})
		txtObj.append(tag);
		// console.log('TAG', tag)
		tag.off('mouseover').on('mouseover', function(ev){
			// console.log( 'mouseover', this, tagDownId )
			tagOver.apply(this);
			$('.tag_label_over').removeClass('tag_label_over');
			$(this).addClass('tag_label_over');
			if( tagDownId )
			{
				noTargetLink();
				var possible = possibleLink( tagDownId, $(this).prop('tidLabel')).length || possibleLink( $(this).prop('tidLabel'), tagDownId ).length;
				if( possible ) $(this).addClass('tag_label_target');
				else $(this).addClass('tag_label_impossible')
			}
		});
		// tag.off('mouseover').on('mouseover', tagOver );
		tag.off('mouseout').on('mouseout', tagOut );
		// tag.off('mousedown').on('mousedown', tagDown );
		var tLabel = label;
		tag.off('mousedown').on('mousedown', function(ev){
			if( boxMode ) return;
			if( blockEdit ) return locked();
			// if( ev.button == 2 ) return;
			var me = this;
			setTimeout( function(){ // settimeout as to treat this event last
				if( tagDownId ) return;
				var tid = $(me).prop('tidLabel');
				var [t,l] = tid.split('_');
				if( !possibleStartHash[l] && !possibleHash['_'] )
				{
					// console.log( 'NOTPOSSIBLEHASH')
					return;
				}
				$(me).addClass('tag_label_relation');
				tagDownId = tid;
				tagDownPos = labelPos(tagDownId);
				if( htmlTextMode ) tagDownPos.y1 += lineOffset[r.line];
				tagDownPos.page = currentPage;
				if( !showTags ) $('.tag_label').addClass('tag_label_invisible');
				setLinkTmp();
				// console.log( 'TAGDOWN')
			},1 );
		});
		tag.off('mouseup').on('mouseup', function(ev){
			// if( ev.button == 2 ) return;
			//aqui
			if( boxMode ) return;
			if( ev.button == 2 || tagDownId !== null ){
				return tagUp.apply(this,[ev]);
			}
			var t = tagFind(id);
			if( t && t.adj )
			{
				if( !ev || !$(ev.target).hasClass('fa-close')) promote( t );
				return;
			}
			tagUp.apply(this,[ev]);
		} );
		tag.off('contextmenu').on('contextmenu', ignoreRightClick );
		top -= topDec;
		tagH = topDec;
	}

	r.stack = stackSize;
}


function promoteCheck( tag )
{
	// check for link of this tags
	var linked = [];
	linkList.forEach( l => {
		// console.log( 'CHECK PROMOTE', l, l.i1, l.i2, 'tag', tag.id );
		if( l.i1 == tag.id )
		{
			var t = tagFind(l.i2);
			if( t.adj ) linked.push( t )
		}
		if( l.i2 == tag.id )
		{
			var t = tagFind(l.i1);
			if( t.adj ) linked.push( t )
		}
	});
	var recs = linked.length == 1 ? 'another label linked with a relationship' : linked.length + ' labels linked with relationships';
	function promoteAll()
	{
		promote(tag,1);
		linked.forEach(t=> promote(t,1));
		// console.log( 'PROMOTE ALL', tag.id, linked );
	}
	function promoteOne()
	{
		promote(tag,1);
		// console.log( 'PROMOTE ONE', tag.id );
	}
	if( linked.length ) frm.myAlert('Promote Label', 'This label has '+recs+'. Do you want to promote them as well?', 'Promote All', promoteAll, 'Only this label', promoteOne, 'Cancel' );
	return linked.length > 0;
}

function tagOverlap( tag )
{
	var overlap = []
	for( var i = 0 ; i < rangeList.length ; i++ )
	{
		var r = rangeList[i];
		if( r.id != tag.id
			&& r.page == tag.page
			&&
			( (r.range[0] >= tag.range[0] && r.range[0] < tag.range[1]) ||
			  (r.range[1] > tag.range[0] && r.range[1] < tag.range[1]) ||
			  (r.range[0] < tag.range[0] && r.range[1] > tag.range[1])) )
		{
			// console.log( 'OVERLAP', r.id, r.adj, r.type, r.text );
			overlap.push(r);
		}
	}
	return overlap;
}

function promote( tag, nocheck )
{
	// console.log( 'PROMOTE', tag )
	if( tag.parent ) tag = tagFind( tag.parent );
	if( !nocheck && promoteCheck( tag ) ) return;

	// find if there is overlaping tags
	showAdjudication = false;
	var overlap = tagOverlap(tag);
	delRange(tag.id,1);
	overlap.forEach( r => {
		delRange(r.id,1);
		addRange(splitRange( r.range, r.id, r.type, !r.adj, r.page, r.properties ));
	})
	showAdjudication = true;
	// console.log( 'splitRange(', [JSON.stringify(tag.range), tag.id, tag.type].join(', '), ')' )
	addRange(splitRange( tag.range, tag.id, tag.type, false, tag.page, tag.properties ));
	adjustText();
	tagUnselect();
	// setTimeout( function(){
	// 	selected = null;
	// 	drawText();
	// }, 1 );
}

function ignoreRightClick(ev)
{
	ev.preventDefault();
	return false;
}

var tagDownId = null;
var tagDownPos = null;
function tagDown(ev,tagId)
{
	// if( blockEdit ) return locked();
	//
    // var id = $(this).prop('tagid');
	// var t = tagFind(id);
	// if( t && t.adj )
	// {
	// 	if( !ev || !$(ev.target).hasClass('fa-close')) promote( t );
	// 	return;
	// }
	// if( tagId ) id = tagId;
	// if( tagDownId ) return tagUp(null,id);
    // tagDownId = id;
    // $('.tag_'+id).addClass('tag_label_relation');
    // // console.log( 'tagDown', tagDownId );
	// drawTags();
}

function tagDownOff()
{
	tagDownId = null;
	$('.tag_label').removeClass('tag_label_invisible');
	$('.tag_label_relation').removeClass('tag_label_relation');
}

function tagDownOn()
{

	if( tagDownId === null ) return;
	var id = tagDownId;
	// tagDownId = null;
	$('.tag_label').removeClass('tag_label_invisible');
	tagDown(null,id);
}


function tagUp(ev,tagId)
{
	var tidLabel = $(this).prop('tidLabel');
	var tid = tagDownId;


	if( tidLabel && tid && tidLabel != tid)
	{
		var poss = possibleLink( tid, tidLabel );
		if( !poss.length )
		{
			poss = possibleLink( tidLabel, tid )
			if( !poss.length ) {
				delTmpLinks();
				tagDownId = null;
				linkChanged = true;
				tagDownId = null;
				unsetLinkTmp();
				delTmpLinks();
				return;
			}
		}
	}


	tagId = tidLabel.split('_')[0];
	console.log( 'tagUp', tidLabel, tagId, tagDownId )
	if( tagDownId == tidLabel ) {
		tagDownId = null;
		unsetLinkTmp();
}
	if( tagDownId === null )
	{
		tagSelect(tagId);
		return false;
	}
	// console.log( 'evButton', ev.button )

	if( ev && ev.button == 2 )
	{
		ev.preventDefault();
		return false;
	}
	else
	{
		$('.tag_label').removeClass('tag_label_invisible');
		tagId = tagDownId.split('_')[0];
		tagDownId = null;
		tagSelect( tagId)
	}
	noTargetLink();
	// console.log( 'tagUp', tidLabel, tid )
	if( tidLabel && tid )
	{
		var poss = possibleLink( tid, tidLabel );
		if( !poss.length )
		{
			poss = possibleLink( tidLabel, tid )
			if( !poss.length ) {
				delTmpLinks();
				tagDownId = null;
				ev.preventDefault();
				ev.stopPropagation();
				return;
			}
			var tmp = tidLabel;
			tidLabel = tid;
			tid = tmp;
		}
		// console.log( 'POSS', poss, tidLabel, tid )
		delTmpLinks();
		var rel = poss.length == 1 ? poss[0] : 'tmp';
		var lid = addLink( currentPage, tid, tidLabel, rel);
		if( lid ) {
			linkTag( tid, tidLabel, rel, linkFind(lid) );
			linkChanged = true;
			if( ocrMode ) ocrPanel();
			changed();
			if( htmlTextMode ) setTimeout(drawHtmlAdjust, 100);
			linkSelect(lid);
		}
	}
}

function bodyUp(ev)
{
	boxUp(ev);
	if( $(ev.target).closest('.pagination').length ) return;
	if( $(ev.target).closest('.nlp-pagination').length ) return;
	if( !$(ev.target).closest('.tag_label').length )
	{
		tagDownId = null;
		$('.tag_label').removeClass('tag_label_invisible');
	}
    $('.tag_label').removeClass('tag_label_relation');
	clearTimeout( lastLnkTid );
	txtObj.find('.link_TMPLID').remove();
	unsetLinkTmp();
}

function adjustText()
{
	if( htmlTextMode || engine2() ) return;
	tList.forEach( function(tl){ textAdjustClass($(tl.obj).parent())})
	tListAdj.forEach( function(tl){ textAdjustClass($(tl.obj).parent(),1)})
	// txtObjAdj.find('.pdf_text').addClass('adj_text');

	adjustTextMode();
}

var tagPanelUpdateTid = null;
function tagPanelUpdate()
{
	clearTimeout( tagPanelUpdateTid );
	tagPanelUpdateTid = setTimeout( tagPanel, 200 );
}

function tagPanel()
{
	if( !rangeChanged ) return;
	if( descriptor.qaMode ) return;
	if( ocrMode ) return ocrPanel();
	var tags = {};
	function add( tag, id, text )
	{
		if( !tags[tag] ) tags[tag] = [];
		tags[tag].push( [id,text] );
	}

	if( ocrMode ) {
		var linked = {};
		for( var ln of linkList ) {
			linked[ln.i1.split('_')[0]] = 1;
			linked[ln.i2.split('_')[0]] = 1;
		}
	}


	rangeList.forEach( function(r)
    {
		if( (!descriptor.showAllPages && r.page != currentPage) || r.adj ) return;
		// if( r.page != currentPage  || r.adj ) return;
		if( ocrMode && linked[r.id]) return;
		if( !r.properties ) r.properties = [];
		for( var l of r.properties )
		{
			if( l == 'TABLECELL' ) continue; 
			add( l, r.id, r.textAdjust || r.text )
		}
    });
	var labs = Object.keys(tags).sort();
	var title = 'Labels'; //modify  Label Annotations  to Labels 20/12mani
	if( ocrMode ) title = 'Single Annotations';
	var out = []
	out.push('<div class="form-check mr-1" style="float:right"><input class="form-check-input" type="checkbox" value="" id="showallpages" /><label class="form-check-label unselectable" for="showallpages">Show all pages</label></div>');
	out.push('<div class="panel-title">'+title+'</div>');
	if( !labs.length ) out.push('<div class="tag-panel-empty">(no annotations in this page)</div>')
	for( var l of labs )
	{
		let ll = l;
		if( ll.match( adjKey ) ) ll = ll.replace( adjKey, '');
		if( ll.match( consensusKey ) ) ll = ll.replace( consensusKey, '');
		if( ll.match(/^(TABLECELL|TABLEHEADER)$/) ) continue
		if( !inDescriptor( 'labels', ll ) ) continue;
		out.push('<div class="tag-panel-label" style="border-color: ' + descriptor.labels[ll].color + '">');
		out.push('<div class="tag-panel-label-name">' + ll + '</div>');
		for( var t of tags[l] )
		{
			// out.push('<span class="label-cloud" tag="'+t[0]+'">'+t[1]+' <i class="fa fa-times-circle"></i></span>') 9/1 hide mani
			out.push('<span class="label-cloud1"><span class="label-cloud" tag="'+t[0]+'">'+t[1]+' </span><i class=" mul fa fa-times-circle" tag="'+t[0]+'"></i></span>')
		}
		out.push('</div>');
	}
	$('#labels').html(out.join(''));

	$('#showallpages').prop('checked', descriptor.showAllPages ).on('click', function(ev){
		descriptor.showAllPages = $('#showallpages').prop('checked');
		rangeChanged = linkChanged = true;
		tagPanel();
		linkPanel();
	})
	function tclick(ev){
		var del = ev.target.tagName == 'I';
		var id = $(ev.target).attr('tag');
		if( !del ){
			var tag = tagFind(id);
			if( tag.page == currentPage ) tsel();
			else drawPDF( gPDF, tag.page, globalZoom, tsel )
			function tsel(){
				tagSelect(id);
				selectedPos();
			}
		}
		else delRange(id);
		// console.log( 'TAG', id, del );
	}
	$('.label-cloud').on('click', tclick );
	$('.fa-times-circle').on('click', tclick );
	$('.label-cloud').on('mouseover', function(ev){
		var id = $(ev.target).closest('span').attr('tag');
		var t = $('.tag_'+id);
		tagOver.apply( t );
	})
	$('.label-cloud').on('mouseout', function(ev){
		var id = $(ev.target).closest('span').attr('tag');
		var t = $('.tag_'+id);
		tagOut.apply( t );
	})
	rangeChanged = false;
	// console.log( tags, out );
}

var linkPanelUpdateTid = null;
function linkPanelUpdate()
{
	clearTimeout(linkPanelUpdateTid);
	linkPanelUpdateTid = setTimeout( linkPanel, 200 );
}

function labId( tag, lab )
{
	var list = tag.properties.map( p => simplify(p) );
	return list.indexOf( lab );
}


window.linkPanel = linkPanel;
function linkPanel()
{
	if( !linkChanged ) return;
	if( ocrMode ) return;
	if( descriptor.qaMode ) return;


	var title = 'Relationships';//modify  Relationship Annotations  to Relationships 20/12 mani
	if( ocrMode ) title = 'Key-value pairs';
	var out = ['<div class="panel-title">' + title + '</div>'];

	var nlinks = 0;
	for( var l of linkList )
	{
		var [t1,l1] = l.i1.split('_');
		var [t2,l2] = l.i2.split('_');
		var tag1 = tagFind(t1);
		var tag2 = tagFind(t2);
		// console.log( 'lpanel', tag1.page, tag2.page, 'currentPage', currentPage, 'ck', tag1.page != currentPage, tag2.page != currentPage  )
		if( !descriptor.showAllPages && tag1.page != currentPage && tag2.page != currentPage ) continue;
		var li1 = labId( tag1, l1 );
		var li2 = labId( tag2, l2 );
		if( !inDescriptor( 'labels', tag1.properties[li1] ) ) continue;
		if( !inDescriptor( 'labels', tag2.properties[li2] ) ) continue;
		
		var lab1 = descriptor.labels[tag1.properties[li1]]
		var lab2 = descriptor.labels[tag2.properties[li2]];
		// console.log( l, t1, lab1, t2, lab2 );
		var rel = l.relationship;
		if( !inDescriptor( 'relationships', rel ) ) continue;
		var relColor = descriptor.relationships[rel].color;
		
		var l1txt = lab1.name;
		var l2txt = lab2.name;
		if( ocrMode ) {
			l1txt = '';
			rel = '';
			var [l2txt,type] = keysetType(l2txt);
		}
		out.push( '<div class="tag-panel-relationship" rel="'+l.lid+'">')
		// out.push( '<table><tr><td class="rel-left" style="color: '+lab1.color+'">'+l1txt+'</td><td class="rel-mid" style="color: '+relColor+'">'+rel+'</td><td class="rel-right" style="color: '+lab2.color+'">'+l2txt+'</td><td class="rel-del" rowspan="2"><i class="fa fa-times-circle"></i></tr>' ); 21 /12 mani
		out.push( '<table><tr><td class="rel-left" >'+l1txt+'</td><td class="rel-mid" >'+rel+'</td><td class="rel-right" >'+l2txt+'</td><td class="rel-del" rowspan="2"><i class="fa fa-times-circle"></i></tr>' );
		// out.push( '<tr><td class="rel-left"><span style="background: '+lab1.color+'44">'+shrinkText(tag1.textAdjust||tag1.text)+'</span></td><td class="rel-mid"><i class="fa fa-long-arrow-right"></i></td><td class="rel-right"><span style="background: '+lab2.color+'44">'+shrinkText(tag2.textAdjust || tag2.text)+'</span></td></tr></table>' ) 16/12 mani;
		out.push( '<tr><td class="rel-left"><span class="rel-textellipsis" style="background: '+lab1.color+'44">'+shrinkText(tag1.textAdjust||tag1.text)+'</span></td><td class="rel-mid"><i class="fa fa-long-arrow-right"></i></td><td class="rel-right"><span class="rel-textellipsis" style="background: '+lab2.color+'44">'+shrinkText(tag2.textAdjust || tag2.text)+'</span></td></tr></table>' );
		out.push( '</div>')
		nlinks++;
	}
	if( !nlinks ) out.push('<div class="tag-panel-empty">(no annotations in this page)</div>')

	$('#relationships').html(out.join(''));
	$('.tag-panel-relationship').on('click', function(ev){
		var del = ev.target.tagName == 'I' && $(ev.target).hasClass('fa-times-circle');
		var id = $(ev.target).closest('.tag-panel-relationship').attr('rel');
		if( !del ){
			var lnk = linkFind(id);
			// console.log( lnk)

			if( lnk.page == currentPage || lnk.page2 == currentPage ) lsel();
			else drawPDF( gPDF, lnk.page, globalZoom, lsel )
			function lsel() {
				linkSelect(id)
				selectedPos($('.link_label_'+id));
			}

			// tagSelect(id);
			// selectedPos();
		}
		else {
			var tmp = id.split('-');
			delLink(tmp[0],tmp[1],true);
		}
		// else delRange(id);
		// console.log( 'RELA', id, del );
	})
	$('.tag-panel-relationship').on('mouseover', function(ev){
		var id = $(ev.target).closest('.tag-panel-relationship').attr('rel');
		var l = $('.link_'+id);
		if( !showLinks ) l.show();
		if( !showTags )
		{
			var [i1,i2] = id.split('-');
			$('.tag_'+i1).show();
			$('.tag_'+i2).show();
		}
		// tagOver.apply( t );
	})
	$('.tag-panel-relationship').on('mouseout', function(ev){
		var id = $(ev.target).closest('.tag-panel-relationship').attr('rel');
		var l = $('.link_'+id);
		if( !showLinks && id != selectedLink ) l.hide();
		if( !showTags )
		{
			var [i1,i2] = id.split('-');
			$('.tag_'+i1).hide();
			$('.tag_'+i2).hide();
		}
	})
	linkChanged = true;
	// console.log( 'linkPanel')
}


function ocrPanel()
{
	if( !rangeChanged && !linkChanged ) return;

	$('#relationships').hide();
	$('#labels').addClass('ocrpanel');

	// var title = 'Key-value pairs';
	var title = 'Entities';
	var out = ['<div class="panel-title">' + title + '</div>'];

	var nlinks = 0;
	var outList = [];
	for( var l of linkList )
	{
		var [t1,l1] = l.i1.split('_');
		var [t2,l2] = l.i2.split('_');
		var tag1 = tagFind(t1);
		var tag2 = tagFind(t2);
		if( !tag1 || !tag2 ) continue;
		if( tag1.page != currentPage && tag2.page != currentPage ) continue;
		var li1 = labId( tag1, l1 );
		var li2 = labId( tag2, l2 );
		if( !inDescriptor( 'labels', tag1.properties[li1] ) ) continue;
		if( !inDescriptor( 'labels', tag2.properties[li2] ) ) continue;
		
		var lab1 = descriptor.labels[tag1.properties[li1]];

		var lab2 = descriptor.labels[tag2.properties[li2]];
		// console.log( 'LINK', t1, t2, l1, l2, lab1.name, lab2.name )
		if( !tag1.links ) tag1.links = {};
		if( !tag2.links ) tag2.links = {};
		tag1.links[l1] = t2;
		tag2.links[l2] = t1;
		var [lab,type] = keysetType(lab1.name);
		outList.push( {
			idx: tag1.idx,
			idx2: tag2.idx,
			id1: t1,
			id2: t2,
			page1: tag1.page,
			page2: tag2.page,
			color: lab1.color,
			txt1: tag1.textAdjust || tag1.text,
			txt2: tag2.textAdjust || tag2.text,
			lid: l.lid,
			label: lab,
		})

	}
	// console.log( 'outList', clone(outList) )
	for( var r of rangeList ) {
		if( r.page != currentPage || !r.properties ) continue;
		for( var p of r.properties ) {
			if( p == 'TABLECELL' ) continue;
			// if( p.match(/(GENERIC|TABLECELL)/)) continue;
			if( p.match(/(TABLECELL)/)) continue;
			var [lab,type] = keysetType(p);
			var olab = descriptor.labels[p];
			if( !olab ) {
				addDescriptorLabel( p, false );
				var olab = descriptor.labels[p];
			}
			if( olab.placeholder ) continue
			// console.log( 'SINGLE', p, olab )
			var slab = simplify(p);
			if( r.links && r.links[slab] ) continue;
			var o = {
				idx: 0,
				idx2: 0,
				id1: -1,
				id2: -1,
				txt1: '',
				txt2: '',
				page1: '',
				page2: '',
				lid: null,
				label: lab,
				single: true,
			}
			if( type == 'KEY') {
				o.idx = r.idx;
				o.id1 = r.id;
				o.page1 = r.page;
				o.color = olab.color;
				o.txt1 = r.textAdjust || r.text;
			}
			else {
				o.idx = r.idx;
				o.id2 = r.id;
				o.page2 = r.page;
				o.color = olab.color;
				o.txt2 = r.textAdjust || r.text;
				if( type == '' ) o.notKeyPair = true;
			}
			// console.log( 'SINGLE', r.id, r.text, p, o )
			outList.push(o);
		}
		delete r.links;
	}
	outList.sort( (a,b) => {
		if( a.idx < b.idx ) return -1;
		else if( a.idx == b.idx ) return a.idx2 < b.idx2 ? -1 : 1;
		else return 1;
	})
	// console.log( 'outList', clone(outList) )


	if( !outList.length ) out.push('<div class="tag-panel-empty">(no annotations in this page)</div>')
	
	for( var l of outList ) {
		var empty1 = l.id1 >= 0 ? '' : ' rel-empty';
		var empty2 = l.id2 >= 0 ? '' : ' rel-empty';
		var page1 = l.page1 ? 'Page ' + l.page1 : '';
		var page2 = l.page2 ? 'Page ' + l.page2 : '';
		page1 = page2 = '';
		if( l.single ) {
			var id = l.id1 >= 0 ? l.id1 : l.id2;
			out.push( '<div class="tag-panel-relationship" tag="'+id+'" sstyle="color: '+l.color+'44">')// modify l.color+'" to l.color+'44" 21/12 mani
		} else {
			out.push( '<div class="tag-panel-relationship" rel="'+l.lid+'" sstyle="color: '+l.color+'44">')// modify l.color+'" to l.color+'44" 21/12 mani
		}
		l.llabel = l.label.replace(adjKey,'').replace(consensusKey,'');
		out.push( '<i class="rel-del-button fa fa-times-circle"></i><table class="rel-table">');
		if( l.notKeyPair ) {
			out.push( '<tr><td class="rel-left" sstyle="color: '+l.color+'44">'+l.llabel+'</td></tr>' );// modify l.color+'" to l.color+'44" 21/12 mani
			out.push( '<tr><td class="rel-left rel-box'+empty2+'" style="background-color: '+l.color+'44" tag="'+l.id2+'"><span class="rel-ellipsis">'+l.txt2+'</span></td></tr></table>' );// modify l.color+'" to l.color+'44" 21/12 mani
		}
		else {
			out.push( '<tr><td class="rel-left rel-head-left">Key</td><td class="rel-mid rel-head-mid" style="color: '+l.color+'">'+l.label+'</td><td class="rel-right rel-head-right">Value</td></tr></table>' );// modify l.color+'" to l.color+'44" 21/12 mani
		out.push( '<table>');
		// out.push( '<table class="rel-table"><tr><td class="rel-left rel-box'+empty1+'" tag="'+l.id1+'" style="background-color: '+l.color+'44"><span class="rel-ellipsis">'+l.txt1+'</span></td><td class="rel-mid" style="color: '+l.color+'44"><i class="fa fa-long-arrow-right"></i></td><td class="rel-right rel-box'+empty2+'" tag="'+l.id2+'" style="background-color: '+l.color+'44"><span class="rel-ellipsis">'+l.txt2+'</span></td></tr>' ); mani
		   out.push( '<table class="rel-table"><tr><td class="rel-left rel-box'+empty1+'" tag="'+l.id1+'" style="background-color: '+l.color+'44"><span class="rel-ellipsis">'+l.txt1+'</span></td><td class="rel-mid"><i class="fa fa-long-arrow-right"></i></td><td class="rel-right rel-box'+empty2+'" tag="'+l.id2+'" style="background-color: '+l.color+'44"><span class="rel-ellipsis">'+l.txt2+'</span></td></tr>' ); // modify l.color+'" to l.color+'44" 21/12 mani
		}
		out.push('</table>');
		if( l.notKeyPair ) {
			out.push( '<table><tr><td class="rel-left rel-page">'+page2+'</td><td class="rel-mid"></td><td class="rel-right"></td></tr></table>' );
		}
		else {
			out.push( '<table><tr><td class="rel-left rel-page">'+page1+'</td><td class="rel-mid"></td><td class="rel-right rel-page">'+page2+'</td></tr></table>' );
		}
		out.push('</div>')
	}
	$('#labels').html(out.join(''));
	$('.tag-panel-relationship').on('click', function(ev){
		var del = ev.target.tagName == 'I' && $(ev.target).hasClass('fa-times-circle');
		var lid = $(ev.target).closest('.tag-panel-relationship').attr('rel');
		var tid = $(ev.target).closest('.tag-panel-relationship').attr('tag');
		if( !del ){
			if( lid ) {
				linkSelect(lid)
				// selectedPos($('.link_label_'+id));
			}
			else {
				tagSelect(tid)
				// selectedPos();
			} 
		}
		else {
			if( lid ) {
				var tmp = lid.split('-');
				delLink(tmp[0],tmp[1],true);
				setTimeout( ocrPanel, 1 )
			}
			else {
				delRange(tid);
			}
		}
		zoomSet(zoomValue)
	})

	$('.rel-box').on('click', function (ev) {
		var tid = $(ev.target).closest('.rel-box').attr('tag');
		popupSelected = null;
		tagSelect(tid)
		selectedPos();
		ev.preventDefault();
		ev.stopPropagation();
	})

	$('.tag-panel-relationship').on('mouseover', function(ev){
		var lid = $(ev.target).closest('.tag-panel-relationship').attr('rel');
		var tid = $(ev.target).closest('.tag-panel-relationship').attr('tag');
		if( lid ) {
			var l = $('.link_'+lid);
			if( !showLinks ) l.show();
			if( !showTags )
			{
				var [i1,i2] = lid.split('-');
				$('.tag_'+i1).show();
				$('.tag_'+i2).show();
			}
		}
		else {
			var t = $('.tag_'+tid);
			tagOver.apply( t );
		}
	})
	$('.tag-panel-relationship').on('mouseout', function(ev){
		var lid = $(ev.target).closest('.tag-panel-relationship').attr('rel');
		var tid = $(ev.target).closest('.tag-panel-relationship').attr('tag');
		if( lid ) {
			var l = $('.link_'+lid);
			if( !showLinks ) l.hide();
			if( !showTags )
			{
				var [i1,i2] = lid.split('-');
				$('.tag_'+i1).hide();
				$('.tag_'+i2).hide();
			}
		}
		else {
			var t = $('.tag_'+tid);
			tagOut.apply( t );
		}
	})
	return;
	linkChanged = true;
	// console.log( 'linkPanel')
}


function drawText()
{
	if( !$('#maincolumn').length ) return;
    clearUsed( $('#labels') );
    clearUsed( $('#relationships') );
    var wh = $(window).height();
    var cs = {height:px(wh),overflowY:'auto',paddingBottom: px(150)};
	var mainHeight = wh-($('#maincolumn')[0].getBoundingClientRect().y+$(window).scrollTop());
    $('#maincolumn').css(cs).css({overflow:'auto',height:px(mainHeight)});
    $('#right').css(cs).css({overflow:'auto',height:px(mainHeight)});
	$('.tools-panel').css({width:'100%'})
	// $('.tools-panel').css({width:px($('#maincolumn').width())})
    $(document.body).css({overflow:'hidden'});
    $(document.body).off('mouseup').on('mouseup', bodyUp );
    var olineHeight = lineHeight;
    // $('.tag_label').remove();
    lineHeight = lineHeightMin;
    if( rangeList.length ) lineHeight += tagHeight + tagMargin;
    if( linkHeight ) lineHeight += linkHeight;
    // txtObj.css({marginTop:px(lineHeight/2),lineHeight:px(lineHeight),fontSize:px(fontSize)});
    rangeList.forEach( function(r)
    {
		if( r.page != currentPage ) return;
        drawTag(r.id);
    });
    var mh = drawLinks();
	adjustText();
	adjustTextMode();

    drawUsed( $('#labels') );
    drawUsed( $('#relationships') );
	drawTags();
	drawBoxes();
	tagPanel();
	linkPanel();
	$('#labels').addClass('scroll-thin')
	$('#relationships').addClass('scroll-thin')
	// console.log( 'dt')
}

function drawTags( nolink )
{
	if( !nolink ) visibleLinks();
	// if( showTags || tagDownId || showAdjudication ) return $('.tag_label').show();
	if( showTags || tagDownId  ) return $('.tag_label').show();
	$('.tag_label').hide();
	$('.tag_label').removeClass('tag_label_invisible');
	if( over ) $('.tag_'+over).show();
	if( selected ) $('.tag_'+selected).show();
	Array.from($('.link_label')).forEach( function(l)
	{
		if( $(l).is(":visible") )
		{
			var ids = $(l).prop('lid').split('-');
			ids.forEach( (id) => { $('.tag_'+id).show() })
		}
	});
}

function clearPaintSelect()
{
	selectRange = [];
	paintSelectRange()
}

var selectTid = null;
var selectQuarentene = false;
var selectRange = [];
var selectRangeTmp = [];
var selectBoundingBox = [];

function paintSelectRange()
{
	// console.log( 'paintSelectRange' );
	if( descriptor.selectBoundingBox ) return paintSelectBoundingBox();
	if( !selectRange || selectRange.length < 2 )
	{
		txtObj.find('.pp-select').removeClass('pp-select');
		return;
	}
	var s1 = selectRange[0];
	var s2 = selectRange[1];
	if( typeof(s1) != 'number' || isNaN(s1) || typeof(s2) != 'number' || isNaN(s2))
	{
		txtObj.find('.pp-select').removeClass('pp-select');
		return;
	}
	// console.log( 'paint', s1, s2, typeof(s1), typeof(s2))
	if( s2 < s1 )
	{
		var tmp = s1;
		s1 = s2;
		s2 = tmp;
	}
	var bulk = (s2-s1) > 500;
	if( bulk ) disableLayer();
	txtObj.find('.pp-select').removeClass('pp-select');
	// console.log( 'paint', gPDF.plainText[currentPage-1].substr(s1,s2-s1+1))
	for( var i = s1 ; i != s2 ; i++)
	{
		txtObj.find('.pp'+i).addClass('pp-select');
	}
	txtObj.find('.pp'+i).addClass('pp-select');
	if( bulk ) enableLayer();
}


function paintSelectBoundingBox()
{
	txtObj.find('.pp-select').removeClass('pp-select').removeClass('pp-select-add').removeClass('pp-select-del');
	if( !selectRange || !selectRange.length ) return;
	for( var i of selectRange )
	{
		var txt = txtObj.find('.pp'+i)
		txt.addClass('pp-select');
		// console.log( 'paintSelectBoundingBox', i, txt, selectRangeTmp.indexOf( i ) )
		if( skeys.shiftOn && selectRangeTmp.indexOf( i ) >= 0 ) txt.addClass('pp-select-add');
		if( skeys.ctrlOn && selectRangeTmp.indexOf( i ) >= 0 ) txt.addClass('pp-select-del');
	}
}


var tagSelecting = false;

// returns is b2 is inside b1
function boxInside(b1, b2) {
	if( !b1 || !b2 ) return false;
	var colideX =
		(b1[0] <= b2[0] && b1[2] >= b2[2]);
	if( !colideX ) return false;
	var colideY =
		(b1[1] <= b2[1] && b1[3] >= b2[3]);
	return colideY;
}

// returns if b2 intersects with b1
function boxIntersect(b1, b2) {
	if( !b1 || !b2 ) return false;
	var colideX = boxIntersectX(b1, b2);
	if( !colideX ) return false;
	var colideY = boxIntersectY(b1, b2);
	return colideY;
}

// returns if b2 intersects with b1 on the x axis
function boxIntersectX(b1, b2) {
	var colideX =
		(b1[0] >= b2[0] && b1[0] <= b2[2]) ||
		(b1[2] >= b2[0] && b1[2] <= b2[2]) ||
		(b1[0] < b2[0] && b1[2] > b2[2]);
	return colideX;
}

// returns if b2 intersects with b1 on the y axis
function boxIntersectY(b1, b2) {
	var colideY =
		(b1[1] >= b2[1] && b1[1] <= b2[3]) ||
		(b1[3] >= b2[1] && b1[3] <= b2[3]) ||
		(b1[1] < b2[1] && b1[3] > b2[3]);
	return colideY;
}

function boxAdd( b1, b2 ) {
	var b = [];
	b.push( b1[0] < b2[0] ? b1[0] : b2[0] );
	b.push( b1[1] < b2[1] ? b1[1] : b2[1] );
	b.push( b1[2] > b2[2] ? b1[2] : b2[2] );
	b.push( b1[3] > b2[3] ? b1[3] : b2[3] );
	return b;
}

function boundingBoxColide(b1, b2) {
	if (ocrMode || showTables)
		return boxInside(b1, b2);
	else
		return boxIntersect(b1, b2);
}

function fixBoundingBox(b) {
	b = clone(b);
	if (b[0] > b[2]) [b[2], b[0]] = [b[0], b[2]];
	if (b[1] > b[3]) [b[3], b[1]] = [b[1], b[3]];
	// b = fromZoom( b )
	return b;
}

// find text idx that colide with box
function boundingBoxColideFindText(b, page) {
	if( !page ) page = currentPage;
	b = fixBoundingBox(b);
	var texts = gPDF.pdfData.textContent[page - 1];
	var list = [];
	// console.log( 'texts', texts )
	texts.forEach((t, tidx) => {
		if (t[5] == -1) return;
		var bt = clone(t);
		bt.shift();
		bt.splice(4);
		if (!boundingBoxColide(b, bt)) return;
		// console.log('box', t)
		list.push(tidx)
	});
	// console.log( 'LIST', list )
	return list;
}

// find boxes that colide with box
function boundingBoxColideFindBoxes(b, page) {
	if( !page ) page = currentPage;
	b = fixBoundingBox(b);
	var texts = gPDF.pdfData.textContent[page - 1];
	var list = [];
	texts.forEach((t, tidx) => {
		if (t[5] == -1) return;
		var bt = clone(t);
		bt.shift();
		bt.splice(4);
		if (!boundingBoxColide(b, bt)) return;
		// console.log('box', t)
		list.push(bt)
	});
	return list;
}



function boundingBoxFromRange( r, page ) {
	if( !page ) page = currentPage;
	var texts = gPDF.pdfData.textContent[page - 1];
	var x1 =  10000;
	var x2 = -10000;
	var y1 =  10000;
	var y2 = -10000;
	// console.log( 'boundingBoxFromRange', r, page )
	for( var i of r ) {
		var tr = texts[i];
		// console.log( 'boundingBoxFromRange i', i, tr )
		if( tr[1] < x1 ) x1 = tr[1];
		if( tr[2] < y1 ) y1 = tr[2];
		if( tr[3] > x2 ) x2 = tr[3];
		if( tr[4] > y2 ) y2 = tr[4];
	}
	return [x1,y1,x2,y2];
}


function drawBoundingBox(b) {
	b = fixBoundingBox(b);
	$('.bounding-box').remove();
	var w = $('#text-layer').width();
	var h = $('#text-layer').height();
	var bb = $('<DIV>').addClass('bounding-box');
	var css = {
		left: b[0]*w,
		top: b[1]*h,
		width: (b[2]-b[0])*w,
		height: (b[3]-b[1])*h,
		border: '2px dashed red',
	};
	bb.css(css);
	// console.log(css);
	$('#text-layer').append(bb);
}

function hideBoundingBox() {
	$('.bounding-box').remove();
}

function adjustOCR( id, box, rotate ) {
	// return;
	if( !ocrMode ) return;
	// console.log('adjustOCR', id, box )
	var s = $('.cid_'+id );
	s.prop('tagId', id );
	// box = fromZoom( box );
	var p1 = pdf2Box({left:box[0],top:box[1]});
	var p2 = pdf2Box({left:box[2],top:box[3]});
	var left = p1.left;
	var top = p1.top;
	var dt = txtObjMarginTop-boxLayerMaringTop; 
	// top -= dt-2; 

	var width = p2.left-p1.left;
	var height = p2.top-p1.top;

	// var color = s.css('border-top-color');
	var color = 'red';
	// console.log( 'COLOR', color );
	var css = { top: top*zoomValue, left: left*zoomValue, width: width*zoomValue, height: height*zoomValue };
	// console.log( 'adjustOCR', s[0], css )
	if( defined(rotate) ) {
		css.transform = 'rotate('+rotate+'deg)'
		css.transformOrigin = '50% 50%';
	} 
	s.css( css );

	if( !selectRange || !selectRange.length ) return;
	$('.tag_'+id).remove();
	var tag = tagFind(id);
	if( tag ) {
		tag.box = clone(box);
		tag.color = color;
		if( tag.rawBox ) tag.range = [];
		if( selectRange && selectRange.length ) {
			tag.range = clone(selectRange);
			var lasti = -1;
			var texts = [];
			for (var i of tag.range) {
				var t = gPDF.pdfData.textContent[tag.page - 1][i][0];
				if (texts.length && lasti != i - 1) texts.push(' ');
				texts.push(t);
				lasti = i;
			}
			tag.text = texts.join('');
			// console.log( 'BBB Adjust', id, texts, 'range', tag.range, 'text', tag.text, tag.box  )
			selectRange = [];
		}
	}
	return; 
}

		//  addOCR( tlist, newId, 'TABLECELL', false, tab.page, null, bb, null);
function addOCR( range, id, rangeType, adj, page, properties, box, rawBox, rotate ) {
	// console.log( 'addOCR', box )
	// console.log( 'addOCR', JSON.stringify([range, id, rangeType, adj, page, properties, box, rawBox]) )
	
	if( isNaN(range[0]) ) range = [];
	delTmp();
	var rt = rangeType || 'tmp'
	var sr = splitRange( range, id, rt, adj, page, properties ) 
	sr.box = box;
	var r = addRange( sr )
	// var b = addBox( id, page, box, '' );
	// b.tagId = id;
	// b.rawBox = rawBox;
	var tag = tagFind(r);
	// tag.boxId = b.idx;
	tag.range = range;
	tag.rawBox = rawBox;
	if( rotate ) tag.rotate = rotate;
	adjustOCR( id, box );

	return tag;
}

var tabId = 1;

function tableFromBoundingBox( b, page ) {
	if( !page ) page = currentPage;


	b = fixBoundingBox(b);
	// console.log( 'tableFromBoundingBox', b )
	var blobX = [];
	var blobY = [];
	function intersect(b1, b2) {
		return (b1[0] >= b2[0] && b1[0] <= b2[1]) ||
			(b1[1] >= b2[0] && b1[1] <= b2[1]) ||
			(b1[0] < b2[0] && b1[1] > b2[1]);
	}
	function add(b1, b2) {
		return [
			b1[0] < b2[0] ? b1[0] : b2[0],
			b1[1] > b2[1] ? b1[1] : b2[1]
		];
	}
	function join(blobs) {
		var reduced = true;
		while (reduced) {
			reduced = false;
			var b1 = null;
			var b2 = null;
			for (var i = 0; i < blobs.length && !reduced; i++) {
				for (var j = i + 1; j < blobs.length && !reduced; j++) {
					if (intersect(blobs[i], blobs[j])) {
						b1 = i;
						b2 = j;
						reduced = true;
					}
				}
			}
			if (reduced) {
				// console.log('blob join', b1, b2);
				var bnew = add(blobs[b1], blobs[b2])
				blobs.splice(b2, 1)
				blobs.splice(b1, 1)
				blobs.push(bnew);
			}
		}
		blobs.sort( (a,b) => a < b ? -1 : 1 )
	}
	for( var r of rangeList ) {
		if( r.page == currentPage && boxInside( b, r.box ) ) {
			var rb = clone(r.box);
			blobX.push( [rb[0],rb[2]] );
			blobY.push( [rb[1],rb[3]] );
		}
	}
	var list = boundingBoxColideFindBoxes(b,page)
	for (var rb of list) {
		blobX.push([rb[0], rb[2]]);
		blobY.push([rb[1], rb[3]]);
	}
	join(blobX);

	join(blobY);
	function slices( blob ) {
		if( !blob.length ) return [];
		var s = [blob[0][0]];
		for( var i = 0 ; i < blob.length-1 ; i++ )
			s.push( (blob[i][1]+blob[i+1][0])/2 );
		s.push( blob[i][1] );
		return s;
	}
	var X = slices( blobX ) ;
	var Y = slices( blobY );
	var tab = {x:X,y:Y};
	tab.rows = Y.length-1;
	tab.cols = X.length-1;
	tab.box = tableBoundingBox( tab );
	return tab;
}

var tableList = null;
function addTable( tab, id, page, nocheck ) {
	// console.log( 'addTable', tab )
	var b = tab.box;
	if( !tab.x.length || !tab.y.length ) return null;
	for( var t of tableList ) {
		if( t.page != page ) continue
		var tb = t.box;
		if( !nocheck && boxIntersect( b, tb ) ) return null;
	}
	var tid = tabId++;
	tab.id = tid;
	tab.page = page;
	tableList.push( tab )
	updateTable( tab );
	pdfPage(currentPage)
	return tab;
}

function findRangesBoundingBox( page, box ) {
	var list = [];
	for( var r of rangeList ) {
		if( r.page != page ) continue;
		// console.log( 'rrrrrrrrrrrrrr', box, r.box )
		if( boxInside( box, r.box ) ) list.push(r);
	}
	return list;
}

var selectedTable = null;
var selectedCells = [];
var tableCellSelect = false;
var tableBulkRanges = null;

function tableUnselect() {
	selectedTable = null;
	tableBulkRanges = null;
	selectedCells = [];
	$('.table-cell-selected').removeClass('table-cell-selected')
}

var tableCleanIgnore = false;
function tableClean( tab ) {
	if( tableCleanIgnore ) return; 
	var dlist = [];
	var rlist = findRangesBoundingBox( tab.page, tab.box ) 
	for( var r of rlist ) {
		delete r.table;
		var itable = r.properties.indexOf('TABLECELL');
		if( itable >= 0 ) {
			r.properties.splice(itable,1);
			if( !r.properties.length ) dlist.push(r.id);
		} 
	}
	// console.log( 'DLIST', dlist )
	for( var d of dlist ) {
		delRange( d );
	}
}

function tableMergeIgnore(tab) {
	tab.ignore = {};
	if (tab.merge) {
		for (var k in tab.merge) {
			var [kx, ky] = k.split(',').map(v => v*1);
			// kx *= 1; ky *= 1;
			// console.log('kx', kx, 'ky', ky, tab.merge[k])
			for (var x1 = 0; x1 <= tab.merge[k][0]; x1++)
				for (var y1 = 0; y1 <= tab.merge[k][1]; y1++) {
					// console.log( 'x1', x1, 'y1', y1 )
					if (x1 > 0 || y1 > 0)
						tab.ignore[[x1 + kx, y1 + ky].join(',')] = 1;
				}
		}
	}
}

function updateTable( tab ) {
	selectRange = [];
	var x = tab.x;
	var y = tab.y;
	tableClean( tab );
	tableMergeIgnore(tab);
	if( x.length < 2 || y.length < 2 ) {
		delTable( tab.id );
		return null;
	}
	disableSort = true;
	for( var ix = 0 ; ix < x.length-1 ; ix++ ) {
		for( var iy = 0 ; iy < y.length-1; iy++ ) {
			var mx = 0;
			var my = 0;
			var k = [ix,iy].join(',');
			if( tab.merge && tab.merge[k] ) [mx,my] = tab.merge[k];
			var b = [x[ix],y[iy],x[ix+1+mx],y[iy+1+my]];
			var tlist = boundingBoxColideFindText(b,tab.page);
			// if( !tlist.length ) continue;
			var slist = JSON.stringify(tlist);
			var rlist = findRangesBoundingBox( tab.page, b );
			var found = false;
			for( var r of rlist ) {
				r.table = {id:tab.id,x:ix,y:iy};
				if( JSON.stringify(r.range) == slist ) {
					found = true;
					if( r.properties.indexOf('TABLECELL') == -1 && r.properties.indexOf('TABLEHEADER') == -1 ) r.properties.push('TABLECELL')
					r.table = {id:tab.id,x:ix,y:iy};
					r.table.cell = true;
					// console.log( 'already tagged', ix, iy, r );
				}
			}
			// console.log( 'found', found, rlist )
			if( !found ) {
				// console.log( 'ADD', tab.id, ix, iy, slist )
				var blist = boundingBoxColideFindBoxes(b,tab.page);
				if( blist.length == 0 ) continue;
				var bb = blist[0];
				for( var i = 1 ; i < blist.length ; i++ ) bb = boxAdd( bb, blist[i] )
				var newId = g_tagId++;
				// var bb = boundingBoxFromRange(tlist);
				// if( bb[0] > 1 ) return;
				// if( tab.mergedList[k] )
				var tabDesc = {id:tab.id,x:ix,y:iy,cell:true}
				var k = JSON.stringify(tabDesc);
				var rtype = 'TABLECELL';
				var rproperties = null;
				if( tab.mergedList && tab.mergedList[k] ) {
					var p = tab.mergedList[k];
					rtype = p[0];
					rproperties = p;
				}
				var r = addOCR( tlist, newId, rtype, false, tab.page, rproperties, bb, null);
				// console.log( 'aaaaaaaaaaaaaaaaaaaaa', ix+'-'+iy, r.id, r.text, tlist, bb )
				var p = r.properties;
				// console.log( r.properties )
				// if( p.indexOf('TABLEHEADER') != -1 ) {
				// 	console.log( 'rrrrrrrrrrrrrrrrrrrrrrrrrr')
				// 	p = p.filter( t => t != 'TABLECELL')
				// } 

				r.table = tabDesc;
				r.table.cell = true;
			}
		}
	}
	tab.mergedList = null;
	tab.box = tableBoundingBox( tab );
	fixRanges()
	tagUnselect();
	boxUnselect();
	disableSort = false;
	sortRange();
	drawText();
	delTmp();
	changed();
	return tab;
}

function findTable( id ) {
	return tableList.find( t => t.id == id );
}

function delTable( id ) {
	tableUnselect();
	var tidx = tableList.findIndex( t => t.id == id );
	if( tidx == -1 ) return;
	tableClean( tableList[tidx] );
	$('.table_'+id).remove();
	tableList.splice(tidx,1);
	delTmp();
	changed();

}

function fixTableCellRange( range )
{
	var [x1,y1] = range[0];
	var [x2,y2] = range[1];
	if( x1 > x2 ) [x1,x2]=[x2,x1];
	if( y1 > y2 ) [y1,y2]=[y2,y1];
	return [[x1,y1],[x2,y2]];
}

function tableSaveBaseAxis( tab, delAxis, delIdx ) {
	// console.log( 'tableSaveBaseAxis', tab.id, delAxis, delIdx )

	var tmp = {}
	var list = {};
	var del = [];
	if( delAxis == 'x' ) {
		var oAxis = 'y';
		var lim = tab.rows;
	}
	else {
		var oAxis = 'x';
		var lim = tab.cols;
	}
	// console.log( 'oAxis', oAxis, 'lim', lim )
	for (var r of rangeList) {
		if (r.table && r.table.id == tab.id) {
			if (r.table[delAxis] == (delIdx - 1) || r.table[delAxis] == delIdx ) {
				var k = JSON.stringify(r.table)
				var p = clone(r.properties);
				tmp[k] = p;
				del.unshift(r.id);
			}
		}
	}
	for( var d of del ) delRange( d )
	for( var i = 0 ; i < lim ; i++ ) {
		var kobj = {id:tab.id,x:0,y:0,cell:true};
		kobj[delAxis] = delIdx-1;
		kobj[oAxis] = i;
		var k = JSON.stringify(kobj);
		// console.log( 'k', k, tmp[k] )
		if( !tmp[k] ) {
			kobj[delAxis] = delIdx;
			var k2 = JSON.stringify(kobj);
			if( tmp[k2] ) list[k] = tmp[k2];
		}
		else list[k] = tmp[k];
	}
	// console.log( 'list', list, 'del', del )
	tab.mergedList = list;
}

function tableRecoverMergedAttrs( tab ) {

}

function tableDelAdjustMerge( tab, delAxis, delIdx ) {
	if( !tab.merge ) return;
	if( delAxis == 'x' ) delAxis = 0;
	else if( delAxis == 'y' ) delAxis = 1;
	// console.log( '-------------------------------------', 'axis', delAxis, 'idx', delIdx )
	var merge = {};
	for( var k in tab.merge ) {
		var d1 = k.split(',').map( v => v*1 );
		var sz = clone(tab.merge[k]);
		var d2 = sz.map( (v,i) => d1[i]+v );
		// console.log( 'k', k, 'd1', d1, 'd2', d2, 'sz', sz )
		if( delIdx > d2[delAxis]+1 ){
			// console.log( 'not affected' )
			merge[k] = tab.merge[k];
		}
		else if( delIdx <= d1[delAxis] && d1[delAxis] > 0 )
		{
			// console.log( 'shift merge' );
			d1[delAxis]--;
			merge[d1.join(',')] = sz;
		}
		else if( sz[delAxis] > 0 ) {
			sz[delAxis]--;
			// console.log( 'shrink merge', sz[0]*sz[1])
			if( sz[0] > 0 || sz[1] > 0 ) {
				merge[d1.join(',')] = sz;
			}
			else console.log( 'merge deleted')
			
		}
	}
	delete tab.merge;
	if( Object.keys(merge).length ) tab.merge = merge;
}

function selectTableCells( id, range, bulk ) {
	$('.table-cell-highlight').removeClass('table-cell-highlight')
	$('.table-cell-delete').removeClass('table-cell-delete')
	if( range[0] == null && range[1] != null ) range[0] = clone(range[1])
	// console.log( 'selectTableCells', id, JSON.stringify(range))
	range = fixTableCellRange( range )
	var [x1,y1] = range[0];
	var [x2,y2] = range[1];
	$('.table-cell-selected').removeClass('table-cell-selected')
	for (var ix = x1; ix <= x2; ix++)
		for (var iy = y1; iy <= y2; iy++) {
			$('.table_'+id+'.table_cell_x_'+ix+'_y_'+iy).addClass('table-cell-selected')
		}
	if( bulk ) {
		tableBulkRanges = rangeList.filter( r => r.table && r.table.id == id && r.table.cell &&
			r.table.x >= x1 && 
			r.table.x <= x2 && 
			r.table.y >= y1 && 
			r.table.y <= y2 )

	}
}

function drawTableCell(b, id, x, y ) {
	var w = $('#text-layer').width();
	var h = $('#text-layer').height();
	var bb = $('<DIV>').addClass('table-ocr').addClass('table-cell')
	.addClass('table_'+id).addClass('table_cell_x_'+x).addClass('table_cell_y_'+y).addClass('table_cell_x_'+x+'_y_'+y)
	.prop('cell',{id:id,x:x,y:y})
	if( x == 0 ) bb.addClass('table-cell-x');
	if( y == 0 ) bb.addClass('table-cell-y');
	var css = {
		left: b[0]*w,
		top: b[1]*h,
		width: (b[2]-b[0])*w,
		height: (b[3]-b[1])*h,
		zIndex: 5000,
	};
	bb.css(css);
	bb.on('mouseover', function(ev){
		var r = rangeList.find( r => r.table && r.table.id == id && r.table.x == x && r.table.y == y && r.table.cell )
		if( !r ) return;
		var span = $('.cid_'+r.id);
		tagOut.apply(span[0]);
		tagOver.apply(span[0]);
		if( tableCellSelect ) {
			selectedCells[1] = [x,y];
			selectTableCells( id, selectedCells )
			// console.log( 'selectedCells', selectedTable, JSON.stringify(selectedCells) )
		}
	})
	bb.on('mouseout', function(ev){
		var r = rangeList.find( r => r.table && r.table.id == id && r.table.x == x && r.table.y == y && r.table.cell )
		if( !r ) return;
		var span = $('.cid_'+r.id);
		// selected = null;
		tagOut.apply(span[0]);
	})

	bb.on('mousedown', function(ev) {
		// console.log( 'button', ev.button )
		if( ev.button == 2 ) {
			popupOut();
			tagUnselect();
			boxUnselect();
			drawBoxes();
			clearSelection()
			selectedTable = id;
			selectedCells = [[x,y],[x,y]];
			selectTableCells( id, selectedCells )
			ev.preventDefault();
			ev.stopPropagation();
			tableCellSelect = true;
			return true;
		}
	})
	bb.on('mouseup', function(ev) {
		if( ev.button == 2 ) {
			selectedCells[1] = [x,y];
			selectTableCells( id, selectedCells, true )
			// console.log( 'selectedCells', selectedTable, JSON.stringify(selectedCells) )
			tableCellSelect = false;
			showPopup('table',bb, {} );
			ev.preventDefault();
			ev.stopPropagation();
			return true;
		}
	})
	bb.on('click', function(ev){
		var r = rangeList.find( r => r.table && r.table.id == id && r.table.x == x && r.table.y == y && r.table.cell )
		if( !r ) {
			var tab = findTable(id);
			if( !tab ) return;
			if( updateTable( tab ) ) drawTable( tab );
			r = rangeList.find( r => r.table && r.table.id == id && r.table.x == x && r.table.y == y && r.table.cell )
			if( !r ) return;
		}
		// console.log( 'cell', r )
		if( !r ) return;
		tagSelect( r.id )
		if (!tableBulkRanges || tableBulkRanges.indexOf(r) == -1)
			tableUnselect();
		var rsel = r;
		if( skeys.cOn ) {
			$('.table_cell_x_'+x).addClass('table-cell-selected');
			tableBulkRanges = rangeList.filter( r => r != rsel && r.table && r.table.id == id && r.table.x == x && r.table.cell )
		}
		else if( skeys.rOn ) {
			$('.table_cell_y_'+y).addClass('table-cell-selected');
			tableBulkRanges = rangeList.filter( r => r != rsel && r.table && r.table.id == id && r.table.y == y && r.table.cell )
		}
	})
	bb.on('contextmenu', ignoreRightClick );

	$('#text-layer').append(bb);
}


var axisClick = null;
function drawAxis(b, id, axis, axisId) {
	return;
	var w = $('#text-layer').width();
	var h = $('#text-layer').height();
	var bb = $('<DIV>').addClass('table-ocr').addClass('table_'+id).addClass('table-axis').prop('axis',{id:id,axis:axis,axisId:axisId})
	var css = {
		left: b[0]*w,
		top: b[1]*h,
		width: (b[2]-b[0])*w,
		height: (b[3]-b[1])*h,
	};
	bb.css(css);
	bb.on('click', function(){
		if( axisClick ) {
			clearTimeout( axisClick );
			axisClick = null;
			delTable( id );
		}
		else axisClick = setTimeout( function(){
			var tab = tableList.find( t => t.id == id );
			if( !tab ) return;
			loading();
			setTimeout( function(){
				tab[axis].splice( axisId, 1 );
				if( updateTable( tab ) ) drawTable( tab );
				// console.log( 'axis', id, axis, axisId )
				loadingOut();
			}, 1 )
			axisClick = null;
		}, 300 );
	});
	$('#text-layer').append(bb);
}

function tableBoundingBox( tab ) {
	var bbox = [tab.x[0],tab.y[0],tab.x[tab.x.length-1],tab.y[tab.y.length-1]]
	return bbox;
}

function drawTable( tab ) {
	// console.log( 'drawTable', tab );
	hideBoundingBox();
	clearPaintSelect();

	if( !tab.ignore ) tableMergeIgnore( tab );

	var box = [tab.x[0], tab.y[0], tab.x[tab.x.length-1], tab.y[tab.y.length-1]];
	// drawBoundingBox( box )
	$('.table_'+tab.id).remove();
	var x = clone(tab.x);
	var y = clone(tab.y);
	var dim = gPDF.pdfData.dimensions[currentPage-1];
	var margin = 3;
	var amargin = 2;
	var dx = margin/dim.width;
	var dy = margin/dim.height;
	var adx = amargin/dim.width;
	var ady = amargin/dim.height;
	// console.log( dim, 'dx', dx, 'dy', dy )
	x[0] -= dx;
	x[x.length-1] += dx;
	y[0] -= dy;
	y[y.length-1] += dy;

	var bbox = [x[0],y[0],x[x.length-1],y[y.length-1]];

	for( var ix = 0 ; ix < x.length-1 ; ix++ ) {
		for( var iy = 0 ; iy < y.length-1; iy++ ) {
			var mx = 0;
			var my = 0;
			var k = [ix,iy].join(',');
			if( tab.merge && tab.merge[k] ) [mx,my] = tab.merge[k];

			var b = [x[ix],y[iy],x[ix+1+mx],y[iy+1+my]];
			var k = [ix,iy].join(',')
			if( tab.ignore[k] ) continue;
			drawTableCell(b, tab.id, ix, iy)
		}
	}
	for (var ix = 0; ix < x.length; ix++) {
		var ab = clone(bbox);
		ab[0] = x[ix] - adx;
		ab[2] = x[ix] + adx;
		drawAxis(ab, tab.id, 'x', ix);
	}
	// for (var iy = 0; iy < y.length; iy++) {
	// 	var ab = clone(bbox);
	// 	ab[1] = y[iy] - ady;
	// 	ab[3] = y[iy] + ady;
	// 	drawAxis(ab, tab.id, 'y', iy);
	// }
}

function setBox( ntag ) {
	ntag.box = null;
	for( var r of ntag.range ) {
		var b = clone(gPDF.textContent[ntag.page-1][r])
		b.shift();
		b.splice(4,1000);
		if( !ntag.box ) ntag.box = b;
		else ntag.box = boxAdd( ntag.box, b );
	}
}

function isort( a, b ) { return a*1 < b*1 }

var setMouseBoundingBoxTid = null;
function setMouseBoundingBox() {
	// if( blockEdit ) return locked();

	function addSet( tlist ) {
		if( skeys.shiftOn ) {
			for( var i of tlist ) {
				if( selectRange.indexOf(i) == -1 ) selectRange.push(i);
				selectRangeTmp = clone(selectRange);
			}
			selectRange.sort(isort);
			return;
		}
		else 
		if( skeys.ctrlOn ) {
			for( var i of tlist ) {
				var d = selectRange.indexOf(i);
				if( d >= 0 ) selectRange.splice(d,1);
			}
			selectRange.sort(isort);
			selectRangeTmp = clone(selectRange);
			return;
		}		
		else 
		{
			selectRange = tlist;
			selectRange.sort(isort);
			selectRangeTmp = [];
		}
	}

	var mouseObj = $(document);
	function eventXY(ev) {
		var x = ev.pageX;
		var y = ev.pageY;
		var toff = $('#text-layer').offset();
		x -= toff.left;
		y -= toff.top;
		x /= $('#text-layer').width();
		y /= $('#text-layer').height();
		x /= zoomValue;
		y /= zoomValue;
		// console.log('eventXY', x, y);
		return [x, y];
	}

	mouseObj.off('mousedown').on('mousedown',function (ev) {

		if( ev.button == 2 ) {
			tableUnselect();
			// console.log( 'ev', ev.target )
			return;
		} 
		// console.log( 'mousedown')
		if( oocrMode && ocrTarget( ev.target ) && !skeys.shiftOn ) {
			var id = $(ev.target).prop('tagId');
			if( id ) tagSelect(id)
			return;
		}
		// if( ocrMode && showBoxes  && !skeys.shiftOn ) return;
		if( descriptor.comprehendMode && showBoxes  ) return;
		if( oocrMode && boxTarget(ev.target) ) return;
		if( oocrMode && !boxTarget(ev.target) && !popupTarget(ev.target)  && !skeys.shiftOn) {
			boxesClearUnlabeled();
			boxUnselect();
			drawBoxes();
		} 
		var target = $(ev.target);
		// console.log( 'TARGET', ev.target );
		// console.log( 'target', target.prop('id'), target.hasClass('pdf_text'), target )
		if( target.prop('id') != 'maincolumn' && target.prop('id') != 'text-layer' && !target.hasClass('pdf_text') )
		{
			selectBoundingBox = null;
			return;
		} 
		tableUnselect();

		// console.log('mousedown', $(ev.target), ev.target, ev);
		var pos = eventXY(ev);
		selectBoundingBox = pos.concat(pos);
		var tlist = boundingBoxColideFindText(selectBoundingBox)
		addSet( tlist );
		paintSelectRange();
		// if (!selectRange.length) return;
		tagSelecting = true;
		mouseObj.off('mousemove').mousemove(function (ev) {
			clearTimeout( setMouseBoundingBoxTid );
			setMouseBoundingBoxTid = setTimeout( function() {
				var pos = eventXY(ev);
				selectBoundingBox[2] = pos[0];
				selectBoundingBox[3] = pos[1];
				var tlist = boundingBoxColideFindText(selectBoundingBox)
				// console.log('tlist', tlist)
				addSet( tlist );
				paintSelectRange();
				drawBoundingBox(selectBoundingBox);
			}, 1 );
		});
		ev.preventDefault();
		ev.stopPropagation();
	})
	mouseObj.off('mouseup').mouseup(textMouseUp);
	function textMouseUp(ev) {
		clearTimeout( setMouseBoundingBoxTid );
		if( !tagSelecting ) return;


		mouseObj.off('mousemove');
		tagSelecting = false;
		if( !selectBoundingBox ) return;
		var pos = eventXY(ev);
		selectBoundingBox[2] = pos[0];
		selectBoundingBox[3] = pos[1];

		if( showTables ) {
			drawBoundingBox(selectBoundingBox);
			hideBoundingBox();
			loading();
			if( blockEdit ) {
				loadingOut();
				return locked();
			}
			setTimeout( function(){
				var tab = tableFromBoundingBox(selectBoundingBox)
				tab = addTable( tab, tabId++, currentPage );
				if( tab ) drawTable( tab );
				loadingOut();
			}, 100 )
			return;
		}
		var tlist = boundingBoxColideFindText(selectBoundingBox);
		addSet( tlist );
		
		paintSelectRange();
		hideBoundingBox();

		if( oocrMode ) {
			setTimeout( function(){
				// console.log( 'SSSSSSSSSSSSSSSSSSSSSSSSSSSSS', selectRange )
				var newId = g_tagId++;
				var bb = boundingBoxFromRange(selectRange);
				if( bb[0] > 1 ) return;
				var tag = addOCR( selectRange, newId, '', false, currentPage, null, bb, null );
				tagSelect( newId );
				sortRange();
				changed();
			}, 100 );
			return;
		}


		if( selected ) {
			let t = tagFind(selected);
			// console.log( 'SELECTED', selected, t, t.range, selectRange  )
			if( t && selectRange.length ) {
				t.range = clone(selectRange);
				t = clone(t);
				delRange( t.id );
				if( t.range.length )
				addRange( splitRange( t.range, t.id, t.type, t.adj, t.page ) )
				var ntag = rangeList.find( r => r.id == t.id );
				ntag.properties = t.properties;
				// console.log( 'ntag', ntag )
				setBox( ntag );
				drawTag( t.id, true )
				sortRange();
			}
			else selected = null; 
		}
		hKeyPressed = null;
        clearTimeout( selectTid );
		selectQuarentene = true;
		// console.log( 'rangeList', rangeList )
        selectTid = setTimeout( function(){
			
			delTmp();
			var range = selectRange;
            if( !range || !range.length )
            {
				if( over ) tagSelect(over);
                else
                {
					tagUnselect();
                    linkUnselect();
                    delTmp();
                    tagOut();
                }
                return;
            }
			var labelObj = null;
            var fr = findRange( range ); // find exact range
			var singleRange = range.length == 1;
			if( !fr && singleRange ) // see if its inside another range
			{
				var outer = findRange( range, true );
				if( outer )
				{
					var otag = tagFind(outer);
					fr = outer;
				}
			}
            if( !fr )
            {
				if( blockEdit ) return locked();
				var newId = null;
				var newType = 'tmp';
				var newComment = '';
                tagUnselect();
                delTmp();
				if( !newId ) newId = g_tagId++;
                var rid = addRange( splitRange( range, newId, newType ) );
				var newTag = tagFind(rid);
				setBox( newTag );

				sortRange();
				if( newComment > '' ) newTag.comment = newComment;
				if( outer )
				{
					newTag.parent = otag.id;
					newTag.parentType = otag.type;
				}
				clearSelection();
				setTimeout( function(){ tagSelect(rid)}, 100 );
				selectRangeTmp = clone(tagFind(rid).range);
                return;
            }
			else {
				rid = fr;
				selectRangeTmp = clone(tagFind(rid).range);
			}
            tagSelect( rid );
	
            // console.log( 'nope')
			clearTimeout(tagOutTid);
            // console.log( text, range );
			selectQuarentene = false;
        }, 200 );
	}
}

function setMouse()
{
	if( !hasLabels ) return;
	if( descriptor.selectBoundingBox ) return setMouseBoundingBox();
	var mouseObj = txtObj;
	if( engine2() || htmlTextMode )
	{
		mouseObj = $(document);
		mouseObj.off('mousedown').mousedown(function(ev){
			var target = $(ev.target);
			// console.log( target )
			// console.log( 'mousedown', $(ev.target), ev.target )
			if( !target.hasClass('pdf_text') ) return;
			// console.log( $(ev.target).attr('o1')*1 );
			selectRange = [$(ev.target).attr('o1')*1];
			tagSelecting = true;
			paintSelectRange();
			mouseObj.off('mousemove').mousemove(function(ev){
				if( !ev || !ev.target || !target.hasClass('pdf_text') ) {
					// console.log( 'out' );
					// textMouseUp();
					return;
				};
				var o2 = $(ev.target).attr('o1')*1;
				if( typeof(o2) != 'number' ) return;
				var dr = o2-selectRange[0];
				// console.log( 'DDDDDDRRRR------------', o2 );
				if( o2 && descriptor.comprehendMode ) {
					dr += gPDF.pdfData.textContent[currentPage-1][o2][0].length;
				}
				var drLim = 4000;
				if( dr < -drLim ) dr = -drLim;
				else if( dr > drLim ) dr = drLim;
				// console.log( 'DDDDDDRRRR', dr );
				// selectRange[1] = o2;
				selectRange[1] = selectRange[0]+dr;
				// console.log( selectRange )
				// console.log( 'move', selectRange, gPDF.plainText[currentPage-1][selectRange[0]], gPDF.plainText[currentPage-1][selectRange[1]] );
				paintSelectRange();
			});
			ev.preventDefault();
			ev.stopPropagation();
			// console.log( 'down', selectRange )
			// if( selectQuarentene ) ev.preventDefault();
		})
		mouseObj.mouseup(textMouseUp);
	}
	else mouseObj.off('mouseup').mouseup(textMouseUp);

	function textMouseUp(ev)
	{
		// console.log( 'mouseup' )
		// console.log( 'mouseup', typeof(ev.target), getList( $(ev.target), 'ids' ) )

		var singleRange = selectRange && selectRange.length == 1;
		// singleRange = false;
		if( engine2() || htmlTextMode )
		{
			mouseObj.off('mousemove');
			var target = $(ev.target);
			// console.log( target )
			if( !tagSelecting && !target.hasClass('pdf_text') ) return;
			tagSelecting = false;
		}
		hKeyPressed = null;
        clearTimeout( selectTid );
		selectQuarentene = true;
        selectTid = setTimeout( function(){
			if( engine2() || htmlTextMode )
			{
				var range = getRange2();
				var expanded = range ? range.pop() : null;
			}
			else {
				var text=getSel();
				if( text.baseNode )
				{ // chrome
					var start = text.baseNode;
					var startOff = text.baseOffset;
				}
				else { // ff
					var start = text.anchorNode;
					var startOff = text.anchorOffset;
				}
				if( text.extentNode )
				{ // chrome
					var end = text.extentNode;
					var endOff = text.extentOffset;
				}
				else { // ff
					var end = text.focusNode;
					var endOff = text.focusOffset;
				}
				// console.log( 'select', start, startOff, end, endOff );
				var range = getRange( start, startOff, end, endOff );
				var expanded = range ? range.pop() : null;
			}
			// console.log( 'range', range );
            // clearSelection();
            delTmp();
            if( !range )
            {
                if( over ) tagSelect(over);
                else
                {
                    tagUnselect();
                    linkUnselect();
					// boxUnselect();
                    delTmp();
                    tagOut();
                }
                return;
            }
			var labelObj = null;
            var fr = findRange( range ); // find exact range
			// console.log( 'FIND', fr )
			if( !fr && singleRange ) // see if its inside another range
			{
				var outer = findRange( range, true );
				if( outer )
				{
					// var labelObj = tagObj[otag.type];
					// if( labelObj && !labelObj.sublabels && expanded )
					var otag = tagFind(outer);
					if( expanded )
					{
						fr = outer;
					}
				}
			}
            if( !fr )
            {
				if( blockEdit ) return locked();
				var newId = null;
				var newType = 'tmp';
				var newComment = '';
				if( skeys.shiftOn )
				{
					if( selected )
					{
						var st = tagFind(selected);
						// console.log( 'ST', clone(st), range );
						if( st.range[0] < range[0] && st.range[1] < range[0] )
						{
							range[0] = st.range[0];
							newId = selected;
							newType = st.type;
							newComment = st.comment;
							delRange( selected, true ); // delete ignoring links
						}
						else if( st.range[0] > range[0] && st.range[1] > range[0] )
						{
							range[1] = st.range[1];
							newId = selected;
							newType = st.type;
							newComment = st.comment;
							delRange( selected, true ); // delete ignoring links
						}
						else return;
					}
					else return;
				}
				// console.log( 'e')
                tagUnselect();
				// console.log( 'e2')
                delTmp();
				// console.log( 'e3')
				if( !newId ) newId = g_tagId++;
				// console.log( 'f')
                var rid = addRange( splitRange( range, newId, newType ) );
				// console.log( 'g')
				var newTag = tagFind(rid);
				if( newComment > '' ) newTag.comment = newComment;
				if( outer )
				{
					// console.log( 'outer', otag.id, otag.type );
					newTag.parent = otag.id;
					newTag.parentType = otag.type;
				}
				clearSelection();

                // tagSelect( rid );
				setTimeout( function(){ tagSelect(rid)}, 100 );
                return;
            }
			else rid = fr;
            tagSelect( rid );
            // console.log( 'nope')
            clearTimeout(tagOutTid);
            // console.log( text, range );
			selectQuarentene = false;
        }, 200 );
    }
}

var labelIdx = {};
var labelIdxCt = 0;
function fixLabels( labels, path )
{
	if( !path ) path = [];
	for( var k in labels )
	{
		labelIdx[k] = labelIdxCt++;
		if( !isobj( labels[k]) ) labels[k] = {"alias":k,color:labels[k]};
		labels[k].name = k;
		labels[k].path = path.concat(k);
		labels[k].spath = labels[k].path.join('/');
		if( labels[k].sublabels ) fixLabels( labels[k].sublabels, labels[k].path );
	}
}

function flatLabels( labels )
{
	var list = [];
	function walk( labels )
	{
		for( var k in labels )
		{
			var o = clone(labels[k]);
			delete o.sublabels;
			o.name = k;
			list.push( o );
			if( labels[k].sublabels ) walk( labels[k].sublabels );
		}
	}
	walk( labels );
	var labs = {};

	list.forEach( li => {
		labs[li.name] = li;
	});
	// if( 0 && descriptor.ocrMode ) {
	if( ocrMode ) {
			var ocrLabs = {};
		for( var k in labs ) {
			var l = labs[k];
			if( !l.keyset ) ocrLabs[k] = l;
			else {
				var [lab,type] = keysetType(k);
				if( type > '' ) {
					ocrLabs[k] = l;
					continue;
				}
				var lk = clone(l);
				if( lk.alias ) lk.alias += ':K';
				lk.name += ':KEY';
				ocrLabs[lk.name] = lk;
				var lv = clone(l);
				if( lv.alias ) lv.alias += ':V';
				lv.name += ':VAL';
				// console.log( 'CCCCCCCCCCCC', l, lk, lv )
				ocrLabs[lv.name] = lv; 
			}
		}
		labs = ocrLabs;
	}
	return labs;
}

function allLabels( labels, list, level, type )
{
	if( !list ) list = [];
	if( !level ) level = 0;
	for( var k in labels )
	{
		if( labels[k].placeholder ) continue;
		if( labels[k].type && labels[k].type != type ) continue;
		var an = iarray('\t',level);
		an.push(k);
		list.push(an.join(''));
		if( labels[k].sublabels ) allLabels( labels[k].sublabels, list, level+1 );
	}
	return list;
}

function rangeEqual( a, b ) {
	return JSON.stringify(a) == JSON.stringify(b);
}

function findRange( range, inner )
{
	if( isarray(range) )
	{
		if( !inner ) // exact match
		{
			for( var i = 0 ; i < rangeList.length ; i++ )
			{
				if( rangeList[i].page != currentPage || rangeList[i].adj ) continue;
				var r = rangeList[i].range;
				if( rangeEqual( r, range ) ) return rangeList[i].id;
				// if( r[0] == range[0] && r[1] == range[1] ) return rangeList[i].id;
			}
			return false;
		}
		else // find inner
		{
			var found = false;
			for( var i = 0 ; i < rangeList.length ; i++ )
			{
				if( rangeList[i].page != currentPage || rangeList[i].adj ) continue;
				var r = rangeList[i].range;
				if( !descriptor.selectBoundingBox ) {
					if( r[0] <= range[0] && r[1] >= range[1] ) found = rangeList[i].id;
				}
				else {
					var match = true;
					for( var ridx of range ) {
						if( r.indexOf(ridx) == -1 ) {
							match = false;
							break;
						}
					}
					if( match ) found = rangeList[i].id;
				}
			}
			return found;
		}
	}
	else {
		var best = null;
		var bestLen = null;
		for( var i = 0 ; i < rangeList.length ; i++ )
		{
			if( rangeList[i].page != currentPage || rangeList[i].adj ) continue;
			var r = rangeList[i].range;
			if( r[0] <= range && r[1] >= range )
			{
				var len = r[1]-r[0];
				if( !bestLen || len < bestLen )
				{
					bestLen = len;
					best = rangeList[i].id;
				}
			}
		}
		return best;
	}
}

function setRedrawRange( range )
{
	// console.log( 'setRedrawRange', range )
	rangeList.forEach( r => {
		// console.log( 'check', r.id, r.range, range, (r.range[0] >= range[0] && r.range[0] < range[1]) || (r.range[1] >= range[0] && r.range[1] < range[1]) )
		if( (r.range[0] >= range[0] && r.range[0] < range[1]) || (r.range[1] >= range[0] && r.range[1] < range[1]) )
		{
			// console.log( 'force', r.id )
			r.force = 1;
		}
	})
}

function addRange( rangeObj )
{
	rangeChanged = true;

    rangeList.push( rangeObj );
	setRedrawRange( rangeObj.range );
    sortRange();
	fixRanges();
	tagPanelUpdate();
    return rangeObj.id;
}

function cleanDuplicateAdjudication()
{
	// return;
	var sigs = {};
	for( var i = rangeList.length-1 ; i >= 0 ; i-- )
		sigs[rangeList[i].sig] = rangeList[i];
	var delId = [];
	for( var i = rangeList.length-1 ; i >= 0 ; i-- )
	{
		var sig = rangeList[i].sig;
		if( sigs[sig] && sigs[sig] != rangeList[i] )
		{
			sigs[sig].equal = 1;
			// console.log( 'remove adjudication', rangeList[i], rangeList[i].sig );
			delId.push( rangeList[i].id );
			// rangeList.splice(i,1);
		}
	}
	delId.forEach( r => delRange(r) );
}

function fixRanges()
{
	var objs = {};
	var links = {};
	linkList.forEach( l => {
		if( !links[l.i1] ) links[l.i1] = {in:[],out:[]};
		if( !links[l.i2] ) links[l.i2] = {in:[],out:[]};
		links[l.i1].out.push([l.i2,l.relationship]);
		links[l.i2].in.push([l.i1,l.relationship]);
	});
	// console.log( 'links', links );
	var delList = [];
	rangeList.forEach( (r, idx) => {
		if( r.type )
		{
			var label = tagObj[r.type] ? tagObj[r.type] : {name:r.type};
			r.type = label.name;
			objs[r.id] = r;
			if( ocrMode && r.range.length == 0 && !r.rawBox ) {
				if( !r.box ) {
					// console.log( 'INVBOX', r )
					delList.unshift( idx );
				}
				else {
					r.range = boundingBoxColideFindText(r.box);
					// console.log( 'FIXRANGE', r.id, r.range )
				}
			}


			// signature makes it easyer to identify identical tags
			let rng = r.rawBox ? r.box.map( v => v.toFixed(3) ) : r.range;
			r.sig = [r.page,r.text,JSON.stringify(rng),r.type,JSON.stringify(r.properties),JSON.stringify(links[r.id])].join(',');
			// ATENTION. Signature should also consider relationships
			if( 0 && label.sublabels )
			{
				// console.log( 'fixRanges', r, idx )
				r.subCount = 0;
				r.subs = [];
				r.adj = r.adj == true;
				for( var i = idx+1 ; i < rangeList.length ; i++ )
				{
					var cr = rangeList[i];
					cr.adj = cr.adj == true;
					// console.log( 'check', i, cr, cr.range[0] > r.range[1], cr.page > r.page, cr.adj != r.adj )
					if( cr.range[0] > r.range[1] || cr.page > r.page ) break;
					if( cr.adj != r.adj ) continue;
					if( cr.range[0] >= r.range[0] && cr.range[1] <= r.range[1] )
					{
						r.subCount++;
						r.subs.push(cr.id);
						cr.sig = [cr.page,cr.range[0],cr.range[1],cr.type].join(',');
						r.sig += ','+cr.sig;
						cr.parent = r.id;
						cr.parentType = r.type;
					}
				}
			}
		}
	});
	for( var d of delList ) rangeList.splice( d, 1 );
}

var rangeHash = {};
var disableSort = false;
function sortRange()
{
	if( disableSort ) return;
	if( showAdjudication ) adjudicationForward();

	function rangeSort( a, b ) {
		if( a.page != b.page ) return a.page < b.page ? -1 : 1;
		var aa = a.adj && !a.adj_forward ? 1 : 0;
		var ab = b.adj && !b.adj_forward ? 1 : 0;
		if( aa != ab ) return ab ? -1 : 1;
		// if( a.adj != b.adj ) return b.adj ? -1 : 1;
        return a.range[0] < b.range[0] ? -1 : 1;
    }

	var idx = 0;
	for( var r of rangeList ) {
		if( !r.box ) {
			r.area = 10000-idx++;
			continue;
		}
		var dx = r.box[2]-r.box[0];
		var dy = r.box[3]-r.box[1];
		r.area = Math.sqrt( dx*dx + dy*dy );
	}

	function sortArea( a, b ) {
		if( a.page != b.page ) return a.page < b.page ? -1 : 1;
		var aa = a.adj && !a.adj_forward ? 1 : 0;
		var ab = b.adj && !b.adj_forward ? 1 : 0;
        return a.area > b.area ? -1 : 1;
	}

	function sortXY( a, b ) {
		if( a.page != b.page ) return a.page < b.page ? -1 : 1;
		var aa = a.adj && !a.adj_forward ? 1 : 0;
		var ab = b.adj && !b.adj_forward ? 1 : 0;
        return a.xy < b.xy ? -1 : 1;
	}


	if( !ocrMode ) {
		rangeList.sort( rangeSort );
		rangeList.forEach( function(r,idx){ r.idx = idx; rangeHash[r.id] = r});
	}
	else {
		rangeList.forEach( r => {
			if( !r.box ) {
				// console.log( 'empty box', clone(r) );
				r.xy = 0;
				return;
			}
			var y = r.box[1];
			var x = r.box[0];
			r.xy = y*10 + x;
		})
		rangeList.sort( sortXY );
		rangeList.forEach( function(r,idx){ 
			r.idx = idx; 
			rangeHash[r.id] = r;
			if( r.page == currentPage ) $('.cid_'+r.id).css({zIndex:idx+10})
		});
	}
}

var translate = {};
function mergeRange(tags,links)
{
	// if( ocrMode ) return;
	sortRange();
	var lastRange = null;
	var lastTag = null;
    rangeList = [];
	translate = {};
	// console.log( 'mergeRange', clone(tags))
	tags.sort( (a,b) => {
		if( a.page == b.page ) {
			return a.range[0] - b.range[0]
		}
		return a.page - b.page
	})

	let listCleaned = true;
	function listClean( l ) {
		return l.map( v => {
			if( v.match(adjKey) ) {
				listCleaned = true;
				v = v.replace(adjKey,'');
			}
			if( v.match(consensusKey) ) {
				listCleaned = true;
				v = v.replace(consensusKey,'');
			}
			return v;
		})
	}
	for( var t of tags )
	{
		if( descriptor.labels && !descriptor.labels[t.type] ) {
			console.error('not found', t.type )
			var [lb,tp] = keysetType(t.type);
			addDescriptorLabel( lb, tp > '' )
			// descriptor.labels[t.type] = {name:lb,color:'#000000',keyset: tp || false };
		}
		// var k = [t.page,t.range[0],t.range[1]];
		var k = [t.page,t.text,t.range];
		if( ocrMode && t.rawBox )k.push(t.box)
		// if( ocrMode )k.push(t.blocks)
		k = JSON.stringify(k)
		if( !t.properties ) t.properties = [t.type];
		if( k == lastRange )
		{
			// console.log( 'merge', t.text, t.properties, lastTag.properties );
			let lastProperties = listClean(lastTag.properties);
			for( var l of listClean(t.properties) )
			{
				let lidx = lastProperties.indexOf(l)
				if( lidx == -1 ) lastTag.properties.push(l);
				else if( listCleaned ) {
					if( !l.match(/^(TABLECELL|TABLEHEADER|GENERIC:KEY|GENERIC:VAL)$/ ) ) {
						lastTag.properties[lidx] = '#con#' + l
					}
				}
				// console.log( 'merge', k, l, clone(lastTag.properties) );
			}
			if( t.table ) {
				lastTag.table = t.table;
			}
			translate[t.id] = lastTag.id+'_'+simplify(t.properties[0]);
			t.del = 1;
			continue;
		}
		else
			translate[t.id] = t.id+'_'+simplify(t.properties[0]);
		rangeList.push(t);
		lastTag = t;
		lastRange = k;
	}
	for( var i = tags.length-1 ; i >= 0 ; i-- ) if( tags[i].del ) tags.splice(i,1);
	for( var l of links )
	{
		if( translate[l.id1] ) l.id1 = translate[l.id1];
		if( translate[l.id2] ) l.id2 = translate[l.id2];
	}
	// console.log( 'MERGETRANSLATE', translate, clone(links) );
}


function getTextObj( id, adj )
{
	var txt = adj ? txtObjAdj : txtObj;
	var r = txt.find('#'+id);
	// console.log( 'getTextObj', id, adj, r );
	return r;
}

function getIdx( o )
{
	for( var i = 0 ; i < tList.length ; i++ )
	{
		if( tList[i].obj.parentElement == o ) return i;
	}
	return 0;
}

function getRange( o1, off1, o2, off2 )
{
	var ct = 0;

	var expanded = false;
	if( o1 == null || o2 == null ) return null;
	if( !o1.tagName ) o1 = o1.parentElement;
	if( !o2.tagName ) o2 = o2.parentElement;
	var o1Id = $(o1).prop('id');
	var o2Id = $(o2).prop('id');

	// console.log( 'getRange', 'o1Id', o1Id, getIdx(o1), off1, 'o2Id', o2Id, getIdx(o2), off2 )

	var o1Idx = getIdx(o1);
	var o2Idx = getIdx(o2);
	if( isNaN(o1Idx) || isNaN(o2Idx) ) return null;
	if( o2Idx < o1Idx )
	{

		var tmp = [o1Id,off1];
		o1Id = o2Id;
		off1 = off2;
		o2Id = tmp[0];
		off2 = tmp[1];
	}
	// console.log( 'totOff1', $(o1).attr('o1')*1+off1, 'totOff2', $(o2).attr('o1')*1+off2 );
	var totOff1 = $(o1).attr('o1')*1+off1;
	var totOff2 = $(o2).attr('o1')*1+off2;

	// console.log( o1Id, '--totOff1', totOff1, '--totOff2', totOff2, gPDF.plainText[currentPage-1].substring(totOff1,totOff2) );
	if( (autoExpand && !skeys.ctrlOn) || (totOff2 == totOff1 && totOff2 > 0) )
	{
		// var fr = findRange( totOff1, true ); // disabeled findRange to make sub label selection easyer
		// if( fr ) return fr.range;

		function getTextCharAt(pos)	{ return gPDF.plainText[currentPage-1][pos] || ' '; }
		function isSep(pos)
		{
			var separator = /[ \-'`~!^*()_|+=?;:'",.<>\{\}\[\]\\\/]/i;
			// console.log( 'isSep', pos, JSON.stringify(getTextCharAt(pos)), getTextCharAt(pos).charCodeAt(0), getTextCharAt(pos).match(separator) )
			return getTextCharAt(pos).match(separator);
		}
		var i = 0;
		while( i++ < 1000 && totOff1 >= 0 && !isSep(totOff1)) totOff1--;
		if( isSep(totOff1) ) totOff1++;
		while( i++ < 1000 && !isSep(totOff2)) totOff2++;
		expanded = true;
	}
	if( descriptor.disableOverlap )
	{
		for( var i = 0 ; i < rangeList.length ; i++ )
		{
			var r = rangeList[i];
			if( r.page != currentPage ) continue;
			if( r.adj ) continue;
			if(
				(r.range[0] < totOff1 && r.range[1] > totOff1 ) ||
				(r.range[0] < totOff2 && r.range[1] > totOff2 ) ||
				(totOff1 < r.range[0] && totOff2 > r.range[0] ) ||
				(totOff1 < r.range[1] && totOff2 > r.range[1] ) ||
				(totOff1 == r.range[0] && totOff1 == r.range[1] )
			)
			{

				console.error( 'range overlap', totOff1, totOff2, r.range );
				setTimeout( clearSelection, 1 );
				return null;
			}
		}
	}
	return totOff2 > totOff1 ? [totOff1,totOff2,expanded] : null;
}



function getRange2( )
{
	// console.log( 'getRange2', selectRange )
	var ct = 0;

	var expanded = false;
	// if( selectRange.length == 1 ) // check if there are ranges at this position and get the closest
	// {
	// 	var p = selectRange[0];
	// 	var min = 0;
	// 	var closest = null;
	// 	for( var r of rangeList )
	// 	{
	// 		if( r.page != currentPage || r.range[0] > p || r.range[1] < p ) continue;
	// 		if( !min || r.text.length < min )
	// 		{
	// 			closest = r.range;
	// 			min = r.text.length
	// 		}
	// 	}
	// 	if( closest ) return closest;
	// }
	if (selectRange.length == 1) {
		if (descriptor.comprehendMode) {
			selectRange.push(selectRange[0] + gPDF.pdfData.textContent[currentPage - 1][selectRange[0]][0].length);
		} else {
			expanded = true;
			selectRange.push(selectRange[0])
		}
	}
	else if( autoExpand && !skeys.ctrlOn )
	{
		for( var i = selectRange[0] ; i <= selectRange[1] ; i++ )
		{
			if( getTextCharAt(i).match(/[a-zA-Z0-9]/) )
			{
				expanded = true;
				break;
			}
		} 
	}

	// console.log( 'expanded', expanded )
	// console.log( 'totOff1', $(o1).attr('o1')*1+off1, 'totOff2', $(o2).attr('o1')*1+off2 );
	var totOff1 = selectRange[0];
	var totOff2 = selectRange[1];
	if( totOff2 < totOff1 )
	{
		var tmp = totOff1;
		totOff1 = totOff2;
		totOff2 = tmp;
	}
	function getTextCharAt(pos)	{ return gPDF.plainText[currentPage-1][pos] || ' '; }
	// if( totOff2 == totOff1 && totOff2 > 0 )
	if( expanded )
	{
		function isSep(pos)
		{
			// var separator = /[ \-\t'`~!^*()_|+=?;:'",.<>\{\}\[\]\\\/]/i;
			var separator = /[ \-\t'`~!^*_|+=?;:'",.<>\{\}\[\]\\\/]/i;
			// console.log( 'isSep', pos, JSON.stringify(getTextCharAt(pos)), getTextCharAt(pos).charCodeAt(0), getTextCharAt(pos).match(separator) )
			return getTextCharAt(pos).match(separator);
		}
		function close(pos)
		{
			if( htmlTextMode ) return true;
			var t = gPDF.textContent[currentPage-1][pos];
			if( !t ) return false;
			return Math.max( Math.abs(t[5]), Math.abs(t[6])) < 0.3;
		}
		var i = 0;
		while( i++ < 1000 && totOff1 >= 0 && !isSep(totOff1) && close(totOff1) )
		{
			// console.log( 'back', totOff1, getTextCharAt(totOff1), isSep(totOff1), close(totOff1) );
			totOff1--;
		}
		if( isSep(totOff1) ) totOff1++;
		while( i++ < 1000 && !isSep(totOff2) && close(totOff2) )
		{
			totOff2++;
		}
		// if( !close( totOff2) ) totOff2--;
		expanded = true;
		if( totOff2 == totOff1 ) totOff2++;
	}
	else totOff2++;

	// console.log( 'tot', totOff1, totOff2 );

	// trim selection
	while( totOff1 < gPDF.plainText[currentPage-1].length && (getTextCharAt(totOff1)==' ' || getTextCharAt(totOff1)=='\t') ) totOff1++;
	while( totOff2 > 0 && (getTextCharAt(totOff2-1) == ' '||getTextCharAt(totOff2-1) == '\t') ) totOff2--;

	selectRange = [totOff1,totOff2-1];
	if( selectRange[1] >= selectRange[0] ) paintSelectRange();
	selectRange = [];


	if( descriptor.disableOverlap )
	{
		for( var i = 0 ; i < rangeList.length ; i++ )
		{
			var r = rangeList[i];
			if( r.page != currentPage ) continue;
			if( r.adj ) continue;
			if(
				(r.range[0] < totOff1 && r.range[1] > totOff1 ) ||
				(r.range[0] < totOff2 && r.range[1] > totOff2 ) ||
				(totOff1 < r.range[0] && totOff2 > r.range[0] ) ||
				(totOff1 < r.range[1] && totOff2 > r.range[1] ) ||
				(totOff1 == r.range[0] && totOff1 == r.range[1] )
			)
			{
				console.error( 'range overlap', totOff1, totOff2, r.range );
				setTimeout( clearSelection, 1 );
				return null;
			}
		}
	}
	// console.log( 'getRange2', totOff1, totOff2 )

	return totOff2 > totOff1 ? [totOff1,totOff2,expanded] : null;
}




function clearSelection()
{
	selectRange = [];
	if( engine2() || htmlTextMode ) paintSelectRange();
    if (window.getSelection) {window.getSelection().removeAllRanges();}
    else if (document.selection) {document.selection.empty();}
}

function inTag( tagId, type, ct )
{
    var ctype = simplify( type );
    var ret = [];
    var cname = 'c_tag c_tag_visible_' + simplify(type) + ' c_' + ctype + ' ' + 'cid_' + tagId;
    var id = 'start_'+tagId;
    ret.push( {len:0,start:ct,end:ct,tag:'span',state:1,id:id,split:'<span id="'+id+'">'} );
    ret.push( {len:0,start:ct,end:ct,tag:'span',state:-1,id:id,split:'</span>'} );
    var id = tagId;
    defineColor(ctype);
    ret.push( {len:0,start:ct,end:ct,tag:'span',state:1,id:id,split:'<span id="'+id+'" class="'+cname+'">'} );
    return ret;
}

var tagCSS = {};
var tagFontCSS = {};
var tagColors = {};
// var tagDefaultColor = alfaColor('bbbbbb');
var tagDefaultColor = alfaColor('ff0000');
var tagObj = {};
var aliases = {};

function initColors()
{

    tagColors = {};
    ['labels','relationships','boxes'].forEach( function(k){
        if( !descriptor[k] ) return;
		var list = descriptor[k];
		function goList( list, pathlist )
		{
			if( !pathlist ) pathlist = []
			for( var n in list )
			{
				var sn = simplify(n);
				var cl = list[n];
				var plist = pathlist.concat([n]);
				var path = plist.join('/');
				var spath = simplify(path);

				if( isobj(cl) )
				{
					aliases[n] = cl.alias;
					if( cl.sublabels ) goList( cl.sublabels, plist );
					cl = cl.color;
				}
				tagColors[sn] = cl;
				tagObj[sn] = list[n];
				tagObj[n] = list[n];
				tagObj[path] = list[n];
				tagObj[spath] = list[n];
				defineColor(sn);
			}
		}
		goList( list );
    });
}

function getColor( type )
{
	type = simplify( type )
	return tagCSS[type];
}

function getFontColor( type )
{
	type = simplify( type )
	return tagFontCSS[type];
}



function defineColor( type )
{
	if( !(type instanceof Array) )
		type = [type];
	type = aUnique( type )
	var stype = clone(type);
	stype.sort();
	var key = stype.join('_');

    var fg = '#000000';
    if( key in tagCSS ) return tagCSS[key];
	var c = [ 0, 0, 0, 0 ];
	for( var i = 0 ; i < stype.length ; i++ )
	{
		var bg = tagDefaultColor;
		// console.log( 'DeFINECOLor', stype[i], tagColors[stype[i]] )
		// if( stype[i] in tagColors )	bg = alfaColor( tagColors[stype[i]] );
		if( stype[i] in tagColors )	bg = tagColors[stype[i]]+'ff';
		bg = bg.substr(1);
		for( var j = 0 ; j < 4 ; j++ )
		{
			c[j] += parseInt(bg.substr(0,2),16);
			bg = bg.substr(2);
		}
		// console.log( 'definecolor', key, stype[i], clone(c) );
	}
	var bg = '#';
	var font = '#';
	for( var j = 0 ; j < 4 ; j++ )
	{
		c[j] /= stype.length;
		var cbg = c[j]*1.4; if( cbg > 255 ) cbg = 255;
		var cft = c[j]*.6; if( cft > 255 ) cft = 255;
		bg += Math.floor(cbg).toString(16).padStart(2,'0')
		font += Math.floor(cft).toString(16).padStart(2,'0')
	}
	console.log( 'defineColor', type, key, bg );
	$("<style type='text/css'> .c_"+ key +"_over { color: #ffff00 !important; background:red !important; font-size: 30px; } </style>").prependTo("head");
	if( !ocrMode )
		$("<style type='text/css'> .c_"+ key +"{ color:"+fg+"; border-top: 3px solid "+bg+"; margin-top: -3px;} </style>").prependTo("head");
	else
		$("<style type='text/css'> .c_"+ key +"{ color:"+fg+"; border: 1px solid "+bg+"; margin-top: 0px; margin-left: 0px} </style>").prependTo("head");
    $("<style type='text/css'> .l_"+ key +"{ border-color:"+bg+"; color:"+font.substr(0,7)+"} </style>").prependTo("head");
    tagCSS[key] = bg;
	tagFontCSS[key] = font;
}

window.defineColor = defineColor;

function findColor( type )
{
    type = simplify( type );
    if( type in tagColors ) return tagColors[type];
    return tagDefaultColor;
}

function outTag( tagId, type, ct )
{
    var ret = [];
    var id = 'end_'+tagId;
    ret.push( {len:0,start:ct,end:ct,tag:'span',state:-1,id:id,split:'</span>'} );
    ret.push( {len:0,start:ct,end:ct,tag:'span',state:1,id:id,split:'<span id="'+id+'">'} );
    ret.push( {len:0,start:ct,end:ct,tag:'span',state:-1,id:id,split:'</span>'} );
    return ret;
}

function delTmp()
{
    var ranges = rangeList;
	var delList = [];
	var fixed = false;
    ranges.forEach( function(r,idx){
        if( (r.type == 'tmp' || (r.properties && !r.properties.length) ) && r.id != selected ) delList.push( r.id );
        if( r.type == 'TABLECELL' && !r.table && r.id != selected && !tableCleanIgnore ) delList.push( r.id );
		var thidx = -1;
		if( !r.table && r.properties && (thidx = r.properties.indexOf('TABLEHEADER')) >= 0 ) {
			// console.log( 'remove TABLEHEADER', thidx )
			r.properties.splice(thidx,1);
			// console.log( 'remove TABLEHEADER2', r.properties )
			if( !r.properties.length ) delList.push( r.id );
			fixed = true;
		}
    });
	for( var d of delList ) {
		// console.log( 'delRange', d )
		delRange( d )
	}
	if( fixed ) drawText();
}

function delRangeLabel( rangeId, label ) {
	let r = rangeList.find( o => o.id == rangeId );
	if( label !== null ) {
		let idx = r.properties.indexOf(label);
		if( idx >= 0 ) r.properties.splice(idx,1);
	}
	else r.properties = [];
	if( r.rawBox ) {
		delBox( r.id )
		selected = null;
	}
	if( !r.properties.length && r.table ) r.properties.push('TABLECELL');
	drawTag( rangeId )
	delTmp();
	drawTags();
	checkLinks(rangeId);
	if( htmlTextMode ) setTimeout(drawHtmlAdjust, 100);
}
var rangeChanged = false;
var linkChanged = false;

function delRange( rangeId, ignoreLinks )
{
	if( blockEdit ) return locked();
	rangeChanged = true;
	var boxDeleted = false;

	changed();
	if( isarray(rangeId))
	{
		rangeId.forEach(r => delRange(r));
		return;
	}
	if( oocrMode ) $('.cid_'+rangeId).remove();
	popupOut();
	$('.c_tag').off('mouseover');
	$('.c_tag').off('mouseout');
	var subRanges = [];
    for( var i = rangeList.length-1 ; i >= 0 ; i-- )
    {
        if( rangeList[i].id == rangeId )
        {
			var r = rangeList[i];
			if( r.table ) {
				delRangeLabel( r.id, null ); // dell all labels, but will keep TABLECELL 
				tagUnselect();
				$('.c_tag').off('mouseover').on('mouseover', tagOver );
				$('.c_tag').off('mouseout').on('mouseout', tagOut );
				tagPanelUpdate();
				return 1;
			}
			if( r.boxId ) {
				delBox( r.boxId, 5 )
			}
			if( r.rawBox ) {
				// if it's ocrMode and range is a rawbox, then it's necessary to remove the span.
				$('[tid='+rangeId+']').remove();
				delBox( r.id )
			}
			setRedrawRange( r.range );
			if( r.subs ) subRanges = r.subs;
            rangeList.splice(i,1);
			if( 0 && r.adj )
			{
				var source = descriptor.adjudication_attributes.tags;
				for( var j = source.length-1 ; j >=0 ; j-- )
				{
					if( source[j].id == r.id )
						source.splice(j,1);
				}
			}
        }
    }
	$('.tag_'+rangeId).remove();
	// console.log( 'cid', '.cid_'+rangeId, $('.cid_'+rangeId) )
	var spans = $('.cid_'+rangeId);
	// console.log( 'SPANS', spans.length )
	// var spans = []; $('.cid_'+rangeId).each( (idx,t) => spans.push($(t)) );
	// layersOut();
	disableLayer();
	Array.from(spans).forEach( function(t){
		// console.log( 'DELETE', t )
		t = $(t);
		var ids = getList( t, 'ids' );
		var types = getList( t, 'types' );
		// console.log( 'del range ids', clone(ids), t[0] );
		var idx = listIdx( ids, rangeId );
		ids.splice(idx,1);
		types.splice(idx,1);
		setList( t, 'ids', ids );
		setList( t, 'types', types );
		if( engine2() || htmlTextMode ) t.css({marginTop:'',marginLeft:''})
		else t.css({marginTop:'auto',marginLeft:'auto'})
		// console.log( 'del range ids2', clone(ids) );
		if( engine2() || htmlTextMode )
		{
			textAdjustClass($(t))
		}
	});
	enableLayer();
	if( htmlTextMode ) setTimeout(drawHtmlAdjust, 100);
    tagUnselect();
	// if( ocrMode && boxDeleted ) {
	// 	alert(1)
	// 	$('[tid='+rangeId+']').remove();

	// }
    if( !ignoreLinks ) delLink( rangeId );
	adjustText();
	fixRanges();
	setTimeout( drawText, 1 );
    $('.c_tag').off('mouseover').on('mouseover', tagOver );
    $('.c_tag').off('mouseout').on('mouseout', tagOut );
	delRange(subRanges);
	paintSelectRange()
	tagPanelUpdate();
    return 1;
}

function getList( o, id )
{
	o = $(o);
	var l = o.prop(id);
	if( !l ) return [];
	return l.split('|')
}

function listIdx( list, s )
{
	return list.indexOf( s.toString() );
}

function setList( o, id, list )
{
	o = $(o);
	o.prop(id,list.join('|'));
}


function textAdjustClass( o, adj )
{
	o = $(o);
	var ids = getList(o,'ids') || [];
	var types = getList(o,'types') || [];
	o.removeClass();
	if( engine2() || htmlTextMode )
	{
		// console.trace( 'ooooooooooooooo', o[0] )
		o.addClass( 'pp pp'+o.attr('o1')*1);
		if( htmlTextMode ) o.addClass( 'pph-position adjusttop');
		// console.log( 'ADDCLASS', 'pp'+o.attr('o1')*1 )
	}
	if( !ids.length )
	{
		o.addClass('pdf_text');
		return;
	}
	o.addClass('pdf_text');
	o.addClass('c_tag');
	if( adj ) o.addClass(tagAdjClass);
	else if( showAdjudication ) o.addClass( tagOpt1Class );
	var stypes = [];
	// console.log('textAdjustClass', o.attr('o1')*1, adj, ids, types, rangeList )
	for( var i = 0 ; i < ids.length ; i++ )
	{
		var t = tagFind(ids[i]);
		var rt = simplify(types[i]);
		// stypes[i] = rt;
		stypes.push(rt);
		if( t && t.properties ) t.properties.forEach( p => {
			p = simplify(p);
			stypes.push(p);
			o.addClass('c_tag_visible_'+p);
		} );
		o.addClass('c_tag_visible_'+rt);
		// o.addClass('c_'+simplify(rt) );
		o.addClass('cid_'+ids[i] );
		// if( t && t.adj )
		// if( adj && !htmlTextMode ) //HTMLCHANGE
		if( adj  ) //HTMLCHANGE
		{
			var mp = {top:-30,left:0};
			if( FIXSPLIT )
			{
				let t = getTransform(o);
				if( t )	mp = {left:30*t[1],top:-30*t[3]};
			}
			o.css({marginTop:mp.top,marginLeft:mp.left})
			o.addClass('adj_text')
		}
		if( t && t.adj_forward ) o.addClass('adj_forward');
		if( showAdjudication && t && t.equal ) o.addClass( tagEqualClass );
	}
	stypes.sort();
	defineColor( stypes );
	o.addClass('c_'+aUnique(stypes).join('_'));
	// AQUII
	if( oocrMode && ids.length ) o.addClass('c_ocr');
	// console.log( 'textAdjustClass', o, o.prop('className'));
}



function getTransform(o)
{
	var t = $(o).css('transform');
	if( t.indexOf('matrix') == 0 )
	{
		var params = t.split(/[\(\)]/)[1].split(',').map( p => parseFloat(p));
		// console.log( params );
		return params;
	}
	return null;
}

function posTransform( p, t )
{
	if( !t ) return p;
	return {left: p.left*t[0]+p.top*t[1], top: -p.left*t[2] + p.top*t[3]}
}


function fixSplitTransform( a, b )
{

	var ts = a.css('transform');
	if( !ts || ts == 'none' ) return null;
	var t = getTransform(a);
	a.css('transform','');
	var ap = a.position();
	var w = a.width();
	var op = posTransform({left:w, top:0}, t);
	var bp = {left: ap.left+op.left, top:ap.top+op.top};
	b.css(bp);
	a.css('transform',ts);
}



var splitTags = 0;
function splitRange2( range, rangeId, rangeType, adj, page, properties )
{

	// return null;
	// console.trace( 'SPLITDEB SPLITRANGE2', range, rangeId, rangeType, adj, page, properties );
	var list = adj ? tListAdj : tList;
	if( !page ) page = currentPage;
	if( page == currentPage )
	{
		function setClass( o )
		{
			var ids = getList(o,'ids') || [];
			if( listIdx(ids,rangeId) == -1 ) ids.push( rangeId );

			var types = getList(o,'types') || [];
			types.push( rangeType );
			// if( properties ) properties.forEach( p => types.push(p) );
			setList(o,'ids',ids);
			setList(o,'types',types);
			textAdjustClass( o, adj );
		}

		// console.log( 'SPLIT', s1, s2, list[s1], list[s2] );
		var texts = [];
		var lastRight = 0;
		var to = adj ? txtObjAdj : txtObj;
		// console.log( 'SPLITRANGE2', to, s1, s2 )
		disableLayer();

		if (ocrMode && !range.length) { // if ocrMode and it's a hadcoded box
			var lasti = -1;
			for (var i of range) {
				var t = gPDF.pdfData.textContent[page - 1][i][0];
				if (texts.length && lasti != i - 1) texts.push(' ');
				texts.push(t);
				lasti = i;
			}
			texts = texts.join('');
			$('.cid_'+rangeId).remove();
			var o = $('<span class="pdf_text pp_ocr" tid="'+rangeId+'">');
			// console.log( 'AAAAAADDD', o )
			txtObj.append(o);
			setClass(o);
		}
		else if (descriptor.selectBoundingBox) {
			var lasti = -1;
			for( var i of range ) {
				var o = to.find('.pp'+i);
				// console.log( 'o', o[0])
				setClass( o );
				var t = gPDF.pdfData.textContent[page-1][i][0];
				if( texts.length && lasti != i-1 ) texts.push(' ');
				texts.push(t);
				lasti = i;
			}
			texts = texts.join('');
		}
		else {
			var s1 = range[0];
			var s2 = range[1];
			for( var i = s1 ; i < s2 ; i++ )
			{
				var o = to.find('.pp'+i);
				// console.log( 'SPLIT', i, adj, o )
				setClass( o );
				// var wid = o[0].getBoundingClientRect().width;
				// lastRight = o.position().left+wid;
			}
			texts = gPDF.pdfData.plainText[page-1].substring(range[0],range[1]);
		}
		enableLayer();
		// console.log( texts, texts.join(''))
		// texts = texts.join('');
		
		adjustText();
		$('.c_tag').off('mouseover').on('mouseover', tagOver );
		$('.c_tag').off('mouseout').on('mouseout', tagOut );
	}
	else {
		var texts = [];
		var lastRight = 0;
		if (oocrMode) {
			var lasti = -1;
			for (var i of range) {
				var t = gPDF.pdfData.textContent[page - 1][i][0];
				if (texts.length && lasti != i - 1) texts.push(' ');
				texts.push(t);
				lasti = i;
			}
			texts = texts.join('');
		}
		else if (descriptor.selectBoundingBox) {
			var lasti = -1;
			for( var i of range ) {
				var t = gPDF.pdfData.textContent[page-1][i][0];
				if( texts.length && lasti != i-1 ) texts.push(' ');
				texts.push(t);
				lasti = i;
			}
			texts = texts.join('');
		}
		else {
			texts = gPDF.pdfData.plainText[page-1].substring(range[0],range[1]);
		}
	}
	
	var rangeObj = {page:page,range:range,text:texts,id:rangeId,type:rangeType,adj: adj == true,properties:properties};
	if( descriptor.comprehendMode ) {
		var blocks = [];
		for( var r of rangeObj.range ) { blocks.push( gPDF.pdfData.textContent[rangeObj.page-1][r][8]) }
		rangeObj.blocks = blocks;		
	}
	// console.log( 'split done', clone(rangeObj) )
	return rangeObj;
}



function splitRange( range, rangeId, rangeType, adj, page, properties )
{
	if( !properties && rangeType && rangeType != 'tmp' ) properties = [rangeType];
	if( engine2() || htmlTextMode ) return splitRange2( range, rangeId, rangeType, adj, page, properties );
	// console.log( 'SPLITRANGE', range, rangeId, rangeType, adj, page );
	var list = adj ? tListAdj : tList;
	if( !page ) page = currentPage;
	if( page == currentPage )
	{
		function setClass( o )
		{
			var ids = getList(o,'ids');
			ids.push( rangeId );

			var types = getList(o,'types');
			types.push( rangeType );
			// if( properties ) properties.forEach( p => types.push(p) );
			setList(o,'ids',ids);
			setList(o,'types',types);
			textAdjustClass( o, adj );
		}

		function split( off, first )
		{
			// console.log( 'SSSSSSSSSSSSSSSSSSSSSSSSSSSSSSs', off )
			// find insertpoint
			var ct = 0;
			lastRight = 0;
			for( var i = 0 ; i < list.length ; i++ )
			{
				try {
					var span = getTextObj(list[i].obj.parentElement.id, adj);
					// console.log( i, 'span', span.attr('o1')*1, span.attr('o2')*1)
					if( !span[0] ) continue;
					if( span.attr('o2')*1 <= off ) continue;
					// console.log( 'split', off, span.attr('o1')*1, span.attr('o2')*1, span[0] );
					if( off > span.attr('o1')*1 && off < span.attr('o2')*1)
					{ // need to split

						// console.log( 'span', span[0])
						var txt = span.text();
						var ct = span.attr('o1')*1;
						// var txt = span.html();
						var txt1 = txt.substr(0,off-ct);
						var txt2 = txt.substr(off-ct);

						// console.log( 'split', 'txt1', txt1, 'txt2', txt2)
						span.text(txt1);
						var wid = span[0].getBoundingClientRect().width;
						var pos = span.position();
						// copy other css
						var fontSize = span.css('font-size');
						var fontFamily = span.css('font-family');
						var transform = span.css('transform');
						var ids = span.prop('ids');
						var types = span.prop('types');
						// var span2 = $('<span>').prop('id','spl_txt_'+splitTags++).html(txt2);
						var span2 = $('<span>').prop('id','spl_txt_'+splitTags++).text(txt2);
						span2.prop('ids', ids );
						span2.attr('o2', span.attr('o2')*1);
						span.attr('o2', span.attr('o1')*1+txt1.length);
						span2.attr('o1', span.attr('o1')*1+txt1.length);
						span2.prop('types', types );
						// console.log( 'splited', span[0], span2[0] )

						var css = {
							top:px(pos.top),
							left:px(pos.left+wid),
							fontSize: fontSize,
							fontFamily: fontFamily,
							transform: transform,
							// background: 'red',
							// color:'white',
						};
						span2.css( css );
						span2.insertAfter(span);
						list[i].text = txt1;
						list[i].obj = span[0].childNodes[0];
						list.splice(i+1,0,{text:txt2,obj:span2[0].childNodes[0]});
						// console.log( 'splited')

						if( FIXSPLIT )
						fixSplitTransform( span, span2 );
						// window.a = span;
						// window.b = span2;
						return i+1;
					}
					else return i;
				} catch(e) { return; }
			}
			return i;
		}



		var s1 = split( range[0], 1 );
		var s2 = split( range[1], 0 );
		// console.log( 'SPLIT', s1, s2, list[s1], list[s2] );
		var texts = [];
		var lastRight = 0;
		for( var i = s1 ; i < s2 ; i++ )
		{
			var o = $(list[i].obj.parentElement)
			setClass( o );
			// if( lastRight && Math.abs(o.position().left-lastRight) > 1 ) // SPACE
			// {  // SPACE
			// 	 texts.push(' '); // SPACE
			// } // SPACE
			texts.push( o.text() )
			// save last right
			var wid = o[0].getBoundingClientRect().width;
			lastRight = o.position().left+wid;
		}
		// console.log( texts, texts.join(''))
		// texts = texts.join('');
		texts = gPDF.plainText[page-1].substring(range[0],range[1]);

		adjustText();
		$('.c_tag').off('mouseover').on('mouseover', tagOver );
		$('.c_tag').off('mouseout').on('mouseout', tagOut );
	}
	return {page:page,range:range,text:texts,id:rangeId,type:rangeType,adj: adj == true,properties:properties};
}


function tagUnselect()
{
	selected = null;
    tagOut();
	tagDownOff();
	if( ocrMode ) {
		delBox( selectedBox, 'tagUnselect' );
		selectedBox = null;
		$('.c_ocr_sel').removeClass('c_ocr_sel').removeClass('c_rawbox_inv');
	}
	// popupOut();
    // $('#labels').hide();
}

function paintTag( id )
{
	setTimeout( function(){
		var tag = tagFind(id);
		if( !tag ) return;
		selectRange = clone(tag.range);
		selectRangeTmp = clone(selectRange);
		if( !descriptor.selectBoundingBox ) selectRange[1]--;
		paintSelectRange()
	}, 100 );
}

window.tagSelect = tagSelect;
function tagSelect( id )
{
	// if( usingBoxes() ) return;
	// console.log( 'tagSelect', id );
    linkUnselect();
	boxUnselect();
    $('.c_tag').removeClass(tagSelectedClass);
    $('.tag_label').removeClass('tag_label_over');
    // console.log( 'tagSelect', id )
    clearTimeout(tagOutTid);
    var tag = tagFind(id);

	if( engine2() ) paintTag( id );
    if( !tag ) return;
	if( isAdj(tag) ) return;
	// if( tag.adj ) return;
    selected = id;
    if( hasLabels ) $('#labels').show();
    $('.cid_'+selected).addClass(tagSelectedClass);


	// check if hotkey is pressed
	if( hKeyPressed && hKeyPressed.type == 'label' )
	 	hKeyPressed.callback('set',hKeyPressed.str);

	// if( tag.type == 'tmp' )
	// 	showPopup('labels',$('.cid_'+tag.id), tag)
	// else
	// 	rightFocus('labels');


	if( skeys.altOn && tag.type != 'tmp' && !ocrMode )
	{
		// console.log( 'skeys.altOn', tag )
		// if( (skeys.ctrlOn || skeys.metaOn) )
		setTimeout( function(){
			showTagComment(tag.id, true);
		}, 100 );
	}
	else if( !skeys.shiftOn )  // HIDE POPUP
		setTimeout( function(){
			showPopup('labels',$('.cid_'+tag.id), tag);
			if( descriptor.popTextEditLayout ) {
				$('.tag-text-area').html(tag.text);
				if( tag.textAdjust )
				{
					$('.tag-text-area').addClass('tag-text-adjust').html(tag.textAdjust);
				}
				$('.tag-text-area').change();
			}
			else {
				$('.tag-text').html(shrinkText(tag.text));
				if( tag.textAdjust )
				{
					$('.tag-text').addClass('tag-text-adjust').html(shrinkText(tag.textAdjust));
				}
			}
			setTimeout( function(){
				showTagComment(tag.id);
			}, 1)
		}, 100 );
	// rightFocus('labels');
	clearSelection();
	if( ocrMode && tag.rawBox ) {
		$('.c_ocr_sel').removeClass('c_ocr_sel');
		$('.cid_'+selected).addClass('c_ocr_sel').addClass('c_rawbox_inv');
		// console.log( 'BBB BOX', tag.id, tag.box )
		var b = addBox( tag.id, tag.page, tag.box, '' )
		if( tag.rotate ) b.rotate = tag.rotate;
		selectedBox = tag.id;
		b.color = tag.color;
		drawBox( selectedBox );
		b.tagId = tag.id;
		b.rawBox = tag.rawBox;
	}

}

var popupClear = true;
var popupSelected = null;
function popupOut()
{
	showPopupAlt = null;
	$('.popup-list-bg').remove();
	$('.popup-list').remove();
	popupClear = false;
	popupSelected = selected;
	hideTagComment();
	setTimeout( function(){ popupClear = true; popupSelected = null}, 1000 );
	popupUpdate = null;
	eventOutsideEnd();
}

function fitPopup( obj, target, width, height )
{
	if( !obj || !$(obj).length ) return null;
	var rect = $(obj)[0].getBoundingClientRect();
	// console.log( 'fitPopup', obj[0], rect, $(obj).position()  )
	var maxx = 0;
	// console.log( 'target', target.length, target[0], rect  );
	for( var i = 0 ; i < $(obj).length ; i++ )
	{
		let bb = $(obj)[i].getBoundingClientRect();
		var xx = bb.x+bb.width;
		if( xx > maxx ) maxx = xx;
	}

	var brect = $(target)[0].getBoundingClientRect();
	var stop = $(target).scrollTop();
	var top = rect.y-brect.y+stop;
	var left = maxx-brect.x+10+$(target).scrollLeft();
	var maxHeight = $(target)[0].scrollHeight;
	console.log('ht', maxHeight)
	var maxWidth = $(target)[0].scrollWidth-20;
	var maxWidth = $(target).width();
	if( left+width > maxWidth )
		left = rect.x-width-10+$(target).scrollLeft()-brect.x;
	if( left < 10 ) left = 10;
	if( top < 10 ) top = 10;
	// console.log( 'maxHeight', maxHeight, 'top', top, 'height', height )

	var topOff = 120;
	if( top+height+topOff > maxHeight) top = maxHeight-height-topOff;

	if( top-stop+height+topOff > $(target).outerHeight() ) {
		// console.log( 'overheight', 'top', top, 'stop', stop, 'height', height, 'theight', $(target).outerHeight() )
		var diff = (top-stop+height+topOff)-$(target).outerHeight();
		top -= diff;
		if( top < 0 ) top = 0;
		if( top < stop ) top = stop;
	}

	return {top:top,left:left,width:width,height:height,targetMaxWidth:maxWidth,targetMaxHeight:maxHeight};
}

var _eventOutEvlist = [];
function eventOutside( obj, event, callback )
{
	var domObj = $(obj)[0];
	function check(ev)
	{
		if( ev.target == domObj || $(ev.target).closest(domObj).length ) return true;
		return callback(ev);
	}
	$(document.body).on( event, check );
	var e = {ev:event,cb:check};
	_eventOutEvlist.push( e );
	return e;
}

function eventOutsideEnd( e )
{
	// console.log( 'eventOutsideEnd' )
	if( e ) return $(document.body).off(e.ev,e.cb);
	while( _eventOutEvlist.length )
	{
		var e = _eventOutEvlist.pop();
		$(document.body).off(e.ev,e.cb);
	}
}

function showTagComment( id, edit )
{
	var tag = tagFind(id);
	// console.log( 'showTagComment', tag, tag.comment, 'edit', edit )
	// if( !tag ) return;
	if( !tag || (!edit && !tag.comment) ) return;
	var tagObj = $('.cid_'+id);
	if( !tagObj.length ) return;
	$('.popup-comment-bg').remove();
	$('.popup-comment').remove();

	var popbg = $('<DIV>').addClass('popup-comment-bg');
	var pop = $('<DIV>').addClass('popup-comment');
	var popcont = $('<DIV>').addClass('popup-comment-content');
	var width = 250;
	var height = 200;
	var pos = fitPopup( tagObj, $('#maincolumn'), width, height );
	if( !pos ) return;
	popcont.css({maxHeight:px(pos.height)});
	pop.append(popcont);
	popbg.css({
		height:px(pos.targetMaxHeight),
		width:px(pos.targetMaxWidth),
	})
	popcont.html('<div class="popup-comment-small">Comment:</div>'+tag.comment);
	if( edit )
	{
		popupOut();
		var comment = tag.comment || '';
		popcont.html('<input class="form-control bborder-secondary border-right-0 rounded-0" type="text" value="'+comment+'" id="tagcomment" placeholder="Enter Comment">')
		$('#maincolumn').append(popbg);
		popbg.off('click').on('click', function(){
			hideTagComment(true);
			selected = null;
			setTimeout( drawText, 100 );
		})
		setTimeout( function(){
			$('#tagcomment').select();
			$('#tagcomment').off('keyup').on('keyup',commentKey);
			$('#tagcomment').off('change').on('change',commentChange);
		}, 100 );
		function commentKey(ev)
		{
			if( ev.keyCode == 13 )
			{
				tag.comment = $('#tagcomment').val().trim();
				hideTagComment(true);
				selected = null;
				setTimeout( drawText, 100 );
				changed();
			}
			ev.preventDefault();
			// console.log( 'commentKey', ev.keyCode );
		}
		function commentChange(ev)
		{
			tag.comment = $('#tagcomment').val().trim();
			changed();
		}
	}
	$('#maincolumn').append(pop);
	pop.css({top:px(-2000), left:px(pos.left), width: px(pos.width)});
	setTimeout( function(){
		pop.css({top:px(pos.top-$('.popup-comment').height()-10), left:px(pos.left), width: px(pos.width)});
	}, 200 )
}

function hideTagComment(force)
{
	if( $('.popup-comment-bg').length && !force ) return;
	$('.popup-comment-bg').remove();
	$('.popup-comment').remove();

}

function selectElementContents(el) {
	// console.log( 'SPAN', el )
    var range = document.createRange();
    range.selectNodeContents(el);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
}

var popupUpdate = null;
var multiSelect = false;

function keysetType(l) {
	if (!l.match(/:(KEY|VAL)$/)) return [l, ''];
	var tmp = l.split(':');
	var kt = tmp.pop();
	var kl = tmp.join(':')
	return [kl, kt];
}

function keysetLabel(l) {
	var [kl, kt] = keysetType(l);
	if (!kt) return l;
	if (kt == 'KEY') var key = '<span class="ks-button ks-key"><i class="fa fa-key"></i></span>';
	else var key = '<span class="ks-button ks-val"><i class="fa fa-key"></i></span>';
	return kl + key;
}

var keysetFlip = false;
var keysetFlipTid = null;
function keysetFlipFlag() {
	clearTimeout(keysetFlipTid);
	keysetFlip = true;
	// console.log('keysetFlip', keysetFlip)
	keysetFlipTid = setTimeout(function () { keysetFlip = false; }, 100);
}

function keysetEvents() {
	$('.ks-button').off('clici').on('click', keysetFlipFlag);
}

var popupList = null;

function updatePopupList( properties ) {
	if( !popupList || !properties ) return;
	var types = {};
	for( var p of properties ) {
		var [kl,kt] = keysetType(p);
		types[kl] = kt;
	}
	for( var i = 0 ; i < popupList.length ; i++ )
	{
		var [kl,kt] = keysetType(popupList[i]);
		// console.log( 'i', i, kl, kt, types[kl])
		if( kt == 'KEY' && types[kl] != 'KEY' ) popupList[i] = [kl,'VAL'].join(':')
		else if( kt == 'VAL' && types[kl] == 'KEY' ) popupList[i] = [kl,'KEY'].join(':')
	}
	resetHotKeys();
	setHotKeys( popupList, 'label', tagSet );
}

function addDescriptorLabel( nlab, kset, attr ) {
	var names = [];
	if( kset ) var names = [nlab+':KEY',nlab+':VAL'];
	else names = [nlab];

	var rels = Object.keys(descriptor.relationships || {});
	var oposs = Object.keys(possibleStartHash);
	var poss = clone(oposs);
	for( var n of names ) poss.push(simplify(n));

	for( var n of names ) {
		if( !descriptor.labels || descriptor.labels[n] ) continue;
		var ncolor = newLabelPalette[newLabelColorIdx % newLabelPalette.length];
		newLabelColorIdx += newLabelColorInc;
		var l = {
			// color: '#888888',
			color: ncolor,
			name: n,
			path: [n],
			spath: n,
			keyset: kset,
		}
		if( attr ) {
			for( var k in attr )
				l[k] = attr[k];
		}
		var sn = simplify(n);
		if( rels ) {
			possibleStartHash[sn] = rels;
			for( var rr of poss ) possibleHash[sn+'_'+rr] = rels;
		}
		descriptor.possibleHash = possibleHash;
		descriptor.labels[n] = l;
		tagColors[simplify(n)] = l.color;
		// for( var k of oposs ) possibleStartHash[k].push(simplify(n));
	}
}

function addDescriptorBox( nlab ) {
	var ncolor = newLabelPalette[newLabelColorIdx % newLabelPalette.length];
	newLabelColorIdx += newLabelColorInc;
	var l = {
		color: ncolor,
	}
	descriptor.boxes[nlab] = l;
	tagColors[simplify(nlab)] = l.color;
}

function addDescriptorRelationship( nlab ) {
	var ncolor = newLabelPalette[newLabelColorIdx % newLabelPalette.length];
	newLabelColorIdx += newLabelColorInc;
	var l = {
		color: ncolor,
	}
	for( var k in possibleHash ) {
		if( possibleHash[k].indexOf(nlab) == -1 ) possibleHash[k].push( nlab );
	}
	tagColors[simplify(nlab)] = l.color;
	descriptor.relationships[nlab] = l;
}

var showPopupAlt = null;
function showPopup( type, o, listObj )
{
	// console.log( 'showPopup', type, listObj, o[0] )
	if (skeys.altOn && type != 'table') {
		showPopupAlt = function() {
			showPopup( type, o, listObj )
		}
		return;
		// alert( 'showPopupAlt')
	}
	if( blockEdit ) return locked();
	if(
			(type == 'labels' && !selected ) ||
			(type == 'relationships' && !selectedLink ) ||
			(type == 'boxes' && selectedBox === null )
	) return;
	// console.log( 'show popup type', type, 'popupSelected', popupSelected, 'selected', selected, 'popupClear', popupClear )
	if( (
			(type == 'labels' && popupSelected == selected ) ||
			(type == 'relationships' && popupSelected == selectedLink ) ||
			(type == 'boxes' && popupSelected == selectedBox )
		) && !popupClear ) return;
	$('.popup-list-bg').remove();
	$('.popup-list').remove();
	$('.popup-comment-bg').remove();
	$('.popup-comment').remove();

	// var popbg = $('<DIV>').addClass('popup-list-bg');
	var pop = $('<DIV>').addClass('popup-list');
	var popcont = $('<DIV>').addClass('popup-list-content').addClass('scroll-thin');
	var width = 250;
	var height = 300;
	var pos = fitPopup( o, $('#maincolumn'), width, height );
	if( !pos ) return;
	pop.css({top:px(pos.top), left:px(pos.left), width: px(pos.width)});
	popcont.css({maxHeight:px(pos.height)});
	pop.append($('<span>').addClass('popup-buttons').html(''))
	if( (engine2() || htmlTextMode) && type == 'labels' )
	{
		if( descriptor.popTextEditLayout ) {
			var divTextError = $('<span class="error" id="text-area-error">');
			var divText = $('<textarea placeholder="Enter Annotation Text">').addClass('tag-text-area').addClass('scroll-thin').html('');
			divText.insertBefore(pop.find('.popup-buttons'))
			divTextError.insertBefore( divText );
			divText.on('change', function() {
				$(this).css({height:25});
				var h = this.scrollHeight;
				var nh = h > 25 ? 49 : h
				$(this).css({height: nh, overflowY: (h > 25 ? 'auto' : 'hidden') })
			})
			divText.on('focus', function(){  this.select(); })
			divText.on('blur', function(){
				inputEdit = null;
				var tag = tagFind(selected);
				var val = divText.val().trim();
				if( val && val != tag.text ) {
					tag.textAdjust = divText.val().trim();
					divText.addClass('tag-text-adjust')
				}
				else {
					divText.val(tag.text);
					tag.textAdjust = null;
					divText.removeClass('tag-text-adjust')
					divText.change();
				}
				rangeChanged = true;
				tagPanelUpdate();
				changed(); 
			})
			divText.on('keydown', function(ev){
				inputEdit = this; 
				if( ev.keyCode == 13 ) {
					ev.preventDefault();
					ev.stopPropagation();
					divText[0].blur();
				}
			})
		}
		else {
			pop.append($('<span>').addClass('tag-text').html(''))
		}
	}

	if( type == 'table' )
	{
		var divTextError = $('<span class="error" id="text-area-error">');
		var divText = $('<textarea placeholder="Enter Table Description">').addClass('tag-text-area').addClass('scroll-thin').html('');
		divText.insertBefore(pop.find('.popup-buttons'))
		divTextError.insertBefore(divText);
		divText.on('change', function () {
			$(this).css({ height: 25 });
			var h = this.scrollHeight;
			var nh = h > 25 ? 49 : h
			$(this).css({ height: nh, overflowY: (h > 25 ? 'auto' : 'hidden') })

		})
		divText.on('focus', function () { this.select(); })
		divText.on('blur', function () {
			var tab = findTable(selectedTable);
			var val = divText.val().trim();
			if (val && val != tab.description) {
				tab.description = divText.val().trim();
			}
			else {
				// tab.description = divText.val().trim();
			}
			changed();
		})
		divText.on('keydown', function (ev) {
			if (ev.keyCode == 13) {
				ev.preventDefault();
				ev.stopPropagation();
				divText[0].blur();
			}
		})
		var tab = findTable(selectedTable);
		if( !tab ) return popupOut();
		divText.val(tab.description);
		var singleCell = JSON.stringify(selectedCells[0]) == JSON.stringify(selectedCells[1]);
		var firstCol = singleCell && selectedCells[0][0] == 0;
		var lastCol = singleCell && selectedCells[0][0] == tab.cols-1;
		var firstRow = singleCell && selectedCells[0][1] == 0;
		var lastRow = singleCell && selectedCells[0][1] == tab.rows-1;
		if( singleCell ) {
			pop.append($('<div class="pop-but" name="selrow">Select Row</div>')) 
			pop.append($('<div class="pop-but" name="selcol">Select Column</div>')) 
			if( !firstRow ) pop.append($('<div class="pop-but" name="mergerow">Merge with previous Row</div>'))
			if( !firstCol ) pop.append($('<div class="pop-but" name="mergecol">Merge with previous Column</div>')) 
		}
		else {
			pop.append($('<div class="pop-but" name="mergecell">Merge selected Cells</div>')) 
		}
		if( singleCell ) {
			if( firstCol || lastCol) pop.append($('<div class="pop-but" name="delcol">Delete Column</div>')) 
			if( firstRow || lastRow) pop.append($('<div class="pop-but" name="delrow">Delete Row</div>')) 
		}
		pop.append($('<div class="pop-but" name="deltable">Delete Table</div>')) 
		pop.find('.pop-but').on('mouseover', tableMenuOver ).on('mouseout', tablemenuOut).on('click', tableMenuClick ).addClass('unselectable');
		function tableMenuOver(ev) {
			var opt = $(this).attr('name');
			var cname = 'table-cell-highlight';
			var range = fixTableCellRange( selectedCells )
			var s1 = clone(range[0]);
			var s2 = clone(range[1]);
			if( opt == 'selrow' ) {
				s1[0] = 0;
				s2[0] = tab.cols-1;
			}
			else if( opt == 'selcol' ) {
				s1[1] = 0;
				s2[1] = tab.rows-1;
			}
			if( opt == 'mergerow' ) {
				s1[0] = 0;
				s1[1]--;
				s2[0] = tab.cols-1;
			}
			else if( opt == 'mergecol' ) {
				s1[1] = 0;
				s1[0]--;
				s2[1] = tab.rows-1;
			}
			if( opt == 'delrow' ) {
				s1[0] = 0;
				s2[0] = tab.cols-1;
				var cname = 'table-cell-delete';
			}
			else if( opt == 'delcol' ) {
				s1[1] = 0;
				s2[1] = tab.rows-1;
				var cname = 'table-cell-delete';
			}
			else if( opt == 'deltable' ) {
				s1 = [0,0];
				s2 = [tab.cols-1,tab.rows-1];
				var cname = 'table-cell-delete';
			}
			for( var x = s1[0] ; x <= s2[0] ; x++ )
			for( var y = s1[1] ; y <= s2[1] ; y++ ) {
				$('.table_'+tab.id+'.table_cell_x_'+x+'_y_'+y).addClass(cname);
			}
		}
		function tablemenuOut(ev) {
			$('.table-cell-highlight').removeClass('table-cell-highlight')
			$('.table-cell-delete').removeClass('table-cell-delete')
		}
		function selectRange() {
			setTimeout( function(){
				var tag = tableBulkRanges.find( r => r.table.x == selectedCells[0][0] && r.table.y == selectedCells[0][1] ) || tableBulkRanges[0];
				if( !tag ) return;
				var rid = tag.id; 
				// console.log( 'RID', rid )
				tagSelect( rid )
			}, 10 )
		}
		function tableMenuClick(ev) {
			var opt = $(this).attr('name');
			var cname = 'table-cell-highlight';
			var range = fixTableCellRange( selectedCells )
			var s1 = clone(range[0]);
			var s2 = clone(range[1]);
			if (opt == 'selrow') {
				s1[0] = 0;
				s2[0] = tab.cols - 1;
				selectTableCells( tab.id, [s1,s2], true )
				selectRange();
			}
			else if (opt == 'selcol') {
				s1[1] = 0;
				s2[1] = tab.rows - 1;
				selectTableCells( tab.id, [s1,s2], true )
				selectRange()
			}
			if (opt == 'mergerow') {
				loading();
				setTimeout( function(){
					var c = s1[1];
					tab['y'].splice( c, 1 );
					tab.rows--;
					tableSaveBaseAxis( tab, 'y', c );
					tableDelAdjustMerge( tab, 'y', c );
					if( updateTable( tab ) ) drawTable( tab );
					tableRecoverMergedAttrs(tab);
					pdfPage( currentPage ) 
					loadingOut();
				}, 1 )	
			}
			else if (opt == 'mergecol') {
				loading();
				setTimeout( function(){
					var c = s1[0];
					tab['x'].splice( c, 1 );
					tab.cols--;
					tableSaveBaseAxis( tab, 'x', c );
					tableDelAdjustMerge( tab, 'x', c );
					if( updateTable( tab ) ) drawTable( tab );
					tableRecoverMergedAttrs(tab);
					pdfPage( currentPage ) 
					loadingOut();
				}, 1 )	
			}
			else if (opt == 'mergecell') {
				loading();
				setTimeout( function(){
					var key = s1.join(',');
					var dx = s2[0]-s1[0];
					var dy = s2[1]-s1[1];
					if( !tab.merge ) tab.merge = {};
					tab.merge[key] = [dx,dy];
					if( updateTable( tab ) ) drawTable( tab );
					pdfPage( currentPage ) 
					loadingOut();
				}, 1 )	
			}			
			if (opt == 'delrow') {
				loading();
				setTimeout( function(){
					var c = s1[1] == 0 ? 0 : s1[1]+1
					tab['y'].splice( c, 1 );
					tab.rows--;
					tableDelAdjustMerge( tab, 'y', c );
					if( updateTable( tab ) ) drawTable( tab );
					pdfPage( currentPage ) 
					loadingOut();
				}, 1 )			}
			else if (opt == 'delcol') {
				loading();
				setTimeout( function(){
					var c = s1[0] == 0 ? 0 : s1[0]+1
					tab['x'].splice( c, 1 );
					tab.cols--;
					tableDelAdjustMerge( tab, 'x', c );
					if( updateTable( tab ) ) drawTable( tab );
					pdfPage( currentPage ) 
					loadingOut();
				}, 1 )
			}
			else if (opt == 'deltable') {
				delTable( tab.id )
				pdfPage( currentPage ) 
			}
			popupOut()
			// console.log('s1', s1, 's2', s2, cname)
			// for (var x = s1[0]; x <= s2[0]; x++)
			// 	for (var y = s1[1]; y <= s2[1]; y++) {
			// 		$('.table_' + tab.id + '.table_cell_x_' + x + '_y_' + y).addClass(cname);
			// 	}
		}
	}


	var relationship = $('<i class="fa fa-link" title="create relationship"></i>').addClass('popup-btn').hide();
	if( type == 'labels')
	{
		var tag = tagFind(selected);
		if( htmlTextMode )
		{
			var line = tag.line;
			var topOffset = lineOffset[line];
			pop.attr('line',line).attr('top', pos.top-topOffset ).addClass('adjusttop');
		}
		if( !listObj.properties ) listObj.properties = [];
		var properties = listObj.properties.filter( p => descriptor.labels[p] && !descriptor.labels[p].attribute && !descriptor.labels[p].placeholder );
		var multi = multiSelect || (properties.length > 1);
		relationship.show();
		var selmulti = $('<i class="fa fa-list-ul"></i>').addClass('popup-sel').addClass('popup-multi');
		var selsingle = $('<i class="fa fa-check-circle-o"></i>').addClass('popup-sel').addClass('popup-single');
		var boxkey = $('<i class="fa fa-key"></i>').addClass('popup-sel').addClass('popup-key');
		var boxvalue = $('<i class="fa fa-language"></i>').addClass('popup-sel').addClass('popup-value');

		relationship.on('click', function(){
			var tag = tagFind(selected);
			// console.log( 'TAG', tag, $('.tag_'+tag.id)[0] )
			var ev = new Event('mousedown');
			popupOut();
			$('.tag_'+tag.id)[0].dispatchEvent(ev);
		})

		selmulti.on('click', function(){
			$('.popup-selected').removeClass('popup-selected');
			selmulti.addClass('popup-selected');
			multiSelect = true;
		});
		selsingle.on('click', function(){
			if( properties && properties.length > 1 ) return;
			$('.popup-selected').removeClass('popup-selected');
			selsingle.addClass('popup-selected');
			multiSelect = false;
		})

		if( multi ) selmulti.addClass('popup-selected');
		else selsingle.addClass('popup-selected');
		pop.find('.popup-buttons').append(selmulti,selsingle);
	}

	var del = $('<i class="fa fa-trash"></i>').addClass('popup-btn');
	// console.log( 'del', del[0])
	del.on('click', function(ev){
		if( type == 'labels' )
		{
			if( selected )
			{
				// console.log( 'DEL', selected )
				delRange(selected);

			}
		}
		else if( type == 'relationships')
		{
			// console.log( 'selectedLink', selectedLink )
			if( selectedLink )
			{
				var tmp = selectedLink.split('-');

				delLink(tmp[0],tmp[1],true);
			}
		}
		else if( type == 'boxes')
		{
			if( selectedBox !== null && !$('#myModal').is(':visible') ) delBox(selectedBox, 6);
		}
		endPopup();
		// ev.preventDefault();
		// ev.stopPropagation();
	})
	var edit = $('<i class="fa fa-pencil" title="Change Text"></i>').addClass('popup-btn');
	if( !htmlTextMode && !descriptor.popTextEditLayout ) pop.find('.popup-buttons').append(edit);
	let popup_list = $('.popup-list-content');
	pop.find('.popup-buttons').append(relationship,selmulti,selsingle,del);
	pop.append(popcont);
	if( type == 'table' ) del.hide();
	if( (type != 'table' && descriptor.allowLabelInput) && !( type == 'relationships' && ocrMode ) ) {
		var addLabel = $('<span class="tag-add-label"><i class="fa fa-plus"></i> Add Label</span>')
		var addLabelPanel = $('<div><span class="error"></span><input type="text" placeholder="Enter new label name" id="addlabel" class="label-input"><div class="keylabelopt"><input type="checkbox" id="keylabel"> Keyset label</div><hr><span class="tag-add-label" id="add">Add Label</span><span class="tag-add-label" style="float:right"id="cancel">Cancel</span></div>')
		pop.append( addLabel, addLabelPanel )
		// pop.append( addLabelPanel );
		// popup_list.append(addLabel);


		// if( !descriptor.ocrMode || type != 'label' ) {
		if( !oocrMode || type != 'label' ) {

			addLabelPanel.find('.keylabelopt').hide();
		}

		var olab = addLabelPanel.find('#addlabel')
		var err = addLabelPanel.find('.error');
		function addL() {
			var nlab = olab.val().trim();
			var kset = addLabelPanel.find('#keylabel')[0].checked;
			if( !nlab ) {
				err.html('Type the new label name');
				olab[0].focus();
				return;
			}
			if( descriptor[type][nlab] ||  descriptor.labels[nlab+':KEY']) {
				err.html('This label name is alredy in use');
				olab[0].focus();
				return;
			}
			err.html('');
			if( type == 'labels')
				addDescriptorLabel( nlab, kset );
			else if (type == 'relationships')
				addDescriptorRelationship(nlab);
			else if (type == 'boxes')
				addDescriptorBox(nlab);
			olab.val('')
			setColors( descriptor[type] );
			addHide();
			popList();
			$('.popup-list-content').scrollTop(100000000000);
			// console.log( 'add', nlab, kset )
		}
		function addShow() {
			// popcont.hide();
			addLabel.hide();
			addLabelPanel.show();
			setTimeout( function(){
				olab[0].focus();
			}, 100 )
		}

		function addHide() {
			// popcont.show();
			addLabel.show();
			addLabelPanel.hide();
		}

		addLabelPanel.find('#add').on('click', addL )
		addLabelPanel.find('#cancel').on('click', addHide )
		addLabel.on('click', addShow )
		addHide();
	}


	if( descriptor.popTextEditLayout ) {
	}
	else {
		function editText() {
			var tt = $('.tag-text');
			tt.attr('contentEditable', true).focus().addClass('tag-text-edit');
			tt.text(listObj.textAdjust || listObj.text);
			selectElementContents(tt[0])
			tt.on('blur', function () {
				var textAdjust = tt.text().trim();
				if (textAdjust) {
					listObj.textAdjust = tt.text()
					tt.text(shrinkText(listObj.textAdjust))
					tt.addClass('tag-text-adjust');
				}
				else {
					listObj.textAdjust = null;
					tt.text(shrinkText(listObj.text))
					tt.removeClass('tag-text-adjust');
				}
				tt.attr('contentEditable', false).removeClass('tag-text-edit');
			});
			tt.on('keydown', function (ev) {
				if (ev.keyCode == 13) {
					tt.blur();
					ev.preventDefault();
				}
			})
			if (htmlTextMode) edit.hide();
		}
		window.editText = editText;
		edit.on('click', editText )
	}



	// $('#maincolumn').append(popbg);
	$('#maincolumn').append(pop);
	function popSet( com, v )
	{
		// console.log( 'popSet', com, v, popcont );
		popcont[0].displayKeyFixed = null;
		popcont[0].displayCurrentKey = null;
		if( com != 'set' ) return;
		var keep = false;
		if( type == 'labels' )
		{
			rangeChanged = true;
			var keep = tagSet(com,v)
			checkLinks(listObj.id);
			drawTags();
			tagPanelUpdate();
		}
		else if( type == 'relationships' )
		{
			linkSet(com,v);
			linkUnselect()
			delTmpLinks();
			drawLinks();
		}
		else if( type == 'boxes' )
		{
			boxSet(com,v);
			drawBoxes();
		}
		if( !keep ) popupOut();
	}
	function labelList(){
		try {
			var klist = allLabels(descriptor.labels, null, null, tag.table ? 'table' : null );
			// console.log( 'KLIST', clone(klist) )
			if( ocrMode ) {
				// if in OCR mode, process the label list. By default the labels available are :VAL but it tag :KEY is selected invert it
				var forceIn = {}; 
				var forceOut = {};
				if( !tag.properties ) tag.properties = []
				for( var k of tag.properties ) {
					// console.log( 'prop', k )
					var [kl,kt] = keysetType(k);
					if( kt == 'KEY' ) {
						forceIn[k] = 1;
						forceOut[ [kl,'VAL'].join(':')] = 1;
					}
				}
				// console.log( tag.properties, 'forceIn', forceIn, 'forceOut', forceOut )
				var nlist = [];
				for( var k of klist ) {
					// console.log( 'nlist', k )
					if( forceOut[k] ) continue;
					if( k.match(/:KEY$/) && !forceIn[k] ) continue;
					nlist.push(k);
				}
				klist = nlist;
				// console.log( 'NLIST', clone(klist) )
			}
			resetHotKeys();
			setHotKeys( klist, 'label', tagSet );
	
			// console.log( 'klist', clone(klist) )
			popupList = klist;
			listKeys( popcont, '', klist, popSet );
		} catch(e) {
			console.error(e)
		}
	}

	var popList = function(){}
	if( type == 'labels')
	{
		var popList = labelList;
	}
	else if( type == 'relationships')
	{
		var popList = function() {

			var [source,target] = listObj.lid.split('-');
			var klist = possibleLink( source, target );
			// var klist = listObj.possible;
			resetHotKeys();
			setHotKeys( klist, 'relationships', popSet );
			listKeys( popcont, '', klist, popSet )
			}
	}
	else if( type == 'boxes')
	{
		var popList = function () {
			resetHotKeys();
			setHotKeys(Object.keys(descriptor.boxes), 'boxes', popSet);
			listKeys(popcont, '', Object.keys(descriptor.boxes), popSet)
		}
	}
	popList();

	function getCheckList()
	{
		if( type == 'labels')
		{
			var ck = listObj.type.split('/');
			// if( listObj.properties ) ck = ck.concat(listObj.properties);
			if( listObj.properties ) ck = listObj.properties;
		}
		else if( type == 'relationships')
		{
			var ck = listObj.relationship.split('/');
		}
		else if( type == 'boxes')
		{
			var ck = listObj.label.split('/');
		}
		else ck = [];
		return ck;
	}

	var ck = getCheckList();

	// console.log( 'ck', ck );
	var scrolled = false;
	ck.forEach( k => {
		k = simplify(k);
		// console.log( '#key-'+k, $('#key-'+k).length, pop.find('#key-'+k).length )
		var opt = pop.find('#key-'+k);
		if( opt.length )
		{
			opt.addClass('keyselected').removeClass('keyunused');
			var optTop = opt.offset().top-popcont.offset().top;
			var scroll = optTop-popcont.height()/4;
			popcont.scrollTop( scroll )
			scrolled = true;
			// console.log( opt[0], optTop, scroll, popcont );
		}
	})

	function update()
	{
		var ck = getCheckList();
		ck.forEach( k => {
			k = simplify(k);
			$('.popup-list').find('#key-'+k).addClass('keyselected').removeClass('keyunused');
		})
	}
	popupUpdate = update;
	// var copy = $('#'+type).clone();
	// pop.append(copy);
	if( !scrolled )
	{
		// setTimeout( function(){
			pop.find('#keysearch').focus();
		// }, 100 )
	}

	// function ignore(ev){ ev.preventDefault(); return false }
	// eventOutside( pop, 'mousedown', ignore );
	// eventOutside( pop, 'mouseup', ignore );

	function endPopup(ev)
	{
		if( !ev || !boxTarget(ev.target) ) {
			selected = null;
			delTmp();
			delTmpLinks();
			if( type == 'labels' ) tagUnselect();
			if( engine2() ) clearPaintSelect()
			if( type == 'relationships' )
			{
				linkUnselect();
			}
			if( descriptor.comprehendMode ) {
				boxUnselect()
				drawBoxes();
			}
		}
		popupOut();
		eventOutsideEnd();
	}

	eventOutsideEnd();
	eventOutside( pop, 'mousedown', endPopup );
	// popbg.off('mousedown').on('mousedown', function(){
	// 	selected = null; delTmp(); paintSelectRange();
	// 	popupOut();
	// 	// selectedLink = null; delTmpLinks(1);
	// 	// selected = null; delTmp();
	// 	// drawText();
	// } );
}

function tagFind( id )
{
	try {
		for( var i = 0 ; i < rangeList.length ; i++ )
			if( rangeList[i].id == id ) return rangeList[i];
	} catch(e) {}
    return null;
}

// var fastTag = {}
// function tagFindFast( id )
// {
// 	if( fastTag[id] ) return fastTag[id];
// 	console.log( 'fast', id )
// 	return fastTag[id] = tagFind(id);
// }



function tagSet( com, v )
{
    if( com == 'set' && selected )
    {

		// alert(1)
		if( blockEdit ) return locked();
		tagPanelUpdate();

		changed();
		var noclose = false;
        var r = tagFind( selected );
		// console.log( 'TAGSET', selected, v, keysetFlip, r, r.text, r.textAdjust )
		if( !r.text && !r.textAdjust ) {
			$('#text-area-error').html('You must set a text for this annotation');
			$('.tag-text-area').focus();
			noclose = true;
			return true;
		}
		var sel = selected.toString();
        // console.log( 'tagFind', r );
        if( !r ) return false;
		var vType = tagObj[v];
		var keyListOpt = $('#key-'+simplify(v));
		keyListOpt.css({color:'red !important'})
		// console.log( 'keyListOpt', v, keysetFlip, keyListOpt[0], keyListOpt.length );

		var rlist = [r];
		if( tableBulkRanges && tableBulkRanges.length ) rlist = tableBulkRanges;
		// using a list bc with tables we might change the label for more than one range

		var origV = v;
		var keep = false;
		rlist.forEach( (r,ridx) => {
			
			var v = origV;
			if( !r.properties ) r.properties = [];
			var properties = r.properties.filter( p => descriptor.labels[p] && !descriptor.labels[p].attribute && !descriptor.labels[p].placeholder );
			var attributes = r.properties.filter( p => descriptor.labels[p] && descriptor.labels[p].attribute );
			// console.log( 'PROPERTIES', properties )
			var multi = multiSelect || (properties && properties.length > 1);
			var attribute = descriptor.labels[v] && descriptor.labels[v].attribute;
			var isSub = false;
			// console.log( 'RRRRRRRRRRRRRRRRRRRRRRRRRR', clone(r) )
			r.box = tagBox(r.id);
			if( keysetFlip ) {
				var [kl,kt] = keysetType(v);
				kt = kt == 'KEY' ? 'VAL' : 'KEY';
				var nv = [kl,kt].join(':');
				if (!multi) {
					properties = [nv];
					v = nv;
				}
				else {
					var reg = new RegExp('^' + kl + ':(KEY|VAL)$');
					// console.log( 'REG', reg )
					var found = false;
					for( var i = properties.length-1 ; i >= 0 ; i-- )
						if( properties[i].match(reg) ) {
							found = true;
							properties.splice(i,1,nv);
						} 
					if( !found ) properties.push( nv );
					if( engine2() ) paintTag(r.id);
					let kv = v;
					let knv = nv;
					v = '';
					keep = 1;
				}
				r.properties = properties.concat(attributes);
			} 
			else if( multi || attribute )
			{
				var source = attribute ? attributes : properties
				if( v ) {
					var idx = source.indexOf(v);
					if( idx == -1 )
					source.push( v );
					else
					source.splice( idx, 1 );
				}
				source.sort();
				r.properties = properties.concat(attributes);
				delete r.labId;
				// console.log( 'prop', r.properties )
				if( engine2() ) paintTag(r.id);
				keep = true;
			}
			else {
				properties = [v];
				attributes.sort();
				r.properties = properties.concat(attributes);
			}
			if( !multi && !attribute ) tagUnselect();
			// console.log( 'isSub', isSub );
			if( r.properties && r.properties.length ) r.type = r.properties[0];
			else r.type = 'tmp'
			var sv = simplify(v);
			defineColor(sv);
			var tag = $('.cid_'+r.id);
			for( var i = 0 ; i < tag.length ; i++ )
			{
				var ids = getList( tag[i], 'ids' );
				var types = getList( tag[i], 'types' );
				var idx = listIdx( ids, sel );
				if( v > '' )types[idx] = v;
				setList( tag[i], 'types', types );
				textAdjustClass( tag[i], r.adj );
			}
		})
		updatePopupList( r.properties );
		if( keep )
		{
			if( popupUpdate ) setTimeout( popupUpdate, 1 );
			// alert(1)
			// showPopup();
		}
		else {
			if( !noclose ) popupOut();
		}
		if( oocrMode )
		{
			if( !keep )
			{
				adjustOCR( r.id, r.box );
				boxUnselect();
				tagUnselect();
			}
			else $('.cid_'+r.id).addClass('c_ocr_sel')
		} 
		fixRanges();
        drawText();
		if( htmlTextMode ) setTimeout(drawHtmlAdjust, 100);
		return keep;
        // console.log( JSON.stringify(rangeList).toString())
    }
    else if( com == 'over' && v && !selectedLink )
    {
		adjustText();
        v = simplify(v);
        $('.c_tag').addClass('c_tag_hide');
        $('.c_tag_visible_'+v).removeClass('c_tag_hide');
        $('.tag_label').hide();
		$('.link_arrow').hide();
		$('.link_label').hide();
        $('.link').hide();
		$('.c_tag_visible_'+v).addClass('c_'+v);
        $('.tag_visible_'+v).show();
		if( selected ) tagSelect(selected)
    }
    else if( com == 'out' )
    {
        $('.c_tag').removeClass('c_tag_hide');
        // $('.tag_label').show();
        // $('.link_label').show();
        // $('.link').show();
		adjustText();
		drawTags();
		if( selected ) tagSelect(selected)
    }
}

function tagSetOld( com, v )
{
    if( com == 'set' && selected )
    {
		if( blockEdit ) return locked();
		changed();
		// console.log( 'set', v )
        var r = tagFind( selected );
		var sel = selected.toString();
        // console.log( 'tagFind', r );
        if( !r ) return;
		var vType = tagObj[v];
		// console.log( 'vType', v, vType, r.parentType );

		// if( vType.path.length > 1 && r.parentType != vType.path[0] )
		// 	return;
		var isSub = false;
		r.box = tagBox(r.id);
		// if( vType.path.length > 1 && r.parentType != vType.path[0] )
		if( vType.path.length > 1 )
		{
			// console.log( 'change v', v, vType );
			isSub = true;
			if( r.type != vType.path[0] ) delete r.properties;
			if( 1 )
			{
				isSub = true;
				if( !r.properties ) r.properties = [];
				var idx = r.properties.indexOf(v);
				if( idx == -1 )
					r.properties.push( v );
				else
					r.properties.splice( idx, 1 );
			}
			else r.properties = [v];
			r.properties.sort();
			delete r.labId;
			v = vType.path[0];
		}
		else {
			delete r.properties;
		}
		// if( r.type != v ) delRange( r.subs );

		if( !isSub ) tagUnselect();
		// console.log( 'isSub', isSub );
        r.type = v;
        var sv = simplify(v);
        defineColor(sv);
        var tag = $('.cid_'+r.id);
		for( var i = 0 ; i < tag.length ; i++ )
		{
			var ids = getList( tag[i], 'ids' );
			var types = getList( tag[i], 'types' );
			var idx = listIdx( ids, sel );
			types[idx] = v;
			setList( tag[i], 'types', types );
			textAdjustClass( tag[i], r.adj );
		}
        // tag.removeClass();
        // tag.addClass('c_tag');
        // tag.addClass('c_tag_visible_'+simplify(r.type))
        // tag.addClass('c_'+sv);
        // tag.addClass('cid_'+r.id);
        // listReset( $('#labels') );
		if( isSub )
		{
			if( popupUpdate ) setTimeout( popupUpdate, 1 );
			// alert(1)
			// showPopup();
		}
		else popupOut();
        drawText();
		return isSub;
        // console.log( JSON.stringify(rangeList).toString())
    }
    else if( com == 'over' && v && !selectedLink )
    {
		adjustText();
        v = simplify(v);
        $('.c_tag').addClass('c_tag_hide');
        $('.c_tag_visible_'+v).removeClass('c_tag_hide');
        $('.tag_label').hide();
		$('.link_arrow').hide();
		$('.link_label').hide();
        $('.link').hide();
		$('.c_tag_visible_'+v).addClass('c_'+v);
        $('.tag_visible_'+v).show();
		if( selected ) tagSelect(selected)
    }
    else if( com == 'out' )
    {
        $('.c_tag').removeClass('c_tag_hide');
        // $('.tag_label').show();
        // $('.link_label').show();
        // $('.link').show();
		adjustText();
		drawTags();
		if( selected ) tagSelect(selected)
    }
}

var tagAdj = null;

function shrinkText( txt )
{
	if( txt.length < 70 ) return txt
	return txt.substr(0,30)+ '...' + txt.substr(txt.length-30);
	return txt;
}

function tagOver()
{
	if( boxMode ) return;
	adjustText();

    clearTimeout(tagOutTid);
    if( tagDownId ) return;
    if($(this).hasClass('c_hide')) return;
    $('.c_tag').removeClass(tagSelectedClass);
    $('.tag_label').removeClass('tag_label_over');

	if( $(this).prop('islabel') ) var id = $(this).prop('tagid');
	else {
		var ids = getList( $(this), 'ids' )
		if( !ids.length ) return;
		// need to find the closest
		var min = 0
		var pos = $(this).attr('o1');
		for( var ti of ids )
		{
			var t = tagFind(ti)
			if( !min || min > t.text.length )
			{
				id = ti;
				min = t.text.length;
			}
		}
	}
	var t = tagFind(id);
	$('.cid_'+id).addClass(tagOverClass);
	if( $('.cid_'+id).hasClass(tagAdjClass) && !$('.cid_'+id).hasClass('adj_forward') )
	{
		// move tag to text-layer so it can be visible
		tagAdj = $('.cid_'+id);
		tagAdj.appendTo(txtObj);
	}
    $('.tag_'+id).addClass('tag_label_over');
	if( id != selected ) showTagComment(id);
    // console.log( 'OVER', id, $(this).prop('id') );
	overTidLabel = $(this).prop('tidLabel');
    over = id;
	// console.log( 'tagover', id )
	$('.cid_'+over).attr('title',shrinkText(t.text));

    tagPos(id);
    if( selected )
    {
        $('.tag_'+selected).addClass('tag_label_over');
        $('.cid_'+selected).addClass(tagSelectedClass);
    }
	drawTags();
	if( showAdjudication )
	{
		$('.tag_label').addClass('invisible');
		$('.c_tag').addClass( showTexts ? 'invisible_span':'invisible');

		makeVisible( id );
	}
    return false;
}

function makeVisible( id )
{
	function vis(id)
	{
		// console.log( 'vis', id );
		$('.cid_'+id).removeClass('invisible').removeClass('invisible_span');
		$('.tag_'+id).removeClass('invisible').show();
	}
	vis(id);
	var tag = tagFind(id);
	var overlap = tagOverlap( tag )
	// console.log( 'overlap', JSON.stringify(overlap) )
	overlap.forEach( o => vis(o.id) );
	linkList.forEach( l => {
		if( l.i1 == id ) vis( l.i2 );
		else if( l.i2 == id ) vis( l.i1 );
	});
}

var tagOutTid = null;
function tagOut(force)
{
	if( tagAdj ) tagAdj.appendTo(txtObjAdj);
	tagAdj = null;
	hideTagComment();
	adjustText();
	$('.invisible').removeClass('invisible');
	$('.invisible_span').removeClass('invisible_span');

    clearTimeout(tagOutTid);
	if( force ) tout();
    else tagOutTid = setTimeout( tout, 400 );
	function tout(){
		$('.c_tag').removeClass(tagSelectedClass).removeClass(tagOverClass);
        $('.tag_label').removeClass('tag_label_over').removeClass('tag_label_target');
		if( over ) $('.cid_'+over).attr('title','');
		// console.log( 'OVER', over )
        over = null;
		overTidLabel = null;
        if( selected )
        {
			$('.tag_'+selected).addClass('tag_label_over');
            $('.cid_'+selected).addClass(tagSelectedClass);
        }
		drawTags();
    }
}

function labelPos( id )
{
	var lab = txtObj.find('.tag_'+id);
	if( !lab.length ) return null;
	var pos = lab.prop('pos');
	return {id:id, y1:pos.top, x1:pos.left};
}

function tagPos(id) {
	var t = tagFind(id);
	if (!t || t.page != currentPage || (t.adj && !showAdjudication) || !t.box) return null;
	// console.log( 'tagPos', id, t.box, {y1: t.box[1]*txtObjHeight(), x1: t.box[0]*txtObjWidth()})
	var ret = {
		id: id,
		line: t.box[4],
		y1: t.box[1] * txtObjHeight(),
		x1: t.box[0] * txtObjWidth(),
		y2: t.box[3] * txtObjHeight(),
		x2: t.box[2] * txtObjWidth()
	};
	if (!descriptor.ocrMode && !descriptor.comprehendMode) {
		// console.log('tagPos', t)
		ret.position = $('.pp'+t.range[0]).position()
	}
	return ret;
}

function tagPos2( id )
{
	try {
		var pos = $('.cid_'+id).position();
		// console.log( 'tagPos', id, pos )
		return( {id: id, line:0, y1: pos.top, x1: pos.left } );
	} catch(e) { return null };
}


function adjudicationForward()
{
	// if( htmlTextMode ) return;
    rangeList.forEach( function(r)
    {
        if( r.page != currentPage ) return;

		delete r.adj_forward;
        if( showAdjudication && r.adj )
        {
            var overlap = tagOverlap(r);
            if( !overlap.length )
            {
				r.adj_forward = true;
                $('.cid_'+r.id).addClass('adj_forward').appendTo(txtObj);
            }
        }
    });
}

function getSel()
{
    if (window.getSelection)
    {
        return window.getSelection();
    }
    else if (document.selection)
    {
        return document.selection.createRange();
    }
    return '';
}


function getText( o )
{
    o = $(o)[0];
    // console.log( 'gtext', o, o.childNodes )
    var list = [];
    for( var i = 0 ; i < o.childNodes.length ; i++ )
    {
        var c = o.childNodes[i];
        if( c.nodeName == '#text' )
        {
            list.push( { text: c.textContent, obj: c } );
        }
        else {
            var rlist = getText( c );
            rlist.forEach( function(r){
                list.push( r );
            } );
        }
    }
    return list;
}

var hasTextOffset = true;
var hasTextMode = true;
var hasAdjudication = true;
var hasLabels = true;
var hasLinks = true;
var hasBoxes = true;
var boxesLabels = false;
var hasAttributes = true;
var hasClassification = false;
var hasPageAttributes = true;



function presetCheckBoxes()
{
	// set the checkboxes if described in descriptor
	var ckobj = {
		"adjudication": "showAdjudication",
		"texts": "showTexts",
		"labels": "showTags",
		"relationships": "showLinks",
		"tables": "showTables",
		"boxes": "showBoxes",
	}
	if(isarray(descriptor.checkboxes_set))
	{
		descriptor.checkboxes_set.forEach( ck => {
			var varName = ckobj[ck];
			if( !$('#'+varName).length ) return;

			$('#'+varName).prop('checked',true);
			$($('#'+varName)[0].parentNode).addClass('ckbutton-set');

            // --- REPLACEMENT FOR eval() ---
            switch(varName) {
                case 'showAdjudication': showAdjudication = true; break;
                case 'showTexts':        showTexts = true; break;
                case 'showTags':         showTags = true; break;
                case 'showLinks':        showLinks = true; break;
                case 'showTables':       showTables = true; break;
                case 'showBoxes':        showBoxes = true; break;
            }
            // --- END REPLACEMENT ---
		})
	}
}







var setCache = function( key, val )
{
    if( typeof(key) != 'string' ) key = JSON.stringify(key);
    key = 'cache_'+key;
    var keys = localStorage.getItem('_keys');
    if( !keys ) keys = [];
    else keys = JSON.parse(keys);
    keys.push( key );
    var retry = 0;
    var ok = false;
    var save = {t: Date.now()+60*60*1000, data:val}
    while( !ok && retry++ < 100 )
    {
        try {
            localStorage.setItem(key,JSON.stringify(save));
            localStorage.setItem('_keys',JSON.stringify(keys));
            ok = true;
        } catch(e) {
            // console.log( 'cleaning localStorage', keys[0] )
            localStorage.removeItem(keys[0]);
            keys.shift();
        }
    }
}



var getCache = function( key )
{
    if( typeof(key) != 'string' ) key = JSON.stringify(key);
    key = 'cache_'+key;
    var recover = localStorage.getItem(key);
    if( typeof(recover) == 'string' )
    {
        recover = JSON.parse(recover);
        if( recover.t < Date.now() ) return null;
        return recover.data;
    }
    return null;
}


var delCache = function( key )
{
    if( typeof(key) != 'string' ) key = JSON.stringify(key);
    key = 'cache_'+key;
    // console.log( 'delCache', key );
    localStorage.removeItem(key);
}

var clearCache = function()
{
    var keys = Object.keys(localStorage);
    keys.forEach( k => {
        if( k.match(/^cache_/)) localStorage.removeItem(k);
    })
}

// Loaded via <script> tag, create shortcut to access PDF.js exports.
var pdfjsLib = window['pdfjs-dist/build/pdf'];

// The workerSrc property shall be specified.
// pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.js';

function testRetina()
{
    var mediaQuery = "(-webkit-min-device-pixel-ratio: 1.5),\
    (min--moz-device-pixel-ratio: 1.5),\
    (-o-min-device-pixel-ratio: 3/2),\
    (min-resolution: 1.5dppx)";
    if( window.matchMedia && window.matchMedia(mediaQuery).matches ) return true;
    return false;
}


var zoomValue = 1;
var zoomTid = null;
function zoomSet( s ) {
	var zcss = {transformOrigin:'top left', transform: 'scale('+s+')'};
	$('#text-layer').css(zcss);
	$('#box-layer').css(zcss);
	$('#img-layer').css(zcss);
	zoomValue = s;
	popupOut();
	if( selected && !tagDownId ) {
		popupSelected = null;
		tagSelect(selected);
		selectedPos();
	}
	else if( selectedLink ) {
		linkSelect(selectedLink)
		selectedPos($('.link_label_'+selectedLink));
	}
	// else selectedPos();
}

function noScale() {
	var zcss = {transformOrigin:'top left', transform: ''};
	$('#text-layer').css(zcss);
	$('#box-layer').css(zcss);
	$('#img-layer').css(zcss);
}

function fromZoom() {
	var a = Array.from(arguments);
	if( isarray(a[0]) ) a = a[0];
	var s = zoomValue;
	a = a.map( v => v/s );
	return a.length == 1 ? a[0] : a;
}


function toZoom() {
	var a = Array.from(arguments);
	var s = zoomValue;
	a = a.map( v => v*s );
	return a.length == 1 ? a[0] : a;
}



function zoomCheck()
{
	var mult = testRetina() ? 50 : 100;
	var browserZoomLevel = Math.floor(window.devicePixelRatio*mult);
	var title = 'Browser Zoom Configuration';
	if( browserZoomLevel != 100 )
	{
		if( !$('#myModal').is(':visible') )
		{
			frm.myAlert( title, 'Your browser zoom level is configured at  <b>'+browserZoomLevel+'%</b>.\nPlease press <b>CTRL+0</b> to reset it to 100%' );
			// console.log( 'zoomErr', browserZoomLevel )
		}
	}
	else
	{
		if( $('#myModal').is(':visible') && $('.modal-title').html() == title )
		{
			window.$('#myModal').modal('toggle');
			drawPDF( gPDF, currentPage, globalZoom );
		}
	}
	setTimeout( zoomCheck, 2000 );
}
// zoomCheck();

function zoomReset()
{
	globalZoom = 1;
	zoomSet( globalZoom );
	// drawPDF( gPDF, currentPage, globalZoom )
}

function showVersion(s)
{
	// descriptor.version = s;
	// $('#version').remove();
	// $('#right').prepend(
	// 	$('<span>')
	// 	.addClass('version')
	// 	.prop('id','version')
	// 	.html('Version: '+s)
	// 	// .html('&nbsp;x')
	// );
}

function showSave(s, ts)
{
	// descriptor.version = s;
	if( ts ) s += ' - ' + new Date(ts).toLocaleString()
	$('#version').remove();
	$('#right').prepend(
		$('<span>')
		.addClass('version')
		.prop('id','version')
		.html(s)
	);
}



function expandSpacing()
{

	if( pageDone )
	{
		var max = 1;
		for( var r of rangeList )
		{
			if( r.page != currentPage ) continue;
			if( r.adj ) continue;
			if( r.properties.length > max ) max = r.properties.length;
		}
		globalLineSpacing = max*20;
		drawPDF( gPDF, currentPage, globalZoom )
	}
}

function compressSpacing()
{
	return expandSpacing();
	if( globalLineSpacing > 20 && pageDone )
	{
		globalLineSpacing -= 20;
		drawPDF( gPDF, currentPage, globalZoom )
	}
}


function zoomIn()
{
	// console.log( 'ZOOMIN')
	if( globalZoom < 8 && pageDone )
	{
		var inc = globalZoom > 2 ? 0.2 : 0.2;
		globalZoom += inc;
		zoomSet( globalZoom );
		// drawPDF( gPDF, currentPage, globalZoom )
	}
}

function zoomOut()
{
	if( globalZoom > 0.25 && pageDone )
	{
		var inc = globalZoom > 1 ? 0.2 : 0.1;
		globalZoom -= inc;
		zoomSet( globalZoom );
		// drawPDF( gPDF, currentPage, globalZoom )
	}
}

// $('.compexpand').hide();
var showTxtsTid = null;
function toolButton( ev )
{
	var cmd = $(this).attr('idx');
	// console.log( 'toolButton', cmd )

	function showTxts()
	{
		clearTimeout( showTxtsTid )
		$('.pdf_text').addClass('pdf-text-adjust');
		showTxtsTid = setTimeout( function(){
			$('.pdf_text').removeClass('pdf-text-adjust');
		}, 2000 )
	}
	if( cmd == 'zoomin' )
	{
		zoomIn();
		ev.preventDefault();
		ev.stopPropagation();
	}
	else if( cmd == 'zoomout' )
	{
		zoomOut();
		ev.preventDefault();
		ev.stopPropagation();
	}
	if( cmd == 'compress' )
	{
		compressSpacing();
	}
	else if( cmd == 'expand' )
	{
		expandSpacing();
	}
	else if( cmd == 'up' )
	{
		descriptor.pdf.offsetText[1]--;
		txtObj.css({
			left:px(descriptor.pdf.offsetText[0]*globalZoom),
			top:px(descriptor.pdf.offsetText[1]*globalZoom)
		});
		showTxts();
	}
	else if( cmd == 'dn' )
	{
		descriptor.pdf.offsetText[1]++;
		txtObj.css({
			left:px(descriptor.pdf.offsetText[0]*globalZoom),
			top:px(descriptor.pdf.offsetText[1]*globalZoom)});
		showTxts();
	}
	else if( cmd == 'left' )
	{
		descriptor.pdf.offsetText[0]--;
		txtObj.css({
			left:px(descriptor.pdf.offsetText[0]*globalZoom),top:px(descriptor.pdf.offsetText[1]*globalZoom)});
		showTxts();
	}
	else if( cmd == 'right' )
	{
		descriptor.pdf.offsetText[0]++;
		txtObj.css({
			left:px(descriptor.pdf.offsetText[0]*globalZoom),
			top:px(descriptor.pdf.offsetText[1]*globalZoom)});
		showTxts();
	}
	else if( cmd == 'help' ) showHelp();
}


function adjustTextMode()
{
	if( showTexts )
	{
		if( engine2() || htmlTextMode )
		{
			txtObj.find('.pdf_text').addClass( 'pp-visible' );
			$('canvas').css({opacity:0.8});
		}
		else {
			$('.pdf_text').addClass( showAdjudication ? 'pdf-text-semivisible' : 'pdf-text-visible');
			$('canvas').css({opacity:0.2});
		}
	}
	else {
		if( engine2() || htmlTextMode )
		{
			$('.pdf_text').removeClass('pp-visible');
		}
		else {
			$('.pdf_text').removeClass('pdf-text-visible').removeClass('pdf-text-semivisible');
		}
		$('canvas').css({opacity:1});
	}
}

function adjustAdjudication()
{
	if( showAdjudication )
	{
		$('.adjcheck').addClass('hideadjudication');
	}
	else
	{
		$('.adjcheck').removeClass('hideadjudication');
	}
	// console.log( 'showAdjudication', showAdjudication );
}




function setSearch( v, results )
{
	var input = $('#pdfsearch');
	if( !v ) v = '';
	v = v.trim();
	input.val(v);
	searchBoxUpdate(v > '' ? 1 : 0);
}

var searchResult = null;
var searchCurrent = null;

function findResultSideBar()
{
	var find = $('#findresults');
	if( !searchResult || !searchResult.length ) return find.hide();
	find.show();
	var num = searchResult.length;
	var res = num == 1 ? 'result' : 'results';
	find.html('<div class="find-result-number"><div class="find-result-close">'+closeIcon+'</div>'+searchResult.length+' '+res+' found for for "'+$('#pdfsearch').val()+'"</div>');
	searchResult.forEach( (s,idx) => {
		var it = (idx+1)+'/'+searchResult.length;
		var r = $('<DIV class="find-result-item"><div class="find-result-page">'+it+' - page '+s.page+'</div>...' + s.nearText + '...</div>');
		if( idx == searchCurrent )
		{
			r.prop('id','searchCurrent');
			r.addClass('find-result-item-selected');
		}
		var sitem = s;
		r.off('click').on('click', function(){
			searchCurrent = idx;
			showFindResult(sitem);
			searchBoxUpdate(1);
		});
		find.append(r);
	});
	$('.find-result-close').off('click').on('click',function(){
		$('#pdfsearch').val('');
		searchResult = [];
		searchCurrent = 0;
		searchBoxUpdate()
		selected = null; delTmp();
	})
	rightFocus( searchCurrent > 0 ? 'searchCurrent' : 'findresults');
}


var findNext = null;
var findPrev = null;
function searchBoxUpdate( mode )
{
	var input = $('#pdfsearch');
	var sbtnsearch = $('#sbtnsearch');
	var sbtnresult = $('#sbtnresult');
	var sbtnup = $('#sbtnup');
	var sbtndown = $('#sbtndown');
	var sbtnclose = $('#sbtnclose');
	findResultSideBar();

	function noActive()
	{
		$('.active').removeClass('active');
	}
	noActive();

	if( !mode )
	{
		sbtnsearch.show();
		sbtnresult.hide();
		sbtnup.hide();
		sbtndown.hide();
		sbtnclose.hide();
		findNext = null;
		findPrev = null;
	}
	else
	{
		sbtnsearch.hide();
		sbtnresult.show();
		sbtnup.show();
		sbtndown.show();
		sbtnclose.show();
		var res = (searchResult.length ? (searchCurrent+1) : 0) + '/' + searchResult.length;
		sbtnresult.html(res);
	}
	findNext = resDown;
	findPrev = resUp;
	input.off('keyup').on('keyup',key);
	input.off('focus').on('focus',function(){
		searchBoxUpdate();
		input.select()
	});
	sbtnsearch.off('click').on('click',search);
	sbtnup.off('click').on('click',resUp);
	sbtndown.off('click').on('click',resDown);
	sbtnclose.off('click').on('click',function(){
		input.val('');
		searchResult = [];
		searchCurrent = 0;
		searchBoxUpdate();
		selected = null; delTmp();
	});
	function key(ev)
	{
		if( ev.keyCode == 13 ) search();
	}
	function search()
	{
		searchCurrent = 0;
		input.blur();
		noActive();
		var result = findPDF( gPDF, input.val() );
		searchResult = result;
		// console.log( 'search', input.val(), result, selected, selected );
		if( selected )
		{
			var r = tagFind(selected);
			for( var i = 0 ; i < result.length ; i++ )
			{
				if( result[i].page == r.page && result[i].range[0] == r.range[0] && result[i].range[1] == r.range[1] )
				{
					searchCurrent = i;
					searchBoxUpdate(1)
					return showFindResult( searchResult[searchCurrent] );
				}
			}
		}
		else for( var i = 0 ; i < result.length ; i++ )
		{
			if( result[i].page == currentPage )
			{
				searchCurrent = i;
				searchBoxUpdate(1)
				return showFindResult( searchResult[searchCurrent] );
			}
		}
		searchBoxUpdate(1);
		if( result.length )
		{
			searchCurrent = 0;
			return showFindResult( searchResult[searchCurrent] );
		}
	}

	function resUp()
	{
		noActive();
		if( !searchResult.length ) return;
		if( searchCurrent > 0 )
		{
			searchCurrent--;
			searchBoxUpdate(1)
		}
		showFindResult( searchResult[searchCurrent] );
	}

	function resDown()
	{
		noActive();
		if( !searchResult || !searchResult.length ) return;
		if( searchCurrent < searchResult.length-1 )
		{
			searchCurrent++;
			searchBoxUpdate(1)
			return showFindResult( searchResult[searchCurrent] );
		}
	}

	var bwid = $('.searchbuttons').width();
	$('.searchinput').css({width: px(200-bwid)});
}

function pagination( pag )
{
	
	if(window.GlobalVars.PDFProjectType === 'Utterance Recording') {
		return $('.nlp-pagination').html('').hide()
	}
	else{
		return $('.nlp-pagination').html('').show()
	}
    frm.paginator( $('.nlp-pagination'), pag, totalPages, pagCb  )
	function pagCb( n ) {
		// console.log( 'pageCb', n )
		drawPDF( gPDF, n*1, globalZoom )
	}


	return;
	if( totalPages <= 1 ) return $('.pagination').hide();
	if(window.GlobalVars.PDFProjectType === 'Utterance Recording')
	$('.rightcontrols').css({position:'absolute',right:px(5),top:px(0)})
	$('.pagination').show();
	$('.page-number').remove();
	var pages = [];
	for( var i = -1 ; i <= 5 ; i++ )
	{
		var p = pag+i;
		if( p > 0 && p <= totalPages ) pages.push( p );
	}
	pages.splice(3,1000);
	pages.forEach( (p) => {
		var ppp = p;
		var pnum = $('<li class="page-item page-number"><a class="page-link" href="#" idx="'+p+'">'+ppp+'</a></li>');
		if( p == pag ) pnum.addClass('active');
		pnum.insertBefore($('.page-last'));
	});
	$('.page-first').html('<a class="page-link" href="#" aria-label="Previous" idx="0"><span aria-hidden="true">&laquo;</span><span class="sr-only">Previous</span></a>');
	$('.page-last').html('<a class="page-link" href="#" aria-label="Next" idx="-1"><span aria-hidden="true">&raquo;</span><span class="sr-only">Next</span></a>');
	$('.page-link').off('click').on('click', function(ev){
		// if( ev.target.tagName != 'A' ) return;
		// var to = $(this).text().trim();
		var to = $(this).attr('idx');
		// console.log( 'to', to, this, ev.target.tagName )
		// if( to[0] == "«") to = 1;
		// if( to[0] == "»") to = totalPages;
		if( to == 0 ) to = 1;
		if( to == -1 ) to = totalPages;
		// console.log( 'to page', to );
		// selectRange = null;
		drawPDF( gPDF, parseInt(to), globalZoom )
		ev.preventDefault();
	})

	$('#formpage').remove();
	var gopage = $('<div id="formpage" class="form-outline searchinput" style=" margin-left: 10px; width: 110px;"><input type="search" id="pdfpage" class="form-control glueright" placeholder="" style="text-align: center !important;"><button type="button" id="sbtnpage" class="btn btn-secondary ssearchbtn glueleft roundright">Go</button></div>');
	gopage.css({lineHeight:'auto',color:'red'})
	gopage.insertAfter($('.page-last'));
	$('#pdfpage').val(currentPage).on('focus', function(){ this.select()}).on('change',jumppage);
	$('#sbtnpage').on('click', jumppage)
	function jumppage()
	{
		var p = parseInt($('#pdfpage').val());
		if( isNaN(p) || p < 1 ) p = 1;
		if( p > totalPages ) p = totalPages;
		$('#pdfpage').val(p);
		drawPDF( gPDF, p, globalZoom )
	}
$('.pagination').css({position: 'absolute', left: 'auto', top:0, right:10})

	// console.log( 'pagination', pag, totalPages, pages )
}

/**
 * Converts a base64 string into a Uint8Array
 */
function base64ToUint8Array(base64) {
    var raw = atob(base64); //This is a native function that decodes a base64-encoded string.
    var uint8Array = new Uint8Array(new ArrayBuffer(raw.length));
    for(var i = 0; i < raw.length; i++) {
        uint8Array[i] = raw.charCodeAt(i);
    }

    return uint8Array;
}


var comprehendBlocks = null;
var comprehendBlocksAux = [];

function ocrProcessKeyPairData() {
	// console.log( 'ocrProcessKeyPairData', descriptor.ocrKeyPairData)
	addDescriptorLabel( 'GENERIC', true );
	function find( e, type, page ) {
		var blist = [];
		var margin = 0.002;
		while( blist.length == 0 && margin < 0.01 )
		{
			var box = [e.BB.Left, e.BB.Top, e.BB.Left+e.BB.Width, e.BB.Top+e.BB.Height];
			box[0] -= margin;
			box[1] -= margin;
			box[2] += margin;
			box[3] += margin;
			blist = boundingBoxColideFindText(box, page);
			margin += 0.001;
		}
		return blist;
	}
	var ta = []

	var id = 1;
	var page = 1;
	var added = 0;
	for( var pageData of descriptor.ocrKeyPairData ) {
		for (let i of pageData) {
			var keys = [];
			var vals = [];
			for( var e of i.key ) keys = keys.concat(find( e, 'key', page ));
			for( var e of i.value ) vals = vals.concat(find( e, 'val', page ));
			// console.log( 'kkkkey', keys, 'val', vals, page )
			if( keys.length ) {
				var bb = boundingBoxFromRange(keys,page);
				var newId = g_tagId++;
				// console.log( 'KEYS', keys, bb )
				var tagk = addOCR( keys, newId, "GENERIC:KEY", false, page, null, bb, null );
				// delRange(tagk.id)
				// splitRange(tagk.range, tagk.id, tagk.type, tagk.adj, tagk.page)
				tagSelect( tagk );
				added++;
			}
			if( vals.length ) {
				var bb = boundingBoxFromRange(vals,page);
				var newId = g_tagId++;
				var tagv = addOCR( vals, newId, "GENERIC:VAL", false, page, null, bb, null );
				// console.log( 'TAGV', tagv )
				// delRange(tagv.id)
				// splitRange(tagv.range, tagv.id, tagv.type, tagv.adj, tagv.page)				
				tagSelect( tagv );
				added++;
			}
			if( keys.length && vals.length ) {
				addLink( page, tagk.id + '_generickey', tagv.id + '_genericval', 'key-pair')
			}
		}
		page++;
	}
	sortRange();
	if( added ) drawPDF( gPDF, 1, globalZoom, function(){} )
}



function ocrProcessTableData(ocrTableData, noDraw) {
	var bigBB = null;
	// console.log( 'ocrProcessTableData', ocrTableData);
	var origCurrentPage = currentPage;

	function find( e, page ) {
		var blist = [];
		var margin = 0.002;
		while( blist.length == 0 && margin < 0.01 )
		{
			var box = [e.BB.Left, e.BB.Top, e.BB.Left+e.BB.Width, e.BB.Top+e.BB.Height];
			box[0] -= margin;
			box[1] -= margin;
			box[2] += margin;
			box[3] += margin;
			// console.log( 'find', e.text, box, boundingBoxColideFindText(box) )
			blist = boundingBoxColideFindText(box,page);
			margin += 0.001;
		}
		if( !blist.length ) {
			// console.log( 'not found', e )
		}
		return blist;
	}
	function walk( o,page ) {
		for( var k in o ) {
			if( isarray(o[k]) ) add(o[k],page)
			else walk(o[k],page);
		}
	}

	function add(a,page) {
		if (!a.length) return;
		var blist = [];
		for (var t of a) {
			blist = blist.concat(find(t,page))
		}
		// console.log('ADD', a.map(t => t.text), blist)
		if( !blist.length ) return;
		var bb = boundingBoxFromRange(blist,page);
		if( !bigBB ) bigBB = clone(bb);
		else bigBB = boxAdd( bigBB, bb );
		// if( bb[0] < 0 ) return;
		var newId = g_tagId++;
		var tagk = addOCR(blist, newId, "TABLECELL", false, page, null, bb, null);
		// console.log( 'ADD', blist, newId, "TABLECELL", page, bb );
		// tagSelect(tagk);
	}
	var page = 1;
	for( var pageData of ocrTableData ) {
		for (var tab of pageData) {
			bigBB = null;
			tableCleanIgnore = true;
			walk(tab,page)
			var tab = tableFromBoundingBox(bigBB)
			tab = addTable( tab, tabId++, page, true );
			// if( tab && tab.page == currentPage) drawTable( tab );
			tableCleanIgnore = false;
		}
		page++;
	}
	if( noDraw ) return;
	for( var tab of tableList ) {
		if (tab && tab.page == currentPage) {
			drawTable(tab);
		} 
	}
}



function ocrSourceRead( url, plumbData, callback ) {
	if (isobj(url)) {
		translate(url);
	}
	else {
		// console.log('getting comprehend json', url)
		$.get(url, translate).fail(function (e) {
			console.error(e)
		});
	}
	var tmpId = 1000000000;
	var tmpEntId = 9000000000;

	function translate(data) {
		var blocks = [];

		function addLine() {
			var id = (tmpId++).toString(32);
			var bid = blocks.length;

			var line = {
				"BlockType": "LINE",
				"Id": id,
				"Text": [],
				"Geometry": {
					"BoundingBox": {},
					"Polygon": []
				},
				"Relationships": [
					{
						"Ids": [],
						"Type": "CHILD"
					}
				],
				"Page": 1,
				"parentBlockIndex": -1,
				"blockIndex": bid,
			}
			blocks.push( line );
			return bid;
		}

		function addBlock( e, parent ,type, eid) {
			var id = (tmpId++).toString(32);
			var bid = blocks.length;
		
			var block = {
				"BlockType": "WORD",
				"Id": id,
				"Text": e.text,
				"Geometry": {
					"BoundingBox": e.BB,
					"Polygon": []
				},
				"Relationships": [],
				"Page": 1,
				"parentBlockIndex": parent,
				"blockIndex": bid,
				"Type": type,
				"Entity": eid
			}
			blocks.push( block );
		}

		for( var i of data ) {
			var lid = addLine();
			var eid = (tmpEntId++).toString(32);
			for( var e of i.key ) addBlock( e, lid, 'key', eid );
			for( var e of i.value ) addBlock( e, lid, 'val', eid );
		}
		// console.log( 'OCRBLOCKS', blocks );
		comprehendSourceRead( blocks, plumbData, callback );

		// comprehendBlocks = data;
		// // console.log('translate', data)
		// comprehendProcessBlocks(data, comprehendBlocksAux, plumbData);
		// callback(plumbData);
	}
}


function comprehendSourceRead(url, plumbData, callback) {
	// console.log( 'comprehendSourceRead', url, plumbData )
	if (isobj(url)) {
		translate(url);
	}
	else {
		// console.log('getting comprehend json', url)
		$.get(url, translate).fail(function (e) {
			console.error('ERROR LOADING', url, e)
		});
	}
	function translate(data) {
		data = jsonParse(data);
		comprehendBlocks = data;
		// console.log( 'comprehendBlocks', comprehendBlocks );
		// console.log('translate', data)
		comprehendProcessBlocks(data, comprehendBlocksAux, plumbData);
		// console.log( 'TRANSLATED')
		callback(plumbData);
	}
}


function comprehendProcessBlocks( blocks, comprehendBlocksAux, plumbData) {
	// console.log( 'comprehendProcessBlocks')
	var words = {};
	var idx = 0;
	var offsets = [0];
	var pages = 0;
	let parent = null;
	for (var d of blocks) {
		d.idx = idx++;
		offsets[d.Page] = d.idx;
		if( idx < 10 ) console.log( idx, d.BlockType, parent )
		if (d.BlockType == 'WORD') {
			if (d.Page > pages) pages = d.Page;
			// if( idx > 900 ) console.log('ddddddddddd', d, 'Block', blocks[d.idx].Id)
			if( parent ) {
				d.parent = parent;
				d.pidx = parent.idx;
			}
			words[d.Id] = d;
		}
		else if (d.BlockType == 'LINE') {
			parent = d;
		}
	}
	var off = 0;
	for( var i = 0 ; i < pages ; i++ ) {
		if( typeof(offsets[i]) == 'undefined' ) offsets[i] = off;
		else off = offsets[i];
	}
	for (var d of blocks) {
		if (d.BlockType == 'LINE') {
			for (var r of d.Relationships) {
				for (var id of r.Ids) words[id].parent = d.Id;
			}
		}
	}
	var cidx = [];
	var pchars = [];
	words = Object.values(words);
	var aux = comprehendBlocksAux;
	// window.cblocks = comprehendBlocks;
	// window.ablocks = aux;
	for (var w of words) {
		var page = w.Page - 1;
		// console.log( 'page', page, w.Text, w.blockIndex, w )
		if( !cidx[page]) cidx[page] = 0;
		if (!pchars[page]) pchars[page] = []
		if( plumbData ) {
			var pw = plumbData.pages[page].mediabox[2];
			var ph = plumbData.pages[page].mediabox[3];
		}
		else {
			var pw = 10; // if no plubData, then widht and height are not relevant
			var ph = 10;
		}
		var x0 = w.Geometry.BoundingBox.Left * pw;
		var x1 = (w.Geometry.BoundingBox.Left + w.Geometry.BoundingBox.Width) * pw;
		var y1 = (1 - w.Geometry.BoundingBox.Top) * ph;
		var y0 = (1 - (w.Geometry.BoundingBox.Top + w.Geometry.BoundingBox.Height)) * ph;
		// var cParentId = w.parentBlockIndex + offsets[page];
		// var cId = w.blockIndex + offsets[page];
		var cId = w.idx;
		// var cParentId = w.parent ? w.pidx : null;
		// if( cParentId !== null ) {
		// 	if (!aux[cParentId]) aux[cParentId] = { id: blocks[cParentId].Id, children: [], len: 0, id: w.parent };
		// 	if (aux[cParentId].children.length) aux[cParentId].len++;
		// }
		// console.log( 'page', page, w, offsets, 'cParentId', cParentId, cId, 'offsets', offsets )
		// console.log( 'blocks', cId )
		// aux[cId] = { id: blocks[cId].Id, page: w.Page, start: aux[cParentId].len, end: aux[cParentId].len + w.Text.length, parent: aux[cParentId] }
		aux[cId] = { id: blocks[cId].Id, page: w.Page }
		aux[cId].translateTo = cidx[page];
		aux[cId].blockIndex = w.blockIndex;
		// if( cParentId !== null ) {
		// 	aux[cParentId].children.push(aux[cId]);
		// 	aux[cParentId].len += w.Text.length;
		// }
		cidx[page] += w.Text.length + 1;

		pchars[page].push({
			text: w.Text,
			x0: x0,
			x1: x1,
			y0: y0,
			y1: y1,
			id: cId
		})

	}
	if (plumbData)
		for (var i = 0; i < pchars.length; i++) {
			plumbData.pages[i].chars = pchars[i];
		}
	return pchars;
}



function comprehendProcessBlocksOld(blocks, comprehendBlocksAux, plumbData) {
	var words = {};
	var idx = 1;
	var offsets = [0];
	var pages = 0;
	// console.log( 'BLOCKS', blocks )
	for (var d of blocks) {
		if( typeof(d.Id) == 'number' ) d.Id = (d.Page*100000+d.Id).toString().padStart(10,'0')
		offsets[d.Page] = idx++;
		if( d.Page > pages ) pages = d.Page;
		if (d.BlockType == 'WORD') {
			d.parent = null;
			words[d.Id] = d;
		}
	}
	var off = 0;
	for( var i = 0 ; i < pages ; i++ ) {
		if( typeof(offsets[i]) == 'undefined' ) offsets[i] = off;
		else off = offsets[i];
	}
	for (var d of blocks) {
		if (d.BlockType == 'LINE') {
			for (var r of d.Relationships) {
				for (var id of r.Ids) words[id].parent = d.Id;
			}
		}
	}
	var cidx = [];
	var pchars = [];

	// console.log( 'WORDS', clone(words))
	words = Object.values(words);
	var aux = comprehendBlocksAux;
	// window.cblocks = comprehendBlocks;
	// window.ablocks = aux;
	for (var w of words) {
		var page = w.Page - 1;
		// console.log( 'page', page, w.Text, w.blockIndex, w )
		if( !cidx[page]) cidx[page] = 0;
		if (!pchars[page]) pchars[page] = []
		if( plumbData ) {
			var pw = plumbData.pages[page].mediabox[2];
			var ph = plumbData.pages[page].mediabox[3];
		}
		else {
			var pw = 10; // if no plubData, then widht and height are not relevant
			var ph = 10;
		}
		var x0 = w.Geometry.BoundingBox.Left * pw;
		var x1 = (w.Geometry.BoundingBox.Left + w.Geometry.BoundingBox.Width) * pw;
		var y1 = (1 - w.Geometry.BoundingBox.Top) * ph;
		var y0 = (1 - (w.Geometry.BoundingBox.Top + w.Geometry.BoundingBox.Height)) * ph;
		var cParentId = w.parentBlockIndex + offsets[page];
		var cId = w.blockIndex + offsets[page];
		// console.log( 'page', page, w, offsets, 'cParentId', cParentId, cId, 'offsets', offsets )
		// if (!aux[cParentId]) aux[cParentId] = { id: blocks[cParentId].Id, children: [], len: 0, id: w.parent };
		// if (aux[cParentId].children.length) aux[cParentId].len++;
		// aux[cId] = { id: blocks[cId].Id, page: w.Page, start: aux[cParentId].len, end: aux[cParentId].len + w.Text.length, parent: aux[cParentId] }
		// console.log( 'AUXCID', cId, w, w.blockIndex, offsets[page] )
		aux[cId] = { id: blocks[cId].Id, page: w.Page }
		aux[cId].translateTo = cidx[page];
		aux[cId].blockIndex = w.blockIndex;
		// aux[cParentId].children.push(aux[cId]);
		// aux[cParentId].len += w.Text.length;
		cidx[page] += w.Text.length + 1;

		pchars[page].push({
			text: w.Text,
			x0: x0,
			x1: x1,
			y0: y0,
			y1: y1,
			id: cId
		})

	}
	if (plumbData) {
		// console.log( 'pchars', pchars.length )
		comprehendPlumbData = clone(pchars);
		for (var i = 0; i < pchars.length; i++) {
			plumbData.pages[i].chars = pchars[i];
		}
	}
	return pchars;
}

function fixComprehend( origPlumber, comprehendPlumbData, rangeList ) {
	if( !comprehendPlumbData ) return;
	// console.log( 'FIXCOMPREHENT', 'origPlumber', origPlumber, 'plumberData', plumberData, rangeList, 'comprehendPlumbData', comprehendPlumbData )
	return;
	var fixed = 0;
	for( var x of comprehendPlumbData )
	{
		var idx = 0;
		for( var y of x ) {
			y.box = [y.x0,y.y0,y.x1,y.y1];
			y.idx = idx;
			idx += y.text.length + 1
		}
	}
	for( var i = 0 ; i < rangeList.length ; i++ ) {
		var r = rangeList[i];
		if( r.blocks.indexOf(-1) == -1 ) {
			// console.log( 'FIX NOT', i )
			continue;
		}
		var page = r.page-1;
		var found = {}; 
		for( var j of r.range ) {
			j /= 2;
			var c = origPlumber.pages[page].chars[j]
			var b = [c.x0,c.y0,c.x1,c.y1];
			for( var k = 0 ; k < comprehendPlumbData[page].length ; k++ ) {
				if( boxIntersect( b, comprehendPlumbData[page][k].box) ) {
					// console.log( 'FIX found', k, comprehendPlumbData[page][k] );
					found[k] = comprehendPlumbData[page][k].id;
				}
			}
			// console.log( 'FIX R', j, c, b )
		}
		r.blocks = Object.values(found);
		r.range = Object.keys(found).map( v => comprehendPlumbData[page][v*1].idx )
		r.text = Object.keys(found).map( v => comprehendPlumbData[page][v*1].text ).join(' ')
		// console.log( 'FIX', i, r )
		fixed++;
	}
	return fixed;
}


var annotationBaseParameters = 	['attributes', 'pageAttributes', 'review', 'taskDeclined', 'declineReason','selectBoundingBox', 'sessionStart', 'elapsedTime', 'jobStart', 'absoluteOffsets'];

function comprehendAnnotationExport(comprehendBlocksAux, annotations) {
	var oret = clone(annotations);
	var Entities = [];
	var ret = annotations;

	function findBlockReference(t) {
		var aux = comprehendBlocksAux;
		var parents = {};
		// console.log('findBlockReference', t)
		for (var i = 0 ; i < t.range.length ; i++ ) {
			var r = t.range[i];
			var id = t.blocks[i];
			var a = aux[id];
			var p = a.parent;
			if (!defined(p.start) || a.start < p.start) p.start = a.start;
			if (!defined(p.end) || a.end > p.end) p.end = a.end;
			if (!parents[p.id]) parents[p.id] = { BlockId: p.id, ChildBlocks: [] };
			parents[p.id].ChildBlocks.push({
				"BeginOffset": 0,
				"EndOffset": a.end - a.start,
				"ChildBlockId": a.id,
			})
			parents[p.id].BeginOffset = p.start;
			parents[p.id].EndOffset = p.end;
		}
		return Object.values(parents);
	}
	for (var t of ret.tags) {
		var e = {};
		var bref = findBlockReference(t);
		// console.log( '---------------------', t, bref )
		Entities.push({
			BlockReferences: bref,
			Text: t.text,
			Type: t.type,
			Score: 1,
		})
	}
	ret = {
		"Version": "2021-04-30",
		"DocumentType": "ScannedPDF",
		"DocumentMetadata": oret.metadata,
		"Entities": Entities,
	}
	for (var k of annotationBaseParameters) {
		if (oret[k]) ret[k] = oret[k];
	}
	return ret;

}


function comprehendAnnotationImport(comprehendBlocksAux, annotations) {
	var orig = annotations;
	if (!isarray(annotations.Entities)) return annotations;
	var tags = [];
	var eidx = 1;
	for (var e of annotations.Entities) {
		// console.log('convert', e);
		var range = [];
		var blocks = [];
		var text = [];
		var page = 0;
		for (var b of e.BlockReferences) {
			for (var c of b.ChildBlocks) {
				// console.log( 'find', c.ChildBlockId )
				var cblock = comprehendBlocksAux.find(b => b.id == c.ChildBlockId)
				var cidx = cblock.translateTo;
				// console.log('block', c.ChildBlockId, cblock, cidx)
				range.push(cidx);
				blocks.push(cblock.blockIndex);
				text.push(cblock.text);
				page = cblock.page;
			}
		}
		var tag = {
			id: eidx++,
			page: page,
			range: range,
			blocks: blocks,
			text: e.Text,
			type: e.Type,
		}
		tags.push(tag);
		// console.log('tag', tag)
	}
	var ret = { tags: tags, links: [] };
	for (var k of annotationBaseParameters) {
		if (orig[k]) ret[k] = orig[k];
	}
	ret.selectBoundingBox = true;
	// console.log('comprehendAnnotationImport')
	return ret;
}



function getPdfPlumber( url, callback )
{
	// console.log( 'getPdfPlumber' )
	var textData = [];
	var plainText = []
	var plainText2Blocks = []
	var dimensions = [];
	if( descriptor.pdf && descriptor.pdf.pdfJson )
	{
		// console.log( 'getting json in descriptor', path )
		// console.log( 'PDFDATA JSON', descriptor.pdf.pdfJson )
		return next( descriptor.pdf.pdfJson );
		// return result( descriptor.pdf.pdfJson );
	}
	if( !url.match(/^http/i) )
	{
		var loc = document.location.href.split('/');
		loc.pop(); loc.push( url );
		url = loc.join('/');
	}

	var path = 'https://adlservice.objectways.com/pdf_data?url='+escape(url);
	if( url.match(/^http:\/\/localhost/) ) path = 'getpdfjson.php?url='+escape(url);
	if( descriptor.pdf.dataInput ) path = descriptor.pdf.dataInput;
	// console.log( 'getting json', path )
	$.get( path, next ).fail(function(e) {
		console.error("Failed to get PDF plumber data:", e);
    	frm.myAlert('PDF Data Error', 'Could not retrieve the document structure. The task cannot be loaded.');
    	loadingOut(); // Hide the loader
	});

	function next( data ) {
		if( !origPlumber ) origPlumber = clone(data);
		plumberData = data;
		data = jsonParse(data);
		if( descriptor.comprehendMode ) {
			var curl = descriptor.comprehendSource;
			if( descriptor.comprehendBlocks ) {
				// console.log( 'already has Blocks descriptiorn' )
				curl = descriptor.comprehendBlocks;
			}
			return comprehendSourceRead( curl, data, result );
		} 
		
		// console.log( 'DATAaaaaaa', data )
		result(data);
	}


	function result( data ) {
		// console.log( 'result')
		// console.log( 'getting json result', clone(data) );
		if( !data.pages ) return frm.myAlert( 'Load Error', 'An error ocourred while loading the pdf file. Please check the original file.')
		// data.pages.forEach( (p, pidx) => {
		// 	var tList = [];
		// 	var idxList = [];
		// 	var cList = [];
		// 	var chars = p.chars;
		// 	var dim = p.mediabox;
		// 	var width = dim[2];
		// 	var height = dim[3];
		// 	var lx = 0;
		// 	var ly = 0;
		// 	dimensions.push( {width:dim[2], height:dim[3]} )
		// 	if( chars )
		// 	{
		// 		chars.forEach( (c,cidx) => {
		// 			var x0 = c.x0/width;
		// 			var x1 = c.x1/width;
		// 			var y1 = 1-c.y0/height;
		// 			var y0 = 1-c.y1/height;
		// 			var w = x1-x0;
		// 			var h = y1-y0;
		// 			var dx = lx ? (x0-lx)/w : 0;
		// 			var dy = ly ? (y0-ly)/h : 0;
		// 			// if( JSON.stringify(c.stroking_color) == JSON.stringify(c.non_stroking_color)) return
		// 			lx = x1;
		// 			ly = y0;
		// 			if( tList.length && (descriptor.comprehendMode || Math.abs(dx) > 0.3) )
		// 			{
		// 				// console.log( '' );
		// 				tList.push( ' ' );
		// 				idxList.push( -1 );
		// 				cList.push( [' ', lx, ly, lx, ly, -1, -1, cidx, -1] );
		// 			}
		// 			// console.log( c.text, x0, y0, dx, dy)
		// 			tList.push( c.text );
		// 			for( let i = 0; i < c.text.length ; i++ ) idxList.push( cList.length )
		// 			// if( c.id >= 0 ) { // for comprehendMode
		// 			// 	comprehendBlocksAux[c.id].translateTo = cList.length;
		// 			// 	if( comprehendBlocksAux[c.id].translateTo != comprehendBlocksAux[c.id].translateTo2 ) console.error( 'translate', comprehendBlocksAux[c.id].translateTo, comprehendBlocksAux[c.id].translateTo2)
		// 			// }
		// 			cList.push( [c.text, x0, y0, x1, y1, dx, dy, cidx, c.id || -1] );
		// 			if( !c.text.length != 1 )
		// 			{
		// 				for( var n = c.text.length-1 ; n ; n-- )
		// 				// cList.push( ['', x0, y0, x1, y1, -1, -1, '', -1] );
		// 				cList.push( ['', -1000, -1000, -1000, -1000, -1, -1, '', -1] );
		// 				// console.log( 'Multichar span found', pidx, 'char', c.text, c.text.length, cidx, x0, x1, y0, y1 );
		// 			}
		// 		});
		// 	}
		// 	plainText.push( tList.join('') );
		// 	plainText2Blocks.push( idxList );
		// 	textData.push( cList );
		// });
		var textData = plumberToText( data );
		// console.log( 'textData', textData )
		window.pdfData = data;
		// callback( {plainText: plainText, plainText2Blocks: plainText2Blocks, textContent: textData, dimensions: dimensions} )
		callback( textData )
	}
}

// PLUMBERTOTEXTIN

function getPlainText( pag ) {
	var tagRegEx = /(<([^ >][^>]*)>)/ig;
	// var tagRegEx = /(<([^>]+)>)/ig;

	function sanitizeTag( tag )
	{
		var nt = tag.match(/<(\/|)([a-z]+)/i);
		if( !nt ) return tag.replace(/</g,'yyy').replace(/>/g,'zzz');
		if( nt[2].match(/^(input|textarea|script|a)$/i) )
			return '';
		return '<'+nt[1]+nt[2].toLowerCase()+'>';
	}
	pag = pag.replace(/\r/g,'');
	try {
		pag = JSON.parse('"'+pag.replace(/\\u/g,'\\u').replace(/\n/g,'\\n').replace(/\\n/g,'\\n').replace(/"/g,'\\"')+'"');
	} catch(e){}
	pag = pag.replace(/\n/g,'<br>');
	var plain = [];
	var html = [];
	var type = [];
	var tags = pag.match( tagRegEx );
	// console.log( pag.substr(0,100));
	while( tags && tags.length )
	{
		var tag = tags.shift();
		var idx = pag.indexOf( tag );
		var txt = decodeEntities(pag.substr( 0, idx));
		var stag = sanitizeTag(tag);
		// console.log( 'stag', stag )
		if( stag.match(/<\/(p|div)>/) || stag == '<br>') txt += ' ';
		html.push(txt);
		html.push(stag);
		plain.push(txt);
		pag = pag.substr( idx+tag.length );
		// console.log( 'plain', plain )
		// console.log( html, pag.substr(0,100) );
		// if( plain.length > 20 ) break;
	}
	html.push( pag )
	plain.push( pag )
	return {html:html,plain:plain}
}


function plumberToText(data) {
	var textData = [];
	var plainText = []
	var plainText2Blocks = []
	var dimensions = [];

	if( data.pages ) {
		data.pages.forEach((p, pidx) => {
			var tList = [];
			var idxList = [];
			var cList = [];
			var chars = p.chars;
			var dim = p.mediabox;
			var width = dim[2];
			var height = dim[3];
			var lx = 0;
			var ly = 0;
			dimensions.push({ width: dim[2], height: dim[3] })
			if (chars) {
				chars.forEach((c, cidx) => {
					var x0 = c.x0 / width;
					var x1 = c.x1 / width;
					var y1 = 1 - c.y0 / height;
					var y0 = 1 - c.y1 / height;
					var w = x1 - x0;
					var h = y1 - y0;
					var dx = lx ? (x0 - lx) / w : 0;
					var dy = ly ? (y0 - ly) / h : 0;
					// if( JSON.stringify(c.stroking_color) == JSON.stringify(c.non_stroking_color)) return
					lx = x1;
					ly = y0;
					if (tList.length && (descriptor.comprehendMode || Math.abs(dx) > 0.3)) {
						// console.log( '' );
						tList.push(' ');
						idxList.push(-1);
						cList.push([' ', lx, ly, lx, ly, -1, -1, cidx, -1]);
					}
					// console.log( c.text, x0, y0, dx, dy)
					tList.push(c.text);
					for (let i = 0; i < c.text.length; i++) idxList.push(cList.length)
					// if( c.id >= 0 ) { // for comprehendMode
					// 	comprehendBlocksAux[c.id].translateTo = cList.length;
					// 	if( comprehendBlocksAux[c.id].translateTo != comprehendBlocksAux[c.id].translateTo2 ) console.error( 'translate', comprehendBlocksAux[c.id].translateTo, comprehendBlocksAux[c.id].translateTo2)
					// }
					cList.push([c.text, x0, y0, x1, y1, dx, dy, cidx, c.id || -1]);
					if (!c.text.length != 1) {
						for (var n = c.text.length - 1; n; n--)
							// cList.push( ['', x0, y0, x1, y1, -1, -1, '', -1] );
							cList.push(['', -1000, -1000, -1000, -1000, -1, -1, '', -1]);
						// console.log( 'Multichar span found', pidx, 'char', c.text, c.text.length, cidx, x0, x1, y0, y1 );
					}
				});
			}
			plainText.push(tList.join(''));
			plainText2Blocks.push(idxList);
			textData.push(cList);
		});
	}
	return {plainText: plainText, plainText2Blocks: plainText2Blocks, textContent: textData, dimensions: dimensions};
}

function plumberBoundingBoxes( pdata ) {
	var boxes = [];
	for( var td of pdata.textContent ) {
		var blist = [];
		boxes.push(blist);
		var word = {"text":"",range:[],box:[]}
		var i = 0;
		for( var c of td ) {
			if( !word.range.length ) word.range[0] = i;
			word.range[1] = i;
			i++;
			if( c[0] == ' ') {
				blist.push(word)
				word = {"text":"",range:[],box:[]}
				continue;
			}
			word.text += c[0];
			var box = [c[1],c[2],c[3],c[4]];
			if( !word.box.length ) word.box = box;
			else word.box = boxAdd( word.box, box );
		}
		word.range[1] = i;
		blist.push(word)
	}
	return boxes;
}

// PLUMBERTOTEXTOUT



function drawPdfPlumber( cList )
{

	// console.log( 'drawPdfPlumber', cList )
	// console.log( 'PDFPlumb', tcount(1) );
	var width = $('#img-layer').width();
	var height = $('#img-layer').height();
	var tl = txtObj;
	tl.html('');
	cList.forEach( (c, i) => {
		var s = $('<span>').addClass('pdf_text').addClass('pp pp'+i);
		s.attr('o1', i );
		s.attr('o2', i+1 );
		// .text(c[0]);
		tl.append(s);
		var x = Math.round(c[1]*width);
		var y = Math.round(c[2]*height);
		var cw = Math.round(c[3]*width)-x;
		var ch = Math.round(c[4]*height)-y;
		// var sx = cw/s.width();
		// var sy = ch/s.height();
		var css = {
			position: 'absolute',
			top:y,
			left:x,
			width: cw,
			height: ch,
		};
		if( c[0] == '' || c == ' ') css.display = 'none';
		s.css( css );
		// console.log( s[0].outerHTML )
		// console.log( s[0], s.width(), s.height(), cw, ch )
	});
	// console.log( 'PDFPlumb2', tcount() );
}

function test()
{
	drawPdfPlumber( gPDF.pdfData.textContent[currentPage-1] );
	// $('.pdf_text').css({border:'1px solid red'})

}


// function engine2(){ return descriptor.pdfEngine == 2 || descriptor.usePDFPlumber }
function engine2(){ return true; }


function getPDF( pdfPath, callback )
{
	if( engine2() )
	{
		getPdfPlumber( pdfPath, pdfData => {
			getPDF2( pdfPath, function( pdf ){
				pdf.pdfData = pdfData;
				pdf.plainText = pdf.pdfData.plainText;
				pdf.textContent = pdf.pdfData.textContent;
				pdf.dimensions = pdf.pdfData.dimensions;

				callback( pdf );
			} )
		} )
	}
	else getPDF2( pdfPath, callback );
}

function getPDF2( pdfData, callback )
{
	// console.log( 'getPDF2', pdfData )
	// var loadingTask = pdfjsLib.getDocument({data: pdfData});
	var loadingTask = pdfjsLib.getDocument(pdfData);
	loadingTask.promise.then(function(pdf) {
		totalPages = pdf._pdfInfo.numPages;
		pdf.url = pdfData;
		// console.log('PDF loaded', pdf.url);
		textPDF(pdf,callback);
	}, function (reason) {
	    // PDF loading error
	    console.error(reason);
	}).catch( e => {
		console.error( 'getPDF2', e );
	});
}

// load the plain text of pdfs as a single string
function textPDF( pdf, callback )
{
	if( engine2() ) return callback(pdf);
	// console.log( 'pages', pages );
	var pages = pdf._pdfInfo.numPages;
	pageNum = 0;
	pdf.plainText = [];
	pdf.dimensions = [];
	pdf.textContent = [];
	function nextPage()
	{
		pageNum++;
		pdf.getPage(pageNum).then(function(page) {
			var viewport = page.getViewport({ scale: 1, });
			pdf._viewport = viewport;
			pdf.dimensions.push( {width:viewport.width,height:viewport.height} );
			page.getTextContent().then(function(textContent){
				pdf._textContent = textContent;
				// console.log( 'textContent', clone(textContent) );
				var texts = [];
				var lastRight = 0;
				var spliceList = [];
				var lastTc = null;
				var offset = 0;
				for( var i = 0 ; i < textContent.items.length ; i++ )
				{
					var tc = textContent.items[i];
					var olen = tc.str.length;
					tc.str = tc.str.replace(/\t/g, ' ');
					tc.str = tc.str.trim();
					tc.str = decodeEntities(tc.str);
					if( tc.str == '' || tc.dir != 'ltr' )
					{
						if( tc.str > '' ) console.log( 'ignored pdf item', clone(tc) );
						spliceList.unshift(i);
						continue;
					}
					var inc = 0;
					if( descriptor.adlMode )
					{
						let t = tc.transform;
						let scale = Math.sqrt(t[0]*t[0]+t[1]*t[1]);
						let pos = {left:t[4],top:t[5]}
						let tmp = {left: tc.width, top:0};
						let tmp2 = {left:(tmp.left*t[0]-tmp.top*t[1])/scale,top:(-tmp.left*t[2]+tmp.top*t[3])/scale};
						let end = {left:pos.left+tmp2.left,top:pos.top+tmp2.top}
						tc.end = end;
						if( lastTc )
						{
							let dt = lastTc.end.top-pos.top;
							let dl = lastTc.end.left-pos.left;
							let dist = Math.sqrt(dt*dt+dl*dl);
							// console.log( lastTc.str, tc.str, dist );
							if( dist > CLOSESPAN )
							{
								texts.push(' '); // SPACE
								offset++;
								inc++;
							}
						}
						var len = tc.str.length;
						// console.log( tc.str, pos, tmp, tmp2, end );
					}
					else {
						// check if transform is inverted
						var invTransf = Math.abs(tc.transform[1]+tc.transform[2]) > Math.abs(tc.transform[0]+tc.transform[3]);
						tc.left = tc.transform[invTransf?5:4];
						var len = tc.str.length;
						if( lastTc && (lastRight && Math.abs(tc.left-lastRight) > CLOSESPAN ) )
						{
							texts.push(' '); // SPACE
							offset++;
							inc++;
						}
					}

					texts.push( tc.str );
					tc.textOffset = offset;

					offset += len;

					// save last right
					lastRight = tc.left+tc.width;
					lastTc = tc;
				}
				spliceList.forEach( s => textContent.items.splice(s,1) );
				pdf.textContent.push( textContent );
				pdf.plainText.push( texts.join('') );
				if( pageNum < pages ) nextPage();
				else if( callback ) callback( pdf );
			});
		}).catch( e => {
			console.error( 'textPdf getTextContent', e );
		});
	}
	nextPage();
}


var decodeEntities = (function() {
  // this prevents any overhead from creating the object each time
  var element = document.createElement('div');

  function decodeHTMLEntities (str) {
    if(str && typeof str === 'string') {
      // strip script/html tags
	  str = str.replace(/</g, '##lt##' );
      // str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
      // str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
      element.innerHTML = str;
      str = element.textContent;
	  str = str.replace(/##lt##/g, '<' );
      element.textContent = '';
    }

    return str;
  }

  return decodeHTMLEntities;
})();


function textRange2BlockRange( page, range ) {
	var blocks = [];
	var bkey = {};
	for( var i = range[0]; i < range[1] ; i++ ) {
		var b = gPDF.pdfData.plainText2Blocks[page-1][i]; 
		if( b >= 0 && !bkey[b] ) {
			blocks.push( b );
			bkey[b] = 1;
		}
	}
	return blocks;
}

function findPDF( pdf, text )
{
	if( !pdf.plainText || !pdf.plainText.length || !text || !text.trim || !text.trim().length ) return [];
	text = text.trim();
	if( text.match( /^(label|relationship):/i) )
		return findEntityPDF( pdf, text );
	var wid = text.length;
	var found = [];
	text = text.replace(/([^a-z0-9])/ig, "\\$1");
	var reg = new RegExp(text,'i');
	var fidx = 0;
	for( var i = 0 ; i < pdf.plainText.length ; i++ )
	{
		var pos = 0;
		var plainText = pdf.plainText[i];
		while( (fidx = plainText.substr(pos).search(reg)) >= 0 )
		{
			// console.log( 'page', i+1, fidx+pos );
			var r = [fidx+pos,fidx+pos+wid];
			var t0 = plainText.substring(0,r[0]);
			var t1 = plainText.substring(r[0],r[1]);
			var t2 = plainText.substring(r[1]);
			var t = t0+'<b>'+t1+'</b>'+t2;
			var out = 40;
			var t = t.substring(r[0]-out-3, r[1]+out+4);
			found.push( {page:i+1,range:r,nearText:t});
			pos += fidx+wid;
		}
	}
	// console.log( 'FOUND', found )
	return found;
}

function findEntityPDF( pdf, text )
{
	var tmp = text.split(':');
	var entity = tmp.shift();
	var find = tmp.join(':');
	entity = entity.trim().toLowerCase();
	text = find.trim();
	if( text == '' ) return [];
	if( entity == 'label' )
	{
		entity = 'tags';
		var list = rangeList;
		var searchField = ['type','properties'];
		var idField = 'id';
	}
	else if( entity == 'relationship' )
	{
		entity = 'links';
		var list = linkList;
		var searchField = ['relationship'];
		var idField = 'i1';
	}
	var wid = text.length;
	var found = [];
	// text = text.replace(/([^a-z0-9])/ig, "\\$1");
	// var reg = new RegExp(text,'i');
	var reg = text.toLowerCase();
	// console.log( 'entity', entity, 'text', text, reg, list, searchField, idField )
	var fidx = 0;
	function match( v, reg )
	{
		if( isarray(v) )
		{
			for( var i = 0 ; i < v.length ; i++ )
				if( match(v[i],reg) ) return 1;
			return 0;
		}
		// var ret = v.match(reg);
		var ret = v.toLowerCase() == reg;
		// console.log( 'MATCH', v, reg, ret )
		return ret;
	}
	var ftids = {};
	for( var i = 0 ; i < list.length ; i++ )
	{
		for( var j = 0 ; j < searchField.length ; j++ )
		{
			// console.log( 'searchField', sf, list[i] )
			var sf = searchField[j];
			if( list[i][sf] && match(list[i][sf], reg ) )
			{
				var page = list[i].page;
				var plainText = pdf.plainText[page-1];
				var tid = list[i][idField];
				if( ftids[tid] ) continue;
				ftids[tid] = 1;
				var tag = tagFind(tid )

				var r = tag.range;
				var t0 = plainText.substring(0,r[0]);
				var t1 = plainText.substring(r[0],r[1]);
				var t2 = plainText.substring(r[1]);
				var t = t0+'<b>'+t1+'</b>'+t2;
				var out = 40;
				var t = t.substring(r[0]-out-3, r[1]+out+4);
				found.push( {page:page,range:r,nearText:t, tid: tid});
				// console.log( 'match', page, r, t)
			}

		}
	}
	found.sort( function(a,b){
		if( a.page == b.page ) return a.range[0] < b.range[0] ? -1 : 1;
		return a.page < b.page ? -1 : 1;
	});
	return found;
}

function rightFocus( id )
{
	// console.log( 'rightFocus', id );
	if( $('#'+id).length )
	{
		var stop = $('#right').scrollTop();
		var top = $('#'+id)[0].offsetTop;
		// console.log( 'stop', stop, 'top', top, 'height', $('#right').height() )
		if( top < stop )
		{
			// console.log( 'case 1' )
			$('#right').scrollTop( top );
		}
		if( (top-stop) > $('#right').height() )
		{
			// console.log( 'case 2' )
			$('#right').scrollTop( top-$('#right').height() );
		}
	}
}

var showFindResultTid = null;
function showFindResult( r, callback )
{
	selected = null;
	delTmp();
	var range = clone(r.range);
	var page = r.page;
	var bbMode = oocrMode || descriptor.selectBoundingBox
	if( bbMode ) {
		range = textRange2BlockRange( page, range )
	}
	var srange = JSON.stringify(range);

	// first check if range is not already there
	var robj = null;
	for( var i = 0 ; i < rangeList.length ; i++ )
	{
		var r = rangeList[i];
		if( !r.adj && r.page == page && JSON.stringify(r.range) == srange )
		{
			robj = r;
			break;
		}
	}
	// check if in correct page first!!!!!!!!!!!!!!!!

	// console.log( 'robj', robj )
	function show()
	{
		if( !pageDone ) return setTimeout( show, 100 );
		if( !robj )
		{
			var id = g_tagId++;
			// console.log( 'RRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRR', clone(r) )
			if( bbMode ) {
				selectRange = [];
				var bb = boundingBoxFromRange( range );
				addOCR( range, id, '', false, page, null, bb, null );
			}
			else {
				addRange(splitRange( range, id, 'tmp' ));
			}
			sortRange();
			tagSelect(id);
		}
		else
		{
			var span = $('.cid_'+robj.id);
			selected = null;
			tagOut.apply(span[0]);
			tagOver.apply(span[0]);
			tagSelect(robj.id);
		}
		selectedPos();
		if( callback ) callback(true);
	}
	if( page != currentPage )
		drawPDF( gPDF, page, globalZoom, show );
	else
		setTimeout( show, 1 );
}

function selectedPos(tmp)
{
	if( !tmp ) tmp = $('.cid_'+selected);
	// console.log( 'selectedPos', tmp[0] )
	if( !tmp.length ) {
		var tmpTop = 0;
		var tmpLeft = 0;
	}
	else {
		var tmpTop = tmp[0].offsetTop;
		var tmpLeft = tmp[0].offsetLeft;
	}
	var mainHeight = $('#maincolumn')[0].clientHeight;
	var mainWidth = $('#maincolumn')[0].clientHeight;
	var mainScroll = $('#maincolumn').scrollTop();
	var mainScrollLeft = $('#maincolumn').scrollLeft();
	// if( tmpTop < mainScroll ) $('#maincolumn').scrollTop( tmpTop-mainHeight/2 );
	// if( tmpTop > mainScroll+mainHeight )
	// console.log( 'tmpTop', tmpTop, 'mainHeight', mainHeight )
	var stop = (tmpTop-1*mainHeight/4)*zoomValue;
	var sleft = (tmpLeft-mainWidth/2)*zoomValue;
	// console.log( 'setSelectedPos', tmpTop, tmpLeft, mainHeight, mainWidth, '-', stop, sleft )
	$('#maincolumn').css({scrollBehavior:'auto'}).scrollTop( stop ).scrollLeft( sleft );
	setTimeout( function(){
		$('#maincolumn').css({scrollBehavior:'smooth'});
	}, 100 )
}

function displayInfo(page)
{
	var metadata = (descriptor.pdf && descriptor.pdf.metadata) || (descriptor.htmlText && descriptor.htmlText.metadata) || (descriptor.image && descriptor.image.metadata) || (descriptor.video && descriptor.video.metadata) || null;
	if( descriptor.tags ) metadata.tags = Object.keys(descriptor.tags).join(',')

	console.log( 'metaDatax', metadata )
	if( !metadata ) return $('#pdfinfo').hide();
	var out = [];
	for( var k in metadata )
	{
		out.push('<b>'+k+':</b>');
		out.push(metadata[k]);
		out.push('&nbsp;');
	}
	var html = out.join(' ');
	var info = 	$('#pdfinfo')
	info.html(html).show();
	info.attr('title',info.text()).off('click').on('click', function(ev) {
		if( ev.ctrlKey ){
			if( metadata.TaskId ) {
				var md = metadata.TaskId;
				var msg = 'Task Id Saved to clipboard';
			}
			else if( metadata.ItemId ) {
				var md = metadata.ItemId;
				var msg = 'Dataset Item Id Saved to clipboard';
			}
		}
		else {
			var md = JSON.stringify(metadata,null,'\t');
			var msg = 'The task metadata was copied to the clipboard';
		}
		saveClipboard( md );
		frm.myAlert('Metadata Copied', msg, 'Ok')
		setTimeout( function(){
			$("#modal-close")[0].click();
		}, 3000  )
	})
}

function tcount( reset )
{
	if( reset ) window.tcount_last = window.tcount_ini = 0;
	var first = !window.tcount_last;
	if( !window.tcount_ini ) window.tcount_ini = Date.now();
	var r =  first ? '' : Date.now()-window.tcount_last;
	window.tcount_last = Date.now();
	return [r, Date.now()-window.tcount_ini];
}


var lineOffset = [];
function drawHtmlAdjust()
{
	if(pageVideo) pageVideo.css({maxHeight:$('#maincolumn')[0].clientHeight-15, maxWidth:$('#maincolumn')[0].clientWidth-15})	
	var maxStack = [];
	var lineLink = {};
	linkList.forEach( l => lineLink[l.topLine] = 1 )
	rangeList.forEach( r => {
		if( r.page != currentPage ) return;
		if( !showAdjudication && r.adj ) return;
		// console.log( r.id, r.line, r.stack )
		if( !maxStack[r.line] || maxStack[r.line] < r.stack ) maxStack[r.line] = r.stack;
	})
	var offset = 0;
	lineOffset = [];
	for( var i = 0 ; i < htmlTextLines.length ; i++ )
	{
		if( maxStack[i] ) offset += maxStack[i]*16;
		if( i && lineLink[i] ) offset += 50;
		lineOffset.push( offset );
	}
	// console.log( maxStack )
	$('.adjusttop').each( (i,x) => {
		x = $(x);
		x.css({top: x.attr('top')*1 + lineOffset[x.attr('line')*1]});
	})
	$('.adjustheight').each( (i,x) => {
		x = $(x);
		x.css({height: x.attr('height')*1 + (lineOffset[x.attr('line1')*1]-lineOffset[x.attr('line2')*1])});
	})
}

var pageImage = null;
function drawImage(pdf, pageNumber, zoom, callback) {
	if (!pageImage) {
		pageImage = new Image;
		pageImage.src = pdf.url;
		pageImage.onload = dImage();
	}
	else dImage();

	function dImage() {
		// console.log('drawimage', pdf.url, pageImage);
		var top = $('#pdfinfo').outerHeight();
		txtObj.css({marginTop:top, top:0});
		txtObj.html('').append($(pageImage));
		var w = $('#maincolumn').width()*zoom;
		$(pageImage).css({width:w})

		pagination( currentPage );
		textSetData( pdf, pageNumber )
		pageDone = true;
		// console.log( 'done', tcount() );
		drawHtmlAdjust()
		$('.searchbox').hide();
		if(callback) callback();

	}
}

///////// VIDEO HERE IN  //////////////////////////////////////////////////////////////
/// 
/// create drawVideo similar do drawImage above. Video you can ignore zoom
/// the tag should be a media player for the video url
let pageVideo = null
function drawVideo(pdf, pageNumber, zoom, callback) {
	if(!pageVideo) {
		pageVideo = $('<video controls></video>');
		pageVideo.attr('src', pdf.url);
		// pageVideo.setAttribute('controls', '');
		pageVideo.onload = dVideo()
	}
	else dVideo();

	function dVideo() {
		let top = $('#pdfinfo').outerHeight();
		txtObj.css({marginTop:top, top:0});
		txtObj.html('').append($(pageVideo));
		// var w = $('#maincolumn').width()*zoom;
		// $(pageVideo).css({width:w})
		pageVideo.css({maxHeight:$('#maincolumn')[0].clientHeight-15, maxWidth:$('#maincolumn')[0].clientWidth-15})
		pagination( currentPage );
		textSetData( pdf, pageNumber )
		pageDone = true;
		drawHtmlAdjust()
		$('.searchbox').hide();
		if(callback) callback();
	}
}
///
///////// VIDEO HERE OUT //////////////////////////////////////////////////////////////


var htmlTextLines = [];

var globalLineSpacing = 15;

function drawHtmlText( pdf, pageNumber, zoom, callback )
{
	noScale();
	popupOut();
	lineOffset = [];
	pageDone = false;
	currentPage = pageNumber;
	globalZoom = zoom;
	var txtWidth = $('#maincolumn').width()-20;
	var tcss = {padding: 20, marginTop: 80, width: '', height: '' };
	var tcss = {padding: 20, marginTop: 80, width: txtWidth, height: '' };

	txtObjAdj.css(tcss).html('')
	txtObj.css(tcss).html('');
	var tl = txtObj;
	tl.html('');
	var scount = 0;

	// console.log( 'draw1', tcount(1))
	setTimeout( () => {
		// console.log( 'DRAW ---------------------------------------------------', tcount(1) )
		// console.log( 'draw2', tcount())
		var html = pdf.html[pageNumber-1];
		// console.log( 'drawHtmlText', pageNumber, html );
		var c = 0;
		var tobj = pdf.textObjs[pageNumber-1] = [];
		var txtlist = [];
		var output = [];
		var fs = zoom*16;
		var css = {marginBottom: globalLineSpacing+'px', fontSize:px(fs), lineHeight:px(fs+1.2)};
		for( var i = 0 ; i < html.length ; i+= 2 )
		{
			var txt = html[i].split('');
			var alpha = false;
			for( var j = 0 ; j < txt.length ; j++ )
			{
				var t = txt[j];

				var a = t.match(/[a-z]/i);
				if( a && !alpha ) output.push('<nobr>');
				if( !a && alpha ) output.push('</nobr>');
				alpha = a;
				var tt = t;
				if( tt == ' ' ) tt = '&nbsp;';
				output.push('<span class="pdf_text pp pph pp'+(c)+' adjusttop" o1="'+scount+'" o2="'+(scount+1)+'">'+tt+'</span>');
				scount++;
				txtlist.push(t);
				c++;
				// tl.append(s);
				// console.log( s[0].getBoundingClientRect() )
			}
			if( alpha ) output.push('</nobr>');
			output.push(html[i+1]);
		}
		tl.html(output.join(''));
		// console.log( 'loopin', tcount() );
		tl.find('.pph').css( css );
		// for( var i = 0 ; i < c ; i++ )
		var mloc = tl[0].getBoundingClientRect();
		// console.log( 'DRAW pos ---------------------------------------------------', tcount() )
		var slist = tl.find('.pp');
		var lines = [];
		var lastTop = -1000000;
		slist.each( (i,s) => {
			var loc = s.getBoundingClientRect();
			var top = loc.top-mloc.top;
			var left = loc.left-mloc.left;
			if( top > lastTop )
			{
				lines.push( top );
				lastTop = top;
			}
			$(s).css({position:'absolute', top: top, left: left})
			.attr('top', top )
			.attr('left', left)
			.attr('line', lines.length-1 )
		})
		htmlTextLines = lines;
		// console.log( 'lines', lines )
		// for( var i = 0 ; i < c ; i++ )
		// {
		// 	var t = txtlist[i];
		// 	// var s = tl.find('.pp'+i);
		// 	var s = $(slist[i]);
		// 	// var s = tl.find('.pp'+i).text(t).css(css);
		// 	// if( t == ' ') s.html('&nbsp;');
		// 	// s.attr('o1', i );
		// 	// s.attr('o2', i+1 );
		// 	var loc = s[0].getBoundingClientRect();
		// 	s.css({position:'absolute', top: loc.top-mloc.top, left: loc.left-mloc.left});
		// }
		// console.log( 'DRAW pos2 ---------------------------------------------------', tcount() )
		// console.log( 'loopout', tcount() );
		var w = tl.width();
		var h = tl.height(); // need to adjust width/height of text layer after fixing spans
		tl.css({width:w,height:h})
		tl.prop('w', w).prop('h',h);
		// console.log( 'page', w, h )
		// var spans = tl.find('.pph');
		// spans.remove();
		var ht = tl.html().replace(/ pph /g,' pph-position ');
		// console.log( ht )
		tl.html(ht);
		tl.css({width:w,height:h})
		// tl.prop('dimension',{width: 1043.32, height: 185.455})
		tl.prop('dimension',{width: txtWidth, height: 185.455})
		// console.log( 'AAAAAAAAAAAAAAAAa', {width:w,height:h} )

		// spans.removeClass('pph').addClass('pph-position');
		// tl.find('nobr').remove();
		// tl.append(spans);
		// console.log( 'paginate', tcount() );
		// console.log( 'DRAW END ---------------------------------------------------', tcount() )
		pagination( currentPage );
		textSetData( pdf, pageNumber )
		pageDone = true;
		// console.log( 'done', tcount() );
		drawHtmlAdjust()
		if(callback) callback();

	}, 100 );
}

function txtObjHeight()
{
	if( htmlTextMode ) var r = txtObj.prop('dimension').height;
	else var r = txtObj.height();
	// console.log( 'txtObjHeight', r );
	return r;
}

function txtObjWidth()
{
	if( htmlTextMode ) var r = txtObj.prop('dimension').width;
	else var r = txtObj.width();
	// console.log( 'txtObjWidth', r );
	return r;
}

var adjLoaded = false;
function drawPDF( pdf, pageNumber, zoom, callback )
{
	console.log('PDXXXXXX', pdf)
	if( !pageDone ) return;
	if( pageNumber != currentPage ) selectRange = null;
	noScale(); zoom = 1;
	loading();
	var ocallback = callback;
	callback = function(){
		loadingOut();
		$('.tools-panel').show();
		$('div[idx="chatbox"]').hide();
		if(window.GlobalVars.PDFProjectType == 'OCR' || window.GlobalVars.PDFProjectType == 'NER') $('div[idx="help"]').show();
		else $('div[idx="help"]').hide();
		if( ocallback ) ocallback();
		drawText();
		zoomSet(zoomValue)
		calcCanvasBox();
	}
	displayInfo(pageNumber);
	if( pdf.isImage ) return drawImage( pdf, pageNumber, zoom, callback );
///////// VIDEO HERE IN  //////////////////////////////////////////////////////////////
/// 
/// check for pdf.isVideo and drawVideo
console.log('pdx', pdf)
if( pdf.isVideo ) {
	$('div[idx="zoomin"]').hide();
	$('div[idx="zoomout"]').hide();
	return drawVideo( pdf, pageNumber, zoom, callback )
}
///
///////// VIDEO HERE OUT //////////////////////////////////////////////////////////////

	if( htmlTextMode ) return drawHtmlText( pdf, pageNumber, zoom, callback );
	try {
		pageDone = false;
		if( !zoom ) zoom = 1;
		selectedLink = null;
		selected = null;
		over = null;
		popupOut();
		txtObj.html('');
		txtObjAdj.html('');
		$('#box-layer').html('');
		$('form').css({height:px(0)});
		try {

		}
		catch(e){
			console.error('page load error', pageNumber, e );
		}
		pdf.getPage(pageNumber).then(function(page) {
			// console.log('Page loaded', page);
			currentPage = pageNumber;
			pagination( currentPage );
			var desiredWidth = $('#maincolumn').width();
			var viewport = page.getViewport({ scale: 1, });
			var scale = desiredWidth / viewport.width;
			// scale = 1;
			scale *= zoom;


			var viewport = page.getViewport({scale: scale});
			pdf._viewport = viewport;

			// remove canvas and create new one
			$('#img-layer').remove();
			$('#maincolumn').prepend($('<CANVAS>').prop('id','img-layer'));

			// Prepare canvas using PDF page dimensions
			var canvas = document.getElementById('img-layer');
			var text = document.getElementById('text-layer');
			var textAdj = document.getElementById('text-layer-adj');
			$(text).css({height:px(viewport.height), width:px(viewport.width)});
			$(textAdj).css({height:px(viewport.height), width:px(viewport.width)});
			var context = canvas.getContext('2d');
			canvas.height = viewport.height;
			canvas.width = viewport.width;
			$('#box-layer').css({height:px(canvas.height),width:px(canvas.width)});
			txtObj.css({height:px(canvas.height),width:px(canvas.width)});
			txtObjAdj.css({height:px(canvas.height),width:px(canvas.width)});

			// Render PDF page into canvas context
			var renderContext = {
				canvasContext: context,
				viewport: viewport
			};
			var renderTask = page.render(renderContext);
			renderTask.promise.then(function () {
				// console.log('Page rendered');
				tagDownOn();
			}).catch( e => {
				console.error( 'renderTask', e );
			});

			window.ppp = page;
			function getText(textContent)
			{
				pdf._textContent = textContent;
				// console.log( 'getText', textContent );
				function fixSingleChar( o, idx )
				{
					o = $(o);
					// console.log( idx, JSON.stringify(o.text()) );
					var txt = o.text().trim();
					var textOffset = pdf.textContent[pageNumber-1].items[idx].textOffset;
					o.text( pdf.textContent[pageNumber-1].items[idx].str );
					o.attr('o1',textOffset);
					o.attr('o2',textOffset+txt.length);
					// console.log( 'texstOffset', idx, o.attr('o1')*1 );

					o.text( decodeEntities(o.text()) );
					o.prop('id','pdf_txt_'+idx );
					o.prop('idx',idx );
					if( o.html().length == 1 )
					{
						var ow = o.width();
						var oh = o.height();
						var iw = textContent.items[idx].width;
						var ih = textContent.items[idx].height;
						// console.log( 'single', idx, o[0], ow/oh, iw/ih );
						var os = (iw/ih)/(ow/oh);
						if( !FIXSPLIT )
						o.css({transform:'scaleX('+os+')'})
					}
				}
				var divs = [];

				if( !descriptor.pdf.offsetText ) descriptor.pdf.offsetText = [0,0];
				txtObj.css(
					{
						left:px(descriptor.pdf.offsetText[0]*globalZoom),
						top:px(descriptor.pdf.offsetText[1]*globalZoom)
					}
				)
				txtObjAdj.css(
					{
						left:px(descriptor.pdf.offsetText[0]*globalZoom),
						top:px(descriptor.pdf.offsetText[1]*globalZoom)
					}
				)

				if( engine2() )
				{
					drawPdfPlumber( gPDF.pdfData.textContent[currentPage-1] );
					// $('.pdf_text').css({border:'1px solid red'})
					textDone();
				}
				else {
					pdfjsLib.renderTextLayer({
						container : text,
						textContent: textContent,
						viewport : viewport,
						textDivs: divs,
					})
					.promise.then(() => {
						return textDone();
					}).catch( e => {
						console.error( 'page renderTextLayer error', pageNumber, e );
						result( false );
					});
				}
				function textDone()
				{
					divs.forEach( fixSingleChar );

					textSetData( pdf, pageNumber );
					// pageList[currentPage] = pdf.plainText[currentPage-1];
					setTimeout( function(){
						pageDone = true
					}, 500 );
					result(true);
				}
			}
			getText(pdf.textContent[pageNumber-1]);
		}).catch( e => {
			console.error( 'page load error', pageNumber, e );
			setTimeout( function(){
				pageDone = true;
				drawPDF( pdf, pageNumber, zoom, callback );
			}, 1000 )
			// result( false );
		});
	}
	catch(e){
		console.error('error drawing page', pageNumber, 'zoom', zoom, e );
		setTimeout( function(){
			pageDone = true;
			drawPDF( pdf, pageNumber, zoom, callback );
		}, 1000 )
		// result( false );
	}
	function result(status)
	{
		pageDone = true;
		if( callback ) setTimeout( function(){callback(status)}, 100 );
	}
}

function fixAbsoluteOffsets()
{
	if( descriptor.exportOffsets ) return;
	var os = 0;
	var offsets = [os];
	for( var t of gPDF.plainText )
	{
		os += t.length;
		offsets.push(os);
	}
	// console.log( 'offsets', offsets );
	descriptor.exportOffsets = offsets;
	if( descriptor.exportFormat == 1 ) descriptor.exportAllPlainTextPages = true;
	if( descriptor.text_attributes.absoluteOffsets )
	{
		for( var r of descriptor.text_attributes.tags )
		{
			r.range[0] -= descriptor.exportOffsets[r.page-1];
			r.range[1] -= descriptor.exportOffsets[r.page-1];
		}
	}
}

function textSetData( pdf, pageNumber )
{
	if( dataLoaded )
	{
		var rr = clone(rangeList);
		var ll = clone(linkList);
		ll.map( function(l){ l.id1 = l.i1; l.id2 = l.i2 })
	}
	else {
		if( descriptor.comprehendMode ) {
			// console.log( 'ANNOTATIONS', descriptor.text_attributes )
			if( descriptor.text_attributes && descriptor.text_attributes.Entities ) { 
				var tables = descriptor.text_attributes.Tables;
				descriptor.text_attributes = comprehendAnnotationImport(comprehendBlocksAux,descriptor.text_attributes);
				if( tables  ) ocrProcessTableData( tables, true );
			}
		}
		var rr = hasLabels ? descriptor.text_attributes.tags : [];
		var ll = hasLinks ? descriptor.text_attributes.links : [];
		dataLoaded = true;
		if( hasClassification )
		{
			for( var cn in descriptor.text_attributes.classifications )
			{
				var co = descriptor.text_attributes.classifications[cn];
				classifications[cn] = {};
				co.forEach( o => classifications[cn][o] = 1)
			}
		} 
	}
	// ajdust g_tagId
	rr.forEach( r => {if( r.id >= g_tagId) g_tagId = r.id+1} );

	// check if there is alternate tags and links for Adjudication
	if( descriptor.adjudication_attributes && !adjLoaded )
	{
		adjLoaded = true;
		var adjTo = {}
		function adjId(id){
			if( !adjTo[id] ) adjTo[id] = g_tagId++;
			// console.log( 'adjTo', id, adjTo[id] );
			return adjTo[id];
		}
		function identical(t)
		{
			for( var i = 0 ; i < rr.length ; i++ )
			{
				if( rr[i].page == t.page &&
					rr[i].range[0] == t.range[0] &&
					rr[i].range[1] == t.range[1] &&
					rr[i].type == t.type
				) return true;
			}
			return false;
		}
		if( descriptor.adjudication_attributes.tags )
		descriptor.adjudication_attributes.tags.forEach( t => {
			t.adj = true;
			t.origId = t.id;
			t.id = adjId(t.id);
			rr.push( t );
		});
		if( descriptor.adjudication_attributes.links )
		descriptor.adjudication_attributes.links.forEach( l => {
			l.adj = true;
			l.origId1 = l.id1;
			l.origId2 = l.id2;
			l.id1 = adjId(l.id1);
			l.id2 = adjId(l.id2);
			ll.push( l );
		});
		// setTxt( rr, ll, descriptor.text_attributes.attributes );
	}
	if( hasPageAttributes )
	{
		if( !descriptor.text_attributes.pageAttributes[currentPage-1] ) descriptor.text_attributes.pageAttributes[currentPage-1] = {};
		listAttributes( $('#page_attrs'), descriptor.pageAttributes, descriptor.text_attributes.pageAttributes[currentPage-1], 'Page Attributes' );
	}
	setTxt( rr, ll, descriptor.text_attributes.attributes );
	pageList[currentPage] = pdf.plainText[pageNumber-1];
	if( hasClassification ) classificationPanel()
	else if( descriptor.qaMode ) {
		questionList = descriptor.text_attributes.questions || [];
		qaPanel();
	}

}

function getPDFOld( url, callback )
{
    var cached = getCache( url );
    if( cached ) return callback( cached );
    var service = 'http://localhost:8088';
    var sURL = url;
    if( !url.match(/^http/) ) // if local file, get blob to send to service
    {
        var fr = new FileReader();
        fr.onload = function(evtLoaded) {
            sURL = evtLoaded.target.result.substr('data:application/pdf;base64,'.length);
            next();
        };
        var xhr = new XMLHttpRequest();
        xhr.open( "GET", url);
        xhr.responseType = "blob"; //force the HTTP response, response-type header to be blob
        xhr.onload = function() {
            fr.readAsDataURL(xhr.response);
        }
        xhr.send();
    }
    else next();

    function next()
    {
        // console.log( 'NEXT', sURL );
        $.post( service+'/extract_pdf', {url: sURL }, function(ret){
            // console.log( 'AJAX', err, ret )
            setCache( url, ret );
            callback( ret );
        } );
    }
}


function getHtmlText()
{
	// if( !descriptor.wordPageBreak ) descriptor.wordPageBreak = 19000;
	if( !descriptor.wordPageBreak ) descriptor.wordPageBreak = 250;
	if( !descriptor.textFilePageBreak ) descriptor.wordPageBreak = 5000000000;
	// $($('.compexpand')[1]).show();
	// descriptor.text_attributes.tags = [];
	var pages = descriptor.htmlText.pages;
	descriptor.htmlText.html = [];
	descriptor.htmlText.plainText = [];

	var pgs = pages[0].split('\n');
	var words = 0;
	var splitted = false;
	var splitPag = [[]];
	var pag = splitPag[0];
	var splitBreak = [];
	var pidx = 0;
	var toff = 0;
	console.log( 'pgs', pgs )
	for( var p of pgs ) {
		var w = p.split(' ').length;
		words += w;
		pag.push( p )
		var pl = getPlainText( pag.join('\n') ).plain.join('');
		var tlen = pl.length + 1;
		// var tlen = 0;
		splitBreak[pidx] = toff+tlen;
		// console.log( 'ppppppppppp', w, words, tlen, toff )

		if( words > descriptor.wordPageBreak ) {
			var tmid = descriptor.text_attributes.tags.filter( t => t.range[0] < (toff+tlen) && t.range[1] > (toff+tlen) );
			console.log( 'tmid', tmid );
			if( tmid.length ) continue;
			pag = [];
			splitPag.push(pag);
			pidx++;
			toff += tlen;
			words = 0;
			splitted = true;
			console.log( 'split')
		}
	}
	if( splitted ) {
		pages = [];
		let tpag = {};
		for( var p of splitPag ) {
			if( !p.length ) continue;
			if( pages.length ) pages[pages.length-1] += ' ';
			pages.push( p.join('\n') );
		}
		// var pplain = pages.map( )
		var ofs = pages.map( p => p.length );
		for( var t of descriptor.text_attributes.tags ) {
			var rini = 0;
			for( var p = 0 ; p < pages.length ; p++ ) {
				var rend = splitBreak[p]
				// console.log( 'check', t.range, p, rini, rend )
				if( t.range[0] >= rini && t.range[0] < rend ) {
					t.range[0] -= rini;
					t.range[1] -= rini;
					t.page = p+1;
					tpag[t.id] = t.page;
				}
				rini = rend;
			}
		}
		var lct = 0;
		for( var l of descriptor.text_attributes.links ) {
			l.page = tpag[l.id1];
			l.page2 = tpag[l.id2];
			// console.log( 'link', lct++, 'page1', l.page, 'page2', l.page2, clone(l))
		}
	}
	// console.log( 'PAGS', pages, splitBreak  )

	pages.forEach( pag => {
		// console.log( html );
		var dp = getPlainText( pag );
		var plain = dp.plain;
		var html = dp.html
		// console.log( 'PLAIN', plain.join('') );
		// console.log( 'HTML', html );
		descriptor.htmlText.html.push( html );
		descriptor.htmlText.plainText.push( plain.join('') );
	})
	totalPages = pages.length;
	window.gPDF = gPDF = descriptor.htmlText;
	window.descriptor = descriptor;
	gPDF.pdfData = {plainText:gPDF.plainText};
	gPDF.textObjs = [];
	gPDF.numPages = totalPages;
	currentPage = 1;
	globalZoom = 1;
	htmlTextMode = 1;
	fixAbsoluteOffsets();
	drawPDF( gPDF, currentPage, globalZoom, () => {
		// console.log( 'html text loaded' );
		initDone();
	} )
}

var pdfPage = window.pdfPage = function(n) {
	let sl = $('#maincolumn').scrollLeft();
	let st = $('#maincolumn').scrollTop();
	var sb = $('#maincolumn').css('scroll-behavior');
	$('#maincolumn').css({scrollBehavior:'auto'});
	// console.log( 'sl', sl, 'st', st )
	drawPDF( gPDF, n, globalZoom, function(){
		setTimeout( function(){
			// console.log( 'recover',  'sl', sl, 'st', st )
			$('#maincolumn').scrollTop(st);
			$('#maincolumn').scrollLeft(sl);
			$('#maincolumn').css({scrollBehavior:sb});
		}, 1 );
	} )
}

function getImage()
{
	totalPages = 1;
	window.gPDF = gPDF = descriptor.image;
	gPDF.isImage = true;
	window.descriptor = descriptor;
	gPDF.pdfData = {plainText:[]};
	gPDF.textObjs = [];
	gPDF.numPages = totalPages;
	gPDF.plainText = [];
	currentPage = 1;
	globalZoom = 1;
	imageMode = 1;
	fixAbsoluteOffsets();
	drawPDF( gPDF, currentPage, globalZoom, () => {
		// console.log( 'imagel loaded' );
		initDone();
	} )
}

///////// VIDEO HERE IN  //////////////////////////////////////////////////////////////
/// 
/// create getVideo similar to getImage above
function getVideo()
{
	totalPages = 1;
	window.gPDF = gPDF = descriptor.video;
	gPDF.isVideo = true;
	window.descriptor = descriptor;
	gPDF.pdfData = {plainText:[]};
	gPDF.textObjs = [];
	gPDF.numPages = totalPages;
	gPDF.plainText = [];
	currentPage = 1;
	globalZoom = 1;
	videoMode = 1;
	fixAbsoluteOffsets();
	drawPDF( gPDF, currentPage, globalZoom, () => {
		console.log( 'video loaded' );
		initDone();
	} )
}
///
///////// VIDEO HERE OUT //////////////////////////////////////////////////////////////

function inDescriptor( key, v )
{
	if( !(v in descriptor[key]))
	{
		console.error( 'Value', v, 'not in descriptor', key );
		return false;
	}
	return true;
}

function exists( o )
{
	if( !o ) return false;
	if( !isobj(o) ) return false;
	return Object.keys(o).length > 0;
}

function showHide( o, flag )
{
	if( flag ) o.show();
	else o.hide();
}

var chatNotificationRead = false;
function displayNotes() {
	$('#messages').remove();
	if (reviewMode) {
		$('#reviewer_notes').hide();
		$('#submitReviewer').show();
	}
	else {
		// $('#messages').hide();
		$('#annotator_notes').hide();
		$('#submitReviewer').hide();
	}
	$('#chatbox').removeClass('unselectable');
	$('#chat_notification').hide();
	$('#chatbox').off('click').on('click', chatPopup );
	if( !chatNotificationRead && window.GlobalVars.PDFProjectType !== 'Utterance Recording')
		if( $('#reviewer_notes').val().trim() || $('#annotator_notes').val().trim() || (descriptor.messages && descriptor.messages.length)) $('#chat_notification').show();
;
}

function chatPopup() {
	let content = '<div id="messages" class="file-messages"></div>';
		if( reviewMode ) {
			content += '<textarea id="chat_reviewer_notes" class="inote-text mt-2" placeholder="Reviewer Notes"></textarea>';
		}
		else {
			content += '<textarea id="chat_annotator_notes" class="inote-text mt-2" placeholder="Annotator Notes"></textarea>';
		}
		frm.myAlert( 'Messages', content, 'Ok' );
		displayMessages();
	if( blockEdit ) {
		$('.modal-body').find('textarea').attr('disabled', true);
	}
	setTimeout( function(){
		$('.modal-body').scrollTop( 100000 )
		if( !blockEdit ) {
			if( reviewMode ) {
				$('#chat_reviewer_notes')[0].focus();
			}
			else {
				$('#chat_annotator_notes')[0].focus();
			}
		}
	}, 500 )

	// copy notes to original text area for compatibility
	$('#chat_reviewer_notes').on('change', function(){
		$('#reviewer_notes').val($(this).val());
		changed();
	} ).val($('#reviewer_notes').val())
	$('#chat_annotator_notes').on('change', function(){
		$('#annotator_notes').val($(this).val());
		descriptor.text_attributes.attributes["Aditional Notes"] = $(this).val(); 
		changed()
	} ).val($('#annotator_notes').val())
	
	chatNotificationRead = true;
	$('#chat_notification').hide();
}

function displayMessages()
{
	if( !descriptor.messages ) return;
	$('#messages').show().html('');
	var role = ['Annotator','QC'];

	var showMoreLess = $('<DIV>').addClass('message-show');
	$('#messages').append(showMoreLess);
	var nshow = 2;
	var nmess = descriptor.messages.length;
	function showMore()
	{

	}
	function show()
	{
		var hidden = 0;
		for( var i = 0 ; i < nmess-nshow ; i++ )
		{
			$('.message-idx-'+i).hide();
			hidden++;
		}
		for( ; i < nmess ; i++ )
			$('.message-idx-'+i).show();
		if( hidden )
		{
			showMoreLess.text('Show more messages').off('click').on('click', function(){
				nshow += 3;
				show();
			});
		}
		else if( nmess > 2 )
		{
			showMoreLess.text('Show less messages').off('click').on('click', function(){
				nshow = 1;
				show();
			});
		}
	}
	
	descriptor.messages.forEach((m,idx)=>{
		var m = $('<DIV>').addClass('message-'+m[0]).addClass('message-idx-'+idx).html('<i>'+role[m[0]]+'</i><br>' + m[1]);
		$('#messages').append(m);
	});
	// show();
}

var blockEdit = false;
var blockSave = false;
var reviewMode = false;
var autoExpand = false;

// showVersion('developer');

var formSet = false;
var tagSelectedClass = 'c_tag_selected';
var tagOverClass = 'c_tag_over';
var tagOpt1Class = 'c_tag_opt1';
var tagAdjClass = 'c_tag_adj';
var tagEqualClass = 'c_tag_equal';
var declined = false;
var claimed = false;
var released = false;

function fixButtons(descriptor) {
	if( !descriptor ) return;
	$('.task-button').hide();
	$('.claim-button').html('Claim Task as '+descriptor.task_role)
	if( descriptor.blockEdit ) {
		if( descriptor.task_can_claim ) {
			if( descriptor.task_auto_claim ) {
				setTimeout( function(){
					$('.claim-button')[0].click();
				}, 1 );
			}
			else {
				$('.claim-button').show();
			}
		}
	}
	else {
		$('#resumeLater').show();
		$('.claim-button').hide();
		if(window.GlobalVars.PDFProjectType !== 'Utterance Recording') {
			$('.submit-button').show();
		}
		$('.autolabel-button').show();
		if( descriptor.task_can_decline ) $('.decline-button').show();
		if( descriptor.task_can_release ) {
			$('.release-button').show();
		}
	}
	reviewMode = descriptor.reviewMode
	if( reviewMode )
	{
		$('#reviewer-fields').show();
		$('#annotator_notes').hide();
		
		// if( !descriptor.reviewMayRequestAdjustment );
		 if (window.GlobalVars.PDFProjectType == 'Content Generation') {
       		if( !descriptor.reviewMayRequestAdjustment ) $('#optadjust').show();
    }else {
			if( !descriptor.reviewMayRequestAdjustment ) $('#optadjust').remove();
	}
	}
	blockEdit = descriptor.blockEdit;

	$('.fqafield').attr('disabled', blockEdit )
	if( descriptor.qaMode ) qaPanel();

	displayNotes();
	ckSelectDisable();
	// $('#right').find('select').attr('disabled', blockEdit)
}

function ckSelectDisable(){
	if( blockEdit )	$('.maincontent').find('select').attr('disabled', true)
	else {
		$('.maincontent').find('select').removeAttr('disabled');
		$('.dropdown').find('button').removeAttr('disabled')
	}
}


function setButtons(descriptor,form) {
	$('#submitButton').removeClass('mt-2').addClass('mr-2').addClass('submit-button').addClass('task-button');
	var claimBtn = $('<button type="submit" class="btn btn-primary btn-primary mr-2 task-button claim-button">').html('Claim Task');
	$('#submitButton').before(claimBtn);
	claimBtn.on('click', function () {
		claimTask(descriptor);
	});
	var declineBtn = $('<button type="submit" class="btn btn-primary btn-danger mr-2 task-button decline-button">').html('<i class=" mr-2 fa fa-ban" aria-hidden="true"></i>Decline  ');//modify Decline Task  as  Decline - mani
	$('#submitButton').after(declineBtn);
	declineBtn.on('click', function () {
		declined = claimed = released = false;
		declined = true;
		if (form) form.submit();
		else submitAnnotations();
	});
	var releaseBtn = $('<button type="submit" class="btn btn-primary btn-warning mr-2 task-button release-button">').html('<i class=" mr-2 fa fa-unlock" aria-hidden="true"></i>Release');  //modify Release Task  as Remove - mani
	declineBtn.after(releaseBtn);
	releaseBtn.on('click', function () {
		releaseTask(descriptor);
	});
	descriptor.fixButtons = fixButtons;
	fixButtons(descriptor);
}



function calcCanvasBox() {
	var off = $('canvas').offset();
	var width = $('canvas').width();
	var height = $('canvas').height();
	var stop = $('#maincolumn').scrollTop();
	var sleft = $('#maincolumn').scrollLeft();
	// console.log( 'canvasBox off', off, width, height, stop, sleft)
	off.width = width;
	off.height = height;
	off.top += stop;
	off.left += sleft;
	canvasBox = off;
	// console.log( 'canvasBox', canvasBox )
}

function init(desc)
{
	$('.tools-panel').hide();
	loading('drawing task');
	// check if there is ocrKeyPair data to be loaded
	
	// console.log( 'keypairsource', descriptor.ocrKeyPairSource)
	if ((descriptor.ocrKeyPairMode || descriptor.ocrTableMode) && descriptor.ocrKeyPairSource && !descriptor.ocrKeyPairData && !descriptor.ocrTableData) {
		return $.get(descriptor.ocrKeyPairSource, function (data) {
			data = jsonParse(data);
			descriptor.ocrKeyPairData = data.key_value_pairs || null;
			descriptor.ocrTableData = data.table_values || null;
			if( !descriptor.ocrKeyPairMode ) descriptor.ocrKeyPairData = null;
			if( !descriptor.ocrTableMode ) descriptor.ocrTableData = null;
			init(desc);
		}).fail(function (e) {
			console.error(e)
		});
	}
	txtObj = $('#text-layer');
	txtObjAdj = $('#text-layer-adj');
	if( desc ) descriptor = desc;

	frm.dotKeys(desc);
	alignErrCt = 0;
	alignCt = 0;
	if( engine2() )
	{
		tagSelectedClass = 'pp-select';
		tagOverClass = 'pp-select';
		tagOpt1Class = 'c_tag_opt1_2';
		tagAdjClass = 'c_tag_adj_2';
		tagEqualClass = 'c_tag_equal_2';
	}
	oocrMode = ocrMode = descriptor.ocrMode;
	oocrMode = false;
	if( ocrMode ) {
		descriptor.relationships = {
			"key-pair": {
				"alias": "keyset",
				"color": "#4DA6FF"
			}
		};
	} 
	else if( !descriptor.htmlText ) optim = 0;
	if( descriptor.labels ) descriptor.labels = flatLabels( descriptor.labels );
	
	
	if( !formSet )
	{
		formSet = true;
		var form = document.querySelector('crowd-form');
		if( form ) form.onsubmit = submitAnnotations;
		
		$('#submitButton').on('click', async function () {
			declined = claimed = released = false;
			if (form) form.submit();
			else submitAnnotations();
		});
		setButtons(descriptor,form);
		checkInstructions();
	}
	$('crowd-form').hide();


	autoExpand = 'autoExpand' in descriptor ? descriptor.autoExpand : 1;

	if( descriptor.preloadData ) return descriptor.preloadData();
	if( descriptor.batchMode )
	{
		batchMode();
		return;
	}
	// if( descriptor.batchMode2 )
	// {
	// 	delete descriptor.batchMode2;
	// 	setTimeout(batchMode2,1);
	// 	return;
	// }
	if( descriptor.text_attributes_url && !descriptor.retrievedAWS )
	{
		return $.get( descriptor.text_attributes_url, function( data ) {
			data = jsonParse(data);
			descriptor.text_attributes = data;
			// console.log( 'loaded text_attributes_url', descriptor.text_attributes_url, data )

			delete descriptor.text_attributes_url;
			init(descriptor);
		}).fail(function() {
			delete descriptor.text_attributes_url;
			init(desc);
		});
	}
	if( descriptor.adjudication_attributes_url )
	{
		return $.get( descriptor.adjudication_attributes_url, function( data ) {
			data = jsonParse(data);
			descriptor.adjudication_attributes = data;
			// console.log( 'loaded adjudication_attributes_url', descriptor.adjudication_attributes_url, data )
			delete descriptor.adjudication_attributes_url;
			init(desc);
		}).fail(function() {
			delete descriptor.adjudication_attributes_url;
			init(desc);
		});
	}
	if( !descriptor.text_attributes ) descriptor.text_attributes = {};
	if( !descriptor.adjudication_attributes ) descriptor.adjudication_attributes = {};

	var now = getsec();
	if( !descriptor.text_attributes.elapsedTime )
	{
		descriptor.text_attributes.elapsedTime = 0;
		if( !descriptor.text_attributes.jobStart ) descriptor.text_attributes.jobStart = now;
	}

	if( !descriptor.text_attributes.attributes ) descriptor.text_attributes.attributes = {};
	if (hasAttributes) {
		listAttributes($('#text_attrs'), descriptor.attributes, descriptor.text_attributes.attributes, 'Document Attributes');
	}
	var addNotes = $('#annotator_notes');
    addNotes.val(descriptor.text_attributes.attributes["Aditional Notes"] || "" );
    addNotes.on('change', updateNotes ).on('blur', updateNotes );
    function updateNotes(){ descriptor.text_attributes.attributes["Aditional Notes"] = $(this).val(); changed() };


	$(document.body).off('keydown').on('keydown', keyDown)
	$(document.body).off('keyup').on('keyup', keyup);
// $(document).off('keyup').on('keyup', keyup );

	descriptor.text_attributes.sessionStart = now;
	if( ocrMode ) {
		$('#box-layer').css({zIndex:100})
	} 
	if( descriptor.modelRunMode ) {
		if( descriptor.text_attributes.tags.find( v => v.type.match(/^#adj#/)) ) adjMode = true;
	}
	showTexts = false;
	showAdjudication = false;
	showTags = false;
	showLinks = false;
	showTables = false;
	showBoxes = false;

	dataLoaded = false;
	adjLoaded = false;
	// alert( 'init')
	if( mode == 'adl' )
	{
		// closeIcon = $('#faTimes')[0].outerHTML;
		// searchIcon = $('#faSearch')[0].outerHTML;
		setTimeout( function(){window.checkInNLP()}, 1000 );
	}
	// console.log( 'DESCRIPTOR', descriptor );
    splitTags = 0;
    popupClear = true;
    popupSelected = null;
    popupUpdate = null;	

    tagAdj = null;

	blockEdit = descriptor.blockEdit ? true : false;
	reviewMode = descriptor.reviewMode ? true : false;

	displayNotes();

	if( !exists( descriptor.messages) ) $('#messages').hide();
	else displayMessages();

	$('#reviewer-opts').html('<select className="mmdb-select mmd-form iselect" id="reviewer_rate" style="width:100%"><option value="">Are the Annotations Ok?</option><option value="Ok">Annotations are OK</option><option value="Rejected">Reject Annotations</option><option id="optadjust" value="Adjust">Request Adjustments</option></select>');
	frm.convertSelects();

	$('#reviewer_rate').on('change', changed );
	$('#reviewer_notes').on('change', changed );
	if( descriptor.text_attributes && descriptor.text_attributes.review )
	{
		$('#reviewer_rate').val(descriptor.text_attributes.review.rate);
		if( descriptor.text_attributes.review.note && descriptor.messages && descriptor.messages.length ){
			let mLast = aLast( descriptor.messages );
			if( mLast[0] == 1 && mLast[1] == descriptor.text_attributes.review.note ) {
				descriptor.text_attributes.review.note = '';
			}
		}
		$('#reviewer_notes').val(descriptor.text_attributes.review.note);
	}
    if( descriptor.labels )
    {
		setColors( descriptor.labels );
        fixLabels( descriptor.labels );
        setHotKeys( descriptor.labels, 'label', tagSet );
    }
    if( descriptor.relationships )
	{
		setColors( descriptor.relationships );
		setHotKeys( descriptor.relationships, 'relationship', linkSet );
	}
    if( descriptor.boxes ){
		setHotKeys( descriptor.boxes, 'box', boxSet );
	} 


    // if( !descriptor.labels ) myAlert('Submit Error', 'no label dictionary defined in meta data' );
    // if( !descriptor.relationships ) myAlert('Submit Error', 'no relationship dictionary defined in meta data' );
    // if( !descriptor.attributes ) myAlert('Submit Error', 'no attributes dictionary defined in meta data' );

	// if( !descriptor.labels ) hasLabels = hasLinks = false;
	// if( !descriptor.relationships ) hasLinks = false;
	// if( !descriptor.attributes ) hasAttributes = false;
	// if( !descriptor.boxes ) hasBoxes = false;
	if( !descriptor.attributes || descriptor.attributes.length == 0 ) hasAttributes = false;
    if( !descriptor.allowTextOffset ) hasTextOffset = false;
    if( !descriptor.allowTextMode ) hasTextMode = false;
    if( !descriptor.allowAdjudication ) hasAdjudication = false;
	if( descriptor.boxes instanceof Object ) boxesLabels = true;
	hasLabels = hasLinks = exists(descriptor.labels);
	hasLinks = exists(descriptor.relationships);
	hasBoxes = exists(descriptor.boxes) || descriptor.ocrMode;
	if( descriptor.comprehendMode && !descriptor.ocrMode) hasBoxes = false;
	if( descriptor.htmlText ) hasBoxes = false;
	hasPageAttributes = exists(descriptor.pageAttributes);
	hasClassification = exists(descriptor.classification);
	boxesLabels = exists(descriptor.boxes);
    if( !descriptor.text_attributes.tags ) descriptor.text_attributes.tags = [];
    if( !descriptor.text_attributes.boxes ) descriptor.text_attributes.boxes = [];
    if( !descriptor.text_attributes.links ) descriptor.text_attributes.links = [];
    if( !descriptor.text_attributes.attributes ) descriptor.text_attributes.attributes = {};
    if( descriptor.text_attributes.plainText ) pageList = descriptor.text_attributes.plainText;
	if( hasPageAttributes )
	{
		if( !descriptor.text_attributes.pageAttributes ) descriptor.text_attributes.pageAttributes = [];
	}
	else $('#page_attrs').hide();

    presetCheckBoxes();

    setTxt( [], [], descriptor.text_attributes.attributes );
	showHide( $('.textoffset'), hasTextOffset );
	showHide( $('#cktexts'), hasTextMode );
	showHide( $('#ckadjudication'), hasAdjudication );
	showHide( $('#cklabels'), hasLabels );
	showHide( $('#ckrelationships'), hasLinks );
	showHide( $('#cktables'), descriptor.ocrTableMode );
	showHide( $('#ckboxes'), hasBoxes );

	console.log('hasClassification ------->',hasClassification);
	

	if (!hasClassification) $('#classification').hide();

	if (hasLabels) {
		// listKeys( $('#labels'), 'Labels', allLabels(descriptor.labels), tagSet )
	}
	else $('#labels').hide();
	if (hasLinks) {
		makePossibleHash();
		descriptor.text_attributes.links.forEach( r => {
			if( !descriptor.relationships[r.relationship] ) addDescriptorRelationship(r.relationship);
		})
		// listKeys( $('#relationships'), 'Relationships', Object.keys(descriptor.relationships), linkSet )
	}
	else $('#relationships').hide();

	if (hasBoxes) {
		boxes = clone(descriptor.text_attributes.boxes);
		if( !descriptor.boxes ) descriptor.boxes = {};
		if( boxes ) boxes.forEach(b => {
			if( !descriptor.boxes[b.label] ) addDescriptorBox( b.label );
			setUsed($('#boxeskeys'), b.label);
		});
		// if( boxesLabels )
		// {
		//     listKeys( $('#boxeskeys'), 'Boxes', Object.keys(descriptor.boxes), boxSet )
		// }
	}
	$('#boxeskeys').hide();

	if (hasAttributes) {
		// if( !descriptor.text_attributes.attributes ) descriptor.text_attributes.attributes = {};
		// listAttributes($('#text_attrs'), descriptor.attributes, descriptor.text_attributes.attributes, 'Document Attributes');
	}
	else $('#text_attrs').hide();

	// make ck labels clickable
	$('.ckbutton').off('click').on('click', function(ev){
		if( ev.target.tagName != 'INPUT' ) var r = $(this).find('input')[0].click();
		var input = $(this).find('input')[0];
		var btn = $(input.parentNode);
		btn.removeClass('ckbutton-set');
		if( input.checked ) btn.addClass('ckbutton-set');
	});
	$('.ckbutton').addClass('unselectable');

    drawText();
    $(window).off('resize').on('resize', function(){
		drawText()
		setTimeout( function(){
			calcCanvasBox();
			// var blayer = $('canvas');
			// if( blayer.length ) canvasBox = blayer[0].getBoundingClientRect();
			// console.log( 'canvasBox', canvasBox )
		}, 500 )
	 } );
    tagUnselect();
	linkUnselect();
	showSave('Session started', descriptor.text_attributes.sessionStart*1000 )

    $('.tool-button').click( toolButton );

    $('#showTexts').click( function(){
        showTexts = $(this).prop('checked');
        adjustTextMode();
    })

	var adjRendering = false;
	function adjudicationClick(ev)
	{
		if( adjRendering ) return ev.preventDefault();
		showAdjudication = $(this).prop('checked');
		adjRendering = true;
		$('#maincolumn').css({opacity:0.3})
		// console.log( ev.target, showAdjudication )
		setTimeout( function(){
			adjustAdjudication();
			drawPDF( gPDF, currentPage, globalZoom, function(){
				adjRendering = false;
				$('#maincolumn').css({opacity:''})
				// $(this).off('mousedown');
				// $(this).off('click').click(adjudicationClick);
			} );
		}, 1);
	}
    $('#showAdjudication').on('click', adjudicationClick );

    adjustAdjudication();

    $('#showTags').on('click', function(){
        showTags = $(this).prop('checked');
        // console.log( 'showTags', showTags );
        drawTags();
    })

    $('#showLinks').on('click', function(){
        showLinks = $(this).prop('checked');
        // console.log( 'showLinks', showLinks );
        drawTags();
    })

    $('#showTables').on('click', function(){
        showTables = $(this).prop('checked');
		if( showBoxes ) $('#ckboxes')[0].click()
        // console.log( 'showLinks', showLinks );
        drawTags();
    })

	$('#showSummary').on('click', function(ev){
		ev.preventDefault();
		ev.stopPropagation();
		showSummary();
	})

    $('#showBoxes').on('click', function(){
        showBoxes = $(this).prop('checked');
		// alert( showBoxes )
		if( showTables ) $('#cktables')[0].click()
		if( !showBoxes ) setTimeout( function(){
			if( !ocrMode ) $('.nlpbbox').hide();
			if( ocrMode ) tagUnselect();
			boxesClearUnlabeled();
			boxUnselect();
			popupOut();
			drawBoxes();
			delTmp();
		}, 50 );
		if( showBoxes ) {
			if( ocrMode ) tagUnselect();
			$('#text-layer').addClass('ocr-mode');
		}
		else $('#text-layer').removeClass('ocr-mode');
		$('#box-layer').css({zIndex: usingBoxes() ? 100 : -1 })
        // console.log( 'showBoxes', showBoxes );
		drawBoxes();
    })

    searchBoxUpdate();

	console.log('1234', descriptor)

	if( descriptor.pdf )
	{
		// console.log( '======================================', descriptor.pdf.url)
		getPDF( descriptor.pdf.url, function( pdf ){
			window.gPDF = gPDF = pdf;
			window.descriptor = descriptor;

			// if( descriptor.ocrKeyPairData ) ocrProcessKeyPairData();

			fixAbsoluteOffsets()
			alignCheck(gPDF);
			// alert( adjRendering )
			adjustAdjudication();
			drawPDF( pdf, 1, 1, initDone );
		} )
	}
	else if( descriptor.htmlText )
	{
		setTimeout( getHtmlText, 100 );
	}
	else if( descriptor.image )
	{
		setTimeout( getImage, 100 );
	}
///////// VIDEO HERE IN  //////////////////////////////////////////////////////////////
/// 
/// add option for getVideo if descriptor.video (this is set in NlpViewer )
else if( descriptor.video )
	{
		setTimeout( getVideo, 100 );
	}
///
///////// VIDEO HERE OUT //////////////////////////////////////////////////////////////	
	extraInit();

}

var drawPos = null;
var canvasBox = null;
var dictionary = [];

function mkDictionary() {
	if( !descriptor.labels ) return;
	if( !descriptor.useKeypairDic ) return;
	for( var lab  of Object.values(descriptor.labels) )
	{
		if( !lab.dictionary ) continue;
		var lname = lab.name;
		if( lname.match(/:VAL$/) ) continue;
		lname = lname.replace(/:KEY$/, '');

		var dic = lab.dictionary.replace(/\\,/g, '###sc###').replace(/,/g, "##COMA##").replace(/###sc###/g,',').split("##COMA##")
		for( var d of dic ) {
			// console.log( 'dictionary', lab.name, lab.dictionary )
			dictionary.push( {
				reg: new RegExp( d, 'i' ), 
				label: lname
			})
		}
	}
	// console.log( 'DICTIONARY', dictionary )
}

function tagLinkedKeyPair( tid ) {
	for( var lnk of linkList ) {
		if( lnk.relationship != 'key-pair' ) continue;
		var [i1,r2,i2,r2] = lnk.lid.split(/[\-\_]/);
		if( i1 == tid ) return { oid: i2, lnk: lnk }
		if( i2 == tid ) return { oid: i1, lnk: lnk }
	}
	return null;
}

function runDictionary( tid ) {
	// return;
	if( !dictionary.length ) return;
	if( !descriptor.useKeypairDic ) return;
	if( tid ) {
		var t = tagFind(tid);
		if( !t ) return;
		var list = [t];
	}
	else var list = rangeList;
	// console.log( 'runDictionary', list )
	var klist = ['GENERIC:KEY','GENERIC:VAL','tmp'];
	if( descriptor.dictionaryMatchKeysOnly ) klist.splice(1,1);
	// console.log( 'KLIST', klist )

	var be = blockEdit;
	blockSave = true;
	descriptor.blockEdit = blockEdit = false;
	for( var t of list ) {
		if( klist.indexOf( t.type ) < 0 ) continue;
		var txt = t.text || t.textAdjust;
		var found = null;
		for( var r of dictionary ) {
			// console.log( 'dic test', txt, r.reg, txt.match(r.reg) )
			if( txt.match(r.reg) ) {
				// console.log( 'dic match', txt, r.reg, r.label );
				found = r.label;
			}
		} 
		if( found ) {
			// addLink( currentPage, i1, i2, p )
			var sfound = simplify(found);
			if( t.type == 'GENERIC:KEY' ) {
				selected = t.id;
				keysetFlip = true;
				var linked = tagLinkedKeyPair(t.id);
				if( linked ) {
					// console.log( 'DELLINK1', t.id+'_generickey', linked.oid+'_genericval', linked )
					delLink( t.id+'_generickey', linked.oid+'_genericval')
				}
				tagSet( 'set', found + ':VAL' );
				if (linked) {
					selected = linked.oid;
					keysetFlip = !keysetFlip;
					tagSet('set', found + ':VAL');
					addLink( t.page, t.id+'_'+sfound+'key', linked.oid+'_'+sfound+'val', 'key-pair')
				}
			}
			else if( t.type == 'GENERIC:VAL' ) {
				selected = t.id;
				keysetFlip = false;
				var linked = tagLinkedKeyPair(t.id);
				if( linked ) {
					// console.log( 'DELLINK2', linked.oid+'_generickey', t.id+'_genericval', linked )
					delLink( linked.oid+'_generickey', t.id+'_genericval')
				}
				tagSet( 'set', found + ':VAL' );
				if (linked) {
					selected = linked.oid;
					keysetFlip = !keysetFlip;
					tagSet('set', found + ':VAL');
					// console.log( 'ADDLINK2', linked.oid+'_'+sfound+'key', t.id+'_'+sfound+'val', 'key-pair' );
					addLink( linked.lnk.page, linked.oid+'_'+sfound+'key', t.id+'_'+sfound+'val', 'key-pair' )
				}
			}
			// console.log( 'dic renametag', txt, t.type, found, t.id, linked );
		}
	}
	if( descriptor.dictionaryIgnoreNoMatch ) {
		var del = [];
		for( var r of rangeList ) {
			if( r.type.match(/(GENERIC:KEY|GENERIC.VAL)/)) del.unshift(r.id);
		}
		for( var d of del ) delRange( d );
	}
	descriptor.blockEdit = blockEdit = be;
	blockSave = false;
	// console.log( 'dic links', clone(linkList) ) 
}

var initComplete = false;
function initDone()
{

	var noAnnotations = rangeList.length == 0;
	mkDictionary();
	if( descriptor.ocrKeyPairData && noAnnotations && descriptor.ocrMode ) ocrProcessKeyPairData();
	if( descriptor.ocrTableData && noAnnotations ) ocrProcessTableData(descriptor.ocrTableData);

	// var blayer = $('canvas');
	// if( !blayer.length ) return {top:0,left:0};
	// canvasBox = blayer[0].getBoundingClientRect();
	// console.log( 'canvasBox', canvasBox )
	calcCanvasBox();

	// drawPDF( gPDF, currentPage, 1, function(){ zoomSet(1.5); tagSelect(1) } )
	if( descriptor.autoSubmit ) autoSubmit();
	runDictionary();
	initComplete = true;
	fixButtons(descriptor);

	if( adjMode ) {
		let legends = $('.legends');
		legends.html('<div class="colorGroundtruth"></div>Groundtruth <div class="colorAdj"></div>Prediction<div class="colorConsensus"></div>Consensus');
	}
}

var newLabelPalette = paletteWheel( 30, 1.5 );
var newLabelColorIdx = 7;
var newLabelColorInc = 13;

function findQuestion( n ) {
	return questionList.find( v => v.name == n ) || {}
}

function setQuestion( n, o ) {
	let idx = questionList.findIndex( v => v.name == n )
	o.name = n;
	if( idx == -1 ) return questionList.push( {name:n, ...o} );
	questionList[idx] = {...questionList[idx], ...o};
	console.log( 'setQuestion', questionList );
}

function qaPanel(){
	$('#right').removeClass('ctrlpanel');
	$('#classification').show().css({width: '100%'}).html('')
	$('#labels').hide();
	$('#relationships').hide();
	
    if (descriptor.qaMode && window.GlobalVars && window.GlobalVars.PDFProjectType === 'Content Generation' && reviewMode) {
        injectGradingCSS();
    }
	let qn = 1;

	function highlight( name ) {
		if( !name ) return $('.c_tag').removeClass('pp-select')

		$('.c_tag').removeClass('pp-select')
		let cname = '.c_' + simplify(name)
		$(cname).addClass('pp-select');
		// console.log( 'highligh', cname, $(cname).length )
		selectedPos( $($(cname)[0]))
	}

	function applicable( name, v, soft ) {
		if( blockEdit ) return;
		let uq = findQuestion( name );
		let sname = simplify(name)
		let qdiv = $('.qcont_'+sname);

		qdiv.find('.na-but').removeClass('question-na-active');
		
		// For Content Generation projects, don't enable all fields - let sequential logic handle it
		if( window.GlobalVars.PDFProjectType !== 'Content Generation' ) {
			qdiv.find('textarea').attr('disabled', false).addClass('qatextenabled')
		}
		
		if( uq.questionNotApplicable ) {
			qdiv.find('.na-question').addClass('question-na-active');
			qdiv.find('textarea').attr('disabled', true).removeClass('qatextenabled')
		}
		else if( uq.answerNotApplicable ) {
			qdiv.find('.na-answer').addClass('question-na-active');
			qdiv.find('.fanswer').attr('disabled', true).removeClass('qatextenabled')
		}
		
		// For Content Generation projects, don't enable feedback fields - let sequential logic handle it
		if( window.GlobalVars.PDFProjectType !== 'Content Generation' ) {
			qdiv.find('.ffeedback').attr('disabled', false).removeClass('qatextenabled')
		}
	}

	console.log('descriptor.questions----->',descriptor.questions);
	
	for( let qk in descriptor.questions ) {
		let q = descriptor.questions[qk];
		q.name = qk;
		let sname = simplify(qk)
		let qdiv = $('<div>').addClass('question');
		qdiv.addClass('qcont_'+sname)
		qdiv.css({background: q.color+'44'});
		let html = [];
		html.push('<div class="question-toolbar question-toolbar-question"></div><p>' + q.instruction1 + '</p>');
		let uq = findQuestion( q.name );
		let dis = blockEdit ? ' disabled=true' : '';
		console.log( 'findQuestion', q.name, uq)
		if( q.summary ) {
			html.push('<label for="summary_'+qn+'">Summary</label>')
			html.push('<textarea id="summary_'+qn+'" key="'+q.name+'" num="'+qn+'" class="form-control fqafield fsummary" placeholder="Enter summary"'+dis+'>'+(uq.summary || '')+'</textarea>')
		}
		
	  if( window.GlobalVars.PDFProjectType == 'Content Generation' ) {
           // html.push('<label for="question_'+qn+'">Question</label>')
			html.push('<textarea id="question_'+qn+'" key="'+q.name+'" num="'+qn+'" class="form-control fqafield fquestion" placeholder="Enter question"'+dis+'>'+(uq.question || '')+'</textarea>')
			// html.push('<p>' + q.instruction1 + '</p>');
           //  if (descriptor.projectType === 'TEXT_QA') {
			// html.push('<div class="question-toolbar question-toolbar-answer"></div>');
			// html.push('<label for="answer_'+qn+'">Answer</label>')
			// html.push('<textarea id="answer_'+qn+'" key="'+q.name+'" num="'+qn+'" class="form-control fqafield fanswer" placeholder="Enter answer"'+dis+'>'+(uq.answer || '')+'</textarea>')
		html.push('<textarea id="feedback_'+qn+'" key="'+q.name+'" num="'+qn+'" class="form-control fqafield ffeedback" title="Feedback Notes" placeholder="Feedback notes"'+dis+'>'+(uq.feedback || '')+'</textarea>')
	  }

		else if( window.GlobalVars.PDFProjectType == 'TEXT_QA' ) {
			html.push('<label for="question_'+qn+'">Question</label>')
			html.push('<textarea id="question_'+qn+'" key="'+q.name+'" num="'+qn+'" class="form-control fqafield fquestion" placeholder="Enter question"'+dis+'>'+(uq.question || '')+'</textarea>')
			html.push('<p>' + q.instruction1 + '</p>');
           //  if (descriptor.projectType === 'TEXT_QA') {
			html.push('<div class="question-toolbar question-toolbar-answer"></div>');
			html.push('<label for="answer_'+qn+'">Answer</label>')
			html.push('<textarea id="answer_'+qn+'" key="'+q.name+'" num="'+qn+'" class="form-control fqafield fanswer" placeholder="Enter answer"'+dis+'>'+(uq.answer || '')+'</textarea>')
		html.push('<textarea id="feedback_'+qn+'" key="'+q.name+'" num="'+qn+'" class="form-control fqafield ffeedback" title="Feedback Notes" placeholder="Feedback notes"'+dis+'>'+(uq.feedback || '')+'</textarea>')
		//  }
		}

		// html.push('<textarea id="feedback_'+qn+'" key="'+q.name+'" num="'+qn+'" class="form-control fqafield ffeedback" title="Feedback Notes" placeholder="Feedback notes"'+dis+'>'+(uq.feedback || '')+'</textarea>')
		qdiv.html( html.join(''))

		   
        if (descriptor.qaMode && window.GlobalVars && window.GlobalVars.PDFProjectType === 'Content Generation'  && reviewMode) {
            const gradingForm = gradingFormHTML(qk);
            qdiv.append(gradingForm);
			// const feedbackForm = $('<textarea id="feedback_'+qn+'" key="'+q.name+'" num="'+qn+'" class="form-control fqafield ffeedback" title="Feedback Notes" placeholder="Enter feedback for the annotator"'+dis+'>'+(uq.feedback || '')+'</textarea>');
            // qdiv.append(feedbackForm);
        }
		$('#classification').append( qdiv )
 
        if (descriptor.qaMode && window.GlobalVars && window.GlobalVars.PDFProjectType === 'Content Generation'  && reviewMode) {
			 if (uq.grading) {
                for (const criterion in uq.grading) {
                    if (uq.grading.hasOwnProperty(criterion) && criterion !== 'scorePercentage') {
                        const value = uq.grading[criterion];
                        const radioId = `#${criterion}${value}-${qk}`;
                        $(radioId).prop('checked', true);
                    }
                }
				
            }
			$(`#grading-form-${qk} input[type="radio"]:checked:first`).trigger('change');
            initializeGradingForm(qk);
        }
		
		$('#classification').find('.fsummary').off('change').on('change', function(){
			let qname = $(this).attr('key');
			setQuestion( qname, {summary: $(this).val().trim()})
			changed();
		})
		$('#classification').find('.fquestion').off('change').on('change', function(){
			let qname = $(this).attr('key');
			setQuestion( qname, {question: $(this).val().trim()})
			changed();
		})
		$('#classification').find('.fanswer').off('change').on('change', function(){
			let qname = $(this).attr('key');
			setQuestion( qname, {answer: $(this).val().trim()})
			changed();
		})
		$('#classification').find('.ffeedback').off('change').on('change', function(){
			let qname = $(this).attr('key');
			setQuestion( qname, {feedback: $(this).val().trim()})
			changed();
		})
		$('#classification').find('textarea').on('mouseover', function(){
			let qname = $(this).attr('key');
			let pre = '';
			if( $(this).hasClass('fquestion')) pre = 'Q:';
			else if( $(this).hasClass('fanswer')) pre = 'A:';
			else if( $(this).hasClass('fsummary')) pre = 'S:';
			else return;

			// console.log( 'over', pre+qname )
			highlight( pre+qname )
		}).on('mouseout', function(){
			highlight()
		})

		async function naClick( ev ) {
			if (blockEdit) return;

			let key = $(this).attr('key');

			if (uq[key]) {
				uq[key] = false;
				setQuestion(qk, { [key]: false })
				applicable(q.name);
			}
			else {
				uq[key] = true;
				setQuestion(qk, { [key]: true })
				applicable(q.name)
			}
			changed();
		}

		async function hskipClick( ev ) {
			let key = $(this).attr('key');
			if (uq[key]) {
				uq[key] = false;
				setQuestion(qk, { [key]: false })
				$(this).addClass('question-na-active')
			}
			else {
				uq[key] = true;
				setQuestion(qk, { [key]: true })
				$(this).removeClass('question-na-active')
			}
			console.log( 'hskipClick', key, uq[key] )
			changed();
		}

		let na = $('<i class="fa fa-ban question-na na-but na-question" key="questionNotApplicable" title="not applicable">');
		let na2 = $('<i class="fa fa-ban question-na na-but na-answer" key="answerNotApplicable" title="not applicable">');
		na.on('click', naClick )
		na2.on('click', naClick );

		qdiv.find('.question-toolbar-question').html('').append( na );
		qdiv.find('.question-toolbar-answer').html('').append( na2 );

		if ((!q.summary && descriptor.requestTextHighlightQ)) {
			let hskip = $('<i class="ml-2 fa fa-pencil-square-o question-na question-na-active butskip" key="questionSkipHighlight" toggle="1" title="highlight text requested">');
			qdiv.find('.question-toolbar-question').append(hskip);
			if (uq.questionSkipHighlight) hskip.removeClass('question-na-active')
		}
		if ((q.summary && descriptor.requestTextHighlightS)) {
			let hskip = $('<i class="ml-2 fa fa-pencil-square-o question-na question-na-active butskip" key="answerSkipHighlight" toggle="1" title="highlight text requested">');
			qdiv.find('.question-toolbar-question').append(hskip);
			if (uq.questionSkipHighlight) hskip.removeClass('question-na-active')
		}
		if ((!q.summary && descriptor.requestTextHighlightA)) {
			let hskip = $('<i class="ml-2 fa fa-pencil-square-o question-na question-na-active butskip" key="answerSkipHighlight" toggle="1" title="highlight text requested">');
			qdiv.find('.question-toolbar-answer').append(hskip);
			if (uq.answerSkipHighlight) hskip.removeClass('question-na-active')
		}
		qdiv.find('.butskip').on('click', hskipClick)
		qn++;
		setTimeout( function(){
			applicable( q.name );
		}, 100 )
	}
	
    if (descriptor.qaMode && window.GlobalVars && window.GlobalVars.PDFProjectType === 'Content Generation' && reviewMode) {
        $('#classification').append(overallScoreHTML());
        updateOverallScore();
        $('#classification').off('change.overallScore').on('change.overallScore', '.grading-container input[type="radio"]', function() {
            updateOverallScore();
        });
    }

	// This logic enables fields sequentially for the 'Content Generation' project type.
    if (window.GlobalVars.PDFProjectType === 'Content Generation' && !blockEdit) {
        const questionFields = $('#classification .fquestion');
        const feedbackFields = $('#classification .ffeedback');
        
        // 1. Initially disable all fields, then enable the first question.
        questionFields.prop('disabled', true);
        feedbackFields.prop('disabled', true);
        $('#question_1').prop('disabled', false);

        // 2. Set up lightweight event handlers that only affect the next field.
        questionFields.on('input', function() {
            const num = $(this).attr('num');
            const hasText = $(this).val().trim().length > 0;
            const feedbackField = $('#feedback_' + num);
            
            if (feedbackField.length) {
                feedbackField.prop('disabled', !hasText);
                // If the question is cleared, also disable the next question.
                if (!hasText) {
                    const nextNum = parseInt(num, 10) + 1;
                    $('#question_' + nextNum).prop('disabled', true);
                }
            }
        });

        feedbackFields.on('input', function() {
            const num = $(this).attr('num');
            const hasText = $(this).val().trim().length > 0;
            const nextNum = parseInt(num, 10) + 1;
            const nextQuestionField = $('#question_' + nextNum);

            if (nextQuestionField.length) {
                nextQuestionField.prop('disabled', !hasText);
            }
        });

        // 3. After setting up handlers, check for any pre-filled data to correctly restore the enabled/disabled state.
        questionFields.each(function() {
            const currentQuestion = $(this);
            // This check is important: only proceed if the question is NOT disabled from the initial setup.
            if (!currentQuestion.prop('disabled')) {
                // Manually trigger the input event to cascade the enabling logic.
                currentQuestion.trigger('input');
                
                const num = currentQuestion.attr('num');
                const feedbackField = $('#feedback_' + num);
                if (feedbackField.length) {
                    // Also trigger for the feedback field if it has content.
                    feedbackField.trigger('input');
                }
            }
        });
    }
}


var classificationPanelDone = false;
function classificationPanel()
{
	if( classificationPanelDone ) return;
	classificationPanelDone = true;
	$('#classification').html('')
	var clspalette = paletteWheel( descriptor.classification.length, 1.5 )
	descriptor.classification.forEach( function(c,cidx){
		if( !c.name ) return;
		var citem = $('<DIV>').prop('id', 'classification_'+cidx).addClass('classification-item')
		$('#classification').append(citem);
		citem.append( $('<H1>').html(c.name))

		if( c.type != 'text' )
		{
			if( !classifications[c.name] ) classifications[c.name] = {};
			c.options.forEach( o => tagColors[simplify(o.label)] = clspalette[cidx] );
			var cpan = $('<div>').addClass('tag-panel');
			citem.append(cpan);
			var clist = $('<DIV>').addClass('classification-list').addClass('scroll-thin');
			citem.append(clist);
			var hlist = {}; c.options.forEach( o => hlist[o.label] = 1 );
			setHotKeys( hlist, 'classification', function(a, b){
				if( blockEdit ) return locked()
				classSet( a, b );
				setTimeout( setOpt, 100 );
				changed();
			}, 1 )
			listKeys(clist, c.name, c.options.map(o => o.label), classSet)
			function classSet(cmd, item) {
				if (cmd == 'over') return;
				// console.log('classSet', cmd, item, c.name)
				if( cmd == 'unset' || classifications[c.name][item] ) delete classifications[c.name][item];
				else if( cmd == 'set' ) {
					if( c.type != 'multi' ) classifications[c.name] = {}
					classifications[c.name][item] = 1;
				} 
				// console.log( Object.keys( classifications[c.name]))
				setTimeout( setOpt, 1 );
				changed();
			}
			function setOpt()
			{
				clist.find('.keyselected').removeClass('keyselected');
				clist.find('.keyhover').removeClass('keyhover');
				clist.find('.keyrow').addClass('keyunused');
				// $('.keyselected').removeClass('keyselected')
				// $('.keyhover').removeClass('keyhover')
				cpan.html('')
				// console.log( 'setOpt', c.name )
				clist.prop('used', classifications[c.name])
				for( var k in classifications[c.name] )
				{
					var ok = k;
					k = simplify(k);
					cpan.append( $('<span class="label-cloud">' + ok + ' <i class="fa fa-times-circle"></i></span>'))
					var opt = clist.find('#key-'+k);
					// console.log( 'setOpt option', k, opt.length )
					if( opt.length )
					{
						opt.removeClass('keyunused');
					}
				}
				cpan.find('.label-cloud').on('click', function(){
					// return;
					if( blockEdit ) return locked()
					// console.log( $(this).text().trim() )
					classSet( 'unset', $(this).text().trim() )
					// setTimeout( setOpt, 1 );
				})
			}
			setOpt()
		}
		else {
			if( !classifications[c.name] ) classifications[c.name] = {};
			var ctext = $('<textarea class="inote-text mt-2" placeholder="Enter Text"></textarea>');
			ctext.on('change', function(){
				classifications[c.name] = {};
				var txt = $(this).val().trim();

				if( txt ) classifications[c.name][txt] = 1;
				changed();
			}).on('focus', function(){
				this.select();
			})
			ctext.val( Object.keys(classifications[c.name]) );
			citem.append( ctext );
		}
	})

}

function pdf2Canvas2(pdfCoord)
{
	var boxLoc = canvasBox;
	var x = pdfCoord.left*boxLoc.width;
	var y = pdfCoord.top*boxLoc.height;
	return {top:y,left:x};
}

function fixBox( coords, width, height )
{
	var b = []; var i = 0;
	b.push( coords[i++] );
	b.push( (coords[i++]*height)/height );
	b.push( coords[i++] );
	b.push( (coords[i++]*height)/height );
	return b;
}

function pdf2Canvas(pdfCoord)
{
	var boxLoc = canvasBox;
	var x = pdfCoord.left*boxLoc.width;
	var y = pdfCoord.top*boxLoc.height;
	return {top:y,left:x};
}


function viewBoxes( o )
{
	// if( !o ) o = {tags:rangeList};
	if( !o ) o = descriptor.orig_text_attributes;
	var imgRect = $('canvas')[0].getBoundingClientRect();
	var canvas = $('canvas').css({
		opacity:1,margin:0, padding:0,
		position:'absolute',top:0,left:0,transformOrigin:'top left',
		transform:'scale(0.5)'}).remove();
	$(document.body).html('').css({ margin:0, padding:0}).append(canvas).css({overflow:'auto'});
	o.tags.forEach( t =>
	{
		if( t.page != currentPage ) return;
		var box = t.box;
		// box = fixBox( box, imgRect.width, imgRect.height )
		var p1 = {left:box[0],top:box[1]}
		// p1.top = 0;
		var p2 = {left:box[2],top:box[3]}
		p1 = pdf2Canvas(p1);
		p2 = pdf2Canvas(p2);
		// console.log( box, p1, p2 );
		var w = p2.left-p1.left;
		var h = p2.top-p1.top;
		var div = $('<div>').css({
			top: p1.top,
			left: p1.left,
			width: w,
			height:h,
			position: 'absolute',
			background: '#00ffff',
			opacity: 0.5
		})
		$(document.body).append(div);
	})
}

function autoSubmit()
{
	var p = 0;
	function next()
	{
		p++;
		if( p > totalPages ) return end()
		drawPDF( gPDF, p, 1, next )
	}
	function end()
	{
		if( descriptor.batchData ) return batchSubmit();
		$('crowd-form')[0].submit()
	}
	next();
}

function unwrap( data, idx )
{
	if( !idx ) idx = 0;
	// console.log( 'idx', idx )
	if( typeof( data ) == 'string' ) data = JSON.parse(data);
	data[idx].annotations[0].annotationData.content = JSON.parse(data[idx].annotations[0].annotationData.content);
	data[idx].annotations[0].annotationData.content.annotations = JSON.parse(data[idx].annotations[0].annotationData.content.annotations);
	return data[idx].annotations[0].annotationData.content.annotations;
}
function wrap( data, idx )
{
	if( !idx ) idx = 0;
	data[idx].annotations[0].annotationData.content.annotations = JSON.stringify(data[idx].annotations[0].annotationData.content.annotations);
	data[idx].annotations[0].annotationData.content = JSON.stringify(data[idx].annotations[0].annotationData.content);
	return JSON.stringify(data);
}

function lpdf( url )
{
	descriptor.pdf.url = url;
}

function lattr( path, offset )
{
	if( !offset ) offset = 0;
	// $.get( 'issue/'+path, data => {
	$.get( ''+path, data => {
		data = jsonParse(data);
		// console.log( 'There are', data.length, 'annotations in json file. Loading #'+(offset+1) );
		unwrap( data, offset );
		window.loadedData = data;
		descriptor.text_attributes = data[offset].annotations[0].annotationData.content.annotations;
		window.origTags = clone(descriptor.text_attributes);
		saveClipboard( JSON.stringify( descriptor.text_attributes, null, '\t' ));
		// console.log( data[offset].annotations[0].annotationData.content.annotations );
		init();
	})
}

function batchSubmit()
{
	var idx = descriptor.batchIdx++;
	descriptor.batchData[idx].annotations[0].annotationData.content.annotations = exportData();
	if( descriptor.batchIdx < descriptor.batchData.length )
	{
		return loadNext()
	}
	// console.log( 'batchSubmit', idx, clone(descriptor.batchData) );
	for( var i = 0 ; i < descriptor.batchData.length ; i++ )
		wrap( descriptor.batchData, i );
	// console.log( 'batchSubmit2', idx, clone(descriptor.batchData) );

	// console.log( 'DATA', JSON.stringify(descriptor.batchData) )
	$.post( 'setjson.php', {file:descriptor.batchFile,data:JSON.stringify(descriptor.batchData)}, function( data ) {
		// alert( 'setjson = ' + data );
		// console.log( 'saving', descriptor.batchFile );
		var list = localStorage.getItem('list');
		if( !list ) list = '[]';
		list = JSON.parse(list);
		if( list.length ) list.shift();
		localStorage.setItem('list',JSON.stringify(list));
		setTimeout( function(){
			document.location.reload();
		}, 200 );
	}).fail(function() {
		alert( 'setjson error');
	});
}

function loadNext( callback )
{
	var urlBase = 's3://aws-comprehend-ssie-smgt-test-data/production/';
	var idx = descriptor.batchIdx;
	// if( idx > 0 ) alert( 'loadNext ' + idx)
	var jsonData = descriptor.batchData;
	// console.log( 'idx', idx, 'length', jsonData.length )
	var url = 'data/' + jsonData[idx].dataObject.s3Uri.substr(urlBase.length);
	var text_attributes = unwrap( jsonData, idx );
	descriptor.pdf.url = url;
	descriptor.pdf.metadata = text_attributes.metadata;
	descriptor.text_attributes = text_attributes;
	descriptor.orig_text_attributes = clone(descriptor.text_attributes);
	// console.log( 'url', url, 'tags', text_attributes, 'idx', idx );
	setTimeout( init, 1 );
}

function loadJsonOld( jsonfile, batch )
{
	if( !batch ) batch = 0;
	// console.log( 'loadJson', jsonfile, batch )
	$.get( 'getjson.php?file='+jsonfile, function( data ) {
		var jsonData = data;
		// console.log( 'loadedData', clone(jsonData))
		if( typeof(jsonData) == 'string' ) jsonData = JSON.parse(jsonData);

		if( batch ) descriptor.autoSubmit = true;
		descriptor.batchFile = jsonfile;
		descriptor.batchData = jsonData;
		descriptor.batchIdx = 0;
		descriptor.batchMode = false;
		loadNext();
	}).fail(function() {
		alert( 'listjson error');
	});
}

function batchMode()
{

	var list = localStorage.getItem('list');
	if( !list ) list = '[]';
	list = JSON.parse(list);
	if( !list.length )
	{
		// console.log( 'get more files' )
		$.get( 'listjson.php', function( data ) {
			if( data == '[]' ) return alert( 'finished processing' );
			// console.log( 'data', data, typeof('data') );
			localStorage.setItem('list',data);
			setTimeout( batchMode, 1 );
		}).fail(function() {
			alert( 'listjson error');
		});
	}
	else {
		var jsonfile = list[0];
		// console.log( jsonfile, list );
		loadJson( jsonfile, 1 );
	}
}


var batchList = [];
var batchAnnotations = [];
var batchReport = [];
var tmp = 0;
// function batchMode2()
// {
// 	batchList = [];
// 	batchAnnotations = [];
// 	batchReport = [];
// 	$.get( 'listjson.php', function( data ) {
// 		if( data == '[]' ) return alert( 'finished processing' );
// 		batchList = JSON.parse(data);
// 		// console.log( 'loading', batchList );
// 		function next()
// 		{
// 			if( !batchList.length )
// 			{
// 				function nextAnnotation()
// 				{
// 					if( !batchAnnotations.length )
// 					{
// 						$.post( 'setreport.php', {data:JSON.stringify(batchReport)}, function( data ) {
// 							// alert( 'done')
// 							document.location.reload();
// 						}).fail(function() {
// 							alert( 'setjson error');
// 						});
// 						return;
// 					}
// 					var a = batchAnnotations.shift();
// 					var text_attributes = a.data.annotations[0].annotationData.content.annotations;
// 					var pdf = a.data.dataObject.s3Uri.split('/').pop();
// 					var basePath = a.file.split('/');
// 					basePath.pop(); basePath.pop(); basePath.push('raw'); basePath.push( pdf )
// 					pdf = basePath.join('/');
// 					// console.log( 'ann', pdf, text_attributes  );

// 					descriptor.text_attributes = clone(text_attributes);
// 					descriptor.pdf.url = pdf;
// 					initDone = function()
// 					{

// 						var report = [
// 							a.file,
// 							pdf,
// 							a.idx,
// 							(text_attributes.tags && text_attributes.tags.length) || 0,
// 							(text_attributes.links && text_attributes.links.length) || 0,
// 							(text_attributes.boxes && text_attributes.boxes.length) || 0,
// 							gPDF.plainText.join('') == Object.values(descriptor.text_attributes.plainText).join() ? 1 : 0,
// 							alignCt,
// 							alignErrCt,
// 						];
// 						batchReport.push( report )
// 						// console.error( 'DONEDONEDONEDONEDONEDONEDONEDONEDONEDONEDONEDONEDONEDONEDONEDONEDONEDONEDONEDONE', a.file, pdf, a.idx, text_attributes.tags.length, text_attributes.links.length, text_attributes.boxes.length )
// 						console.error( 'DONEDONEDONEDONEDONEDONEDONEDONEDONEDONEDONEDONEDONEDONEDONEDONEDONEDONEDONEDONE' );
// 						setTimeout( nextAnnotation, 1 );
// 					}
// 					init();
// 				}
// 				// console.log( 'batchAnnotations', batchAnnotations );
// 				nextAnnotation();
// 				return;
// 			}
// 			var jsonfile = batchList.shift();
// 			$.get( 'getjson.php?file='+jsonfile, function( data ) {
// 				// console.log( jsonfile, data.length )
// 				for( var i = 0 ; i < data.length ; i++ )
// 				{
// 					try {
// 						unwrap( data, i );
// 						batchAnnotations.push( {file: jsonfile, idx: i, data: data[i]} );
// 					} catch(e){}
// 				}
// 				setTimeout( next, 1 );
// 			});
// 		}
// 		next();
// 	}).fail(function() {
// 		alert( 'listjson error');
// 	});
// }

function loadJson( jsonfile, batch )
{
	if( !batch ) batch = 0;
	// console.log( 'loadJson', jsonfile, batch )
	$.get( 'getjson.php?file='+jsonfile, function( data ) {
		var jsonData = data;
		// console.log( 'loadedData', clone(jsonData))
		if( typeof(jsonData) == 'string' ) jsonData = JSON.parse(jsonData);

		if( batch ) descriptor.autoSubmit = true;
		descriptor.batchFile = jsonfile;
		descriptor.batchData = jsonData;
		descriptor.batchIdx = 0;
		descriptor.batchMode = false;
		loadNext();
	}).fail(function() {
		alert( 'listjson error');
	});
}



// setTimeout( () => {
// 	viewBoxes({"tags":[{"page":1,"range":[0,6],"text":"RFax03","id":1,"type":"NAME","box":[0.05891959798994975,0.08354615527488855,0.1257912180531564,0.09989088038632987]},{"page":1,"range":[56,61],"text":"pages","id":3,"type":"NAME","box":[0.08610238693467337,0.4027326337295691,0.1261349548646553,0.4153626485884101]},{"page":1,"range":[929,936],"text":"Medical","id":4,"type":"NAME","box":[0.2769315326633166,0.9957280832095097,0.32047321568781406,1.0068722139673105]},{"page":1,"range":[1139,1149],"text":"Transmitta","id":2,"type":"ADDRESS","box":[0.7224717336683417,0.2506384658246657,0.8917755893726445,0.2788702637444279]}],"links":[],"attributes":{}})
// }, 3000 )

var FIXSPLIT = true;



function listReset( obj )
{
	obj = $(obj);
	var domObj = obj[0];
	domObj.displayKeysLastList = null;
	domObj.displayKeyFixed = null;
	domObj.displayCurrentKey = null;
	domObj.displayKeyList = null;
	domObj.keyShow(1);
}

function listKeys( obj, label, keyList, drawFunc )
{
	// console.log( 'listKeys', label, 'keyList', keyList  )
	obj = $(obj);
	obj.prop('keyList', keyList)
	obj.prop('docLabel', label.toLowerCase() )
	var domObj = obj[0];
	if( !domObj._drawn )
	{
		domObj._drawn = true;
		// console.log( 'searchIcon', searchIcon );
		var ini = '<div class="row no-gutters mb-0"><div class="col"><input class="form-control border-secondary border-right-0 rounded-0" type="search" value="" id="keysearch" placeholder="Search '+label+'"></div><div class="col-auto"><button class="btn btn-outline-secondary border-left-0 rounded-0 rounded-right" type="button">'+searchIcon+'</button></div></div><div class="row no-gutters" id="keylist"><div class="keyrow"><div class="keycolor"></div><span class="Keyname">bobo</span></div><div class="keyrow keyhover"><div class="keycolor"></div><span class="Keyname">xpto</span></div></div>';
		domObj.displayKeysLastList = null;
		domObj.displayKeyFixed = null;
		domObj.displayCurrentKey = null;
		domObj.displayKeyList = null;
		obj.html(ini);
	}
	var skeys = JSON.stringify(keyList);
	domObj.displayKeyList = keyList;
	if( skeys == domObj.displayKeysLastList ) return;
	domObj.displayKeysLastList = skeys;
	if( !keyList.length ) return obj.hide();
	obj.show();
	var labelType = label.toLowerCase().replace(/s$/,'')
	function keyShow( release, ev )
	{
		if( release )
		{
			domObj.displayKeyFixed = domObj.displayCurrentKey = null;
		}
		var search = obj.find('#keysearch').val();
		if( search > '' )
		{
			var sreg = new RegExp(search,'i');
		}
		var keyObj = obj.find('#keylist');
		keyObj.html('');
		var kcount = 0;
		var lastOpt = null;
		keyList.forEach( function(k)
		{
			var ok = k;
			k = k.trim();
			if( search && !k.match(sreg) ) return;
			var color = findColor(k);
			var kopt = $('<div class="keyrow"><div class="keycolor"></div><span class="keyname"></span></div>');
			var txt = ok.replace(/\t/g,'<span class="tab"></span>');
			var title = txt;
			if( ocrMode ) txt = keysetLabel(txt);
			txt = '<span class="ktxt">' + txt + '</span>';
			if( hotKeysVals && hotKeysVals[k] )
			{
				var hk = hotKeysVals[k];
				txt += '<div class="hotkey hotkey_'+ hk.char +'">' + hk.char + '</div>';
			}
			// console.log( 'LABELTYPE', labelType );
			if( labelType.match(/(label|relationship)/) )
			{
				txt += '<div class="keysearch"><i class="fa fa-search"></i></div>';
			}
			// console.log( 'txt', txt )
			kopt.find('.keyname').html( txt ).attr('title', title );
			kopt.find('.keycolor').css({background:color})
			kopt.prop('key', k);
			if( !obj.prop('used') || !obj.prop('used')[k] ) kopt.addClass('keyunused');
			if( getDocUsed(obj.prop('docLabel'),k) ) kopt.addClass('keydocused');
			kopt.prop('id', 'key-'+simplify(k) )
			if( !domObj.displayKeyFixed )
			{
				kopt.off('mouseover').on('mouseover',keyOver);
				kopt.off('mouseout').on('mouseout',keyOut);
			}
			else {
				if( k == domObj.displayKeyFixed )
					kopt.addClass('keyselected');
			}
			lastOpt = kopt;
			keyObj.append( kopt );
			// console.log( 'keyClick', kopt.html())
			kopt.off('click').on('click',keyClick);
			kopt.find('.keysearch').prop('key',k).on('click',function(ev){
				// console.log( 'search', $(this).prop('key') )
				tagUnselect();
				popupOut();
				$('#pdfsearch').val( labelType+':'+$(this).prop('key').toLowerCase() );
				$('#pdfsearch').focus();
				$('#sbtnsearch').click();
				ev.preventDefault();
				return false;
			});
			kcount++;
		});
		var key = (ev && ev.keyCode) || 'nokey';
		// console.log( 'kcount', kcount, key );
		if( key == 13 && kcount == 1 && lastOpt && lastOpt.length )
		{
			lastOpt[0].click();
		}
		if( ocrMode ) keysetEvents();
	}
	function keyOver()
	{
		clearTimeout( outTid );
		obj.find('.keyhover').removeClass('keyhover');
		if( domObj.displayKeyFixed ) return;
		var key = $(this).prop('key');
		domObj.displayCurrentKey = key;
		$(this).addClass('keyhover');
		keyDraw();
	}
	var outTid = null;
	function sendOut()
	{
		clearTimeout( outTid );
		outTid = setTimeout( function(){
			drawFunc('out',domObj.displayCurrentKey);
		}, 50 );
	}
	function keyOut()
	{
		$(this).removeClass('keyhover');
		if( domObj.displayKeyFixed ) return;
		domObj.displayCurrentKey = null;
		sendOut();
		keyDraw();
	}
	function keyClick()
	{
		if( blockEdit ) return locked()

		// console.log( 'click')
		obj.find('.keyhover').removeClass('keyhover');
		obj.find('.keyselected').removeClass('keyselected');
		var key = $(this).prop('key');
		if( domObj.displayKeyFixed && key == domObj.displayKeyFixed )
		{
			$(this).addClass('keyhover');
			domObj.displayKeyFixed = domObj.displayCurrentKey = null;
			keyDraw();
			keyShow();
			drawFunc('unset', key)
			return;
		}
		domObj.displayCurrentKey = key;
		domObj.displayKeyFixed = key;
		$(this).addClass('keyselected');
		drawFunc('set',domObj.displayCurrentKey)
		keyDraw();
		keyShow();
	}
	var keyTid = null;
	function keyDraw()
	{
		clearTimeout( keyTid );
		keyTid = setTimeout( function(){
			drawFunc('over',domObj.displayCurrentKey)
		}, 50 );
	}
	domObj.keyDraw = keyDraw;
	domObj.keyShow = keyShow;
	obj.find('#keysearch').off('keyup').on('keyup',function(ev){keyShow(1,ev)}).off('focus').on('focus', function(){
		this.select();
	});

	keyShow();
	obj[0].redraw = keyShow;
}



function listAttributes( div, iattrs, attributes, title )
{
    div.html('');
    div.addClass('text-attrs');
	// console.log( 'listAttributes', div, iattrs, attributes, title )
    // console.log( 'iattrs', iattrs )
    if( iattrs )
    {
        var choose = $('<DIV>');
        choose.append($('<DIV>').addClass('cchoosetitle').addClass('cchooselabel').html('<h5>'+title+'</h5>'));
        choose.css({width:px(div.width())})
        div.append( choose );

        iattrs.forEach( function(a){
            a.optional = bool(a.optional);
            a.allowNew = bool(a.allowNew);
            if( !( a.label in attributes) && !a.optional ) attributes[a.label] = null;
            var label = a.label;
            // if( !a.optional ) label = '*'+label;
            var aline = $('<div>').html('<div class="doc-attributes">'+label+'</div>');
            var select = $('<select class="mmdb-select mmd-form iselect">');
            select.prop('id','select'+label);
            aline.append(select);
            if( !a.options ) a.options = ["no", "yes"];
			var placeholder = a.placeholder || '(select)';
			select.append( $('<option>').prop('value','').html( placeholder ));
            var opts = {};
			if( attributes[a.label] && a.options.indexOf(attributes[a.label]) == -1 )
				a.options.push(attributes[a.label])
            a.options.forEach(function(aopt,idx){
				if( aopt == '_new' ) return;
                opts[aopt] = 1;
                select.append( $('<option>').prop('value',aopt).html( aopt ));
            });
			// console.log('ATTR', attributes[a.label], a.options );
            if( a.allowNew )
            {
                select.append( $('<option>').prop('value','_new').html( '(Add new '+ a.label + ')' ));
            }
            select.val(attributes[a.label])
            select.on('change', function(){
                // selectStyle(select);
                val = select.val();
                if( val == '' ) val = null;
                attributes[a.label] = val;
                if( val != '_new' ) text.hide();
                else
                {
                    text.show();
                    text.focus();
                }
				changed();
            });
            var text = $('<INPUT TYPE="text">').prop('id','selectText'+a.label).addClass('iselect-text').hide();
            text.on('keyup',function(ev)
            {
                if( ev.keyCode == 13 )
                {
					textSave();
                }
            });
			text.on('change',textSave)
			function textSave()
			{
				// console.log( 'textsave')
				val = text.val().trim();
				if( val == '' ) return frm.myAlert( 'Value Required', 'Please select the new value for attribute "'+ a.label +'"' );
				text.hide();
				if( !(val in opts) )
				{
					a.options.push( val );
				}
				attributes[a.label] = val;
				listAttributes( div, iattrs, attributes, title );
				setTimeout( function(){
					$(div).find('select').val(val);
					// console.log( 'new value selected')
					changed();
				}, 500 )
			}
            aline.append(text);
            choose.append(aline);
        });
    }
    // div.append( $('<br><h5>Aditional Notes</h5>') );
	// var addNotes = $('<TEXTAREA>').addClass('inote-text');
    // div.append( addNotes );
	frm.convertSelects();
	ckSelectDisable()
}
// EXPORTEND

// ADL

extraInit = function()
{
	// console.log( 'MODELS', descriptor.models );
	if( descriptor.autoLabelModel && descriptor.autoLabelModel.length ) {
		$('.btn-model').remove();
		$('#resumeLater').before( $('<button class="btn-model mr-2 btn task-button btn-primary autolabel-button">Auto Label</button>'));
		$('.btn-model').on('click', runModels );
		fixButtons();
	}
	// for( var m in descriptor.models )
	// {
	// 	if( descriptor.models[m] )
	// 	{
	// 		$('.btn-model').remove();
	// 		$('#resumeLater').before( $('<button class="btn-model mr-2 btn task-button btn-primary autolabel-button">Auto Label</button>'));
	// 		$('.btn-model').on('click', runModels );
	// 		fixButtons();
	// 		break;
	// 	}
	// }
}

function isId( v ) {
	return v.length == 24 && v.match(/^[abcdef0-9]+$/) ? true : false;
}


function runModels()
{
	if( blockEdit ) return locked()
	var text = gPDF.plainText[currentPage-1];
	var mlist = descriptor.autoLabelModel || [];
	// for( var m in descriptor.models ) if( descriptor.models[m] ) mlist.push(m);
	var nanot = 0;
	function end()
	{
		frm.myAlert( 'Auto Label', nanot + ' new annotations added', 'Ok', function(){
			if( nanot )
			{
				changed();
				drawPDF( gPDF, currentPage, globalZoom, 0 );
			}
		});
		// console.log( 'model end', nanot );
	}
	function next()
	{
		if( !mlist.length ) return end();
		var m = mlist.shift();
		// var multipage = true;
		// if( !multipage ) {
		// 	var payload = {model:m,text:text};
		// }
		// else {
		// 	var multiTxt = {};
		// 	gPDF.plainText.forEach( (t,i) => multiTxt[i+1] = t );
		// 	var payload = {model:m,text:multiTxt,multipage:1};
		// }

		var multiTxt = {};
		gPDF.plainText.forEach( (t,i) => multiTxt[i+1] = t );
		var payload = {model:m,text:multiTxt,multipage:1};


		var model_cmd = 'ner_assist';
		var adlLabels = {}
		for( var k in descriptor.labels )
		{
			if( descriptor.labels[k][m] )
			{
				adlLabels[descriptor.labels[k][m]] = k;
			}
		}
		let translate = {};
		if( descriptor.labels ) {
			for( let k in descriptor.labels ) {
				let l = descriptor.labels[k];
				k = k.replace(/:(KEY|VAL)$/, '');
				if( l[m] ) translate[l[m]] = k;
			}
		}
		// console.log( 'TRANSLATE', translate );
		// if( descriptor.customModels[m] ) {
		if( isId(m) ) {
				model_cmd = 'run_model'
			payload.url = descriptor.pdf && descriptor.pdf.url || '';
			payload.modelId = m;
			if( (descriptor.ocrMode || descriptor.comprehendMode) && descriptor.comprehendBlocks ) {
				delete payload.text;
				payload.blocks = descriptor.comprehendBlocks;
			}
		} 
		console.log( 'AUTOLABEL', model_cmd, payload );
		window.post( model_cmd, payload, res => {
			var origPage = currentPage;
			try {
				// console.log('model', m, res, 'translate', translate )
				// var entities = JSON.parse( res.data.entities );
				var entities = res.data.entities;
				// console.log( 'entities', entities )
				var page = 0;
				for (var page in entities) {
					page *= 1;
					currentPage = page;
					var elist = entities[page];
					// kpAnnotationsInv( elist )
					// console.log( 'page', page, 'elist', elist )
					for (var e of elist) {
						// console.log( m, 'entity', e.type, adlLabels[e.type], adlLabels )
						// var adlLabel = adlLabels[e.type]
						var adlLabel = translate[e.type];
						// console.log('entity', e.type, adlLabel, e)
						if (adlLabel) {
							if( e.kv_type ) {
								adlLabel += (e.kv_type[0] == 'v' ? ':VAL' : ':KEY')
								delete e.kv_type;
							}
							var tag = null;
							var tid = findRange(e.range);
							if (tid !== false) tag = tagFind(tid);
							// console.log('tid', tid, 'tag', tag)
							if (tag && tag.properties.indexOf(adlLabel) >= 0) {
								// console.log( 'already tagged');
								continue;
							}
							if (tid == false) tid = g_tagId++;
							addRange(splitRange(e.range, tid, adlLabel, 0, page))
							nanot++;
							// console.log( 'entity', e, adlLabel, tid )
						}
					}
				}
			} catch(e){}
			currentPage = origPage;
			next();
		})
	}
	frm.myAlert( 'Auto Label', 'Running Models, please wait');
	next();
}

function checkInstructions() {
	if(blockEdit) return;

	const engine = new Liquid();

	// Define the data to be passed to the template
	// const data = {
	// File: 'testfile',
	// Name: 'pdf'
	// };

	const data = (descriptor.pdf && descriptor.pdf.metadata) || descriptor.metadata


	// Render a template using Liquid
	let itext = (descriptor.globalTaskInstructions && descriptor.globalTaskInstructions.text) || '';
	console.log( 'globalTaskInstructions', descriptor.globalTaskInstructions, itext);
	
	if( itext ) {
		engine
			.parseAndRender(itext.replace(/\n/g, '<br>'), data)
			.then(result => {
				console.log('Rendered template:------', result);
				
				if (descriptor.globalTaskInstructions.showModal && descriptor.globalTaskInstructions.text && window.GlobalVars.PDFProjectType !== 'Utterance Recording') {
					frm.myAlert('Instructions', result, 'Ok');
				}
				else if(window.Utterancedata.projectType === 'Utterance Recording'){
					frm.myAlert('User Consent form', result, 'Yes', function(){
							frm.myAlertClose()
					}, 'No', function(){
						window.goPage( window.projectWizzard[mode-1] );});
					}
	
				if(descriptor.globalTaskInstructions.text && window.GlobalVars.PDFProjectType !== 'Utterance Recording'){
					if($('#right').find('.instruct').length > 0){
						$('#right').find('.instruct').remove();
					}
	
					let instructionsBox = `
					<div class="instruct">
						<div class="panel-title">Instructions</div>
						<p>${result || 'No Instrctions set'}</p>
					</div>`
					
					$('#right').prepend(instructionsBox)
				}
			})
			.catch(error => {
				console.error('Error rendering template:', error);
			});
	}
}

claimTask = async function(d) {
	await descriptor.claimCallback(d);
	checkInstructions();
}

releaseTask = function(d) {
	descriptor.releaseCallback(d);
}

submitAnnotations = async function()
{
	var annotations = exportData();
	if( annotations )
	{
		let isDecline = declined && declineReason;
		if(window.GlobalVars.PDFProjectType === 'Utterance Recording' && !isDecline) {
			if(window.descriptor.taskcomplete  ){
			frm.myAlert('Utterance Recording', 'Please make sure you have recorded the utterance before submitting the annotations.', 'Ok');
			return false;
			}
		}
		if( !isDecline && !await frm.myConfirm( 'Confirm Submit', "Do you really want to submit your annotations?", null, "Yes, submit annotations", "No")) 
			return;
		if( reviewMode && annotations && annotations.review ) annotations.review.reviewerId = window.GlobalVars.userId || window.GlobalVars.userWoekerId;
		clearTimeout( changeTid );
		updateFlag = true;
		window.onbeforeunload = null;
		descriptor.submit(annotations);
		// document.getElementById('annotations').value = JSON.stringify(annotations);
	}
	else
	return false;
};

var updateFlag = false;
function updating(){
	return updateFlag;
}

var changeTid = null;
changed = function()
{
	if( blockEdit || !initComplete ) return;
	if( blockSave ) {
		// console.log( 'blocksave')
		return;
	}
	ocrLinks();
	clearTimeout( changeTid );
	updateFlag = true;
	window.onbeforeunload = function(ev){
		ev.preventDefault();
		return ev.returnValue = "Are you sure you want to exit?";
	}
	showSave('Saving...')
	changeTid = setTimeout( function(){
		var annotations = exportData(1);
		if( reviewMode && annotations && annotations.review ) annotations.review.reviewerId = window.GlobalVars.userId || window.GlobalVars.userWoekerId;
		console.log( 'UPDATE', annotations );
		runUpdate();
		function runUpdate() {
			descriptor.update(annotations, (res) => {
				console.log( 'UPDATE RES', res )
				console.log('annp', annotations)
				if( !res ) {
					setTimeout( runUpdate, 3000 )
					frm.myAlert( 'Update Error', 'The annotations on this page could not be saved. Please check your network connection.');
					$('.modal-footer').hide();
					return;
				}
				// frm.myAlertClose();
				updateFlag = false;
				window.onbeforeunload = null;
				showSave('Saved', Date.now() )
			});
		}
	}, 1000 );
	// return;
}
// exports.textPDF = textPDF;

export default {init,loading,loadingOut,updating};

// ADLEND